var fl = Object.defineProperty;
var gl = (t, n, a) => n in t ? fl(t, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[n] = a;
var O = (t, n, a) => gl(t, typeof n != "symbol" ? n + "" : n, a);
import { jsx as _, jsxs as L, Fragment as Ee } from "react/jsx-runtime";
import { twMerge as A, twJoin as Gn } from "tailwind-merge";
import { Transition as Ka, Dialog as Tr, Popover as Vi, PopoverButton as Ui, PopoverPanel as ji, Field as ln, Switch as _l, Label as yl, FocusTrap as bl, FocusTrapFeatures as vl, MenuButton as Sl, Menu as kl, MenuItems as Ml, MenuItem as wl, ComboboxButton as er, Combobox as Yi, ComboboxInput as Cl, ComboboxOption as Wi, ComboboxOptions as Zi, Listbox as ar, ListboxButton as zt, ListboxOptions as tr, ListboxOption as Ji } from "@headlessui/react";
import * as j from "react";
import C, { Fragment as ct, useState as ee, useRef as ue, useEffect as de, forwardRef as yt, createContext as Dl, useCallback as Sa, useMemo as Qa, useLayoutEffect as nr, cloneElement as Qi, createRef as pa, Component as ye, createElement as Pl } from "react";
import { C as bt, P as q, a as Al, D as Nl, b as Tl, c as Il, Q as $i, A as qi, d as xl, S as El, L as Bl, e as Rl, f as Ol, g as Xi } from "./payment-method.enum-BnslgSnW.mjs";
import { HexAlphaColorPicker as Ll, HexColorPicker as Gl, HexColorInput as Fl } from "react-colorful";
import Kl, { toast as Fn, Toaster as Hl } from "react-hot-toast";
import * as zl from "react-dom";
import Vl from "react-dom";
var Ul = /* @__PURE__ */ ((t) => (t.small = "small", t.medium = "medium", t.big = "big", t))(Ul || {});
function O_({
  opened: t,
  onClose: n,
  children: a,
  title: e,
  size: r = "small",
  isFetching: i,
  afterLeave: o,
  afterEnter: s,
  className: l,
  contentClassName: c,
  isCentered: u,
  dialogClassName: d,
  backdropClassName: p,
  dialogContentClassName: m,
  dialogContentWrapperClassName: h,
  dialogContentWrapper1ClassName: f,
  titleClassName: g,
  closeIconWrapperClassName: y,
  closeIconClassName: b,
  ...k
}) {
  return /* @__PURE__ */ _(Ka.Root, { afterEnter: s, show: t, as: ct, children: /* @__PURE__ */ L(
    Tr,
    {
      className: A("relative z-10", d),
      onClose: i ? () => {
      } : n,
      children: [
        /* @__PURE__ */ _(
          Ka.Child,
          {
            as: ct,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ _(
              "div",
              {
                className: A(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  p
                )
              }
            )
          }
        ),
        /* @__PURE__ */ _(
          "div",
          {
            className: A("fixed inset-0 z-10 overflow-y-auto", h),
            children: /* @__PURE__ */ _(
              "div",
              {
                id: "modal-background",
                className: A(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  f
                ),
                children: /* @__PURE__ */ _(
                  Ka.Child,
                  {
                    as: ct,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: o,
                    children: /* @__PURE__ */ L(
                      Tr.Panel,
                      {
                        className: A(
                          "relative w-full",
                          r === "small" ? "max-w-2xl" : r === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          l
                        ),
                        ...k,
                        children: [
                          /* @__PURE__ */ L(
                            "div",
                            {
                              className: A(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                u ? "justify-center" : "justify-between",
                                m
                              ),
                              children: [
                                /* @__PURE__ */ _("h3", { className: A(u ? "px-6 lg:px-10" : "", g), children: e }),
                                /* @__PURE__ */ _(
                                  "button",
                                  {
                                    className: A(
                                      "focus-ring rounded-full",
                                      u && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      y
                                    ),
                                    disabled: i,
                                    onClick: n,
                                    children: /* @__PURE__ */ _(
                                      bt,
                                      {
                                        className: A(
                                          "cursor-pointer",
                                          i && "fill-text-secondary pointer-events-none",
                                          b
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ _(
                            "div",
                            {
                              className: A(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                c
                              ),
                              children: a
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const Vt = ({ small: t = !1, type: n = "light", className: a, style: e }) => /* @__PURE__ */ L("div", { role: "status", className: a, style: e, children: [
  /* @__PURE__ */ L(
    "svg",
    {
      "aria-hidden": "true",
      className: `${t ? "h-5 w-5" : "h-8 w-8"} animate-spin ${n === "light" ? "fill-brand-primary text-background-secondary" : "fill-background-secondary text-text-primary"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ _(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ _("span", { className: "sr-only", children: "Loading..." })
] });
function pt(t) {
  "@babel/helpers - typeof";
  return pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, pt(t);
}
function jl(t, n) {
  if (pt(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var e = a.call(t, n);
    if (pt(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(t);
}
function Yl(t) {
  var n = jl(t, "string");
  return pt(n) == "symbol" ? n : n + "";
}
function Wl(t, n, a) {
  return (n = Yl(n)) in t ? Object.defineProperty(t, n, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = a, t;
}
function Zl(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Jl(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var n = t.default;
  if (typeof n == "function") {
    var a = function e() {
      return this instanceof e ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    a.prototype = n.prototype;
  } else a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(t).forEach(function(e) {
    var r = Object.getOwnPropertyDescriptor(t, e);
    Object.defineProperty(a, e, r.get ? r : {
      enumerable: !0,
      get: function() {
        return t[e];
      }
    });
  }), a;
}
var Ql = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, $l = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ql = function(n) {
  return $l[n];
}, Xl = function(n) {
  return n.replace(Ql, ql);
};
function Ir(t, n) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    n && (e = e.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), a.push.apply(a, e);
  }
  return a;
}
function xr(t) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ir(Object(a), !0).forEach(function(e) {
      Wl(t, e, a[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : Ir(Object(a)).forEach(function(e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(a, e));
    });
  }
  return t;
}
var Er = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Xl
};
function ec() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Er = xr(xr({}, Er), t);
}
var ac = {
  type: "3rdParty",
  init: function(n) {
    ec(n.options.react);
  }
};
const Y = (t) => typeof t == "string", Xa = () => {
  let t, n;
  const a = new Promise((e, r) => {
    t = e, n = r;
  });
  return a.resolve = t, a.reject = n, a;
}, Br = (t) => t == null ? "" : "" + t, tc = (t, n, a) => {
  t.forEach((e) => {
    n[e] && (a[e] = n[e]);
  });
}, nc = /###/g, Rr = (t) => t && t.indexOf("###") > -1 ? t.replace(nc, ".") : t, Or = (t) => !t || Y(t), ut = (t, n, a) => {
  const e = Y(n) ? n.split(".") : n;
  let r = 0;
  for (; r < e.length - 1; ) {
    if (Or(t)) return {};
    const i = Rr(e[r]);
    !t[i] && a && (t[i] = new a()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++r;
  }
  return Or(t) ? {} : {
    obj: t,
    k: Rr(e[r])
  };
}, Lr = (t, n, a) => {
  const {
    obj: e,
    k: r
  } = ut(t, n, Object);
  if (e !== void 0 || n.length === 1) {
    e[r] = a;
    return;
  }
  let i = n[n.length - 1], o = n.slice(0, n.length - 1), s = ut(t, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = ut(t, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = a;
}, rc = (t, n, a, e) => {
  const {
    obj: r,
    k: i
  } = ut(t, n, Object);
  r[i] = r[i] || [], r[i].push(a);
}, Ut = (t, n) => {
  const {
    obj: a,
    k: e
  } = ut(t, n);
  if (a)
    return a[e];
}, ic = (t, n, a) => {
  const e = Ut(t, a);
  return e !== void 0 ? e : Ut(n, a);
}, eo = (t, n, a) => {
  for (const e in n)
    e !== "__proto__" && e !== "constructor" && (e in t ? Y(t[e]) || t[e] instanceof String || Y(n[e]) || n[e] instanceof String ? a && (t[e] = n[e]) : eo(t[e], n[e], a) : t[e] = n[e]);
  return t;
}, Ba = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var oc = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const sc = (t) => Y(t) ? t.replace(/[&<>"'\/]/g, (n) => oc[n]) : t;
class lc {
  constructor(n) {
    this.capacity = n, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(n) {
    const a = this.regExpMap.get(n);
    if (a !== void 0)
      return a;
    const e = new RegExp(n);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(n, e), this.regExpQueue.push(n), e;
  }
}
const cc = [" ", ",", "?", "!", ";"], uc = new lc(20), dc = (t, n, a) => {
  n = n || "", a = a || "";
  const e = cc.filter((o) => n.indexOf(o) < 0 && a.indexOf(o) < 0);
  if (e.length === 0) return !0;
  const r = uc.getRegExp(`(${e.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !r.test(t);
  if (!i) {
    const o = t.indexOf(a);
    o > 0 && !r.test(t.substring(0, o)) && (i = !0);
  }
  return i;
}, Kn = function(t, n) {
  let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t) return;
  if (t[n]) return t[n];
  const e = n.split(a);
  let r = t;
  for (let i = 0; i < e.length; ) {
    if (!r || typeof r != "object")
      return;
    let o, s = "";
    for (let l = i; l < e.length; ++l)
      if (l !== i && (s += a), s += e[l], o = r[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < e.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    r = o;
  }
  return r;
}, jt = (t) => t && t.replace("_", "-"), pc = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, n) {
    console && console[t] && console[t].apply(console, n);
  }
};
class Yt {
  constructor(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(n, a);
  }
  init(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = a.prefix || "i18next:", this.logger = n || pc, this.options = a, this.debug = a.debug;
  }
  log() {
    for (var n = arguments.length, a = new Array(n), e = 0; e < n; e++)
      a[e] = arguments[e];
    return this.forward(a, "log", "", !0);
  }
  warn() {
    for (var n = arguments.length, a = new Array(n), e = 0; e < n; e++)
      a[e] = arguments[e];
    return this.forward(a, "warn", "", !0);
  }
  error() {
    for (var n = arguments.length, a = new Array(n), e = 0; e < n; e++)
      a[e] = arguments[e];
    return this.forward(a, "error", "");
  }
  deprecate() {
    for (var n = arguments.length, a = new Array(n), e = 0; e < n; e++)
      a[e] = arguments[e];
    return this.forward(a, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(n, a, e, r) {
    return r && !this.debug ? null : (Y(n[0]) && (n[0] = `${e}${this.prefix} ${n[0]}`), this.logger[a](n));
  }
  create(n) {
    return new Yt(this.logger, {
      prefix: `${this.prefix}:${n}:`,
      ...this.options
    });
  }
  clone(n) {
    return n = n || this.options, n.prefix = n.prefix || this.prefix, new Yt(this.logger, n);
  }
}
var je = new Yt();
class cn {
  constructor() {
    this.observers = {};
  }
  on(n, a) {
    return n.split(" ").forEach((e) => {
      this.observers[e] || (this.observers[e] = /* @__PURE__ */ new Map());
      const r = this.observers[e].get(a) || 0;
      this.observers[e].set(a, r + 1);
    }), this;
  }
  off(n, a) {
    if (this.observers[n]) {
      if (!a) {
        delete this.observers[n];
        return;
      }
      this.observers[n].delete(a);
    }
  }
  emit(n) {
    for (var a = arguments.length, e = new Array(a > 1 ? a - 1 : 0), r = 1; r < a; r++)
      e[r - 1] = arguments[r];
    this.observers[n] && Array.from(this.observers[n].entries()).forEach((o) => {
      let [s, l] = o;
      for (let c = 0; c < l; c++)
        s(...e);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [s, l] = o;
      for (let c = 0; c < l; c++)
        s.apply(s, [n, ...e]);
    });
  }
}
class Gr extends cn {
  constructor(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = n || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(n) {
    this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
  }
  removeNamespaces(n) {
    const a = this.options.ns.indexOf(n);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(n, a, e) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, o = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    n.indexOf(".") > -1 ? s = n.split(".") : (s = [n, a], e && (Array.isArray(e) ? s.push(...e) : Y(e) && i ? s.push(...e.split(i)) : s.push(e)));
    const l = Ut(this.data, s);
    return !l && !a && !e && n.indexOf(".") > -1 && (n = s[0], a = s[1], e = s.slice(2).join(".")), l || !o || !Y(e) ? l : Kn(this.data && this.data[n] && this.data[n][a], e, i);
  }
  addResource(n, a, e, r) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [n, a];
    e && (s = s.concat(o ? e.split(o) : e)), n.indexOf(".") > -1 && (s = n.split("."), r = a, a = s[1]), this.addNamespaces(a), Lr(this.data, s, r), i.silent || this.emit("added", n, a, e, r);
  }
  addResources(n, a, e) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in e)
      (Y(e[i]) || Array.isArray(e[i])) && this.addResource(n, a, i, e[i], {
        silent: !0
      });
    r.silent || this.emit("added", n, a, e);
  }
  addResourceBundle(n, a, e, r, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [n, a];
    n.indexOf(".") > -1 && (s = n.split("."), r = e, e = a, a = s[1]), this.addNamespaces(a);
    let l = Ut(this.data, s) || {};
    o.skipCopy || (e = JSON.parse(JSON.stringify(e))), r ? eo(l, e, i) : l = {
      ...l,
      ...e
    }, Lr(this.data, s, l), o.silent || this.emit("added", n, a, e);
  }
  removeResourceBundle(n, a) {
    this.hasResourceBundle(n, a) && delete this.data[n][a], this.removeNamespaces(a), this.emit("removed", n, a);
  }
  hasResourceBundle(n, a) {
    return this.getResource(n, a) !== void 0;
  }
  getResourceBundle(n, a) {
    return a || (a = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(n, a)
    } : this.getResource(n, a);
  }
  getDataByLanguage(n) {
    return this.data[n];
  }
  hasLanguageSomeTranslations(n) {
    const a = this.getDataByLanguage(n);
    return !!(a && Object.keys(a) || []).find((r) => a[r] && Object.keys(a[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var ao = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, n, a, e, r) {
    return t.forEach((i) => {
      this.processors[i] && (n = this.processors[i].process(n, a, e, r));
    }), n;
  }
};
const Fr = {};
class Wt extends cn {
  constructor(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), tc(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = je.create("translator");
  }
  changeLanguage(n) {
    n && (this.language = n);
  }
  exists(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (n == null)
      return !1;
    const e = this.resolve(n, a);
    return e && e.res !== void 0;
  }
  extractFromKey(n, a) {
    let e = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    e === void 0 && (e = ":");
    const r = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let i = a.ns || this.options.defaultNS || [];
    const o = e && n.indexOf(e) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !dc(n, e, r);
    if (o && !s) {
      const l = n.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: n,
          namespaces: Y(i) ? [i] : i
        };
      const c = n.split(e);
      (e !== r || e === r && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), n = c.join(r);
    }
    return {
      key: n,
      namespaces: Y(i) ? [i] : i
    };
  }
  translate(n, a, e) {
    if (typeof a != "object" && this.options.overloadTranslationOptionHandler && (a = this.options.overloadTranslationOptionHandler(arguments)), typeof a == "object" && (a = {
      ...a
    }), a || (a = {}), n == null) return "";
    Array.isArray(n) || (n = [String(n)]);
    const r = a.returnDetails !== void 0 ? a.returnDetails : this.options.returnDetails, i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(n[n.length - 1], a), l = s[s.length - 1], c = a.lng || this.language, u = a.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const D = a.nsSeparator || this.options.nsSeparator;
        return r ? {
          res: `${l}${D}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(a)
        } : `${l}${D}${o}`;
      }
      return r ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(a)
      } : o;
    }
    const d = this.resolve(n, a);
    let p = d && d.res;
    const m = d && d.usedKey || o, h = d && d.exactUsedKey || o, f = Object.prototype.toString.apply(p), g = ["[object Number]", "[object Function]", "[object RegExp]"], y = a.joinArrays !== void 0 ? a.joinArrays : this.options.joinArrays, b = !this.i18nFormat || this.i18nFormat.handleAsObject, k = !Y(p) && typeof p != "boolean" && typeof p != "number";
    if (b && p && k && g.indexOf(f) < 0 && !(Y(y) && Array.isArray(p))) {
      if (!a.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const D = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, p, {
          ...a,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return r ? (d.res = D, d.usedParams = this.getUsedParamsDetails(a), d) : D;
      }
      if (i) {
        const D = Array.isArray(p), v = D ? [] : {}, S = D ? h : m;
        for (const w in p)
          if (Object.prototype.hasOwnProperty.call(p, w)) {
            const M = `${S}${i}${w}`;
            v[w] = this.translate(M, {
              ...a,
              joinArrays: !1,
              ns: s
            }), v[w] === M && (v[w] = p[w]);
          }
        p = v;
      }
    } else if (b && Y(y) && Array.isArray(p))
      p = p.join(y), p && (p = this.extendTranslation(p, n, a, e));
    else {
      let D = !1, v = !1;
      const S = a.count !== void 0 && !Y(a.count), w = Wt.hasDefaultValue(a), M = S ? this.pluralResolver.getSuffix(c, a.count, a) : "", P = a.ordinal && S ? this.pluralResolver.getSuffix(c, a.count, {
        ordinal: !1
      }) : "", N = S && !a.ordinal && a.count === 0 && this.pluralResolver.shouldUseIntlApi(), B = N && a[`defaultValue${this.options.pluralSeparator}zero`] || a[`defaultValue${M}`] || a[`defaultValue${P}`] || a.defaultValue;
      !this.isValidLookup(p) && w && (D = !0, p = B), this.isValidLookup(p) || (v = !0, p = o);
      const F = (a.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && v ? void 0 : p, x = w && B !== p && this.options.updateMissing;
      if (v || D || x) {
        if (this.logger.log(x ? "updateKey" : "missingKey", c, l, o, x ? B : p), i) {
          const I = this.resolve(o, {
            ...a,
            keySeparator: !1
          });
          I && I.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, a.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && z && z[0])
          for (let I = 0; I < z.length; I++)
            K.push(z[I]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(a.lng || this.language) : K.push(a.lng || this.language);
        const T = (I, V, U) => {
          const ae = w && U !== p ? U : F;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(I, l, V, ae, x, a) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(I, l, V, ae, x, a), this.emit("missingKey", I, l, V, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && S ? K.forEach((I) => {
          const V = this.pluralResolver.getSuffixes(I, a);
          N && a[`defaultValue${this.options.pluralSeparator}zero`] && V.indexOf(`${this.options.pluralSeparator}zero`) < 0 && V.push(`${this.options.pluralSeparator}zero`), V.forEach((U) => {
            T([I], o + U, a[`defaultValue${U}`] || B);
          });
        }) : T(K, o, B));
      }
      p = this.extendTranslation(p, n, a, d, e), v && p === o && this.options.appendNamespaceToMissingKey && (p = `${l}:${o}`), (v || D) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, D ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return r ? (d.res = p, d.usedParams = this.getUsedParamsDetails(a), d) : p;
  }
  extendTranslation(n, a, e, r, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      n = this.i18nFormat.parse(n, {
        ...this.options.interpolation.defaultVariables,
        ...e
      }, e.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!e.skipInterpolation) {
      e.interpolation && this.interpolator.init({
        ...e,
        interpolation: {
          ...this.options.interpolation,
          ...e.interpolation
        }
      });
      const c = Y(n) && (e && e.interpolation && e.interpolation.skipOnVariables !== void 0 ? e.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = n.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = e.replace && !Y(e.replace) ? e.replace : e;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), n = this.interpolator.interpolate(n, d, e.lng || this.language || r.usedLng, e), c) {
        const p = n.match(this.interpolator.nestingRegexp), m = p && p.length;
        u < m && (e.nest = !1);
      }
      !e.lng && this.options.compatibilityAPI !== "v1" && r && r.res && (e.lng = this.language || r.usedLng), e.nest !== !1 && (n = this.interpolator.nest(n, function() {
        for (var p = arguments.length, m = new Array(p), h = 0; h < p; h++)
          m[h] = arguments[h];
        return i && i[0] === m[0] && !e.context ? (o.logger.warn(`It seems you are nesting recursively key: ${m[0]} in key: ${a[0]}`), null) : o.translate(...m, a);
      }, e)), e.interpolation && this.interpolator.reset();
    }
    const s = e.postProcess || this.options.postProcess, l = Y(s) ? [s] : s;
    return n != null && l && l.length && e.applyPostProcessor !== !1 && (n = ao.handle(l, n, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(e)
      },
      ...e
    } : e, this)), n;
  }
  resolve(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e, r, i, o, s;
    return Y(n) && (n = [n]), n.forEach((l) => {
      if (this.isValidLookup(e)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      r = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = a.count !== void 0 && !Y(a.count), m = p && !a.ordinal && a.count === 0 && this.pluralResolver.shouldUseIntlApi(), h = a.context !== void 0 && (Y(a.context) || typeof a.context == "number") && a.context !== "", f = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((g) => {
        this.isValidLookup(e) || (s = g, !Fr[`${f[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Fr[`${f[0]}-${g}`] = !0, this.logger.warn(`key "${r}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((y) => {
          if (this.isValidLookup(e)) return;
          o = y;
          const b = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(b, u, y, g, a);
          else {
            let D;
            p && (D = this.pluralResolver.getSuffix(y, a.count, a));
            const v = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (b.push(u + D), a.ordinal && D.indexOf(S) === 0 && b.push(u + D.replace(S, this.options.pluralSeparator)), m && b.push(u + v)), h) {
              const w = `${u}${this.options.contextSeparator}${a.context}`;
              b.push(w), p && (b.push(w + D), a.ordinal && D.indexOf(S) === 0 && b.push(w + D.replace(S, this.options.pluralSeparator)), m && b.push(w + v));
            }
          }
          let k;
          for (; k = b.pop(); )
            this.isValidLookup(e) || (i = k, e = this.getResource(y, g, k, a));
        }));
      });
    }), {
      res: e,
      usedKey: r,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(n) {
    return n !== void 0 && !(!this.options.returnNull && n === null) && !(!this.options.returnEmptyString && n === "");
  }
  getResource(n, a, e) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(n, a, e, r) : this.resourceStore.getResource(n, a, e, r);
  }
  getUsedParamsDetails() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], e = n.replace && !Y(n.replace);
    let r = e ? n.replace : n;
    if (e && typeof n.count < "u" && (r.count = n.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !e) {
      r = {
        ...r
      };
      for (const i of a)
        delete r[i];
    }
    return r;
  }
  static hasDefaultValue(n) {
    const a = "defaultValue";
    for (const e in n)
      if (Object.prototype.hasOwnProperty.call(n, e) && a === e.substring(0, a.length) && n[e] !== void 0)
        return !0;
    return !1;
  }
}
const wn = (t) => t.charAt(0).toUpperCase() + t.slice(1);
class Kr {
  constructor(n) {
    this.options = n, this.supportedLngs = this.options.supportedLngs || !1, this.logger = je.create("languageUtils");
  }
  getScriptPartFromCode(n) {
    if (n = jt(n), !n || n.indexOf("-") < 0) return null;
    const a = n.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(n) {
    if (n = jt(n), !n || n.indexOf("-") < 0) return n;
    const a = n.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(n) {
    if (Y(n) && n.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let r = Intl.getCanonicalLocales(n)[0];
          if (r && this.options.lowerCaseLng && (r = r.toLowerCase()), r) return r;
        } catch {
        }
      const a = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let e = n.split("-");
      return this.options.lowerCaseLng ? e = e.map((r) => r.toLowerCase()) : e.length === 2 ? (e[0] = e[0].toLowerCase(), e[1] = e[1].toUpperCase(), a.indexOf(e[1].toLowerCase()) > -1 && (e[1] = wn(e[1].toLowerCase()))) : e.length === 3 && (e[0] = e[0].toLowerCase(), e[1].length === 2 && (e[1] = e[1].toUpperCase()), e[0] !== "sgn" && e[2].length === 2 && (e[2] = e[2].toUpperCase()), a.indexOf(e[1].toLowerCase()) > -1 && (e[1] = wn(e[1].toLowerCase())), a.indexOf(e[2].toLowerCase()) > -1 && (e[2] = wn(e[2].toLowerCase()))), e.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
  }
  isSupportedCode(n) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
  }
  getBestMatchFromCodes(n) {
    if (!n) return null;
    let a;
    return n.forEach((e) => {
      if (a) return;
      const r = this.formatLanguageCode(e);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (a = r);
    }), !a && this.options.supportedLngs && n.forEach((e) => {
      if (a) return;
      const r = this.getLanguagePartFromCode(e);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(n, a) {
    if (!n) return [];
    if (typeof n == "function" && (n = n(a)), Y(n) && (n = [n]), Array.isArray(n)) return n;
    if (!a) return n.default || [];
    let e = n[a];
    return e || (e = n[this.getScriptPartFromCode(a)]), e || (e = n[this.formatLanguageCode(a)]), e || (e = n[this.getLanguagePartFromCode(a)]), e || (e = n.default), e || [];
  }
  toResolveHierarchy(n, a) {
    const e = this.getFallbackCodes(a || this.options.fallbackLng || [], n), r = [], i = (o) => {
      o && (this.isSupportedCode(o) ? r.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return Y(n) && (n.indexOf("-") > -1 || n.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(n))) : Y(n) && i(this.formatLanguageCode(n)), e.forEach((o) => {
      r.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), r;
  }
}
let mc = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], hc = {
  1: (t) => +(t > 1),
  2: (t) => +(t != 1),
  3: (t) => 0,
  4: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  5: (t) => t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5,
  6: (t) => t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2,
  7: (t) => t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  8: (t) => t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3,
  9: (t) => +(t >= 2),
  10: (t) => t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4,
  11: (t) => t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3,
  12: (t) => +(t % 10 != 1 || t % 100 == 11),
  13: (t) => +(t !== 0),
  14: (t) => t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3,
  15: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  16: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2,
  17: (t) => t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1,
  18: (t) => t == 0 ? 0 : t == 1 ? 1 : 2,
  19: (t) => t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3,
  20: (t) => t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2,
  21: (t) => t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0,
  22: (t) => t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3
};
const fc = ["v1", "v2", "v3"], gc = ["v4"], Hr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, _c = () => {
  const t = {};
  return mc.forEach((n) => {
    n.lngs.forEach((a) => {
      t[a] = {
        numbers: n.nr,
        plurals: hc[n.fc]
      };
    });
  }), t;
};
class yc {
  constructor(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = n, this.options = a, this.logger = je.create("pluralResolver"), (!this.options.compatibilityJSON || gc.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = _c(), this.pluralRulesCache = {};
  }
  addRule(n, a) {
    this.rules[n] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const e = jt(n === "dev" ? "en" : n), r = a.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: e,
        type: r
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(e, {
          type: r
        });
      } catch {
        if (!n.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(n);
        o = this.getRule(l, a);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[n] || this.rules[this.languageUtils.getLanguagePartFromCode(n)];
  }
  needsPlural(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const e = this.getRule(n, a);
    return this.shouldUseIntlApi() ? e && e.resolvedOptions().pluralCategories.length > 1 : e && e.numbers.length > 1;
  }
  getPluralFormsOfKey(n, a) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(n, e).map((r) => `${a}${r}`);
  }
  getSuffixes(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const e = this.getRule(n, a);
    return e ? this.shouldUseIntlApi() ? e.resolvedOptions().pluralCategories.sort((r, i) => Hr[r] - Hr[i]).map((r) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : e.numbers.map((r) => this.getSuffix(n, r, a)) : [];
  }
  getSuffix(n, a) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const r = this.getRule(n, e);
    return r ? this.shouldUseIntlApi() ? `${this.options.prepend}${e.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(a)}` : this.getSuffixRetroCompatible(r, a) : (this.logger.warn(`no plural rule found for: ${n}`), "");
  }
  getSuffixRetroCompatible(n, a) {
    const e = n.noAbs ? n.plurals(a) : n.plurals(Math.abs(a));
    let r = n.numbers[e];
    this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 && (r === 2 ? r = "plural" : r === 1 && (r = ""));
    const i = () => this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
    return this.options.compatibilityJSON === "v1" ? r === 1 ? "" : typeof r == "number" ? `_plural_${r.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 ? i() : this.options.prepend && e.toString() ? this.options.prepend + e.toString() : e.toString();
  }
  shouldUseIntlApi() {
    return !fc.includes(this.options.compatibilityJSON);
  }
}
const zr = function(t, n, a) {
  let e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = ic(t, n, a);
  return !i && r && Y(a) && (i = Kn(t, a, e), i === void 0 && (i = Kn(n, a, e))), i;
}, Cn = (t) => t.replace(/\$/g, "$$$$");
class bc {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = je.create("interpolator"), this.options = n, this.format = n.interpolation && n.interpolation.format || ((a) => a), this.init(n);
  }
  init() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    n.interpolation || (n.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: e,
      useRawValueToEscape: r,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: m,
      nestingSuffix: h,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: g,
      maxReplaces: y,
      alwaysFormat: b
    } = n.interpolation;
    this.escape = a !== void 0 ? a : sc, this.escapeValue = e !== void 0 ? e : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = i ? Ba(i) : o || "{{", this.suffix = s ? Ba(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? Ba(p) : m || Ba("$t("), this.nestingSuffix = h ? Ba(h) : f || Ba(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = y || 1e3, this.alwaysFormat = b !== void 0 ? b : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const n = (a, e) => a && a.source === e ? (a.lastIndex = 0, a) : new RegExp(e, "g");
    this.regexp = n(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = n(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = n(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(n, a, e, r) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const y = zr(a, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(y, void 0, e, {
          ...r,
          ...a,
          interpolationkey: m
        }) : y;
      }
      const h = m.split(this.formatSeparator), f = h.shift().trim(), g = h.join(this.formatSeparator).trim();
      return this.format(zr(a, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), g, e, {
        ...r,
        ...a,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler, d = r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => Cn(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? Cn(this.escape(m)) : Cn(m)
    }].forEach((m) => {
      for (s = 0; i = m.regex.exec(n); ) {
        const h = i[1].trim();
        if (o = c(h), o === void 0)
          if (typeof u == "function") {
            const g = u(n, i, r);
            o = Y(g) ? g : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, h))
            o = "";
          else if (d) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${n}`), o = "";
        else !Y(o) && !this.useRawValueToEscape && (o = Br(o));
        const f = m.safeValue(o);
        if (n = n.replace(i[0], f), d ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= i[0].length) : m.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), n;
  }
  nest(n, a) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, i, o;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, o);
      const m = p.match(/'/g), h = p.match(/"/g);
      (m && m.length % 2 === 0 && !h || h.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), c && (o = {
          ...c,
          ...o
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; r = this.nestingRegexp.exec(n); ) {
      let l = [];
      o = {
        ...e
      }, o = o.replace && !Y(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let c = !1;
      if (r[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(r[1])) {
        const u = r[1].split(this.formatSeparator).map((d) => d.trim());
        r[1] = u.shift(), l = u, c = !0;
      }
      if (i = a(s.call(this, r[1].trim(), o), o), i && r[0] === n && !Y(i)) return i;
      Y(i) || (i = Br(i)), i || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${n}`), i = ""), c && (i = l.reduce((u, d) => this.format(u, d, e.lng, {
        ...e,
        interpolationkey: r[1].trim()
      }), i.trim())), n = n.replace(r[0], i), this.regexp.lastIndex = 0;
    }
    return n;
  }
}
const vc = (t) => {
  let n = t.toLowerCase().trim();
  const a = {};
  if (t.indexOf("(") > -1) {
    const e = t.split("(");
    n = e[0].toLowerCase().trim();
    const r = e[1].substring(0, e[1].length - 1);
    n === "currency" && r.indexOf(":") < 0 ? a.currency || (a.currency = r.trim()) : n === "relativetime" && r.indexOf(":") < 0 ? a.range || (a.range = r.trim()) : r.split(";").forEach((o) => {
      if (o) {
        const [s, ...l] = o.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        a[u] || (a[u] = c), c === "false" && (a[u] = !1), c === "true" && (a[u] = !0), isNaN(c) || (a[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: n,
    formatOptions: a
  };
}, Ra = (t) => {
  const n = {};
  return (a, e, r) => {
    let i = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (i = {
      ...i,
      [r.interpolationkey]: void 0
    });
    const o = e + JSON.stringify(i);
    let s = n[o];
    return s || (s = t(jt(e), r), n[o] = s), s(a);
  };
};
class Sc {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = je.create("formatter"), this.options = n, this.formats = {
      number: Ra((a, e) => {
        const r = new Intl.NumberFormat(a, {
          ...e
        });
        return (i) => r.format(i);
      }),
      currency: Ra((a, e) => {
        const r = new Intl.NumberFormat(a, {
          ...e,
          style: "currency"
        });
        return (i) => r.format(i);
      }),
      datetime: Ra((a, e) => {
        const r = new Intl.DateTimeFormat(a, {
          ...e
        });
        return (i) => r.format(i);
      }),
      relativetime: Ra((a, e) => {
        const r = new Intl.RelativeTimeFormat(a, {
          ...e
        });
        return (i) => r.format(i, e.range || "day");
      }),
      list: Ra((a, e) => {
        const r = new Intl.ListFormat(a, {
          ...e
        });
        return (i) => r.format(i);
      })
    }, this.init(n);
  }
  init(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = a.interpolation.formatSeparator || ",";
  }
  add(n, a) {
    this.formats[n.toLowerCase().trim()] = a;
  }
  addCached(n, a) {
    this.formats[n.toLowerCase().trim()] = Ra(a);
  }
  format(n, a, e) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((s) => s.indexOf(")") > -1)) {
      const s = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, s)].join(this.formatSeparator);
    }
    return i.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = vc(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const p = r && r.formatParams && r.formatParams[r.interpolationkey] || {}, m = p.locale || p.lng || r.locale || r.lng || e;
          d = this.formats[c](s, m, {
            ...u,
            ...r,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, n);
  }
}
const kc = (t, n) => {
  t.pending[n] !== void 0 && (delete t.pending[n], t.pendingCount--);
};
class Mc extends cn {
  constructor(n, a, e) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = n, this.store = a, this.services = e, this.languageUtils = e.languageUtils, this.options = r, this.logger = je.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(e, r.backend, r);
  }
  queueLoad(n, a, e, r) {
    const i = {}, o = {}, s = {}, l = {};
    return n.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const p = `${c}|${d}`;
        !e.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, u = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(n, a, e) {
    const r = n.split("|"), i = r[0], o = r[1];
    a && this.emit("failedLoading", i, o, a), !a && e && this.store.addResourceBundle(i, o, e, void 0, void 0, {
      skipCopy: !0
    }), this.state[n] = a ? -1 : 2, a && e && (this.state[n] = 0);
    const s = {};
    this.queue.forEach((l) => {
      rc(l.loaded, [i], o), kc(l, n), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(n, a, e) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!n.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: n,
        ns: a,
        fcName: e,
        tried: r,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, n, a, e, r + 1, i * 2, o);
        }, i);
        return;
      }
      o(c, u);
    }, l = this.backend[e].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(n, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(n, a, s);
  }
  prepareLoading(n, a) {
    let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    Y(n) && (n = this.languageUtils.toResolveHierarchy(n)), Y(a) && (a = [a]);
    const i = this.queueLoad(n, a, e, r);
    if (!i.toLoad.length)
      return i.pending.length || r(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(n, a, e) {
    this.prepareLoading(n, a, {}, e);
  }
  reload(n, a, e) {
    this.prepareLoading(n, a, {
      reload: !0
    }, e);
  }
  loadOne(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const e = n.split("|"), r = e[0], i = e[1];
    this.read(r, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${a}loading namespace ${i} for language ${r} failed`, o), !o && s && this.logger.log(`${a}loaded namespace ${i} for language ${r}`, s), this.loaded(n, o, s);
    });
  }
  saveMissing(n, a, e, r, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${e}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(e == null || e === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(n, a, e, r, l) : u = c(n, a, e, r), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(n, a, e, r, s, l);
      }
      !n || !n[0] || this.store.addResource(n[0], a, e, r);
    }
  }
}
const Vr = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let n = {};
    if (typeof t[1] == "object" && (n = t[1]), Y(t[1]) && (n.defaultValue = t[1]), Y(t[2]) && (n.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const a = t[3] || t[2];
      Object.keys(a).forEach((e) => {
        n[e] = a[e];
      });
    }
    return n;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Ur = (t) => (Y(t.ns) && (t.ns = [t.ns]), Y(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), Y(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t), Pt = () => {
}, wc = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((a) => {
    typeof t[a] == "function" && (t[a] = t[a].bind(t));
  });
};
class mt extends cn {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Ur(n), this.services = {}, this.logger = je, this.modules = {
      external: []
    }, wc(this), a && !this.isInitialized && !n.isClone) {
      if (!this.options.initImmediate)
        return this.init(n, a), this;
      setTimeout(() => {
        this.init(n, a);
      }, 0);
    }
  }
  init() {
    var n = this;
    let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof a == "function" && (e = a, a = {}), !a.defaultNS && a.defaultNS !== !1 && a.ns && (Y(a.ns) ? a.defaultNS = a.ns : a.ns.indexOf("translation") < 0 && (a.defaultNS = a.ns[0]));
    const r = Vr();
    this.options = {
      ...r,
      ...this.options,
      ...Ur(a)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...r.interpolation,
      ...this.options.interpolation
    }), a.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = a.keySeparator), a.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = a.nsSeparator);
    const i = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? je.init(i(this.modules.logger), this.options) : je.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = Sc);
      const d = new Kr(this.options);
      this.store = new Gr(this.options.resources, this.options);
      const p = this.services;
      p.logger = je, p.resourceStore = this.store, p.languageUtils = d, p.pluralResolver = new yc(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === r.interpolation.format) && (p.formatter = i(u), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new bc(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new Mc(i(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(m) {
        for (var h = arguments.length, f = new Array(h > 1 ? h - 1 : 0), g = 1; g < h; g++)
          f[g - 1] = arguments[g];
        n.emit(m, ...f);
      }), this.modules.languageDetector && (p.languageDetector = i(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = i(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new Wt(this.services, this.options), this.translator.on("*", function(m) {
        for (var h = arguments.length, f = new Array(h > 1 ? h - 1 : 0), g = 1; g < h; g++)
          f[g - 1] = arguments[g];
        n.emit(m, ...f);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, e || (e = Pt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return n.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return n.store[u](...arguments), n;
      };
    });
    const l = Xa(), c = () => {
      const u = (d, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(p), e(d, p);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(n) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Pt;
    const r = Y(n) ? n : this.language;
    if (typeof n == "function" && (e = n), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return e();
      const i = [], o = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      r ? o(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((s) => o(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), e(s);
      });
    } else
      e(null);
  }
  reloadResources(n, a, e) {
    const r = Xa();
    return typeof n == "function" && (e = n, n = void 0), typeof a == "function" && (e = a, a = void 0), n || (n = this.languages), a || (a = this.options.ns), e || (e = Pt), this.services.backendConnector.reload(n, a, (i) => {
      r.resolve(), e(i);
    }), r;
  }
  use(n) {
    if (!n) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!n.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return n.type === "backend" && (this.modules.backend = n), (n.type === "logger" || n.log && n.warn && n.error) && (this.modules.logger = n), n.type === "languageDetector" && (this.modules.languageDetector = n), n.type === "i18nFormat" && (this.modules.i18nFormat = n), n.type === "postProcessor" && ao.addPostProcessor(n), n.type === "formatter" && (this.modules.formatter = n), n.type === "3rdParty" && this.modules.external.push(n), this;
  }
  setResolvedLanguage(n) {
    if (!(!n || !this.languages) && !(["cimode", "dev"].indexOf(n) > -1))
      for (let a = 0; a < this.languages.length; a++) {
        const e = this.languages[a];
        if (!(["cimode", "dev"].indexOf(e) > -1) && this.store.hasLanguageSomeTranslations(e)) {
          this.resolvedLanguage = e;
          break;
        }
      }
  }
  changeLanguage(n, a) {
    var e = this;
    this.isLanguageChangingTo = n;
    const r = Xa();
    this.emit("languageChanging", n);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, r.resolve(function() {
        return e.t(...arguments);
      }), a && a(l, function() {
        return e.t(...arguments);
      });
    }, s = (l) => {
      !n && !l && this.services.languageDetector && (l = []);
      const c = Y(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        o(u, c);
      });
    };
    return !n && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !n && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(n), r;
  }
  getFixedT(n, a, e) {
    var r = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = r.options.overloadTranslationOptionHandler([o, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || e || i.keyPrefix);
      const p = r.options.keySeparator || ".";
      let m;
      return l.keyPrefix && Array.isArray(o) ? m = o.map((h) => `${l.keyPrefix}${p}${h}`) : m = l.keyPrefix ? `${l.keyPrefix}${p}${o}` : o, r.t(m, l);
    };
    return Y(n) ? i.lng = n : i.lngs = n, i.ns = a, i.keyPrefix = e, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(n) {
    this.options.defaultNS = n;
  }
  hasLoadedNamespace(n) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const e = a.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (e.toLowerCase() === "cimode") return !0;
    const o = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, o);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(e, n) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(e, n) && (!r || o(i, n)));
  }
  loadNamespaces(n, a) {
    const e = Xa();
    return this.options.ns ? (Y(n) && (n = [n]), n.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      e.resolve(), a && a(r);
    }), e) : (a && a(), Promise.resolve());
  }
  loadLanguages(n, a) {
    const e = Xa();
    Y(n) && (n = [n]);
    const r = this.options.preload || [], i = n.filter((o) => r.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = r.concat(i), this.loadResources((o) => {
      e.resolve(), a && a(o);
    }), e) : (a && a(), Promise.resolve());
  }
  dir(n) {
    if (n || (n = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !n) return "rtl";
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], e = this.services && this.services.languageUtils || new Kr(Vr());
    return a.indexOf(e.getLanguagePartFromCode(n)) > -1 || n.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    return new mt(n, a);
  }
  cloneInstance() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Pt;
    const e = n.forkResourceStore;
    e && delete n.forkResourceStore;
    const r = {
      ...this.options,
      ...n,
      isClone: !0
    }, i = new mt(r);
    return (n.debug !== void 0 || n.prefix !== void 0) && (i.logger = i.logger.clone(n)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, e && (i.store = new Gr(this.store.data, r), i.services.resourceStore = i.store), i.translator = new Wt(i.services, r), i.translator.on("*", function(s) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      i.emit(s, ...c);
    }), i.init(r, a), i.translator.options = r, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const G = mt.createInstance();
G.createInstance = mt.createInstance;
G.createInstance;
G.dir;
G.init;
G.loadResources;
G.reloadResources;
G.use;
G.changeLanguage;
G.getFixedT;
G.t;
G.exists;
G.setDefaultNamespace;
G.hasLoadedNamespace;
G.loadNamespaces;
G.loadLanguages;
var Z = /* @__PURE__ */ ((t) => (t.FRENCH = "fr", t.ENGLISH = "en", t.SPANISH = "es", t.ITALIAN = "it", t.PORTUGUESE = "pt", t.DEUTSCH = "de", t.DUTCH = "nl", t.RUSSIAN = "ru", t.JAPANESE = "ja", t.ARABIC = "ar", t.TURKISH = "tr", t.CHINESE = "zh", t.SWEDISH = "sv", t.ROMANIAN = "ro", t.CZECH = "cs", t.HUNGARIAN = "hu", t.SLOVAK = "sk", t.DANISH = "da", t.INDONESIAN = "id", t.POLISH = "pl", t.GREEK = "el", t.SERBIAN = "sr", t.NORWEGIAN = "no", t.THAI = "th", t.SLOVENIAN = "sl", t.UKRAINIAN = "uk", t.ALBANIA = "sq", t.HINDI = "hi", t))(Z || {});
const Cc = { affiliate_badge: { made_with: "يعمل بواسطة" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات", trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم", trial_period_price: "مجانا", unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}" } } }, contact_slug: { city: "المدينة", company_name: "اسم الشركة", country: "البلد", email: "البريد الإلكتروني", first_name: "الاسم", last_name: "اسم العائلة", neighborhood: "الحي", phone_number: "رقم الهاتف", postal_code: "الرمز البريدي", state_province: "الولاية/المقاطعة", street_address: "عنوان الشارع", street_number: "رقم الشارع", tax_number: "الرقم الضريبي" }, copy_clipboard: "تم النسخ في الحافظة", copy_clipboard_error: "فشل في نسخ النص", date_picker: { all_time: "كل الوقت", apply: "تطبيق", clear: "إزالة", from: "من", last_3_months: "آخر 3 أشهر", last_30_days: "آخر 30 يوم", last_month: "الشهر الفائت", last_pool_period: "فترة التقييم الأخيرة للمجموعة", this_month: "هذا الشهر", time: "الوقت", title_dates: "تواريخ", to: "إلى" }, error: "خطأ", form_select: { empty_list: "يبدو أن هذه القائمة فارغة", select: "حدد" }, including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})", input: { phone_number: "رقم الهاتف", phone_search: "بحث", search: "بحث" }, locale: { albania: "الألبانية", arabic: "العربية", chinese: "الصينية", czech: "التشيكية", danish: "الدانماركية", dutch: "هولندية", english: "إنجليزية", french: "فرنسية", german: "ألمانية", greek: "اليونانية", hindi: "الهندية", hungarian: "الهنغارية", indonesian: "الأندونيسية", italian: "ايطالية", japanese: "اليابانية", norwegian: "النرويجية", polish: "البولندية", portuguese: "البرتغالية", romanian: "الرومانية", russian: "الروسية", serbian: "الصربية", slovak: "السلوفاكية", slovenian: "السلوفينية", spanish: "الإسبانية", swedish: "السويدية", thai: "التايلندية", turkish: "التركية", ukrainian: "الأوكرانية" }, order_summary: "ملخص الطلب", payment: { cash_on_delivery: "الدفع عند الاستلام", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "بطاقات الائتمان (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "بطاقات الائتمان (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "mollie", paypal_connect: "ربط paypal", paypal_edit_organization_name: "تعديل اسم المنظمة", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "بطاقات الإئتمان (Paystack)", price_plan: "عرض", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "بطاقة ائتمان أو خصم", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "كلارنا (سترايب)", stripe_multibanco: "موتي بانكو (سترايب)", xendit: { "3ds": "3D-Secure" }, xendit_card: "بطاقات الائتمان (Xendit)" }, payment_inputs: { card_holder_placeholder: "حامل البطاقة", card_number_placeholder: "رقم البطاقة", cvc_placeholder: "رمز التحقق", date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي", empty_card_holder: "أدخل اسم حامل البطاقة", empty_card_number: "أدخل رقم البطاقة", empty_cvc: "أدخل رمز التحقق", empty_expiry_date: "أدخل تاريخ الانتهاء", expiry_data_placeholder: "الشهر/السنة", invalid_card_number: "رقم البطاقة غير صالح", invalid_cvc: "رمز التحقق غير صالح", invalid_expiry_date: "تاريخ الانتهاء غير صالح", month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12", year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي" }, "Payment-method": "طريقة دفع", price_plan: { interval: { day_0: "{{count}} يوم", day_1: "يوم {{count}}", day_2: "يومين {{count}}", day_3: "{{count}} أيام", day_4: "{{count}} يوم", day_5: "{{count}} يوم", month_0: "{{count}} شهر", month_1: "شهر {{count}}", month_2: "شهرين {{count}}", month_3: "{{count}} أشهر", month_4: "{{count}} شهر", month_5: "{{count}} شهر", week_0: "{{count}} أسبوع", week_1: "أسبوع {{count}}", week_2: "أسبوعين {{count}}", week_3: "{{count}} أسابيع", week_4: "{{count}} أسبوع", week_5: "{{count}} أسبوع", year_0: "{{count}} سنة", year_1: "سنة {{count}}", year_2: "سنتان{{count}}", year_3: "{{count}} سنوات", year_4: "{{count}} سنة", year_5: "{{count}} سنة" }, trial_period: { day_0: "{{count}} يوم", day_1: "يوم {{count}}", day_2: "يومين {{count}}", day_3: "{{count}} أيام", day_4: "{{count}} يوم", day_5: "{{count}} يوم", month_0: "{{count}} شهر", month_1: "شهر{{count}}", month_2: "شهربن {{count}}", month_3: "{{count}} أشهر", month_4: "{{count}} شهر", month_5: "{{count}} شهر", week_0: "{{count}} أسبوع", week_1: "أسبوع {{count}}", week_2: "أسبوعين {{count}}", week_3: "{{count}} أسابيع", week_4: "{{count}} أسبوع", week_5: "{{count}} أسبوع", year_0: "{{count}} سنة", year_1: "سنة {{count}}", year_2: "سنتان {{count}}", year_3: "{{count}} سنوات", year_4: "{{count}} سنة", year_5: "{{count}} سنة" } }, product: "منتج", quantity: "الكمية", "registered-over": "مسجل أكثر من", "required-field": "الحقل مطلوب", shipping: { condition_label: { price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}", price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر", quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر", quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر", weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام", weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر" }, not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.", shipping_method: "طريقة الشحن" }, shipping_fee: "رسوم الشحن", subtotal: "المجموع الفرعي", total: "المجموع", total_amount_with_shipping: "المجموع (شامل الشحن)", total_amount_with_tax: "المجموع (شامل الضرائب)", total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)", vat: "ضريبة المبيعات", vat_percent: "ضريبة المبيعات ({{percent}}%)" }, Dc = {
  public_pages_purchase: Cc
}, Pc = { affiliate_badge: { made_with: "Vytvořeno v" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát", trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak", trial_period_price: "Zdarma", unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}" } } }, contact_slug: { city: "Město", company_name: "Název společnosti", country: "Země", email: "E-mail", first_name: "Jméno", last_name: "Příjmení", neighborhood: "Čtvrť", phone_number: "Telefonní číslo", postal_code: "PSČ", state_province: "Stát/Provincie", street_address: "Ulice", street_number: "Číslo ulice", tax_number: "DIČ" }, copy_clipboard: "Zkopírováno do schránky", copy_clipboard_error: "Kopírování textu se nezdařilo", date_picker: { all_time: "Celý čas", apply: "Použít", clear: "Vymazat", from: "Z", last_3_months: "Poslední 3 měsíce", last_30_days: "Posledních 30 dní", last_month: "Minulý měsíc", last_pool_period: "Poslední hodnotící období", this_month: "Tento měsíc", time: "Čas", title_dates: "Data", to: "Do" }, error: "Chyba", form_select: { empty_list: "Vypadá to, že tento seznam je prázdný", select: "Vybrat" }, including_tax: "Včetně DPH {{percent}} % ({{amount}})", input: { phone_number: "Telefonní číslo", phone_search: "Hledat", search: "Hledat" }, locale: { albania: "Albánština", arabic: "Arabština", chinese: "Čínština", czech: "Čeština", danish: "Dánština", dutch: "Holandský", english: "Angličtina", french: "Francouzština", german: "Němčina", greek: "Řečtina", hindi: "Hindi", hungarian: "Maďarský", indonesian: "Indonéština", italian: "Italština", japanese: "Japonština", norwegian: "Norština", polish: "Polština", portuguese: "Portugalština", romanian: "Rumunština", russian: "Ruština", serbian: "Srbština", slovak: "Slovenština", slovenian: "Slovinský", spanish: "Španělština", swedish: "Švédnština", thai: "Thajština", turkish: "Turečtina", ukrainian: "Ukrajinština" }, order_summary: "Shrnutí objednávky", payment: { cash_on_delivery: "Dobírka", dlocal_boleto: "Boleto (místní)", dlocal_card: "Kreditní karty (místní)", dlocal_pix: "Pix (místní)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditní karty (Mercado Pago)", mercadopago_pix: "PIX (Platební trh)", mollie: "Mollie", paypal_connect: "Připojte PayPal", paypal_edit_organization_name: "Upravit název organizace", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditní karty (Paystack)", price_plan: "Plán", razorpay: "Razorpay", secure_and_pay: "Zabezpečte a zaplaťte", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kreditní nebo debetní karta", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditní karty (Xendit)" }, payment_inputs: { card_holder_placeholder: "Držitel karty", card_number_placeholder: "Číslo karty", cvc_placeholder: "CVC", date_out_of_range: "Datum expirace nemůže být v minulosti", empty_card_holder: "Zadejte jméno držitele karty", empty_card_number: "Zadejte číslo karty", empty_cvc: "Zadejte CVC", empty_expiry_date: "Zadejte datum expirace", expiry_data_placeholder: "MM/YY", invalid_card_number: "Číslo karty je neplatné", invalid_cvc: "CVC je neplatné", invalid_expiry_date: "Datum expirace je neplatné", month_out_of_range: "Měsíc expirace musí být mezi 01 a 12", year_out_of_range: "Rok expirace nemůže být v minulosti" }, "Payment-method": "Platební metoda", price_plan: { interval: { day_0: "den", day_1: "{{count}} dnů", day_2: "{{count}} dnů", month_0: "měsíc", month_1: "{{count}} měsíců", month_2: "{{count}} měsíců", week_0: "týden", week_1: "{{count}} týdnů", week_2: "{{count}} týdnů", year_0: "rok", year_1: "{{count}} let", year_2: "{{count}} let" }, trial_period: { day_0: "{{count}} den", day_1: "{{count}} dny", day_2: "{{count}} dní", month_0: "{{count}} měsíc", month_1: "{{count}} měsíců", month_2: "{{count}} měsíců", week_0: "{{count}} týden", week_1: "{{count}} týdnů", week_2: "{{count}} týdnů", year_0: "{{count}} rok", year_1: "{{count}} let", year_2: "{{count}} let" } }, product: "Produkt", quantity: "Množství", "registered-over": "registrovaných přes", "required-field": "Pole je povinné", shipping: { condition_label: { price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}", price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více", quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami", quantity_min: "Pro objednávky obsahující {{min}} nebo více položek", weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g", weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více" }, not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.", shipping_method: "Způsob dopravy" }, shipping_fee: "Poplatek za dopravu", subtotal: "Mezisoučet", total: "Celkem", total_amount_with_shipping: "Celkem (včetně dopravy)", total_amount_with_tax: "Celkem (včetně daně)", total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)", vat: "Daň z prodeje", vat_percent: "Daň z prodeje ({{percent}}%)" }, Ac = {
  public_pages_purchase: Pc
}, Nc = { affiliate_badge: { made_with: "Støttet af" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}" } } }, contact_slug: { city: "By", company_name: "Firmanavn", country: "Land", email: "E-mail", first_name: "Fornavn", last_name: "Efternavn", neighborhood: "Kvarter", phone_number: "Telefonnummer", postal_code: "Postnummer", state_province: "stat/provins", street_address: "Gadeadresse", street_number: "Gadenummer", tax_number: "Skattenummer" }, copy_clipboard: "Kopieret til udklipsholder", copy_clipboard_error: "Teksten kunne ikke kopieres", date_picker: { all_time: "Hele tiden", apply: "Anvende", clear: "Slet", from: "Fra", last_3_months: "Sidste 3 måneder", last_30_days: "Sidste 30 dage", last_month: "Sidste måned", last_pool_period: "Sidste puljeevalueringsperiode", this_month: "Denne måned", time: "Tid", title_dates: "Datoer", to: "Til" }, error: "Fejl", form_select: { empty_list: "Det ser ud til, at denne liste er tom", select: "Vælge" }, including_tax: "Inkluderer {{percent}} % moms ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Søge", search: "Søge" }, locale: { albania: "Albansk", arabic: "Arabisk", chinese: "Kinesisk", czech: "Tjekkisk", danish: "Dansk", dutch: "Hollandsk", english: "Engelsk", french: "Fransk", german: "Tysk", greek: "Græsk", hindi: "Hindi", hungarian: "Ungarsk", indonesian: "Indonesisk", italian: "Italiensk", japanese: "Japansk", norwegian: "Norsk", polish: "Polsk", portuguese: "Portugisisk", romanian: "Rumænsk", russian: "Russisk", serbian: "Serbisk", slovak: "Slovakisk", slovenian: "Slovensk", spanish: "Spansk", swedish: "Svensk", thai: "Thai", turkish: "Tyrkisk", ukrainian: "Ukrainsk" }, order_summary: "Ordreoversigt", payment: { cash_on_delivery: "Kontant ved levering", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditkort (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditkort (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Tilslut PayPal", paypal_edit_organization_name: "Rediger organisationens navn", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditkort (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kredit- eller betalingskort", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditkort (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kortholder", card_number_placeholder: "Kortnummer", cvc_placeholder: "CVC", date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden", empty_card_holder: "Indtast et kortholdernavn", empty_card_number: "Indtast et kortnummer", empty_cvc: "Indtast en CVC", empty_expiry_date: "Indtast en udløbsdato", expiry_data_placeholder: "MM/ÅÅ", invalid_card_number: "Kortnummeret er ugyldigt", invalid_cvc: "CVC er ugyldig", invalid_expiry_date: "Udløbsdatoen er ugyldig", month_out_of_range: "Udløbsmåned skal være mellem 01 og 12", year_out_of_range: "Udløbsåret må ikke ligge i fortiden" }, "Payment-method": "Betalingsmetode", price_plan: { interval: { day: "dag", day_plural: "{{count}} dage", month: "måned", month_plural: "{{count}} måneder", week: "uge", week_plural: "{{count}} uger", year: "år", year_plural: "{{count}} år" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dage", month: "{{count}} måned", month_plural: "{{count}} måneder", week: "{{count}} uge", week_plural: "{{count}} uger", year: "{{count}} år", year_plural: "{{count}} år" } }, product: "Produkt", quantity: "Mængde", "registered-over": "registreret over", "required-field": "Feltet er påkrævet", shipping: { condition_label: { price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}", price_min: "For ordrer prissat til {{min}} {{currency}} eller mere", quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer", quantity_min: "For ordrer indeholdende {{min}} eller flere varer", weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g", weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere" }, not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.", shipping_method: "Forsendelsesmetode" }, shipping_fee: "Forsendelsesgebyr", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (inklusive forsendelse)", total_amount_with_tax: "Total (inkl. skat)", total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)", vat: "Salgsskat", vat_percent: "Moms ({{percent}} %)" }, Tc = {
  public_pages_purchase: Nc
}, Ic = { affiliate_badge: { made_with: "Unterstützt von" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal", trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann", trial_period_price: "Kostenlos", unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}" } } }, contact_slug: { city: "Stadt", company_name: "Firmenname", country: "Land", email: "E-Mail", first_name: "Vorname", last_name: "Nachname", neighborhood: "Nachbarschaft", phone_number: "Telefonnummer", postal_code: "Postleitzahl", state_province: "Bundesland/Provinz", street_address: "Straßenadresse", street_number: "Hausnummer", tax_number: "Steuernummer" }, copy_clipboard: "In die Zwischenablage kopiert", copy_clipboard_error: "Text konnte nicht kopiert werden", date_picker: { all_time: "Alle Zeiten", apply: "Anwenden", clear: "Löschen", from: "Von", last_3_months: "Letzte 3 Monate", last_30_days: "Letzte 30 Tage", last_month: "Letzter Monat", last_pool_period: "Letzter Pool-Auswertungszeitraum", this_month: "Dieser Monat", time: "Zeit", title_dates: "Termine", to: "Nach" }, error: "Fehler", form_select: { empty_list: "Es sieht so aus, als wäre diese Liste leer", select: "Auswählen" }, including_tax: "Enthält {{percent}} % MwSt. ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Suchen", search: "Suchen" }, locale: { albania: "Albanisch", arabic: "Arabisch", chinese: "Chinesisch", czech: "Tschechisch", danish: "Dänisch", dutch: "Niederländisch", english: "Englisch", french: "Französisch", german: "Deutsch", greek: "Griechisch", hindi: "Hindi", hungarian: "Ungarisch", indonesian: "Indonesisch", italian: "Italienisch", japanese: "Japanisch", norwegian: "Norwegisch", polish: "Polnisch", portuguese: "Portugiesisch", romanian: "Rumänisch", russian: "Russisch", serbian: "Serbisch", slovak: "Slowakisch", slovenian: "Slowenisch", spanish: "Spanisch", swedish: "Schwedisch", thai: "Thailändisch", turkish: "Türkisch", ukrainian: "Ukrainisch" }, order_summary: "Bestellübersicht", payment: { cash_on_delivery: "Lieferung per Nachnahme", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditkarten (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditkarten (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "PayPal verbinden", paypal_edit_organization_name: "Organisationsnamen bearbeiten", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditkarten (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kredit- oder Debitkarte", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditkarten (Xendit)" }, payment_inputs: { card_holder_placeholder: "Karteninhaber", card_number_placeholder: "Kartennummer", cvc_placeholder: "CVC", date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen", empty_card_holder: "Name des Karteninhabers eingeben", empty_card_number: "Eine Kartennummer eingeben", empty_cvc: "Einen CVC eingeben", empty_expiry_date: "Geben Sie ein Verfallsdatum ein", expiry_data_placeholder: "MM/JJ", invalid_card_number: "Kartennummer ist ungültig", invalid_cvc: "CVC ist ungültig", invalid_expiry_date: "Verfallsdatum ist ungültig", month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen", year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen" }, "Payment-method": "Zahlungsmethode", price_plan: { interval: { day: "Tag", day_plural: "{{count}} Tage", month: "Monat", month_plural: "{{count}} Monate", week: "Woche", week_plural: "{{count}} Wochen", year: "Jahr", year_plural: "{{count}} Jahre" }, trial_period: { day: "{{count}} Tag", day_plural: "{{count}} Tage", month: "{{count}} Monat", month_plural: "{{count}} Monate", week: "{{count}} Woche", week_plural: "{{count}} Wochen", year: "{{count}} Jahr", year_plural: "{{count}} Jahre" } }, product: "Produkt", quantity: "Menge", "registered-over": "registriert über", "required-field": "Das Feld ist erforderlich", shipping: { condition_label: { price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}", price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr", quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln", quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln", weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g", weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr" }, not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.", shipping_method: "Versandmethode" }, shipping_fee: "Versandgebühr", subtotal: "Zwischensumme", total: "Gesamt", total_amount_with_shipping: "Gesamtbetrag (einschließlich Versand)", total_amount_with_tax: "Gesamtbetrag (inkl. Steuern)", total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)", vat: "Mehrwertsteuer", vat_percent: "Umsatzsteuer ({{percent}} %)" }, xc = {
  public_pages_purchase: Ic
}, Ec = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές", trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα", trial_period_price: "Δωρεάν", unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}" } } }, contact_slug: { city: "Πόλη", company_name: "Επωνυμία εταιρίας", country: "Χώρα", email: "Email", first_name: "Όνομα", last_name: "Επώνυμο", neighborhood: "Γειτονιά", phone_number: "Τηλέφωνο", postal_code: "Ταχυδρομικός κώδικας", state_province: "Νομός", street_address: "Διεύθυνση", street_number: "Αριθμός οδού", tax_number: "Α.Φ.Μ." }, copy_clipboard: "Επιτυχής αντιγραφή", copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου", date_picker: { all_time: "Συνολικά", apply: "Υποβολή", clear: "Επαναφορά", from: "Από", last_3_months: "Τελευταίοι 3 μήνες", last_30_days: "Τελευταίες 30 ημέρες", last_month: "Προηγούμενος μήνας", last_pool_period: "Τελευταία περίοδος αξιολόγησης email", this_month: "Αυτό το μήνα", time: "Χρόνος", title_dates: "Ημερομηνίες", to: "Προς" }, error: "Σφάλμα", form_select: { empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή", select: "Επιλογή" }, including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})", input: { phone_number: "Τηλέφωνο", phone_search: "Αναζήτηση", search: "Αναζήτηση" }, locale: { albania: "Αλβανικά", arabic: "Αραβικά", chinese: "Κινέζικα", czech: "Τσέχικα", danish: "Δανικά", dutch: "Ολλανδικά", english: "Αγγλικά", french: "Γαλλικά", german: "Γερμανικά", greek: "Ελληνικά", hindi: "Ινδικά", hungarian: "Ουγγρικά", indonesian: "Ινδονησιακά", italian: "Ιταλικά", japanese: "Ιαπωνικά", norwegian: "Νορβηγικά", polish: "Πολωνικά", portuguese: "Πορτογαλικά", romanian: "Ρουμανικά", russian: "Ρωσικά", serbian: "Σερβικά", slovak: "Σλοβάκικα", slovenian: "Σλοβενικά", spanish: "Ισπανικά", swedish: "Σουηδικά", thai: "Ταϊλανδέζικα", turkish: "Τούρκικα", ukrainian: "Ουκρανικά" }, order_summary: "Σύνοψη Παραγγελίας", payment: { cash_on_delivery: "Με αντικαταβολή", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Τραπεζικές κάρτες (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Σύνδεση με PayPal", paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Τραπεζικές κάρτες (Paystack)", price_plan: "Πλάνο", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Πιστωτική ή χρεωστική κάρτα", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Κλάρνα (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Τραπεζικές κάρτες (Xendit)" }, payment_inputs: { card_holder_placeholder: "Κάτοχος κάρτας", card_number_placeholder: "Αριθμός κάρτας", cvc_placeholder: "CVC", date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν", empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας", empty_card_number: "Εισάγετε έναν αριθμό κάρτας", empty_cvc: "Εισάγετε το CVC", empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης", expiry_data_placeholder: "ΜΜ/ΕΕ", invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος", invalid_cvc: "Το CVC είναι μη έγκυρο", invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη", month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12", year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν" }, "Payment-method": "Τρόπος πληρωμής", price_plan: { interval: { day: "ημέρα", day_plural: "{{count}} ημέρες", month: "μήνας", month_plural: "{{count}} μήνες", week: "εβδομάδα", week_plural: "{{count}} εβδομάδες", year: "έτος", year_plural: "{{count}} έτη" }, trial_period: { day: "{{count}} ημέρα", day_plural: "{{count}} ημέρες", month: "{{count}} μήνας", month_plural: "{{count}} μήνες", week: "{{count}} εβδομάδα", week_plural: "{{count}} εβδομάδες", year: "{{count}} έτος", year_plural: "{{count}} έτη" } }, product: "Προϊόν", quantity: "Ποσότητα", "registered-over": "εγγεγραμμένο πάνω από", "required-field": "Το πεδίο είναι υποχρεωτικό", shipping: { condition_label: { price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}", price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}", quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα", quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα", weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g", weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g" }, not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη", shipping_method: "Τρόπος αποστολής" }, shipping_fee: "Χρέωση αποστολής", subtotal: "Μερικό σύνολο", total: "Σύνολο", total_amount_with_shipping: "Σύνολο (συμπεριλαμβανομένων των μεταφορικών)", total_amount_with_tax: "Σύνολο (συμπεριλαμβανομένου φόρου)", total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)", vat: "Φόρος πωλήσεων", vat_percent: "ΦΠΑ ({{percent}}%)" }, Bc = {
  public_pages_purchase: Ec
}, Rc = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then", trial_period_price: "Free", unlimited_new: "<bold>{{amount}}</bold> every {{interval}}" } } }, contact_slug: { city: "City", company_name: "Company name", country: "Country", email: "Email", first_name: "First name", last_name: "Last name", neighborhood: "Neighborhood", phone_number: "Phone number", postal_code: "Postal code", state_province: "State/Province", street_address: "Street address", street_number: "Street number", tax_number: "Tax number" }, copy_clipboard: "Copied to clipboard", copy_clipboard_error: "Failed to copy text", date_picker: { all_time: "All time", apply: "Apply", clear: "Clear", from: "From", last_3_months: "Last 3 months", last_30_days: "Last 30 days", last_month: "Last month", last_pool_period: "Last pool evaluation period", this_month: "This month", time: "Time", title_dates: "Dates", to: "To" }, error: "Error", form_select: { empty_list: "It looks like this list is empty", select: "Select" }, including_tax: "Includes {{percent}}% VAT ({{amount}})", input: { phone_number: "Phone number", phone_search: "Search", search: "Search" }, locale: { albania: "Albanian", arabic: "Arabic", chinese: "Chinese", czech: "Czech", danish: "Danish", dutch: "Dutch", english: "English", french: "French", german: "German", greek: "Greek", hindi: "Hindi", hungarian: "Hungarian", indonesian: "Indonesian", italian: "Italiano", japanese: "Japanese", norwegian: "Norwegian", polish: "Polish", portuguese: "Portuguese", romanian: "Romanian", russian: "Russian", serbian: "Serbian", slovak: "Slovak", slovenian: "Slovenian", spanish: "Spanish", swedish: "Swedish", thai: "Thai", turkish: "Turkish", ukrainian: "Ukrainian" }, order_summary: "Order summary", payment: { cash_on_delivery: "Cash on delivery", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Credit cards (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Credit cards (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Connect PayPal", paypal_edit_organization_name: "Edit organization name", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Credit cards (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Credit or debit card", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Credit cards (Xendit)" }, payment_inputs: { card_holder_placeholder: "Card holder", card_number_placeholder: "Card number", cvc_placeholder: "CVC", date_out_of_range: "Expiry date cannot be in the past", empty_card_holder: "Enter a card holder name", empty_card_number: "Enter a card number", empty_cvc: "Enter a CVC", empty_expiry_date: "Enter an expiry date", expiry_data_placeholder: "MM/YY", invalid_card_number: "Card number is invalid", invalid_cvc: "CVC is invalid", invalid_expiry_date: "Expiry date is invalid", month_out_of_range: "Expiry month must be between 01 and 12", year_out_of_range: "Expiry year cannot be in the past" }, "Payment-method": "Payment method", price_plan: { interval: { day: "day", day_plural: "{{count}} days", month: "month", month_plural: "{{count}} months", week: "week", week_plural: "{{count}} weeks", year: "year", year_plural: "{{count}} years" }, trial_period: { day: "{{count}} day", day_plural: "{{count}} days", month: "{{count}} month", month_plural: "{{count}} months", week: "{{count}} week", week_plural: "{{count}} weeks", year: "{{count}} year", year_plural: "{{count}} years" } }, product: "Product", quantity: "Quantity", "registered-over": "registered over", "required-field": "Field is required", shipping: { condition_label: { price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}", price_min: "For orders priced at {{min}} {{currency}} or more", quantity: "For orders containing between {{min}} to {{max}} items", quantity_min: "For orders containing {{min}} or more items", weight: "For orders with a total weight between {{min}}g to {{max}}g", weight_min: "For orders with a total weight of {{min}}g or more" }, not_available: "Oops! It looks like we don't offer shipping to this location yet", shipping_method: "Shipping method" }, shipping_fee: "Shipping fee", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (including Shipping)", total_amount_with_tax: "Total (including tax)", total_amount_with_tax_and_shipping: "Total (including tax and Shipping)", vat: "Sales tax", vat_percent: "Sales tax ({{percent}}%)" }, Oc = {
  public_pages_purchase: Rc
}, Lc = { affiliate_badge: { made_with: "Desarrollado por" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces", trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}" } } }, contact_slug: { city: "Ciudad", company_name: "Nombre de la empresa", country: "País", email: "Correo", first_name: "Nombre", last_name: "Apellido", neighborhood: "Barrio", phone_number: "Número de teléfono", postal_code: "Código postal", state_province: "Estado/Provincia", street_address: "Dirección", street_number: "Dirección", tax_number: "Número de IVA" }, copy_clipboard: "Copiado en el portapapeles", copy_clipboard_error: "Error el copiar el texto", date_picker: { all_time: "Desde siempre", apply: "Aplicar", clear: "Borrar", from: "Desde", last_3_months: "Últimos 3 meses", last_30_days: "Últimos 30 días", last_month: "Último mes", last_pool_period: "Último periodo de evaluación de la pool", this_month: "Este mes", time: "Hola", title_dates: "Fechas", to: "Hasta" }, error: "Error", form_select: { empty_list: "Parece que esta lista está vacía", select: "Seleccionar" }, including_tax: "Incluye el {{percent}}% de IVA ({{amount}})", input: { phone_number: "Teléfono", phone_search: "Buscar", search: "Buscar" }, locale: { albania: "Albanés", arabic: "árabe", chinese: "Chino", czech: "Checo", danish: "Danés", dutch: "Holandés", english: "Inglés", french: "Francés", german: "Alemán", greek: "Griego", hindi: "Hindi", hungarian: "Húngaro", indonesian: "Indonesio", italian: "Italiano", japanese: "Japonés", norwegian: "Noruego", polish: "Polaco", portuguese: "Portugués", romanian: "Rumano", russian: "Ruso", serbian: "Serbio", slovak: "Eslovaco", slovenian: "Esloveno", spanish: "Español", swedish: "Sueco", thai: "Tailandés", turkish: "Turco", ukrainian: "Ucraniano" }, order_summary: "Resumen del pedido", payment: { cash_on_delivery: "Pago contra entrega", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Tarjetas de crédito (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Tarjetas de crédito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Conectar PayPal", paypal_edit_organization_name: "Editar el nombre de la organización", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Tarjetas de crédito (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Tarjeta de crédito o débito", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Tarjetas de crédito (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titular de la tarjeta", card_number_placeholder: "Número de tarjeta", cvc_placeholder: "CVC", date_out_of_range: "La fecha de expiración no puede estar situada en el pasado", empty_card_holder: "Ingresa el nombre del titular de la tarjeta", empty_card_number: "Ingresa un número de tarjeta", empty_cvc: "Ingresa un CVC", empty_expiry_date: "Ingresa la fecha de expiración", expiry_data_placeholder: "MM/AA", invalid_card_number: "El número de tarjeta no es válido", invalid_cvc: "El CVC no es válido", invalid_expiry_date: "La fecha de expiracion no es válida", month_out_of_range: "El mes de expiración debe estar entre 01 y 12", year_out_of_range: "El año de expiración no puede estar situado en el pasado" }, "Payment-method": "Método de pago", price_plan: { interval: { day: "día", day_plural: "{{count}} días", month: "mes", month_plural: "{{count}} meses", week: "semana", week_plural: "{{count}} semanas", year: "año", year_plural: "{{count}} años" }, trial_period: { day: "{{count}} día", day_plural: "{{count}} días", month: "{{count}} mes", month_plural: "{{count}} meses", week: "{{count}} semana", week_plural: "{{count}} semanas", year: "{{count}} año", year_plural: "{{count}} años" } }, product: "Producto", quantity: "Cantidad", "registered-over": "registrado hace más de", "required-field": "El campo es necesario", shipping: { condition_label: { price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}", price_min: "Para pedidos que cuesten {{min}} {{currency}} o más", quantity: "Para pedidos de entre {{min}} y {{max}} artículos", quantity_min: "Para pedidos con {{min}} o más artículos", weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g", weight_min: "Para pedidos con un peso total de {{min}}g o más" }, not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación", shipping_method: "Método de envío" }, shipping_fee: "Tarifa de envío", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (incluyendo envío)", total_amount_with_tax: "Total (IVA incluido)", total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)", vat: "IVA", vat_percent: "IVA ({{percent}}%)" }, Gc = {
  public_pages_purchase: Lc
}, Fc = { affiliate_badge: { made_with: "Développé par" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois", trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis", trial_period_price: "Gratuit", unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}" } } }, contact_slug: { city: "Ville", company_name: "Nom de l'entreprise", country: "Pays", email: "Email", first_name: "Prénom", last_name: "Nom", neighborhood: "Quartier", phone_number: "Numéro de téléphone", postal_code: "Code postal", state_province: "Région", street_address: "Adresse", street_number: "Numéro de rue", tax_number: "Numéro d'identification fiscale" }, copy_clipboard: "Copié dans le presse-papier", copy_clipboard_error: "Échec de la copie du texte", date_picker: { all_time: "Depuis le début", apply: "Appliquer", clear: "Effacer", from: "De", last_3_months: "Les 3 derniers mois", last_30_days: "Les 30 derniers jours", last_month: "Le mois dernier", last_pool_period: "Dernière période d'évaluation du pool", this_month: "Ce mois", time: "Horaire", title_dates: "Dates", to: "À" }, error: "Erreur", form_select: { empty_list: "Cette liste semble vide", select: "Sélectionner" }, including_tax: "Comprend {{percent}} % de TVA ({{amount}})", input: { phone_number: "Numéro de téléphone", phone_search: "Recherche", search: "Recherche" }, locale: { albania: "Albanais", arabic: "Аrabe", chinese: "Chinois", czech: "Tchèque", danish: "Danois", dutch: "Néerlandais", english: "Anglais", french: "Français", german: "Allemand", greek: "Grec", hindi: "Indien", hungarian: "Hongrois", indonesian: "Indonésien", italian: "Italiano", japanese: "Japonais", norwegian: "Norvégien", polish: "Polonais", portuguese: "Portugais", romanian: "Roumain", russian: "Russe", serbian: "Serbe", slovak: "Slovaque", slovenian: "Slovène", spanish: "Espagnol", swedish: "Suédois", thai: "Thaïlandais", turkish: "Turc", ukrainian: "Ukrainien" }, order_summary: "Résumé de la commande", payment: { cash_on_delivery: "Paiement à la livraison", dlocal_boleto: "Billet (Dlocal)", dlocal_card: "Cartes de crédit (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Cartes de crédit (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Connectez-vous à PayPal", paypal_edit_organization_name: "Modifier le nom de l'organisation", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Cartes de crédit (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "BanContact (Stripe)", stripe_card: "Carte de crédit ou de débit", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Cartes de crédit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titulaire de la carte", card_number_placeholder: "Numéro de carte", cvc_placeholder: "CVC", date_out_of_range: "La date d’expiration ne peut pas être dans le passé", empty_card_holder: "Saisir le nom du titulaire de la carte", empty_card_number: "Entrez un numéro de carte", empty_cvc: "Saisissez le code CVC", empty_expiry_date: "Entrez une date d'expiration", expiry_data_placeholder: "MM/AA", invalid_card_number: "Le numéro de carte est invalide", invalid_cvc: "Le code CVC est invalide", invalid_expiry_date: "La date d’expiration est invalide", month_out_of_range: "Le mois d’expiration doit être entre 01 et 12", year_out_of_range: "L'année d'expiration ne peut pas être dans le passé" }, "Payment-method": "Mode de paiement", price_plan: { interval: { day: "jour", day_plural: "{{count}} jours", month: "mois", month_plural: "{{count}} mois", week: "semaine", week_plural: "{{count}} semaines", year: "an", year_plural: "{{count}} ans" }, trial_period: { day: "{{count}} jour", day_plural: "{{count}} jours", month: "{{count}} mois", month_plural: "{{count}} mois", week: "{{count}} semaine", week_plural: "{{count}} semaines", year: "{{count}} an", year_plural: "{{count}} ans" } }, product: "Produit", quantity: "Quantité", "registered-over": "enregistré plus de", "required-field": "Le champ est obligatoire", shipping: { condition_label: { price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}", price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus", quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles", quantity_min: "Pour les commandes contenant {{min}} articles ou plus", weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g", weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus" }, not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit", shipping_method: "Méthode d'expédition" }, shipping_fee: "Frais d'expédition", subtotal: "Sous-total", total: "Total", total_amount_with_shipping: "Total (y compris livraison)", total_amount_with_tax: "Total (TVA incluse)", total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)", vat: "TVA", vat_percent: "TVA ({{percent}}%)" }, Kc = {
  public_pages_purchase: Fc
}, Hc = { affiliate_badge: { made_with: "द्वारा संचालित" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार", trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर", trial_period_price: "मुफ्त", unlimited_new: "{{amount}} हर {{interval}} पर" } } }, contact_slug: { city: "शहर", company_name: "कंपनी का नाम", country: "देश", email: "ईमेल", first_name: "प्रथम नाम", last_name: "अंतिम नाम", neighborhood: "पड़ोस", phone_number: "फ़ोन नंबर", postal_code: "पोस्टल कोड", state_province: "राज्य/प्रान्त", street_address: "सड़क का पता", street_number: "सड़क संख्या", tax_number: "टैक्स नंबर" }, copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया", copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल", date_picker: { all_time: "सभी समय", apply: "लागू करें", clear: "हटाएं", from: "से", last_3_months: "पिछले 3 महीने", last_30_days: "पिछले 30 दिन", last_month: "पिछले महीने", last_pool_period: "पिछले पूल मूल्यांकन अवधि", this_month: "इस महीने", time: "समय", title_dates: "दिनांक", to: "तक" }, error: "एरर", form_select: { empty_list: "लगता है यह लिस्ट खाली है", select: "चूनें" }, including_tax: "शामिल है {{percent}}% VAT ({{amount}})", input: { phone_number: "फोन नंबर", phone_search: "खोजें", search: "खोजें" }, locale: { albania: "अल्बानियन", arabic: "अरबी", chinese: "चीनी", czech: "चेक", danish: "डैनिश", dutch: "डच", english: "अंग्रेज़ी", french: "फ्रेंच", german: "जर्मन", greek: "यूनानी", hindi: "हिंदी ", hungarian: "हंगेरीअन ", indonesian: "इन्डोनेशियाई", italian: "इटैलिनो", japanese: "जापानी", norwegian: "नार्वेजियन", polish: "पोलिश", portuguese: "पुर्तगाली", romanian: "रोमानियाई", russian: "रूसी", serbian: "सर्बियाई", slovak: "स्लोवाक", slovenian: "स्लोवेनियाई", spanish: "स्पैनिश", swedish: "स्वीडिश", thai: "थाई", turkish: "तुर्की", ukrainian: "यूक्रेनी" }, order_summary: "ऑर्डर समरी", payment: { cash_on_delivery: "कैश-ऑन-डिलीवरी", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "क्रेडिट कार्ड्स (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Paypal से जुड़ें", paypal_edit_organization_name: "संगठन का नाम एडिट करें", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "क्रेडिट कार्ड्स (Paystack)", price_plan: "प्लान", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "एप्पल पे", stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)", stripe_card: "क्रेडिट या डेबिट कार्ड", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "क्लार्ना (स्ट्राइप)", stripe_multibanco: "मल्टीबैंको (स्ट्राइप)", xendit: { "3ds": "3D-सिक्योर" }, xendit_card: "क्रेडिट कार्ड्स (Xendit)" }, payment_inputs: { card_holder_placeholder: "कार्ड धारक", card_number_placeholder: "कार्ड नंबर", cvc_placeholder: "CVC", date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती", empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें", empty_card_number: "कार्ड नंबर दर्ज करें", empty_cvc: "CVC दर्ज करें  ", empty_expiry_date: "समाप्ति तिथि दर्ज करें", expiry_data_placeholder: "MM/YY", invalid_card_number: "कार्ड नंबर अमान्य है ", invalid_cvc: "CVC अमान्य है", invalid_expiry_date: "समाप्ति तिथि अमान्य है", month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ", year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता" }, "Payment-method": "पेमेंट मेथड", price_plan: { interval: { day: "दिन", day_plural: "{{count}} दिन", month: "महीना", month_plural: "{{count}} महीने", week: "सप्ताह", week_plural: "{{count}} सप्ताह", year: "वर्ष", year_plural: "{{count}} वर्ष" }, trial_period: { day: "{{count}} दिन", day_plural: "{{count}} दिन", month: "{{count}} महीना", month_plural: "{{count}} महीने", week: "{{count}} सप्ताह", week_plural: "{{count}} दिन", year: "{{count}} वर्ष", year_plural: "{{count}} वर्ष" } }, product: "प्रोडक्ट", quantity: "क्वान्टिटी", "registered-over": "पंजीकृत किया गया", "required-field": "यह फील्ड भरना अनिवार्य है", shipping: { condition_label: { price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए", price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए", quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए", quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए", weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए", weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए" }, not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ", shipping_method: "शिपिंग मेथड" }, shipping_fee: "शिपिंग शुल्क", subtotal: "सब टोटल ", total: "टोटल", total_amount_with_shipping: "कुल (शिपिंग सहित)", total_amount_with_tax: "कुल (कर सहित)", total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)", vat: "सेल्स टैक्स", vat_percent: "सेल्स टैक्स ({{percent}}%)" }, zc = {
  public_pages_purchase: Hc
}, Vc = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal", trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}", trial_period_price: "Ingyenes", unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}" } } }, contact_slug: { city: "Város", company_name: "Cégnév", country: "Ország", email: "E-mail", first_name: "Keresztnév", last_name: "Vezetéknév", neighborhood: "Környék", phone_number: "Telefonszám", postal_code: "Irányítószám", state_province: "Állam/Mező", street_address: "Út/utca", street_number: "Házszám", tax_number: "Adószám" }, copy_clipboard: "Másolva a vágólapra", copy_clipboard_error: "A szöveg másolása nem sikerült", date_picker: { all_time: "Minden idő", apply: "Alkalmaz", clear: "Törlés", from: "Tól", last_3_months: "Utolsó 3 hónap", last_30_days: "Utolsó 30 nap", last_month: "Utolsó hónap", last_pool_period: "Utolsó medenceértékelési időszak", this_month: "Ez a hónap", time: "Idő", title_dates: "Dátumok", to: "Ig" }, error: "Hiba", form_select: { empty_list: "Úgy tűnik, hogy ez a lista üres", select: "Kiválasztás" }, including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})", input: { phone_number: "Telefonszám", phone_search: "Keresés", search: "Keresés" }, locale: { albania: "Albán", arabic: "Arab", chinese: "Kínai", czech: "Cseh", danish: "Dán", dutch: "Holland", english: "Angol", french: "Francia", german: "Német", greek: "Görög", hindi: "Dehogy", hungarian: "Magyar", indonesian: "Indonéz", italian: "Olasz", japanese: "Japán", norwegian: "Norvég", polish: "Fényesít", portuguese: "Portugál", romanian: "Román", russian: "Orosz", serbian: "Szerb", slovak: "Szlovák", slovenian: "Szlovén", spanish: "Spanyol", swedish: "Svéd", thai: "Thai", turkish: "Török", ukrainian: "Ukrán" }, order_summary: "Rendelés összegzése", payment: { cash_on_delivery: "Utánvétes fizetés", dlocal_boleto: "Boleto (helyi)", dlocal_card: "Hitelkártyák (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Hitelkártyák (Mercado Pago)", mercadopago_pix: "PIX (fizetési piac)", mollie: "Mollie", paypal_connect: "Csatlakoztassa a PayPal-t", paypal_edit_organization_name: "Szerkessze a szervezet nevét", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Hitelkártyák (Paystack)", price_plan: "Terv", razorpay: "Razorpay", secure_and_pay: "Biztonságos és fizetés", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (csíkos)", stripe_card: "Hitel- vagy betéti kártya", stripe_ideal: "iDeal (csík)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Hitelkártyák (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kártyabirtokos", card_number_placeholder: "Kártyaszám", cvc_placeholder: "CVC", date_out_of_range: "A lejárati dátum nem lehet a múltban", empty_card_holder: "Adja meg a kártyabirtokos nevét", empty_card_number: "Adjon meg egy kártyaszámot", empty_cvc: "Adja meg a CVC-t", empty_expiry_date: "Adjon meg egy lejárati dátumot", expiry_data_placeholder: "HH/YY", invalid_card_number: "A kártyaszám érvénytelen", invalid_cvc: "A CVC érvénytelen", invalid_expiry_date: "A lejárati dátum érvénytelen", month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie", year_out_of_range: "A lejárati év nem lehet a múltban" }, "Payment-method": "Fizetési mód", price_plan: { interval: { day: "nap", day_plural: "{{count}} nap", month: "hónap", month_plural: "{{count}} hónap", week: "hét", week_plural: "{{count}} hét", year: "év", year_plural: "{{count}} év" }, trial_period: { day: "{{count}} nap", day_plural: "{{count}} nap", month: "{{count}} hónap", month_plural: "{{count}} hónap", week: "{{count}} hét", week_plural: "{{count}} hét", year: "{{count}} év", year_plural: "{{count}} év" } }, product: "Termék", quantity: "Mennyiség", "registered-over": "regisztrált több mint", "required-field": "A mező kitöltése kötelező", shipping: { condition_label: { price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez", price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez", quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez", quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez", weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez", weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez" }, not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.", shipping_method: "Szállítási mód" }, shipping_fee: "Szállítási díj", subtotal: "Részösszeg", total: "Összesen", total_amount_with_shipping: "Összesen (beleértve a szállítást)", total_amount_with_tax: "Összesen (beleértve az adót)", total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)", vat: "Áfa", vat_percent: "Áruforgalmi adó ({{percent}}%)" }, Uc = {
  public_pages_purchase: Vc
}, jc = { affiliate_badge: { made_with: "Ditenagai oleh" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali", trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu", trial_period_price: "Bebas", unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}" } } }, contact_slug: { city: "Kota", company_name: "Nama perusahaan", country: "Negara", email: "Email", first_name: "Nama depan", last_name: "Nama belakang", neighborhood: "Lingkungan", phone_number: "Nomor telepon", postal_code: "Kode pos", state_province: "Negara Bagian/Provinsi", street_address: "Alamat jalan", street_number: "Nomor jalan", tax_number: "Nomor pajak" }, copy_clipboard: "Disalin ke clipboard", copy_clipboard_error: "Gagal menyalin teks", date_picker: { all_time: "Semua waktu", apply: "Terapkan", clear: "Bersihkan", from: "Dari", last_3_months: "3 bulan terakhir", last_30_days: "30 hari terakhir", last_month: "Bulan lalu", last_pool_period: "Periode evaluasi kolam terakhir", this_month: "Bulan ini", time: "Waktu", title_dates: "Tanggal", to: "Ke" }, error: "Kesalahan", form_select: { empty_list: "Sepertinya daftar ini kosong", select: "Pilih" }, including_tax: "Termasuk PPN {{percent}}% ({{amount}})", input: { phone_number: "Nomor telepon", phone_search: "Cari", search: "Cari" }, locale: { albania: "Bahasa Albania", arabic: "Arab", chinese: "Cina", czech: "Ceko", danish: "Orang Denmark", dutch: "Belanda", english: "Bahasa inggris", french: "Perancis", german: "Jerman", greek: "Orang yunani", hindi: "Tidak", hungarian: "Hongaria", indonesian: "Bahasa Indonesia", italian: "Italia", japanese: "Jepang", norwegian: "Norwegia", polish: "Polandia", portuguese: "Portugis", romanian: "Rumania", russian: "Rusia", serbian: "Orang Serbia", slovak: "Orang Slovakia", slovenian: "Slovenia", spanish: "Orang Spanyol", swedish: "Orang Swedia", thai: "Thai", turkish: "Turki", ukrainian: "Orang Ukraina" }, order_summary: "Ringkasan Pesanan", payment: { cash_on_delivery: "Bayar di tempat", dlocal_boleto: "Boleto (Dlokal)", dlocal_card: "Kartu kredit (Dlokal)", dlocal_pix: "Pix (Dlokal)", flutterwave: "Gelombang bergetar", gocardless: "Tanpa kartu", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kartu kredit (Mercado Pago)", mercadopago_pix: "PIX (Pasar Pembayaran)", mollie: "Mollie", paypal_connect: "Hubungkan PayPal", paypal_edit_organization_name: "Edit nama organisasi", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kartu kredit (Paystack)", price_plan: "Rencana", razorpay: "Pembayaran pisau cukur", secure_and_pay: "Amankan dan Bayar", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Garis)", stripe_card: "Kartu kredit atau debit", stripe_ideal: "iDeal (Garis)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kartu kredit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Pemegang kartu", card_number_placeholder: "Nomor kartu", cvc_placeholder: "CVC", date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu", empty_card_holder: "Masukkan nama pemegang kartu", empty_card_number: "Masukkan nomor kartu", empty_cvc: "Masukkan CVC", empty_expiry_date: "Masukkan tanggal kedaluwarsa", expiry_data_placeholder: "MM/YY", invalid_card_number: "Nomor kartu tidak valid", invalid_cvc: "CVC tidak valid", invalid_expiry_date: "Tanggal kedaluwarsa tidak valid", month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12", year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu" }, "Payment-method": "Metode pembayaran", price_plan: { interval: { day: "hari", month: "bulan", week: "pekan", year: "tahun" }, trial_period: { day: "{{count}} hari", month: "{{count}} bulan", week: "{{count}} minggu", year: "{{count}} tahun" } }, product: "Produk", quantity: "Kuantitas", "registered-over": "terdaftar lebih dari", "required-field": "Bidang wajib diisi", shipping: { condition_label: { price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}", price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih", quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item", quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih", weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g", weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih" }, not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.", shipping_method: "Metode Pengiriman" }, shipping_fee: "Biaya pengiriman", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (termasuk pengiriman)", total_amount_with_tax: "Total (termasuk pajak)", total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)", vat: "Pajak penjualan", vat_percent: "Pajak penjualan ({{percent}}%)" }, Yc = {
  public_pages_purchase: jc
}, Wc = { affiliate_badge: { made_with: "Realizzato da" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi", trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi", trial_period_price: "Gratuito", unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}" } } }, contact_slug: { city: "Città", company_name: "Nome azienda", country: "Paese", email: "Email", first_name: "Nome", last_name: "Cognome", neighborhood: "Quartiere", phone_number: "Numero di telefono", postal_code: "Codice postale", state_province: "Stato/Provincia", street_address: "Indirizzo", street_number: "Numero civico", tax_number: "Partita IVA" }, copy_clipboard: "Copiato negli appunti", copy_clipboard_error: "Impossibile copiare il testo", date_picker: { all_time: "Per tutto il periodo", apply: "Applicare", clear: "Cancella", from: "Da", last_3_months: "Ultimi 3 mesi", last_30_days: "Ultimi 30 giorni", last_month: "Ultimo mese", last_pool_period: "Ultimo periodo di valutazione del pool", this_month: "Questo mese", time: "Ora", title_dates: "Date", to: "A" }, error: "Errore", form_select: { empty_list: "Sembra che questo elenco sia vuoto", select: "Selezionare" }, including_tax: "Include {{percent}}% di IVA ({{amount}})", input: { phone_number: "Numero di telefono", phone_search: "Ricerca", search: "Ricerca" }, locale: { albania: "Albanese", arabic: "Аrabo", chinese: "Cinese", czech: "Ceco", danish: "Danese", dutch: "Olandese", english: "Inglese", french: "Francese", german: "Tedesco", greek: "Greco", hindi: "Hindi", hungarian: "Ungherese", indonesian: "Indonesiano", italian: "Italiano", japanese: "Giapponese", norwegian: "Norvegese", polish: "Polacco", portuguese: "Portoghese", romanian: "Rumeno", russian: "Russo", serbian: "Serbo", slovak: "Slovacco", slovenian: "Sloveno", spanish: "Spagnolo", swedish: "Svedese", thai: "Tailandese", turkish: "Turco", ukrainian: "Ucraino" }, order_summary: "Riepilogo dell'ordine", payment: { cash_on_delivery: "Contanti alla consegna", dlocal_boleto: "Biglietto (Dlocal)", dlocal_card: "Carte di credito (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Biglietto (Mercado Pago)", mercadopago_card: "Carte di credito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Collegare PayPal", paypal_edit_organization_name: "Modifica il nome dell'organizzazione", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Carte di credito (Paystack)", price_plan: "Piano", razorpay: "Razorpay", secure_and_pay: "Sicurezza e pagamento", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Carta di credito o di debito", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Carte di credito (Xendit)" }, payment_inputs: { card_holder_placeholder: "Portacarte", card_number_placeholder: "Numero della carta", cvc_placeholder: "CVC", date_out_of_range: "La data di scadenza non può essere passata", empty_card_holder: "Inserire il nome del titolare della carta", empty_card_number: "Inserire un numero di carta", empty_cvc: "Inserire una CVC", empty_expiry_date: "Inserire una data di scadenza", expiry_data_placeholder: "MM/AA", invalid_card_number: "Il numero della carta non è valido", invalid_cvc: "Il CVC non è valido", invalid_expiry_date: "La data di scadenza non è valida", month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12", year_out_of_range: "L'anno di scadenza non può essere passato" }, "Payment-method": "Metodo di pagamento", price_plan: { interval: { day: "giorno", day_plural: "{{count}} giorni", month: "mese", month_plural: "{{count}} mesi", week: "settimana", week_plural: "{{count}} settimane", year: "anno", year_plural: "{{count}} anni" }, trial_period: { day: "{{count}} giorno", day_plural: "{{count}} giorni", month: "{{count}} mese", month_plural: "{{count}} mesi", week: "{{count}} settimana", week_plural: "{{count}} settimane", year: "{{count}} anni", year_plural: "{{count}} anni" } }, product: "Prodotto", quantity: "Quantità", "registered-over": "registrato oltre", "required-field": "Il campo è obbligatorio", shipping: { condition_label: { price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}", price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più", quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli", quantity_min: "Per ordini contenenti {{min}} articoli o più", weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g", weight_min: "Per ordini con un peso totale di {{min}}g o più" }, not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.", shipping_method: "Metodo di spedizione" }, shipping_fee: "Spese di spedizione", subtotal: "Totale parziale", total: "Totale", total_amount_with_shipping: "Totale (spedizione inclusa)", total_amount_with_tax: "Totale (IVA inclusa)", total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)", vat: "Imposta sulle vendite", vat_percent: "Imposta sulle vendite ({{percent}}%)" }, Zc = {
  public_pages_purchase: Wc
}, Jc = { affiliate_badge: { made_with: "提供元" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回", trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は", trial_period_price: "無料", unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>" } } }, contact_slug: { city: "市区町村", company_name: "法人名", country: "国", email: "Eメール", first_name: "名", last_name: "姓", neighborhood: "地域", phone_number: "電話番号", postal_code: "郵便番号", state_province: "都道府県", street_address: "住所", street_number: "番地", tax_number: "法人番号（税番号）" }, copy_clipboard: "クリップボードにコピーされました", copy_clipboard_error: "テキストのコピーに失敗しました", date_picker: { all_time: "全期間", apply: "適用", clear: "消去", from: "から", last_3_months: "過去3ヶ月", last_30_days: "過去30日", last_month: "先月", last_pool_period: "前回の集計期間", this_month: "今月", time: "時", title_dates: "日", to: "へ" }, error: "エラー", form_select: { empty_list: "このリストが空のようです", select: "選択する" }, including_tax: "消費税 {{percent}}% を含む（{{amount}}）", input: { phone_number: "電話番号", phone_search: "検索", search: "検索" }, locale: { albania: "アルバニア語", arabic: "アラブ", chinese: "中国語", czech: "チェコ語", danish: "デンマーク語", dutch: "オランダ語", english: "英語", french: "フランス語", german: "ドイツ語", greek: "ギリシャ語", hindi: "ヒンズー語", hungarian: "ハンガリー語", indonesian: "インドネシア語", italian: "イタリア語", japanese: "日本語", norwegian: "ノルウェー語", polish: "ポーランド語", portuguese: "ポルトガル語", romanian: "ルーマニア語", russian: "ロシア語", serbian: "セルビア語", slovak: "スロバキア語", slovenian: "スロバニア語", spanish: "スペイン語", swedish: "スウェーデン語", thai: "タイ語", turkish: "トルコ語", ukrainian: "ウクライナ語" }, order_summary: "ご注文内容", payment: { cash_on_delivery: "着払い", dlocal_boleto: "Borelo（Dlocal）", dlocal_card: "クレジットカード（Dlocal）", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave ", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "クレジットカード (Mercado Pago)", mercadopago_pix: "PIX（Mercado Pago）", mollie: "Mollie", paypal_connect: "PayPalに接続", paypal_edit_organization_name: "組織名を編集", paypal_rest: "ペイパル", paypal_soap: "Paypal", paystack_card: "クレジットカード（Paystack）", price_plan: "プラン", razorpay: "Razorpay ", secure_and_pay: "Secure and Pay", stripe_applepay: "Appleペイ", stripe_bancotact: "Bancontact（Stripe）", stripe_card: "クレジットカードまたはデビットカード", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna（Stripe）", stripe_multibanco: "Multibanco（Stripe）", xendit: { "3ds": "3Dセキュア" }, xendit_card: "クレジットカード（Xendit）" }, payment_inputs: { card_holder_placeholder: "カード所有者", card_number_placeholder: "カード番号", cvc_placeholder: "CVC", date_out_of_range: "有効期限は過去の日付にすることはできません。", empty_card_holder: "カード所有者の名前を入力してください", empty_card_number: "カード番号を入力", empty_cvc: "CVCを入力", empty_expiry_date: "有効期限を入力してください。", expiry_data_placeholder: "月/年", invalid_card_number: "カード番号が無効です", invalid_cvc: "CVCが無効です", invalid_expiry_date: "有効期限が無効です", month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。", year_out_of_range: "有効期限の年は過去にすることはできません。" }, "Payment-method": "支払い方法", price_plan: { interval: { day: `日

{{count}} 日`, month: `ヶ月

{{count}}ヶ月`, week: `週

{{count}}週`, year: `年

{{count}}年` }, trial_period: { day: `{{count}} 日

{{count}} 日`, month: `{{count}}ヶ月

{{count}}ヶ月`, week: `{{count}}週

{{count}}週`, year: `{{count}}年

{{count}}年` } }, product: "商品", quantity: "数量", "registered-over": "登録された", "required-field": "この項目は必須です", shipping: { condition_label: { price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合", price_min: "{{min}} {{currency}}以上の注文の場合", quantity: "{{min}}から{{max}}個の商品を含む注文の場合", quantity_min: "{{min}}個以上の商品を含む注文の場合", weight: "合計重量が {{min}}g から {{max}}g までの注文の場合", weight_min: "合計重量が {{min}}g 以上の注文の場合" }, not_available: "おっと！この地域への配送にはまだ対応していないようです。", shipping_method: "配送方法" }, shipping_fee: "送料", subtotal: "小計", total: "合計", total_amount_with_shipping: "合計（送料込み）", total_amount_with_tax: "合計（税込）", total_amount_with_tax_and_shipping: "合計（消費税・送料込み）", vat: "消費税", vat_percent: "消費税（{{percent}}%）" }, Qc = {
  public_pages_purchase: Jc
}, $c = { affiliate_badge: { made_with: "Ondersteund door" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer", trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}" } } }, contact_slug: { city: "Plaats", company_name: "Bedrijfsnaam", country: "Land", email: "E-mail", first_name: "Voornaam", last_name: "Achternaam", neighborhood: "Buurt", phone_number: "Telefoonnummer", postal_code: "Postcode", state_province: "Staat/Provincie", street_address: "Straatadres", street_number: "Huisnummer", tax_number: "BTW-nummer" }, copy_clipboard: "Gekopieerd naar klembord", copy_clipboard_error: "Tekst kopiëren mislukt", date_picker: { all_time: "Alle tijden", apply: "Toepassen", clear: "Wissen", from: "Van", last_3_months: "Laatste 3 maanden", last_30_days: "Laatste 30 dagen", last_month: "Afgelopen maand", last_pool_period: "Laatste pool-evaluatieperiode", this_month: "Deze maand", time: "Tijd", title_dates: "Datum", to: "Naar" }, error: "Fout", form_select: { empty_list: "Het lijkt erop dat deze lijst leeg is", select: "Selecteer" }, including_tax: "Inclusief {{percent}}% BTW ({{amount}})", input: { phone_number: "Telefoonnummer", phone_search: "Zoek", search: "Zoek" }, locale: { albania: "Albanees", arabic: "Arabisch", chinese: "Chinees", czech: "Tsjechisch", danish: "Deens", dutch: "Nederlands", english: "Engels", french: "Frans", german: "Duits", greek: "Grieks", hindi: "Hindi", hungarian: "Hongaars", indonesian: "Indonesisch", italian: "Italiaans", japanese: "Japans", norwegian: "Noors", polish: "Pools", portuguese: "Portugees", romanian: "Roemeens", russian: "Russisch", serbian: "Servisch", slovak: "Slowaaks", slovenian: "Sloveens", spanish: "Spaans", swedish: "Zweeds", thai: "Thais", turkish: "Turks", ukrainian: "Oekraïens" }, order_summary: "Besteloverzicht", payment: { cash_on_delivery: "Contant bij levering", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Creditcards (Dlocal)", dlocal_pix: "Pix (Dlokaal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Creditcards (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Verbind PayPal", paypal_edit_organization_name: "Organisatienaam bewerken", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Creditcards (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Beveiligd betalen", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Creditcard of debetkaart", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Creditcards (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kaarthouder", card_number_placeholder: "Kaartnummer", cvc_placeholder: "CVC", date_out_of_range: "Vervaldatum mag niet in het verleden liggen", empty_card_holder: "Voer de naam van de kaarthouder in", empty_card_number: "Voer een kaartnummer in", empty_cvc: "Voer een CVC in", empty_expiry_date: "Voer een vervaldatum in", expiry_data_placeholder: "MM/JJ", invalid_card_number: "Kaartnummer is ongeldig", invalid_cvc: "CVC is ongeldig", invalid_expiry_date: "Vervaldatum is ongeldig", month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen", year_out_of_range: "Vervaljaar mag niet in het verleden liggen" }, "Payment-method": "Betaalmethode", price_plan: { interval: { day: "dag", day_plural: "{{count}} dagen", month: "maand", month_plural: "{{count}} maanden", week: "week", week_plural: "{{count}} weken", year: "jaar", year_plural: "{{count}} jaren" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dagen", month: "{{count}} maand", month_plural: "{{count}} maanden", week: "{{count}} week", week_plural: "{{count}} weken", year: "{{count}} jaar", year_plural: "{{count}} jaren" } }, product: "Product", quantity: "Aantal", "registered-over": "geregistreerd over", "required-field": "Veld is vereist", shipping: { condition_label: { price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}", price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer", quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten", quantity_min: "Voor bestellingen met {{min}} of meer artikelen", weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g", weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer" }, not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden", shipping_method: "Verzendmethode" }, shipping_fee: "Verzendkosten", subtotal: "Subtotaal", total: "Totaal", total_amount_with_shipping: "Totaal (incl. verzending)", total_amount_with_tax: "Totaal (incl. belasting)", total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)", vat: "Verkoopbelasting", vat_percent: "BTW ({{percent}}%)" }, qc = {
  public_pages_purchase: $c
}, Xc = { affiliate_badge: { made_with: "Drevet av" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}" } } }, contact_slug: { city: "By", company_name: "Firmanavn", country: "Land", email: "E-post", first_name: "Fornavn", last_name: "Etternavn", neighborhood: "Nabolag", phone_number: "Telefonnummer", postal_code: "Postnummer", state_province: "Stat/Provins", street_address: "Gateadresse", street_number: "Gate nummer", tax_number: "Skattenummer" }, copy_clipboard: "Kopiert til utklippstavlen", copy_clipboard_error: "Kunne ikke kopiere tekst", date_picker: { all_time: "All tid", apply: "Bruk", clear: "Fjern", from: "Fra", last_3_months: "Siste 3 måneder", last_30_days: "Siste 30 dager", last_month: "Siste måned", last_pool_period: "Siste evalueringsperiode for basseng", this_month: "Denne måneden", time: "Tid", title_dates: "Datoer", to: "Til" }, error: "Feil", form_select: { empty_list: "Det ser ut som denne listen er tom", select: "Velg" }, including_tax: "Inkludert {{percent}}% MVA ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Søk", search: "Søk" }, locale: { albania: "Albansk", arabic: "Arabisk", chinese: "Kinesisk", czech: "Tsjekkisk", danish: "Dansk", dutch: "Nederlandsk", english: "Engelsk", french: "Fransk", german: "Tysk", greek: "Gresk", hindi: "Nei", hungarian: "Ungarsk", indonesian: "Indonesisk", italian: "Italiensk", japanese: "Japansk", norwegian: "Norsk", polish: "Pusse", portuguese: "Portugisisk", romanian: "Rumensk", russian: "Russisk", serbian: "Serbisk", slovak: "Slovakisk", slovenian: "Slovensk", spanish: "Spansk", swedish: "Svensk", thai: "Thai", turkish: "Tyrkisk", ukrainian: "Ukrainsk" }, order_summary: "Ordresammendrag", payment: { cash_on_delivery: "Kontantbetaling ved levering", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kredittkort (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterbølge", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kredittkort (Mercado Pago)", mercadopago_pix: "PIX (betalingsmarked)", mollie: "Mollie", paypal_connect: "Koble til PayPal", paypal_edit_organization_name: "Rediger organisasjonsnavn", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kredittkort (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Sikker og betal", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kreditt- eller debetkort", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kredittkort (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kortholder", card_number_placeholder: "Kortnummer", cvc_placeholder: "CVC", date_out_of_range: "Utløpsdato kan ikke være i fortiden", empty_card_holder: "Skriv inn navnet til kortholderen", empty_card_number: "Skriv inn et kortnummer", empty_cvc: "Skriv inn en CVC", empty_expiry_date: "Skriv inn en utløpsdato", expiry_data_placeholder: "MM/ÅÅ", invalid_card_number: "Kortnummeret er ugyldig", invalid_cvc: "CVC er ugyldig", invalid_expiry_date: "Utløpsdato er ugyldig", month_out_of_range: "Utløpsmåned må være mellom 01 og 12", year_out_of_range: "Utløpsår kan ikke være i fortiden" }, "Payment-method": "Betalingsmåte", price_plan: { interval: { day: "dag", day_plural: "{{count}} dager", month: "måned", month_plural: "{{count}} måneder", week: "uke", week_plural: "{{count}} uker", year: "år", year_plural: "{{count}} år" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dager", month: "{{count}} måned", month_plural: "{{count}} måneder", week: "{{count}} uke", week_plural: "{{count}} uker", year: "{{count}} år", year_plural: "{{count}} år" } }, product: "Produkt", quantity: "Mengde", "registered-over": "registrert over", "required-field": "Felt er obligatorisk", shipping: { condition_label: { price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}", price_min: "For bestillinger priset til {{min}} {{currency}} eller mer", quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer", quantity_min: "For bestillinger som inneholder {{min}} eller flere varer", weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g", weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer" }, not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.", shipping_method: "Fraktmetode" }, shipping_fee: "Fraktgebyr", subtotal: "Delsum", total: "Totalt", total_amount_with_shipping: "Totalbeløp (inkludert frakt)", total_amount_with_tax: "Totalbeløp (inkludert skatt)", total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)", vat: "Moms", vat_percent: "Merverdiavgift ({{percent}}%)" }, eu = {
  public_pages_purchase: Xc
}, au = { affiliate_badge: { made_with: "Zasilane przez" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy", trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem", trial_period_price: "Bezpłatny", unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}" } } }, contact_slug: { city: "Miasto", company_name: "Nazwa firmy", country: "Kraj", email: "Email", first_name: "Imię", last_name: "Nazwisko", neighborhood: "Osiedle", phone_number: "Numer telefonu", postal_code: "Kod pocztowy", state_province: "Stan/Województwo", street_address: "Adres", street_number: "Numer ulicy", tax_number: "Numer identyfikacji podatkowej" }, copy_clipboard: "Skopiowano do schowka", copy_clipboard_error: "Nie udało się skopiować tekstu", date_picker: { all_time: "Cały czas", apply: "Zastosuj", clear: "Wyczyść", from: "Z", last_3_months: "Ostatnie 3 miesiące", last_30_days: "Ostatnie 30 dni", last_month: "Ostatni miesiąc", last_pool_period: "Ostatni okres oceny puli", this_month: "Ten miesiąc", time: "Czas", title_dates: "Daty", to: "Do" }, error: "Błąd", form_select: { empty_list: "Wygląda na to, że ta lista jest pusta", select: "Wybierz" }, including_tax: "Zawiera {{percent}}% VAT ({{amount}})", input: { phone_number: "Numer telefonu", phone_search: "Szukaj", search: "Szukaj" }, locale: { albania: "Albański", arabic: "Arabski", chinese: "Chiński", czech: "Czeski", danish: "Duński", dutch: "Holenderski", english: "Angielski", french: "Francuski", german: "Niemiecki", greek: "Grecki", hindi: "Hinduski", hungarian: "Węgierski", indonesian: "Indonezyjski", italian: "Włoski", japanese: "Japoński", norwegian: "Norweski", polish: "Polski", portuguese: "Portugalski", romanian: "Rumuński", russian: "Rosyjski", serbian: "Serbski", slovak: "Słowacki", slovenian: "Słoweński", spanish: "Hiszpański", swedish: "Szwedzki", thai: "Tajski", turkish: "Turecki", ukrainian: "Ukraiński" }, order_summary: "Podsumowanie zamówienia", payment: { cash_on_delivery: "Płatność gotówką przy odbiorze", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Karty kredytowe (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Karty kredytowe (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Połącz PayPala", paypal_edit_organization_name: "Edytuj nazwę organizacji", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Karty kredytowe (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Karta kredytowa lub debetowa", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Karty kredytowe (Xendit)" }, payment_inputs: { card_holder_placeholder: "Właściciel karty", card_number_placeholder: "Numer karty", cvc_placeholder: "CVC", date_out_of_range: "Data ważności nie może być w przeszłości", empty_card_holder: "Wprowadź imię i nazwisko właściciela karty", empty_card_number: "Wprowadź numer karty", empty_cvc: "Wprowadź CVC", empty_expiry_date: "Wprowadź datę ważności", expiry_data_placeholder: "MM/RR", invalid_card_number: "Numer karty jest nieprawidłowy", invalid_cvc: "CVC jest nieprawidłowy", invalid_expiry_date: "Data ważności jest nieprawidłowa", month_out_of_range: "Miesiąc ważności musi być między 01 a 12", year_out_of_range: "Rok ważności nie może być w przeszłości" }, "Payment-method": "Metoda płatności", price_plan: { interval: { day_0: "dzień", day_1: "{{count}} dni", day_2: "{{count}} dni", month_0: "miesiąc", month_1: "{{count}} miesięcy", month_2: "{{count}} miesięcy", week_0: "tydzień", week_1: "{{count}} tygodni", week_2: "{{count}} tygodni", year_0: "rok", year_1: "{{count}} lat", year_2: "{{count}} lat" }, trial_period: { day_0: "{{count}} dzień", day_1: "{{count}} dni", day_2: "{{count}} dni", month_0: "{{count}} miesiąc", month_1: "{{count}} miesięcy", month_2: "{{count}} miesięcy", week_0: "{{count}} tydzień", week_1: "{{count}} tygodni", week_2: "{{count}} tygodni", year_0: "{{count}} rok", year_1: "{{count}} lat", year_2: "{{count}} lat" } }, product: "Produkt", quantity: "Ilość", "registered-over": "zarejestrowano ponad", "required-field": "Pole jest wymagane", shipping: { condition_label: { price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}", price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej", quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów", quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów", weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g", weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej" }, not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.", shipping_method: "Metoda wysyłki" }, shipping_fee: "Opłata za wysyłkę", subtotal: "Suma częściowa", total: "Razem", total_amount_with_shipping: "Razem (z wysyłką)", total_amount_with_tax: "Razem (z podatkiem)", total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)", vat: "Podatek od sprzedaży", vat_percent: "Podatek od sprzedaży ({{percent}}%)" }, tu = {
  public_pages_purchase: au
}, nu = { affiliate_badge: { made_with: "Desenvolvido por" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes", trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois", trial_period_price: "Gratuito", unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}" } } }, contact_slug: { city: "Cidade", company_name: "Nome da empresa", country: "País", email: "Email", first_name: "Nome", last_name: "Sobrenome", neighborhood: "Bairro", phone_number: "Número de telefone", postal_code: "Código postal", state_province: "Estado/Província", street_address: "Endereço", street_number: "Número", tax_number: "CNPJ/NIF" }, copy_clipboard: "Copiado para a área de transferência", copy_clipboard_error: "Falha ao copiar o texto", date_picker: { all_time: "Desde o início", apply: "Aplicar", clear: "Limpar", from: "De", last_3_months: "Últimos 3 meses", last_30_days: "Últimos 30 dias", last_month: "Último mês", last_pool_period: "Último período de avaliação do grupo", this_month: "Este mês", time: "Horário", title_dates: "Datas", to: "Até" }, error: "Erro", form_select: { empty_list: "Parece que essa lista está vazia", select: "Selecionar" }, including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})", input: { phone_number: "Número de telefone", phone_search: "Pesquisar", search: "Pesquisar" }, locale: { albania: "Albanês", arabic: "Árabe", chinese: "Chinês", czech: "Tcheco", danish: "Dinamarquês", dutch: "Holandês", english: "Inglês", french: "Francês", german: "Alemão", greek: "Grego", hindi: "Hindi", hungarian: "Húngaro", indonesian: "Indonésio", italian: "Italiano", japanese: "Japonês", norwegian: "Norueguês", polish: "Polonês", portuguese: "Português", romanian: "Romeno", russian: "Russo", serbian: "Sérvio", slovak: "Eslovaco", slovenian: "Esloveno", spanish: "Espanhol", swedish: "Sueco", thai: "Tailandês", turkish: "Turco", ukrainian: "Ucraniano" }, order_summary: "Resumo do pedido", payment: { cash_on_delivery: "Pagamento na entrega", dlocal_boleto: "Boleto bancário (Dlocal)", dlocal_card: "Cartão de crédito (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Cartão de crédito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "Conectar PayPal", paypal_edit_organization_name: "Editar o nome da empresa", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Cartão de crédito (Paystack)", price_plan: "Plano", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Cartão de crédito ou débito", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Cartão de crédito (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titular do cartão", card_number_placeholder: "Número do cartão", cvc_placeholder: "CVV", date_out_of_range: "A data de validade não pode estar no passado", empty_card_holder: "Insira o nome do titular do cartão", empty_card_number: "Insira um número de cartão", empty_cvc: "Insira o CVV", empty_expiry_date: "Insira uma data de validade", expiry_data_placeholder: "MM/AA", invalid_card_number: "O número do cartão é inválido", invalid_cvc: "O CVV é inválido", invalid_expiry_date: "A data de validade é inválida", month_out_of_range: "O mês de validade deve estar entre 01 e 12", year_out_of_range: "O ano de validade não pode estar no passado" }, "Payment-method": "Método de pagamento", price_plan: { interval: { day: "dia", day_plural: "{{count}} dias", month: "mês", month_plural: "{{count}} meses", week: "semana", week_plural: "{{count}} semanas", year: "ano", year_plural: "{{count}} anos" }, trial_period: { day: "{{count}} dia", day_plural: "{{count}} dias", month: "{{count}} mês", month_plural: "{{count}} meses", week: "{{count}} semana", week_plural: "{{count}} semanas", year: "{{count}} ano", year_plural: "{{count}} anos" } }, product: "Produto", quantity: "Quantidade", "registered-over": "registrado há mais de", "required-field": "O campo é obrigatório", shipping: { condition_label: { price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}", price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais", quantity: "Para pedidos contendo entre {{min}} e {{max}} itens", quantity_min: "Para pedidos contendo {{min}} ou mais itens", weight: "Para pedidos com peso total entre {{min}}g e {{max}}g", weight_min: "Para pedidos com peso total de {{min}}g ou mais" }, not_available: "Ops! Parece que ainda não oferecemos envio para este local", shipping_method: "Método de envio" }, shipping_fee: "Taxa de envio", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (incluindo envio)", total_amount_with_tax: "Total (incluindo impostos)", total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)", vat: "Imposto", vat_percent: "Imposto ({{percent}}%)" }, ru = {
  public_pages_purchase: nu
}, iu = { affiliate_badge: { made_with: "Realizat de" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori", trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci", trial_period_price: "Gratuit", unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}" } } }, contact_slug: { city: "Oraș", company_name: "Numele companiei", country: "Țară", email: "Email", first_name: "Prenume", last_name: "Nume de familie", neighborhood: "Cartier", phone_number: "Număr de telefon", postal_code: "Cod poștal", state_province: "Stat/Provincie", street_address: "Adresă", street_number: "Numărul străzii", tax_number: "Număr de identificare fiscală" }, copy_clipboard: "Copiat în clipboard", copy_clipboard_error: "Copierea textului a eșuat", date_picker: { all_time: "Tot timpul", apply: "Aplică", clear: "Șterge", from: "De la", last_3_months: "Ultimele 3 luni", last_30_days: "Ultimele 30 de zile", last_month: "Luna trecută", last_pool_period: "Ultima perioadă de evaluare a grupului", this_month: "Luna aceasta", time: "Timp", title_dates: "Date", to: "Către" }, error: "Eroare", form_select: { empty_list: "Se pare că această listă este goală", select: "Selectați" }, including_tax: "Incluzând TVA de {{percent}}% ({{amount}})", input: { phone_number: "Număr de telefon", phone_search: "Căutare", search: "Caută" }, locale: { albania: "Albanez", arabic: "Arabic", chinese: "Chinez", czech: "Ceh", danish: "Danez", dutch: "Olandeză", english: "Engleză", french: "Limba franceza", german: "Limba germana", greek: "Greacă", hindi: "Nu", hungarian: "Maghiară", indonesian: "Indoneziană", italian: "Italiană", japanese: "Japonez", norwegian: "Norvegian", polish: "Lustrui", portuguese: "Portugheză", romanian: "Română", russian: "Rusă", serbian: "Sârb", slovak: "Slovacă", slovenian: "Slovenă", spanish: "Spaniolă", swedish: "Suedez", thai: "Thailandez", turkish: "Turc", ukrainian: "Ucrainean" }, order_summary: "Rezumatul comenzii", payment: { cash_on_delivery: "Plata la livrare", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Carduri de credit (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Carduri de credit (Mercado Pago)", mercadopago_pix: "PIX (piață de plată)", mollie: "Mollie", paypal_connect: "Conectați PayPal", paypal_edit_organization_name: "Editați numele organizației", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Carduri de credit (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Securizat și plătiți", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (stripe)", stripe_card: "Card de credit sau debit", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Carduri de credit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Titularul cardului", card_number_placeholder: "Numărul cardului", cvc_placeholder: "CVC", date_out_of_range: "Data de expirare nu poate fi în trecut", empty_card_holder: "Introduceți un nume al titularului cardului", empty_card_number: "Introduceți un număr de card", empty_cvc: "Introduceți un CVC", empty_expiry_date: "Introduceți o dată de expirare", expiry_data_placeholder: "LL/AA", invalid_card_number: "Numărul cardului este invalid", invalid_cvc: "CVC este invalid", invalid_expiry_date: "Data de expirare este invalidă", month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12", year_out_of_range: "Anul de expirare nu poate fi în trecut" }, "Payment-method": "Modalitate de plată", price_plan: { interval: { day_0: "zi", day_1: "{{count}} zile", day_2: "{{count}} zile", month_0: "lună", month_1: "{{count}} luni", month_2: "{{count}} luni", week_0: "săptămână", week_1: "{{count}} săptămâni", week_2: "{{count}} săptămâni", year_0: "an", year_1: "{{count}} ani", year_2: "{{count}} ani" }, trial_period: { day_0: "{{count}} zi", day_1: "{{count}} zile", day_2: "{{count}} zile", month_0: "{{count}} lună", month_1: "{{count}} luni", month_2: "{{count}} luni", week_0: "{{count}} săptămână", week_1: "{{count}} săptămâni", week_2: "{{count}} săptămâni", year_0: "{{count}} an", year_1: "{{count}} ani", year_2: "{{count}} ani" } }, product: "Produs", quantity: "Cantitate", "registered-over": "înregistrat peste", "required-field": "Câmpul este obligatoriu", shipping: { condition_label: { price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}", price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult", quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole", quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole", weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g", weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult" }, not_available: "Ups! Se pare că nu oferim livrare în această locație încă.", shipping_method: "Metoda de livrare" }, shipping_fee: "Taxa de livrare", subtotal: "Subtotal", total: "Total", total_amount_with_shipping: "Total (inclusiv transport)", total_amount_with_tax: "Total (inclusiv taxe)", total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)", vat: "Taxa pe vânzări", vat_percent: "Taxa pe vânzări ({{percent}}%)" }, ou = {
  public_pages_purchase: iu
}, su = { affiliate_badge: { made_with: "Создано с " }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз", trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем", trial_period_price: "Бесплатно", unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}" } } }, contact_slug: { city: "Город", company_name: "Название компании", country: "Страна", email: "Почта", first_name: "Имя", last_name: "Фамилия", neighborhood: "Соседство", phone_number: "Номер телефона", postal_code: "Почтовый индекс", state_province: "Штат/Область", street_address: "Адрес", street_number: "Номер улицы", tax_number: "Налоговый номер" }, copy_clipboard: "Номер карты недействителен", copy_clipboard_error: "Не удалось скопировать текст", date_picker: { all_time: "Все время", apply: "Применить", clear: "Очистить", from: "От", last_3_months: "Последние 3 месяца", last_30_days: "Последние 30 дней", last_month: "Последний месяц", last_pool_period: "Последний период оценки пула", this_month: "В этом месяце", time: "Время", title_dates: "Даты", to: "В" }, error: "Ошибка", form_select: { empty_list: "Похоже, что этот список пуст.", select: "Выбрать" }, including_tax: "Включает {{percent}}% НДС ({{amount}})", input: { phone_number: "Номер телефона", phone_search: "Поиск", search: "Поиск" }, locale: { albania: "Албанский", arabic: "Арабский", chinese: "Китайский", czech: "Чешский", danish: "Датский", dutch: "Голландский", english: "Английский", french: "Французский", german: "Немецкий", greek: "Греческий", hindi: "Хинди", hungarian: "Венгерский", indonesian: "Индонезийский", italian: "Итальянский", japanese: "Японский", norwegian: "Норвежский", polish: "Польский", portuguese: "Португальский", romanian: "Румынский", russian: "Русский", serbian: "Сербский", slovak: "Словацкий", slovenian: "Словенский", spanish: "Испанский", swedish: "Шведский", thai: "Тайский", turkish: "Турецкий", ukrainian: "Украинский" }, order_summary: "Итог заказа", payment: { cash_on_delivery: "Оплата наличными при доставке", dlocal_boleto: "Заготовка (Dlocal)", dlocal_card: "Кредитные карты (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Билет (Платный рынок)", mercadopago_card: "Кредитные карты", mercadopago_pix: "PIX (Платный рынок)", mollie: "Mollie", paypal_connect: "Подключить PayPal", paypal_edit_organization_name: "Изменить название организации", paypal_rest: "PayPal", paypal_soap: "Разрешить платежи PayPal", paystack_card: "Кредитные карты (Paystack)", price_plan: "План", razorpay: "Razorpay", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", stripe_bancotact: "Разрешить платежи через BanContact", stripe_card: "Кредитная или дебетовая карта", stripe_ideal: "Разрешить платежи через iDeal", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Кредитные карты (Xendit)" }, payment_inputs: { card_holder_placeholder: "Держатель карты", card_number_placeholder: "Номер карты", cvc_placeholder: "CVC код", date_out_of_range: "Дата окончания срока действия не может быть в прошлом", empty_card_holder: "Введите имя держателя карты", empty_card_number: "Введите номер карты", empty_cvc: "Введите CVC код", empty_expiry_date: "Введите дату окончания срока действия", expiry_data_placeholder: "М/Г", invalid_card_number: "Номер карты недействителен", invalid_cvc: "CVC код неправильный", invalid_expiry_date: "Срок годности недействителен", month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12", year_out_of_range: "Год окончания срока действия не может быть в прошлом" }, "Payment-method": "Способ оплаты", price_plan: { interval: { day_0: "день", day_1: "{{count}} дней", day_2: "{{count}} дни", month_0: "месяц", month_1: "{{count}} месяцы", month_2: "{{count}} месяца", week_0: "неделя", week_1: "{{count}} недели", week_2: "{{count}} неделями", year_0: "год", year_1: "{{count}} годы", year_2: "{{count}} лет" }, trial_period: { day_0: "день", day_1: "{{count}} дней", day_2: "{{count}} дни", month_0: "месяц", month_1: "{{count}} месяца", month_2: "{{count}} месяцев", week_0: "{{count}} неделя", week_1: "{{count}} недели", week_2: "{{count}} недель", year_0: "год", year_1: "{{count}} года", year_2: "{{count}} лет" } }, product: "Продукт", quantity: "Количество", "registered-over": "зарегистрировано более чем", "required-field": "Поле обязательно для заполнения", shipping: { condition_label: { price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}", price_min: "Для заказов стоимостью {{min}} {{currency}} или более", quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров", quantity_min: "Для заказов, содержащих {{min}} или более товаров", weight: "Для заказов с общим весом от {{min}}g до {{max}}g", weight_min: "Для заказов с общим весом {{min}}g или более" }, not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.", shipping_method: "Способ доставки" }, shipping_fee: "Стоимость доставки", subtotal: "Промежуточный итог", total: "Итого", total_amount_with_shipping: "Общая сумма (с учетом доставки)", total_amount_with_tax: "Общая сумма (с налогом)", total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)", vat: "Налог с продаж", vat_percent: "Налог с продаж ({{percent}}%)" }, lu = {
  public_pages_purchase: su
}, cu = { affiliate_badge: { made_with: "Poháňané" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát", trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}", trial_period_price: "Zadarmo", unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}" } } }, contact_slug: { city: "Mesto", company_name: "Názov spoločnosti", country: "Krajina", email: "Email", first_name: "Meno", last_name: "Priezvisko", neighborhood: "Štvrť", phone_number: "Telefónne číslo", postal_code: "PSČ", state_province: "Štát/Provincie", street_address: "Ulica", street_number: "Číslo ulice", tax_number: "Daňové číslo" }, copy_clipboard: "Skopírované do schránky", copy_clipboard_error: "Nepodarilo sa skopírovať text", date_picker: { all_time: "Celý čas", apply: "Použiť", clear: "Vymazať", from: "Z", last_3_months: "Posledné 3 mesiace", last_30_days: "Posledných 30 dní", last_month: "Minulý mesiac", last_pool_period: "Posledné hodnotenie bazéna", this_month: "Tento mesiac", time: "Čas", title_dates: "Dátumy", to: "Do" }, error: "Chyba", form_select: { empty_list: "Zdá sa, že tento zoznam je prázdny", select: "Vybrať" }, including_tax: "Vrátane DPH {{percent}}% ({{amount}})", input: { phone_number: "Telefónne číslo", phone_search: "Hľadať", search: "Hľadať" }, locale: { albania: "Albánsky", arabic: "Arabčina", chinese: "čínsky", czech: "český", danish: "Dánčina", dutch: "Holandský", english: "Angličtina", french: "Francúzsky", german: "Nemecký", greek: "Grécky", hindi: "Nie", hungarian: "Maďarský", indonesian: "Indonézsky", italian: "Taliansky", japanese: "Japončina", norwegian: "Nórsky", polish: "Poľský", portuguese: "Portugalčina", romanian: "Rumunský", russian: "Ruský", serbian: "Srbský", slovak: "Slovenský", slovenian: "Slovensky", spanish: "španielčina", swedish: "švédsky", thai: "Thajčina", turkish: "Turecký", ukrainian: "Ukrajinčina" }, order_summary: "Zhrnutie objednávky", payment: { cash_on_delivery: "Platba na dobierku", dlocal_boleto: "Boleto (miestne)", dlocal_card: "Kreditné karty (miestne)", dlocal_pix: "Pix (miestne)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditné karty (Mercado Pago)", mercadopago_pix: "PIX (Platobný trh)", mollie: "Mollie", paypal_connect: "Pripojte PayPal", paypal_edit_organization_name: "Upravte názov organizácie", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditné karty (Paystack)", price_plan: "Plán", razorpay: "Razorpay", secure_and_pay: "Zabezpečiť a zaplatiť", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (pruh)", stripe_card: "Kreditná alebo debetná karta", stripe_ideal: "iDeal (pruh)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditné karty (Xendit)" }, payment_inputs: { card_holder_placeholder: "Držiteľ karty", card_number_placeholder: "Číslo karty", cvc_placeholder: "CVC", date_out_of_range: "Dátum expirácie nemôže byť v minulosti", empty_card_holder: "Zadajte meno držiteľa karty", empty_card_number: "Zadajte číslo karty", empty_cvc: "Zadajte CVC", empty_expiry_date: "Zadajte dátum expirácie", expiry_data_placeholder: "MM/YY", invalid_card_number: "Číslo karty je neplatné", invalid_cvc: "CVC je neplatný", invalid_expiry_date: "Dátum expirácie je neplatný", month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12", year_out_of_range: "Rok expirácie nemôže byť v minulosti" }, "Payment-method": "Spôsob platby", price_plan: { interval: { day_0: "deň", day_1: "{{count}} dní", day_2: "{{count}} dní", month_0: "mesiac", month_1: "{{count}} mesiacov", month_2: "{{count}} mesiacov", week_0: "týždeň", week_1: "{{count}} týždňov", week_2: "{{count}} týždňov", year_0: "rok", year_1: "{{count}} rokov", year_2: "{{count}} rokov" }, trial_period: { day_0: "{{count}} deň", day_1: "{{count}} dní", day_2: "{{count}} dní", month_0: "{{count}} mesiac", month_1: "{{count}} mesiacov", month_2: "{{count}} mesiacov", week_0: "{{count}} týždeň", week_1: "{{count}} týždňov", week_2: "{{count}} týždňov", year_0: "{{count}} rok", year_1: "{{count}} rokov", year_2: "{{count}} rokov" } }, product: "Produkt", quantity: "Množstvo", "registered-over": "registrované viac ako", "required-field": "Pole je povinné", shipping: { condition_label: { price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}", price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac", quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami", quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek", weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g", weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac" }, not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.", shipping_method: "Spôsob dopravy" }, shipping_fee: "Poplatok za dopravu", subtotal: "Medzisúčet", total: "Celkom", total_amount_with_shipping: "Celkom (vrátane dopravy)", total_amount_with_tax: "Celkom (vrátane dane)", total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)", vat: "Daň z predaja", vat_percent: "Daň z predaja ({{percent}}%)" }, uu = {
  public_pages_purchase: cu
}, du = { affiliate_badge: { made_with: "Powered by" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat", trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem", trial_period_price: "Brezplačno", unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}" } } }, contact_slug: { city: "Mesto", company_name: "Ime podjetja", country: "Država", email: "E-pošta", first_name: "Ime", last_name: "Priimek", neighborhood: "Soseska", phone_number: "Telefonska številka", postal_code: "Poštna številka", state_province: "Država/Provinca", street_address: "Ulična naslov", street_number: "Številka ulice", tax_number: "Davčna številka" }, copy_clipboard: "Kopirano v odložišče", copy_clipboard_error: "Kopiranje besedila ni uspelo", date_picker: { all_time: "Vse čase", apply: "Uporabi", clear: "Počisti", from: "Iz", last_3_months: "Zadnja 3 meseca", last_30_days: "Zadnjih 30 dni", last_month: "Zadnji mesec", last_pool_period: "Zadnje obdobje ocenjevanja bazena", this_month: "Ta mesec", time: "Čas", title_dates: "Datumi", to: "Do" }, error: "Napaka", form_select: { empty_list: "Zdi se, da je ta seznam prazen", select: "Izberi" }, including_tax: "Vključeno {{percent}}% DDV ({{amount}})", input: { phone_number: "Telefonska številka", phone_search: "Iskanje", search: "Iskanje" }, locale: { albania: "Albanski", arabic: "Arabsko", chinese: "Kitajski", czech: "češki", danish: "Danščina", dutch: "Nizozemščina", english: "Angleščina", french: "Francosko", german: "Nemški", greek: "Grški", hindi: "Ne", hungarian: "Madžarski", indonesian: "Indonezijski", italian: "Italijanski", japanese: "Japonska", norwegian: "Norveški", polish: "Poljski", portuguese: "Portugalščina", romanian: "Romunščina", russian: "Ruski", serbian: "Srbsko", slovak: "Slovaški", slovenian: "Slovenščina", spanish: "španski", swedish: "švedščina", thai: "Tajska", turkish: "Turško", ukrainian: "Ukrajinski" }, order_summary: "Povzetek naročila", payment: { cash_on_delivery: "Gotovino po povzetju", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditne kartice (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditne kartice (Mercado Pago)", mercadopago_pix: "PIX (plačilni trg)", mollie: "Mollie", paypal_connect: "Povežite PayPal", paypal_edit_organization_name: "Uredi ime organizacije", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditne kartice (Paystack)", price_plan: "Načrtujte", razorpay: "Razorpay", secure_and_pay: "Zavarujte in plačajte", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kreditna ali debetna kartica", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditne kartice (Xendit)" }, payment_inputs: { card_holder_placeholder: "Imetnik kartice", card_number_placeholder: "Številka kartice", cvc_placeholder: "CVC", date_out_of_range: "Datum poteka ne more biti v preteklosti", empty_card_holder: "Vnesite ime imetnika kartice", empty_card_number: "Vnesite številko kartice", empty_cvc: "Vnesite CVC", empty_expiry_date: "Vnesite datum poteka", expiry_data_placeholder: "MM/YY", invalid_card_number: "Številka kartice je neveljavna", invalid_cvc: "CVC je neveljaven", invalid_expiry_date: "Datum poteka je neveljaven", month_out_of_range: "Mesec poteka mora biti med 01 in 12", year_out_of_range: "Leto poteka ne more biti v preteklosti" }, "Payment-method": "Način plačila", price_plan: { interval: { day_0: "dan", day_1: "{{count}} dni", day_2: "{{count}} dni", day_3: "{{count}} dni", month_0: "mesec", month_1: "{{count}} mesecev", month_2: "{{count}} mesecev", month_3: "{{count}} mesecev", week_0: "teden", week_1: "{{count}} tednov", week_2: "{{count}} tednov", week_3: "{{count}} tednov", year_0: "leto", year_1: "{{count}} let", year_2: "{{count}} let", year_3: "{{count}} let" }, trial_period: { day_0: "{{count}} dan", day_1: "{{count}} dni", day_2: "{{count}} dni", day_3: "{{count}} dni", month_0: "{{count}} mesec", month_1: "{{count}} mesecev", month_2: "{{count}} mesecev", month_3: "{{count}} mesecev", week_0: "{{count}} teden", week_1: "{{count}} tednov", week_2: "{{count}} tednov", week_3: "{{count}} tednov", year_0: "{{count}} leto", year_1: "{{count}} let", year_2: "{{count}} let", year_3: "{{count}} let" } }, product: "Izdelek", quantity: "Količina", "registered-over": "registrirani več kot", "required-field": "Polje je obvezno", shipping: { condition_label: { price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}", price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več", quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli", quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov", weight: "Za naročila s skupno težo med {{min}}g in {{max}}g", weight_min: "Za naročila s skupno težo {{min}}g ali več" }, not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.", shipping_method: "Način dostave" }, shipping_fee: "Strošek dostave", subtotal: "Medseštevek", total: "Skupaj", total_amount_with_shipping: "Skupaj (vključno s poštnino)", total_amount_with_tax: "Skupaj (vključno z davkom)", total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)", vat: "Davek na prodajo", vat_percent: "Davek na prodajo ({{percent}}%)" }, pu = {
  public_pages_purchase: du
}, mu = { affiliate_badge: { made_with: "E fuqizuar nga" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë", trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj", trial_period_price: "Falas", unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}" } } }, contact_slug: { city: "Qyteti", company_name: "Emri i kompanisë", country: "Shteti", email: "Email", first_name: "Emri i parë", last_name: "Mbiemri", neighborhood: "Lagja", phone_number: "Numri i telefonit", postal_code: "Kodi postar", state_province: "Shteti/Provinca", street_address: "Adresa e rrugës", street_number: "Numri i rrugës", tax_number: "Numri i tatimit" }, copy_clipboard: "Kopjuhet në clipboard", copy_clipboard_error: "Dështoi të kopjohet teksti", date_picker: { all_time: "Të gjitha kohët", apply: "Apliko", clear: "Pastro", from: "Nga", last_3_months: "3 muajt e fundit", last_30_days: "30 ditët e fundit", last_month: "Muaji i kaluar", last_pool_period: "Periudha e fundit e vlerësimit të grupit", this_month: "Ky muaj", time: "Koha", title_dates: "Datat", to: "Në" }, error: "Gabim", form_select: { empty_list: "Duket se kjo listë është bosh", select: "Zgjidhni" }, including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})", input: { phone_number: "Numri i telefonit", phone_search: "Kërko", search: "Kërko" }, locale: { albania: "Shqiptare", arabic: "Arabisht", chinese: "Kineze", czech: "çeke", danish: "Daneze", dutch: "Holandeze", english: "Anglisht", french: "Frëngjisht", german: "Gjermane", greek: "Greke", hindi: "Jo", hungarian: "Hungareze", indonesian: "Indonezisht", italian: "Italisht", japanese: "Japoneze", norwegian: "Norvegjeze", polish: "Polonisht", portuguese: "Portugeze", romanian: "Rumun", russian: "Rusisht", serbian: "Serb", slovak: "Sllovake", slovenian: "Slloven", spanish: "Spanjisht", swedish: "Suedeze", thai: "Thai", turkish: "Turk", ukrainian: "Ukrainase" }, order_summary: "Përmbledhja e Porosisë", payment: { cash_on_delivery: "Para ne dore gjate dorezimit", dlocal_boleto: "Boleto (lokale)", dlocal_card: "Kartat e kreditit (Dlokale)", dlocal_pix: "Pix (vendor)", flutterwave: "Flutterwave", gocardless: "Pa kartë", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kartat e kreditit (Mercado Pago)", mercadopago_pix: "PIX (Tregu i Pagesave)", mollie: "Mollie", paypal_connect: "Lidhni PayPal", paypal_edit_organization_name: "Redakto emrin e organizatës", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kartat e kreditit (Paystack)", price_plan: "Planifikoni", razorpay: "Razorpay", secure_and_pay: "Siguro dhe Paguaj", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (shirit)", stripe_card: "Kartë krediti ose debiti", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kartat e kreditit (Xendit)" }, payment_inputs: { card_holder_placeholder: "Emri i mbajtësit të kartës", card_number_placeholder: "Numri i kartës", cvc_placeholder: "CVC", date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën", empty_card_holder: "Shkruani emrin e mbajtësit të kartës", empty_card_number: "Shkruani një numër kartelash", empty_cvc: "Shkruani një CVC", empty_expiry_date: "Shkruani një datë skadimi", expiry_data_placeholder: "MM/YY", invalid_card_number: "Numri i kartelës është i pavlefshëm", invalid_cvc: "CVC është i pavlefshëm", invalid_expiry_date: "Data e skadencës është e pavlefshme", month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12", year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën" }, "Payment-method": "Mënyra e pagesës", price_plan: { interval: { day: "ditë", day_plural: "{{count}} ditë", month: "muaj", month_plural: "{{count}} muaj", week: "javë", week_plural: "{{count}} javë", year: "vit", year_plural: "{{count}} vjet" }, trial_period: { day: "{{count}} ditë", day_plural: "{{count}} ditë", month: "{{count}} muaj", month_plural: "{{count}} muaj", week: "{{count}} javë", week_plural: "{{count}} javë", year: "{{count}} vit", year_plural: "{{count}} vjet" } }, product: "Produkt", quantity: "Sasia", "registered-over": "regjistruar mbi", "required-field": "Fusha kërkohet", shipping: { condition_label: { price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}", price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë", quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj", quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj", weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g", weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë" }, not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.", shipping_method: "Metoda e Dërgesës" }, shipping_fee: "Tarifa e dërgesës", subtotal: "Nëntotali", total: "Totali", total_amount_with_shipping: "Totali (përfshirë Transportin)", total_amount_with_tax: "Totali (përfshirë taksën)", total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)", vat: "Tatimi mbi shitjet", vat_percent: "Tatimi mbi shitjet ({{percent}}%)" }, hu = {
  public_pages_purchase: mu
}, fu = { affiliate_badge: { made_with: "Pokreće" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута", trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда", trial_period_price: "Бесплатно", unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}" } } }, contact_slug: { city: "Grad", company_name: "Naziv kompanije", country: "Zemlja", email: "Email", first_name: "Ime", last_name: "Prezime", neighborhood: "Kraj", phone_number: "Broj telefona", postal_code: "Poštanski broj", state_province: "Država/Provincija", street_address: "Adresa", street_number: "Broj ulice", tax_number: "Poreski broj" }, copy_clipboard: "Kopirano u međuspremnik", copy_clipboard_error: "Kopiranje teksta nije uspelo", date_picker: { all_time: "Sve vreme", apply: "Primeni", clear: "Obriši", from: "Od", last_3_months: "Poslednja 3 meseca", last_30_days: "Poslednjih 30 dana", last_month: "Prošli mesec", last_pool_period: "Poslednji period evaluacije", this_month: "Ovaj mesec", time: "Vreme", title_dates: "Datumi", to: "Do" }, error: "Грешка", form_select: { empty_list: "Izgleda da je ova lista prazna", select: "Izaberi" }, including_tax: "Uključujući {{percent}}% PDV ({{amount}})", input: { phone_number: "Broj telefona", phone_search: "Pretraži", search: "Pretraži" }, locale: { albania: "Албанац", arabic: "арапски", chinese: "кинески", czech: "чешки", danish: "дански", dutch: "холандски", english: "енглески језик", french: "Француски", german: "Немачки", greek: "грчки", hindi: "Јок", hungarian: "мађарски", indonesian: "индонезијски", italian: "Италијан", japanese: "јапански", norwegian: "норвешки", polish: "Пољски", portuguese: "португалски", romanian: "румунски", russian: "Руски", serbian: "Српски", slovak: "словачки", slovenian: "словеначки", spanish: "Шпански", swedish: "Шведски", thai: "тајландски", turkish: "турски", ukrainian: "украјински" }, order_summary: "Pregled narudžbine", payment: { cash_on_delivery: "Плаћање поузећем", dlocal_boleto: "Болето (Длоцал)", dlocal_card: "Кредитне картице (Длоцал)", dlocal_pix: "Пик (Длоцал)", flutterwave: "Флуттерваве", gocardless: "Гоцардлесс", mercadopago_boleto: "Болето (Меркадо Паго)", mercadopago_card: "Кредитне картице (Мерцадо Паго)", mercadopago_pix: "ПИКС (тржиште плаћања)", mollie: "Моллие", paypal_connect: "Повежите ПаиПал", paypal_edit_organization_name: "Измените назив организације", paypal_rest: "ПаиПал", paypal_soap: "ПаиПал", paystack_card: "Кредитне картице (Паистацк)", price_plan: "План", razorpay: "Разорпаи", secure_and_pay: "Осигурајте и платите", stripe_applepay: "Apple Pay", stripe_bancotact: "Банцонтацт (Стрипе)", stripe_card: "Kreditna ili debitna kartica", stripe_ideal: "иДеал (Стрипе)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Кредитне картице (Ксендит)" }, payment_inputs: { card_holder_placeholder: "Ime vlasnika kartice", card_number_placeholder: "Broj kartice", cvc_placeholder: "CVC", date_out_of_range: "Datum isteka ne može biti u prošlosti", empty_card_holder: "Unesite ime vlasnika kartice", empty_card_number: "Unesite broj kartice", empty_cvc: "Unesite CVC", empty_expiry_date: "Unesite datum isteka", expiry_data_placeholder: "MM/YY", invalid_card_number: "Broj kartice je nevažeći", invalid_cvc: "CVC je nevažeći", invalid_expiry_date: "Datum isteka je nevažeći", month_out_of_range: "Mesec isteka mora biti između 01 i 12", year_out_of_range: "Godina isteka ne može biti u prošlosti" }, "Payment-method": "Начин плаћања", price_plan: { interval: { day_0: "дан", day_1: "{{count}} дана", day_2: "{{count}} дана", month_0: "месец", month_1: "{{count}} месеци", month_2: "{{count}} месеци", week_0: "недељу дана", week_1: "{{count}} недеља", week_2: "{{count}} недеља", year_0: "године", year_1: "{{count}} година", year_2: "{{count}} година" }, trial_period: { day_0: "{{count}} дан", day_1: "{{count}} дана", day_2: "{{count}} дана", month_0: "{{count}} месец", month_1: "{{count}} месеци", month_2: "{{count}} месеци", week_0: "{{count}} недеља", week_1: "{{count}} недеља", week_2: "{{count}} недеља", year_0: "{{count}} година", year_1: "{{count}} година", year_2: "{{count}} година" } }, product: "Proizvod", quantity: "Količina", "registered-over": "registrovano više od", "required-field": "Поље је обавезно", shipping: { condition_label: { price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}", price_min: "Za narudžbine od {{min}} {{currency}} ili više", quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki", quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki", weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g", weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više" }, not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.", shipping_method: "Metod isporuke" }, shipping_fee: "Trošak isporuke", subtotal: "Međuzbir", total: "Ukupno", total_amount_with_shipping: "Ukupno (uključujući dostavu)", total_amount_with_tax: "Ukupno (uključujući porez)", total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)", vat: "Porez na promet", vat_percent: "Porez na promet ({{percent}}%)" }, gu = {
  public_pages_purchase: fu
}, _u = { affiliate_badge: { made_with: "Drivs av" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger", trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan", trial_period_price: "Gratis", unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}" } } }, contact_slug: { city: "Stad", company_name: "Företagsnamn", country: "Land", email: "E-post", first_name: "Förnamn", last_name: "Efternamn", neighborhood: "Grannskap", phone_number: "Telefonnummer", postal_code: "Postnummer", state_province: "Stat/Provins", street_address: "Gatuadress", street_number: "Gatu nummer", tax_number: "Skattenummer" }, copy_clipboard: "Kopierad till urklipp", copy_clipboard_error: "Misslyckades med att kopiera text", date_picker: { all_time: "All tid", apply: "Tillämpa", clear: "Rensa", from: "Från", last_3_months: "Senaste 3 månaderna", last_30_days: "Senaste 30 dagarna", last_month: "Senaste månaden", last_pool_period: "Senaste poolutvärderingsperioden", this_month: "Denna månad", time: "Tid", title_dates: "Datum", to: "Till" }, error: "Fel", form_select: { empty_list: "Det verkar som att denna lista är tom", select: "Välj" }, including_tax: "Inklusive {{percent}}% moms ({{amount}})", input: { phone_number: "Telefonnummer", phone_search: "Sök", search: "Sök" }, locale: { albania: "Albanska", arabic: "Arabiska", chinese: "Kinesiska", czech: "Tjeckiska", danish: "Danska", dutch: "Holländska", english: "Engelsk", french: "Franska", german: "Tysk", greek: "Grekisk", hindi: "Nej", hungarian: "Ungerska", indonesian: "Indonesiska", italian: "Italienska", japanese: "Japanska", norwegian: "Norska", polish: "Putsa", portuguese: "Portugisiska", romanian: "Rumänska", russian: "Ryska", serbian: "Serbiska", slovak: "Slovakiska", slovenian: "Slovenska", spanish: "Spanska", swedish: "Svenska", thai: "Thai", turkish: "Turkiska", ukrainian: "Ukrainska" }, order_summary: "Orderöversikt", payment: { cash_on_delivery: "Postförskott", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kreditkort (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Fluttervåg", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kreditkort (Mercado Pago)", mercadopago_pix: "PIX (betalningsmarknad)", mollie: "Mollie", paypal_connect: "Anslut PayPal", paypal_edit_organization_name: "Redigera organisationens namn", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kreditkort (Paystack)", price_plan: "Planen", razorpay: "Razorpay", secure_and_pay: "Säkra och betala", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Kredit- eller betalkort", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Kreditkort (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kortinnehavare", card_number_placeholder: "Kortnummer", cvc_placeholder: "CVC", date_out_of_range: "Utgångsdatum kan inte vara i det förflutna", empty_card_holder: "Ange ett namn på kortinnehavaren", empty_card_number: "Ange ett kortnummer", empty_cvc: "Ange en CVC", empty_expiry_date: "Ange ett utgångsdatum", expiry_data_placeholder: "MM/ÅÅ", invalid_card_number: "Kortnumret är ogiltigt", invalid_cvc: "CVC är ogiltigt", invalid_expiry_date: "Utgångsdatum är ogiltigt", month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12", year_out_of_range: "Utgångsår kan inte vara i det förflutna" }, "Payment-method": "Betalningsmetod", price_plan: { interval: { day: "dag", day_plural: "{{count}} dagar", month: "månad", month_plural: "{{count}} månader", week: "vecka", week_plural: "{{count}} veckor", year: "år", year_plural: "{{count}} år" }, trial_period: { day: "{{count}} dag", day_plural: "{{count}} dagar", month: "{{count}} månad", month_plural: "{{count}} månader", week: "{{count}} vecka", week_plural: "{{count}} veckor", year: "{{count}} år", year_plural: "{{count}} år" } }, product: "Produkt", quantity: "Antal", "registered-over": "registrerade över", "required-field": "Fält är obligatoriskt", shipping: { condition_label: { price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}", price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer", quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar", quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar", weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g", weight_min: "För beställningar med en totalvikt av {{min}}g eller mer" }, not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.", shipping_method: "Fraktmetod" }, shipping_fee: "Fraktavgift", subtotal: "Delsumma", total: "Totalt", total_amount_with_shipping: "Totalt (inklusive frakt)", total_amount_with_tax: "Totalt (inklusive moms)", total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)", vat: "Moms", vat_percent: "Moms ({{percent}}%)" }, yu = {
  public_pages_purchase: _u
}, bu = { affiliate_badge: { made_with: "ขับเคลื่อนโดย" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง", trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น", trial_period_price: "ฟรี", unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}" } } }, contact_slug: { city: "เมือง", company_name: "ชื่อบริษัท", country: "ประเทศ", email: "อีเมล", first_name: "ชื่อจริง", last_name: "นามสกุล", neighborhood: "ย่าน", phone_number: "หมายเลขโทรศัพท์", postal_code: "รหัสไปรษณีย์", state_province: "รัฐ/จังหวัด", street_address: "ที่อยู่ถนน", street_number: "หมายเลขถนน", tax_number: "หมายเลขภาษี" }, copy_clipboard: "คัดลอกไปยังคลิปบอร์ด", copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้", date_picker: { all_time: "ทั้งหมด", apply: "สมัคร", clear: "ล้าง", from: "จาก", last_3_months: "3 เดือนที่ผ่านมา", last_30_days: "30 วันที่ผ่านมา", last_month: "เดือนที่แล้ว", last_pool_period: "ช่วงเวลาประเมินผลล่าสุด", this_month: "เดือนนี้", time: "เวลา", title_dates: "วันที่", to: "ถึง" }, error: "ข้อผิดพลาด", form_select: { empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า", select: "เลือก" }, including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})", input: { phone_number: "หมายเลขโทรศัพท์", phone_search: "ค้นหา", search: "ค้นหา" }, locale: { albania: "แอลเบเนีย", arabic: "ภาษาอาหรับ", chinese: "ชาวจีน", czech: "เช็ก", danish: "ภาษาเดนมาร์ก", dutch: "ภาษาดัตช์", english: "ภาษาอังกฤษ", french: "ภาษาฝรั่งเศส", german: "เยอรมัน", greek: "กรีก", hindi: "ไม่", hungarian: "ภาษาฮังการี", indonesian: "ชาวอินโดนีเซีย", italian: "ภาษาอิตาลี", japanese: "ญี่ปุ่น", norwegian: "ภาษานอร์เวย์", polish: "ขัด", portuguese: "โปรตุเกส", romanian: "โรมาเนีย", russian: "ภาษารัสเซีย", serbian: "เซอร์เบีย", slovak: "สโลวัก", slovenian: "ภาษาสโลเวเนีย", spanish: "สเปน", swedish: "ภาษาสวีเดน", thai: "แบบไทย", turkish: "ภาษาตุรกี", ukrainian: "ภาษายูเครน" }, order_summary: "สรุปคำสั่งซื้อ", payment: { cash_on_delivery: "เงินสดในการจัดส่ง", dlocal_boleto: "โบเลโต (Dlocal)", dlocal_card: "บัตรเครดิต (ดีโลคอล)", dlocal_pix: "Pix (Dlocal)", flutterwave: "กระพือปีก", gocardless: "ไร้บัตร", mercadopago_boleto: "โบเลโต (Mercado Pago)", mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)", mercadopago_pix: "PIX (ตลาดการชำระเงิน)", mollie: "มอลลี่", paypal_connect: "เชื่อมต่อเพย์พาล", paypal_edit_organization_name: "แก้ไขชื่อองค์กร", paypal_rest: "เพย์พาล", paypal_soap: "เพย์พาล", paystack_card: "บัตรเครดิต (เพย์สแต็ค)", price_plan: "วางแผน", razorpay: "เรเซอร์เพย์", secure_and_pay: "ปลอดภัยและชำระเงิน", stripe_applepay: "Apple Pay", stripe_bancotact: "แบนคอนแทค (ลายทาง)", stripe_card: "บัตรเครดิตหรือเดบิต", stripe_ideal: "ไอดีล (ลายทาง)", stripe_klarna: "คลาร์น่า (สไตรป์)", stripe_multibanco: "มัลติแบงก์ (สตรีป)", xendit: { "3ds": "3D-Secure" }, xendit_card: "บัตรเครดิต (Xendit)" }, payment_inputs: { card_holder_placeholder: "ชื่อผู้ถือบัตร", card_number_placeholder: "หมายเลขบัตร", cvc_placeholder: "CVC", date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้", empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร", empty_card_number: "กรอกหมายเลขบัตร", empty_cvc: "กรุณาใส่ CVC", empty_expiry_date: "กรอกวันที่หมดอายุ", expiry_data_placeholder: "MM/YY", invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง", invalid_cvc: "CVC ไม่ถูกต้อง", invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง", month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12", year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้" }, "Payment-method": "วิธีการชำระเงิน", price_plan: { interval: { day: "วัน", month: "เดือน", week: "สัปดาห์", year: "ปี" }, trial_period: { day: "{{count}} วัน", month: "{{count}} เดือน", week: "{{count}} สัปดาห์", year: "{{count}} ปี" } }, product: "ผลิตภัณฑ์", quantity: "จำนวน", "registered-over": "ลงทะเบียนมากกว่า", "required-field": "จำเป็นต้องกรอกข้อมูล", shipping: { condition_label: { price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}", price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป", quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ", quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป", weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g", weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป" }, not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้", shipping_method: "วิธีการจัดส่ง" }, shipping_fee: "ค่าจัดส่ง", subtotal: "ยอดรวมย่อย", total: "รวม", total_amount_with_shipping: "รวมค่าส่งแล้ว", total_amount_with_tax: "รวมทั้งภาษีแล้ว", total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)", vat: "ภาษีขาย", vat_percent: "ภาษีขาย ({{percent}}%)" }, vu = {
  public_pages_purchase: bu
}, Su = { affiliate_badge: { made_with: "Tarafından desteklenmektedir" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez", trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra", trial_period_price: "Ücretsiz", unlimited_new: "<bold>{{amount}}</bold> her {{interval}}" } } }, contact_slug: { city: "Şehir", company_name: "Şirket adı", country: "Ülke", email: "E-posta", first_name: "İsim", last_name: "Soyisim", neighborhood: "Mahalle", phone_number: "Telefon numarası", postal_code: "Posta kodu", state_province: "Eyalet/İl", street_address: "Sokak adresi", street_number: "Sokak numarası", tax_number: "Vergi numarası" }, copy_clipboard: "Panoya kopyalandı", copy_clipboard_error: "Metin kopyalanamadı", date_picker: { all_time: "Tüm zamanlar", apply: "Uygula", clear: "Temizle", from: "Tarihinden itibaren", last_3_months: "Son 3 ay", last_30_days: "Son 30 gün", last_month: "Geçen Ay", last_pool_period: "Son havuz değerlendirme dönemi", this_month: "Bu Ay", time: "Zaman", title_dates: "Tarihler", to: "Tarihine kadar" }, error: "Hata", form_select: { empty_list: "Bu liste boş gibi görünüyor", select: "Seçin" }, including_tax: "KDV dahil {{percent}}% ({{amount}})", input: { phone_number: "Telefon numarası", phone_search: "Ara", search: "Ara" }, locale: { albania: "Arnavut", arabic: "Arap", chinese: "Çince", czech: "Çek", danish: "Danimarka", dutch: "Flemenkçe", english: "İngilizce", french: "Fransızca", german: "Almanca", greek: "Yunan", hindi: "Hintçe", hungarian: "Macarca", indonesian: "Endonezya dili", italian: "İtalyan", japanese: "Japonca", norwegian: "Norveççe", polish: "Lehçe", portuguese: "Portekizce", romanian: "Romen", russian: "Rusça", serbian: "Sırpça", slovak: "Slovak", slovenian: "Slovence", spanish: "İspanyol", swedish: "İsveççe", thai: "Tay dili", turkish: "Türkçe", ukrainian: "Ukrayna" }, order_summary: "Sipariş Özeti", payment: { cash_on_delivery: "Kapıda ödeme", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Kredi kartları (Dlocal)", dlocal_pix: "Pix (Dlocal)", flutterwave: "Çarpıntı dalgası", gocardless: "Gocardless", mercadopago_boleto: "Boleto (Mercado Pago)", mercadopago_card: "Kredi kartları (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mollie: "Mollie", paypal_connect: "PayPal'ı bağlayın", paypal_edit_organization_name: "Kuruluş adını düzenleyin", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Kredi kartları (Paystack)", price_plan: "Plan", razorpay: "Razorpay", secure_and_pay: "Güvenli ve Ödemeli", stripe_applepay: "Apple Pay", stripe_bancotact: "İletişimi yasakla (Stripe)", stripe_card: "Kredi veya banka kartı", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Klarna (Stripe)", stripe_multibanco: "Multibanco (Stripe)", xendit: { "3ds": "3D-Güvenlik" }, xendit_card: "Kredi kartları (Xendit)" }, payment_inputs: { card_holder_placeholder: "Kart sahibi", card_number_placeholder: "Kart numarası", cvc_placeholder: "CVC", date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz", empty_card_holder: "Bir kart sahibi adı girin", empty_card_number: "Bir kart numarası girin", empty_cvc: "CVC girin", empty_expiry_date: "Bir son kullanma tarihi girin", expiry_data_placeholder: "AA/YY", invalid_card_number: "Kart numarası geçersiz", invalid_cvc: "CVC geçersiz", invalid_expiry_date: "Son kullanma tarihi geçersiz", month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır", year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz" }, "Payment-method": "Ödeme yöntemi", price_plan: { interval: { day: "gün", day_plural: "{{count}} gün", month: "ay", month_plural: "{{count}} ay", week: "hafta", week_plural: "{{count}} hafta", year: "yıl", year_plural: "{{count}} yıl" }, trial_period: { day: "{{count}} gün", day_plural: "{{count}} gün", month: "{{count}} ay", month_plural: "{{count}} ay", week: "{{count}} hafta", week_plural: "{{count}} hafta", year: "{{count}} yıl", year_plural: "{{count}} yıl" } }, product: "Ürün", quantity: "Miktar", "registered-over": "kaydedilen", "required-field": "Alan gereklidir", shipping: { condition_label: { price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için", price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için", quantity: "{{min}} ile {{max}} ürün içeren siparişler için", quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için", weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için", weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için" }, not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.", shipping_method: "Gönderim Yöntemi" }, shipping_fee: "Gönderim ücreti", subtotal: "Ara Toplam", total: "Toplam", total_amount_with_shipping: "Toplam (kargo dahil)", total_amount_with_tax: "Toplam (vergiler dahil)", total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)", vat: "Satış vergisi", vat_percent: "Satış vergisi ({{percent}}%)" }, ku = {
  public_pages_purchase: Su
}, Mu = { affiliate_badge: { made_with: "Підтримується" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів", trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ", trial_period_price: "безкоштовно", unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}" } } }, contact_slug: { city: "Місто", company_name: "Назва компанії", country: "Країна", email: "Електронна пошта", first_name: "Ім'я", last_name: "Прізвище", neighborhood: "Район", phone_number: "Номер телефону", postal_code: "Поштовий індекс", state_province: "Штат/Область", street_address: "Вулиця", street_number: "Номер вулиці", tax_number: "Податковий номер" }, copy_clipboard: "Скопійовано в буфер обміну", copy_clipboard_error: "Не вдалося скопіювати текст", date_picker: { all_time: "Весь час", apply: "Застосувати", clear: "Очистити", from: "З", last_3_months: "Останні 3 місяці", last_30_days: "Останні 30 днів", last_month: "Останній місяць", last_pool_period: "Останній період оцінки пулу", this_month: "Цей місяць", time: "Час", title_dates: "Дати", to: "До" }, error: "Помилка", form_select: { empty_list: "Схоже, що цей список порожній", select: "Вибрати" }, including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})", input: { phone_number: "Номер телефону", phone_search: "Пошук", search: "Пошук" }, locale: { albania: "албанець", arabic: "арабська", chinese: "китайський", czech: "чеська", danish: "датська", dutch: "голландська", english: "англійська", french: "французька", german: "Німецький", greek: "грецька", hindi: "ні", hungarian: "угорська", indonesian: "індонезійська", italian: "італійська", japanese: "Японський", norwegian: "норвезька", polish: "польський", portuguese: "португальська", romanian: "румунська", russian: "російський", serbian: "сербська", slovak: "словацький", slovenian: "словенська", spanish: "Іспанська", swedish: "шведська", thai: "тайська", turkish: "турецька", ukrainian: "Українська" }, order_summary: "Підсумок замовлення", payment: { cash_on_delivery: "Накладений платіж", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "Кредитні картки (Dlocal)", dlocal_pix: "Пікс (Dlocal)", flutterwave: "Флаттервейв", gocardless: "Gocardless", mercadopago_boleto: "Болето (Меркадо Паго)", mercadopago_card: "Кредитні картки (Mercado Pago)", mercadopago_pix: "PIX (платіжний ринок)", mollie: "Моллі", paypal_connect: "Підключіть PayPal", paypal_edit_organization_name: "Редагувати назву організації", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "Кредитні картки (Paystack)", price_plan: "План", razorpay: "Razorpay", secure_and_pay: "Захистіть і заплатите", stripe_applepay: "Apple Pay", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "Кредитна або дебетова карта", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "Кларна (Stripe)", stripe_multibanco: "Мультибанко (Stripe)", xendit: { "3ds": "3D-Secure" }, xendit_card: "Кредитні картки (Xendit)" }, payment_inputs: { card_holder_placeholder: "Власник картки", card_number_placeholder: "Номер картки", cvc_placeholder: "CVC", date_out_of_range: "Дата закінчення не може бути в минулому", empty_card_holder: "Введіть ім'я власника картки", empty_card_number: "Введіть номер картки", empty_cvc: "Введіть CVC", empty_expiry_date: "Введіть дату закінчення терміну дії", expiry_data_placeholder: "ММ/РР", invalid_card_number: "Номер картки недійсний", invalid_cvc: "CVC недійсний", invalid_expiry_date: "Дата закінчення недійсна", month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12", year_out_of_range: "Рік закінчення не може бути в минулому" }, "Payment-method": "Спосіб оплати", price_plan: { interval: { day_0: "день", day_1: "{{count}} днів", day_2: "{{count}} днів", month_0: "місяць", month_1: "{{count}} місяців", month_2: "{{count}} місяців", week_0: "тиждень", week_1: "{{count}} тижнів", week_2: "{{count}} тижнів", year_0: "рік", year_1: "{{count}} років", year_2: "{{count}} років" }, trial_period: { day_0: "{{count}} день", day_1: "{{count}} днів", day_2: "{{count}} днів", month_0: "{{count}} місяць", month_1: "{{count}} місяців", month_2: "{{count}} місяців", week_0: "{{count}} тиждень", week_1: "{{count}} тижнів", week_2: "{{count}} тижнів", year_0: "{{count}} рік", year_1: "{{count}} років", year_2: "{{count}} років" } }, product: "Продукт", quantity: "Кількість", "registered-over": "зареєстровано понад", "required-field": "Поле обов'язкове", shipping: { condition_label: { price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}", price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше", quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів", quantity_min: "Для замовлень, що містять {{min}} або більше товарів", weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g", weight_min: "Для замовлень з загальною вагою {{min}}g або більше" }, not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.", shipping_method: "Спосіб доставки" }, shipping_fee: "Вартість доставки", subtotal: "Проміжний підсумок", total: "Всього", total_amount_with_shipping: "Загалом (з урахуванням доставки)", total_amount_with_tax: "Загалом (з урахуванням податку)", total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)", vat: "Податок на продаж", vat_percent: "Податок з продажу ({{percent}}%)" }, wu = {
  public_pages_purchase: Mu
}, Cu = { affiliate_badge: { made_with: "技术支持" }, components: { offer_price: { price_plans: { limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次", trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后", trial_period_price: "免费", unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}" } } }, contact_slug: { city: "城市", company_name: "公司名称", country: "国家", email: "电子邮件", first_name: "名字", last_name: "姓氏", neighborhood: "街道邻里", phone_number: "电话号码", postal_code: "邮政编码", state_province: "州/省", street_address: "街道地址", street_number: "街道号码", tax_number: "税号" }, copy_clipboard: "已复制到剪贴板", copy_clipboard_error: "复制文本失败", date_picker: { all_time: "所有的时间", apply: "应用", clear: "清除", from: "从", last_3_months: "过去3个月", last_30_days: "过去30天", last_month: "次月", last_pool_period: "最后一个池评估期", this_month: "这个月", time: "时间", title_dates: "日期", to: "到" }, error: "错误", form_select: { empty_list: "看起来这个列表是空的", select: "选择" }, including_tax: "含{{percent}}%增值税（{{amount}}）", input: { phone_number: "电话号码", phone_search: "搜索", search: "搜索" }, locale: { albania: "阿尔巴尼亚语", arabic: "阿拉伯语", chinese: "中國人", czech: "捷克语", danish: "丹麦语", dutch: "荷兰语", english: "英语", french: "法语", german: "德语", greek: "希腊语", hindi: "印地语", hungarian: "匈牙利语", indonesian: "印度尼西亚语", italian: "意大利语", japanese: "日语", norwegian: "挪威语", polish: "波兰语", portuguese: "葡萄牙语", romanian: "罗马尼亚语", russian: "俄语", serbian: "塞尔维亚语", slovak: "斯洛伐克语", slovenian: "斯洛文尼亚语", spanish: "西班牙语", swedish: "瑞典语", thai: "泰语", turkish: "土耳其语", ukrainian: "乌克兰语" }, order_summary: "订单摘要", payment: { cash_on_delivery: "货到付款", dlocal_boleto: "Boleto (Dlocal)", dlocal_card: "信用卡（Dlocal）", dlocal_pix: "Pix (Dlocal)", flutterwave: "Flutterwave", gocardless: "Gocardless", mercadopago_boleto: "Boleto（Mercado Pago）", mercadopago_card: "信用卡（Mercado Pago）", mercadopago_pix: "PIX（Mercado Pago）", mollie: "Mollie", paypal_connect: "连接 PayPal", paypal_edit_organization_name: "编辑组织名称", paypal_rest: "PayPal", paypal_soap: "PayPal", paystack_card: "信用卡（Paystack）", price_plan: "计划", razorpay: "Razorpay", secure_and_pay: "安全与支付", stripe_applepay: "苹果支付", stripe_bancotact: "Bancontact (Stripe)", stripe_card: "信用卡或借记卡", stripe_ideal: "iDeal (Stripe)", stripe_klarna: "克拉纳（Stripe）", stripe_multibanco: "Multibanco（Stripe）", xendit: { "3ds": "3D-安全" }, xendit_card: "信用卡 (Xendit)" }, payment_inputs: { card_holder_placeholder: "持卡人", card_number_placeholder: "卡号", cvc_placeholder: "CVC", date_out_of_range: "过期日期不能是过去时间", empty_card_holder: "输入持卡人姓名", empty_card_number: "输入卡号", empty_cvc: "输入CVC", empty_expiry_date: "输入到期日期", expiry_data_placeholder: "月/年", invalid_card_number: "卡号无效", invalid_cvc: "CVC无效", invalid_expiry_date: "过期日期无效", month_out_of_range: "到期月份必须在01到12之间", year_out_of_range: "到期年不能是过去的年份" }, "Payment-method": "付款方式", price_plan: { interval: { day: `天

{{count}} 天`, month: `月

{{count}} 月`, week: `周

{{count}}周`, year: `年

{{count}}年` }, trial_period: { day: `{{count}} 天

{{count}} 天`, month: `{{count}} 月

{{count}} 月`, week: `周

{{count}} 周`, year: `{{count}}年

{{count}}年` } }, product: "产品", quantity: "数量", "registered-over": "注册超过", "required-field": "字段为必填项", shipping: { condition_label: { price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单", price_min: "对于价格在 {{min}} {{currency}} 或以上的订单", quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单", quantity_min: "对于包含 {{min}} 件或更多商品的订单", weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单", weight_min: "对于总重量在 {{min}}g 或以上的订单" }, not_available: "哎呀！看起来我们还不提供该地点的运输服务。", shipping_method: "运输方式" }, shipping_fee: "运费", subtotal: "小计", total: "总计", total_amount_with_shipping: "总计（含运费）", total_amount_with_tax: "总计（含税）", total_amount_with_tax_and_shipping: "总计（包括税费和运费）", vat: "销售税", vat_percent: "销售税 ({{percent}}%)" }, Du = {
  public_pages_purchase: Cu
}, to = ["common"], Pu = to[0], Au = Object.values(Z), Nu = {
  ar: { common: Dc },
  cs: { common: Ac },
  da: { common: Tc },
  de: { common: xc },
  el: { common: Bc },
  en: { common: Oc },
  es: { common: Gc },
  fr: { common: Kc },
  hi: { common: zc },
  hu: { common: Uc },
  id: { common: Yc },
  it: { common: Zc },
  ja: { common: Qc },
  nl: { common: qc },
  no: { common: eu },
  pl: { common: tu },
  pt: { common: ru },
  ro: { common: ou },
  ru: { common: lu },
  sk: { common: uu },
  sl: { common: pu },
  sq: { common: hu },
  sr: { common: gu },
  sv: { common: yu },
  th: { common: vu },
  tr: { common: ku },
  uk: { common: wu },
  zh: { common: Du }
}, Tu = {
  supportedLngs: Au,
  load: "languageOnly",
  debug: !1,
  defaultNS: Pu,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: to,
  compatibilityJSON: "v3",
  fallbackLng: Z.ENGLISH,
  lng: Z.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Nu
};
G.use(ac).init(Tu);
const L_ = (t) => {
  switch (t) {
    case q.stripe_card:
      return G.t("public_pages_purchase.payment.stripe_card");
    case q.stripe_ideal:
      return G.t("public_pages_purchase.payment.stripe_ideal");
    case q.stripe_bancontact:
      return G.t("public_pages_purchase.payment.stripe_bancotact");
    case q.stripe_applepay:
      return G.t("public_pages_purchase.payment.stripe_applepay");
    case q.stripe_klarna:
      return G.t("public_pages_purchase.payment.stripe_klarna");
    case q.dlocal_card:
      return G.t("public_pages_purchase.payment.dlocal_card");
    case q.dlocal_boleto:
      return G.t("public_pages_purchase.payment.dlocal_boleto");
    case q.dlocal_pix:
      return G.t("public_pages_purchase.payment.dlocal_pix");
    case q.paypal_soap:
    case q.paypal_rest:
      return G.t("public_pages_purchase.payment.paypal_soap");
    case q.mercadopago_br_card:
      return G.t("public_pages_purchase.payment.mercadopago_card");
    case q.mercadopago_br_pix:
      return G.t("public_pages_purchase.payment.mercadopago_pix");
    case q.mercadopago_br_boleto:
      return G.t("public_pages_purchase.payment.mercadopago_boleto");
    case q.mercadopago_co_card:
    case q.mercadopago_ar_card:
    case q.mercadopago_mx_card:
    case q.mercadopago_cl_card:
      return G.t("public_pages_purchase.payment.mercadopago_card");
    case q.razorpay:
      return G.t("public_pages_purchase.payment.razorpay");
    case q.flutterwave:
      return G.t("public_pages_purchase.payment.flutterwave");
    case q.mollie:
      return G.t("public_pages_purchase.payment.mollie");
    case q.gocardless:
      return G.t("public_pages_purchase.payment.gocardless");
    case q.cash_on_delivery:
      return G.t("public_pages_purchase.payment.cash_on_delivery");
    case q.xendit_id_card:
    case q.xendit_ph_card:
      return G.t("public_pages_purchase.payment.xendit_card");
    case q.paystack_gh_card:
    case q.paystack_ke_card:
    case q.paystack_ng_card:
    case q.paystack_za_card:
    case q.paystack_eg_card:
    case q.paystack_ci_card:
      return G.t("public_pages_purchase.payment.paystack_card");
    case q.secure_and_pay:
      return G.t("public_pages_purchase.payment.secure_and_pay");
  }
}, ha = ({
  description: t,
  descriptionClassName: n,
  error: a,
  errorClassName: e,
  className: r
}) => {
  const i = a ? /* @__PURE__ */ _(
    "p",
    {
      className: A("text-danger [&>a]:text-brand-primary text-sm", e),
      ...typeof a == "string" ? {
        dangerouslySetInnerHTML: { __html: a }
      } : {
        children: a
      }
    }
  ) : null;
  return a || t ? /* @__PURE__ */ L("div", { className: r, children: [
    t ? /* @__PURE__ */ _(
      "span",
      {
        className: A("[&>a]:text-brand-primary text-sm opacity-70", n),
        children: t
      }
    ) : null,
    i
  ] }) : null;
}, G_ = ({
  inputRef: t,
  error: n,
  description: a,
  value: e,
  onChange: r,
  label: i,
  disabled: o,
  isFetching: s,
  labelClassName: l,
  className: c,
  errorClassName: u,
  descriptionClassName: d,
  checkboxIconClassName: p,
  inputClassName: m,
  inputWrapperClassName: h
}) => /* @__PURE__ */ L(
  "label",
  {
    className: A(
      "group flex w-fit items-center gap-3",
      o ? "cursor-default" : "cursor-pointer",
      c
    ),
    "aria-checked": e,
    children: [
      /* @__PURE__ */ L("div", { className: A("relative flex items-center justify-center", h), children: [
        /* @__PURE__ */ _(
          "input",
          {
            ref: t,
            disabled: o,
            checked: e,
            className: A(
              "peer/checkbox main-transition-colors",
              o ? "bg-skeleton-primary/40 border-darkgray/20 checked:bg-text-primary/60 checked:border-text-primary/75 cursor-default" : "border-darkgray bg-background-secondary checked:border-text-primary checked:bg-text-primary",
              s && "animate-pulse",
              "focus-ring h-[20px] w-[20px] cursor-pointer appearance-none rounded-md border",
              m
            ),
            type: "checkbox",
            onChange: (f) => r(f.target.checked)
          }
        ),
        /* @__PURE__ */ _(
          Al,
          {
            className: A(
              "absolute",
              o ? e ? "fill-background-secondary/70 opacity-100" : "opacity-0" : "fill-background-secondary opacity-100",
              p
            )
          }
        )
      ] }),
      i && /* @__PURE__ */ _(
        "span",
        {
          className: A(
            "main-transition-colors",
            e ? "text-text-primary" : "text-text-primary/50",
            "leading-5",
            l,
            "text-left"
          ),
          children: i
        }
      ),
      /* @__PURE__ */ _(
        ha,
        {
          description: a,
          error: n,
          errorClassName: u,
          descriptionClassName: d
        }
      )
    ]
  }
);
function Na({
  wrapperAs: t = "div",
  wrapperProps: n = { className: "flex justify-between gap-2" },
  label: a,
  required: e,
  labelClassName: r,
  labelRightElement: i,
  requiredSignClassName: o
}) {
  return a || e || i ? /* @__PURE__ */ L(t, { ...n, children: [
    (a || e) && /* @__PURE__ */ L("span", { className: A("flex", r), children: [
      a,
      " ",
      e && /* @__PURE__ */ _("i", { className: A("text-danger", o), children: "*" })
    ] }),
    i
  ] }) : null;
}
function no() {
  const [t, n] = C.useState({
    width: 1200,
    height: 800,
    isWindowSizeSetFromBrowser: !1
  });
  function a() {
    n({
      width: window.innerWidth,
      height: window.innerHeight,
      isWindowSizeSetFromBrowser: !0
    });
  }
  return C.useEffect(() => (n({
    width: window.innerWidth,
    height: window.innerHeight,
    isWindowSizeSetFromBrowser: !0
  }), window.addEventListener("resize", a), () => {
    window.removeEventListener("resize", a);
  }), []), t;
}
const ro = ({ hoverOpenDelay: t = 100 } = {}) => {
  const [n, a] = ee(!1), e = ue(null), r = () => {
    e.current !== null && (clearTimeout(e.current), e.current = null);
  }, i = () => {
    r(), a(!0);
  }, o = () => {
    r(), e.current = setTimeout(() => {
      a(!0);
    }, t);
  }, s = () => {
    r(), a(!1);
  }, l = () => {
    r(), e.current = setTimeout(() => {
      a(!1);
    }, 100);
  };
  return de(() => () => r(), []), { show: n, open: i, close: s, delayClose: l, delayOpen: o };
}, io = (t) => {
  var n;
  return t.hasChildNodes() ? ((n = t.childNodes[0]) == null ? void 0 : n.nodeType) === 3 ? t : io(t.childNodes[0]) : t;
}, Iu = (t, n) => {
  const [a, e] = j.useState(void 0), { width: r } = no();
  return j.useLayoutEffect(() => {
    const { current: i } = t;
    i && (() => {
      const s = io(i);
      if (!s) return;
      const l = s.scrollWidth > i.clientWidth;
      e(l), n && n(l);
    })();
  }, [n, t, r]), a;
}, oo = yt(function(t, n) {
  return /* @__PURE__ */ _(
    "button",
    {
      ref: n,
      ...t,
      onClick: (a) => {
        var e;
        a.preventDefault = () => {
        }, (e = t.onClick) == null || e.call(t, a);
      }
    }
  );
}), xu = yt(function(t, n) {
  return /* @__PURE__ */ _(
    "div",
    {
      ref: n,
      ...t,
      onClick: (a) => {
        var e;
        a.preventDefault = () => {
        }, a.stopPropagation = () => {
        }, (e = t.onClick) == null || e.call(t, a);
      }
    }
  );
}), rr = ({
  mode: t = "hover",
  popoverButtonRef: n,
  label: a,
  position: e = "top",
  anchor: r,
  className: i,
  wrapperClassName: o,
  popoverClassName: s,
  labelClassName: l,
  disabled: c,
  stayOnHover: u,
  children: d,
  hoverOpenDelay: p
}) => {
  const m = ue(void 0), h = ue(null), f = Iu(m), { width: g } = no(), { show: y, delayOpen: b, delayClose: k } = ro({ hoverOpenDelay: p });
  return /* @__PURE__ */ _(Vi, { className: A("flex items-center", o), children: ({ open: D }) => {
    const v = c ? !1 : t === "click" || g < 1024 ? D : t === "hover" || t === "overflow" && f ? y : !1;
    return /* @__PURE__ */ L(Ee, { children: [
      /* @__PURE__ */ _(
        Ui,
        {
          ref: (S) => {
            m && (m.current = S), n && (n.current = S);
          },
          as: t === "click" ? oo : xu,
          className: A(
            "relative truncate outline-hidden",
            t === "click" && !c && "cursor-pointer",
            "h-full w-full max-w-fit",
            i
          ),
          disabled: c,
          onMouseEnter: b,
          onMouseLeave: k,
          children: typeof d == "function" ? d(v) : d
        }
      ),
      /* @__PURE__ */ _(
        Ka,
        {
          as: ct,
          show: v,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ _(
            ji,
            {
              ref: h,
              anchor: r ?? e.replace("-", " "),
              className: A(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                s
              ),
              onMouseEnter: u ? b : void 0,
              onMouseLeave: u ? k : void 0,
              children: /* @__PURE__ */ _(
                "div",
                {
                  className: A(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    l
                  ),
                  children: a
                }
              )
            }
          )
        }
      )
    ] });
  } });
}, F_ = (t) => /* @__PURE__ */ _(rr, { ...t, mode: "click" }), Eu = ({
  switcherElement: t,
  selected: n,
  onChange: a,
  label: e,
  labelClassName: r,
  wrapperClassName: i,
  switcherClassName: o,
  disabled: s
}) => /* @__PURE__ */ L(
  ln,
  {
    className: A(
      "relative flex flex-col gap-2 md:flex-row md:items-center",
      i
    ),
    children: [
      /* @__PURE__ */ _(
        _l,
        {
          checked: n,
          disabled: s,
          onChange: a,
          onKeyDown: (l) => {
            l.key === "Enter" && !s && (l.preventDefault(), a(!n));
          },
          className: A("focus-ring inline-flex w-fit shrink-0 rounded-sm", o),
          children: t
        }
      ),
      e && /* @__PURE__ */ _(yl, { className: A("cursor-pointer", r), children: e })
    ]
  }
), K_ = ({
  selected: t,
  onChange: n,
  switcherClassName: a,
  disabled: e,
  ...r
}) => {
  const i = A(
    "main-transition-colors focus-ring relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent",
    t && !e ? "bg-brand-primary" : "bg-fill-primary",
    a
  ), o = /* @__PURE__ */ _(
    "span",
    {
      "aria-hidden": "true",
      className: A(
        "bg-background-secondary pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-lg ring-0 transition-transform duration-200 ease-linear",
        t ? "translate-x-5" : "translate-x-0"
      )
    }
  );
  return /* @__PURE__ */ _(
    Eu,
    {
      switcherElement: o,
      selected: t,
      disabled: e,
      onChange: n,
      switcherClassName: i,
      ...r
    }
  );
}, H_ = ({
  color: t,
  labelClassName: n,
  popoverClassName: a,
  popoverButtonClassName: e,
  popoverButtonChildClassName: r,
  hexColorInput: i,
  wrapperClassName: o,
  children: s,
  additionalPopoverChildren: l,
  focusTrapFeatures: c = vl.None,
  stayWhenUnfocused: u = !1,
  showAlpha: d = !0,
  showOnlyHue: p = !1,
  pickerRef: m,
  error: h,
  description: f,
  anchor: g = "top",
  disabled: y,
  ...b
}) => {
  const [k, D] = ee(!1), v = ue(null);
  de(() => {
    const w = (N) => {
      var B;
      (B = v.current) != null && B.contains(N.target) && D(!0);
    }, M = (N) => {
      v.current && !v.current.contains(N.target) && D(!1);
    }, P = (N) => {
      N.key === "Escape" && D(!1);
    };
    return document.addEventListener("focusin", w), document.addEventListener("touchstart", M, !0), document.addEventListener("mousedown", M, !0), document.addEventListener("keydown", P), () => {
      document.removeEventListener("focusin", w), document.removeEventListener("touchstart", M, !0), document.removeEventListener("mousedown", M, !0), document.removeEventListener("keydown", P);
    };
  }, []), m && (m.current = {
    allowToHideWhenUnfocused: (w) => {
      D(!w);
    }
  });
  const S = d && !p ? Ll : Gl;
  return /* @__PURE__ */ _(Vi, { className: "flex items-center", children: ({ open: w, close: M }) => {
    const P = u && k || w;
    return /* @__PURE__ */ L(Ee, { children: [
      /* @__PURE__ */ _(
        Ui,
        {
          disabled: y,
          as: oo,
          className: A(
            "relative truncate outline-hidden",
            "cursor-pointer",
            "h-full w-full max-w-fit",
            "focus-ring rounded-lg",
            h && "border-danger rounded-xl border-2 p-0.5",
            e
          ),
          children: (s == null ? void 0 : s(P)) ?? /* @__PURE__ */ _(
            "div",
            {
              style: { backgroundColor: t },
              className: A(
                "border-text-secondary/30 h-10 w-10 rounded-lg border",
                r
              )
            }
          )
        }
      ),
      /* @__PURE__ */ _(
        Ka,
        {
          as: ct,
          show: P,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ _(
            ji,
            {
              ref: v,
              anchor: g,
              className: A(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                p ? "pt-4" : "pt-5",
                a
              ),
              children: /* @__PURE__ */ _(bl, { features: c, children: /* @__PURE__ */ _(
                "div",
                {
                  className: A(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    "max-w-[200px]",
                    n
                  ),
                  children: /* @__PURE__ */ L(
                    "div",
                    {
                      className: A(
                        "flex flex-col gap-3",
                        p && "[&_.react-colorful]:!h-fit [&_div.react-colorful>div:first-child]:hidden [&_div.react-colorful>div:nth-of-type(2)]:!rounded-lg",
                        o
                      ),
                      children: [
                        /* @__PURE__ */ _(S, { color: t, ...b }),
                        !p && /* @__PURE__ */ L("div", { className: "flex", children: [
                          /* @__PURE__ */ _("div", { className: "bg-background-tertiary rounded-l-lg p-2", children: "#" }),
                          /* @__PURE__ */ _(
                            Fl,
                            {
                              alpha: d,
                              className: A(
                                "main-transition-colors border-text-secondary/30 focus:border-brand-primary w-full rounded-r-lg border p-2 outline-hidden",
                                i
                              ),
                              color: t,
                              onChange: b.onChange
                            }
                          )
                        ] }),
                        l == null ? void 0 : l(M),
                        /* @__PURE__ */ _(
                          ha,
                          {
                            errorClassName: "text-left",
                            error: h,
                            description: f
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
}, Hn = (t, n) => ({
  ...t ? {
    "data-test-id": `${n}`
  } : {}
});
var se = /* @__PURE__ */ ((t) => (t.Stripe = "stripe", t.PaypalSoap = "paypal-soap", t.Dlocal = "dlocal", t.MercadoPagoBR = "mercadopago-br", t.MercadoPagoCO = "mercadopago-co", t.MercadoPagoMX = "mercadopago-mx", t.MercadoPagoAR = "mercadopago-ar", t.MercadoPagoCL = "mercadopago-cl", t.Razorpay = "razorpay", t.Flutterwave = "flutterwave", t.Mollie = "mollie", t.Gocardless = "gocardless", t.XenditID = "xendit-id", t.XenditPH = "xendit-ph", t.PaystackGH = "paystack-gh", t.PaystackKE = "paystack-ke", t.PaystackNG = "paystack-ng", t.PaystackZA = "paystack-za", t.PaystackEG = "paystack-eg", t.PaystackCI = "paystack-ci", t.CashOnDelivery = "cash-on-delivery", t.PaypalRest = "paypal-rest", t.SecureAndPay = "secure-and-pay", t))(se || {});
const z_ = (t) => {
  switch (t) {
    case se.Stripe:
      return "Stripe";
    case se.PaypalSoap:
    case se.PaypalRest:
      return "PayPal";
    case se.Dlocal:
      return "dLocal";
    case se.MercadoPagoBR:
    case se.MercadoPagoCO:
    case se.MercadoPagoMX:
    case se.MercadoPagoAR:
    case se.MercadoPagoCL:
      return "Mercado Pago";
    case se.Razorpay:
      return "Razorpay";
    case se.Flutterwave:
      return "Flutterwave";
    case se.Mollie:
      return "Mollie";
    case se.Gocardless:
      return "GoCardless";
    case se.XenditID:
    case se.XenditPH:
      return "Xendit";
    case se.PaystackGH:
    case se.PaystackKE:
    case se.PaystackNG:
    case se.PaystackZA:
    case se.PaystackEG:
    case se.PaystackCI:
      return "Paystack";
    case se.CashOnDelivery:
      return G.t("public_pages_purchase.payment.cash_on_delivery");
    case se.SecureAndPay:
      return "Secure and Pay";
  }
};
var zn = /* @__PURE__ */ ((t) => (t.dateFirst = "d/m/Y", t.monthFirst = "m/d/Y", t))(zn || {}), ot = /* @__PURE__ */ ((t) => (t.hourMinute = "H:i", t.hourMinuteAmPm = "h:i A", t.hourMinuteSecond = "H:i:s", t.hourMinuteSecondAmPm = "h:i:s A", t))(ot || {}), Ca = /* @__PURE__ */ ((t) => (t.ENGLISH = "en", t.FRENCH = "fr", t.SPANISH = "es", t.ITALIAN = "it", t.PORTUGUESE = "pt", t.DEUTSCH = "de", t.DUTCH = "nl", t.RUSSIAN = "ru", t.JAPANESE = "jp", t.ARABIC = "ar", t.TURKISH = "tr", t.CHINESE = "zh", t.SWEDISH = "sv", t.ROMANIAN = "ro", t.CZECH = "cs", t.HUNGARIAN = "hu", t.SLOVAK = "sk", t.DANISH = "dk", t.INDONESIAN = "id", t.POLISH = "pl", t.GREEK = "el", t.SERBIAN = "sr", t.NORWEGIAN = "no", t.THAI = "th", t.SLOVENIAN = "sl", t.UKRAINIAN = "ua", t.ALBANIA = "sq", t.HINDI = "hi", t))(Ca || {});
const V_ = {
  en: "EN",
  fr: "FR",
  es: "ES",
  it: "IT",
  pt: "PT",
  de: "DE",
  nl: "NL",
  ru: "RU",
  jp: "JP",
  ar: "AR",
  tr: "TR",
  zh: "CH",
  sv: "SV",
  ro: "RO",
  cs: "CS",
  hu: "HU",
  sk: "SK",
  dk: "DK",
  id: "ID",
  pl: "PL",
  el: "EL",
  sr: "SR",
  hi: "HI",
  no: "NO",
  th: "TH",
  sl: "SL",
  ua: "UA",
  sq: "SQ"
}, U_ = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  de: "Deutsch",
  nl: "Nederlands",
  ru: "Русский",
  jp: "日本語",
  ar: "عربي",
  tr: "Türkçe",
  zh: "中文(简体)",
  sv: "Svenska",
  ro: "Română",
  cs: "Čeština",
  hu: "Magyar",
  sk: "Slovenský",
  dk: "Dansk",
  id: "Indonesian",
  pl: "Polski",
  el: "Ελληνικά",
  sr: "Srpski",
  hi: "Hindi",
  no: "Norsk",
  th: "ไทย",
  sl: "Slovenski",
  ua: "Український",
  sq: "Shqiptare"
}, Bu = {
  en: "public_pages_purchase.locale.english",
  fr: "public_pages_purchase.locale.french",
  es: "public_pages_purchase.locale.spanish",
  it: "public_pages_purchase.locale.italian",
  pt: "public_pages_purchase.locale.portuguese",
  de: "public_pages_purchase.locale.german",
  nl: "public_pages_purchase.locale.dutch",
  ru: "public_pages_purchase.locale.russian",
  jp: "public_pages_purchase.locale.japanese",
  zh: "public_pages_purchase.locale.chinese",
  tr: "public_pages_purchase.locale.turkish",
  ar: "public_pages_purchase.locale.arabic",
  sv: "public_pages_purchase.locale.swedish",
  ro: "public_pages_purchase.locale.romanian",
  cs: "public_pages_purchase.locale.czech",
  hu: "public_pages_purchase.locale.hungarian",
  sk: "public_pages_purchase.locale.slovak",
  dk: "public_pages_purchase.locale.danish",
  id: "public_pages_purchase.locale.indonesian",
  pl: "public_pages_purchase.locale.polish",
  el: "public_pages_purchase.locale.greek",
  sr: "public_pages_purchase.locale.serbian",
  hi: "public_pages_purchase.locale.hindi",
  no: "public_pages_purchase.locale.norwegian",
  th: "public_pages_purchase.locale.thai",
  sl: "public_pages_purchase.locale.slovenian",
  ua: "public_pages_purchase.locale.ukrainian",
  sq: "public_pages_purchase.locale.albania"
};
function so(t) {
  const n = Object.keys(Ca).find(
    (a) => Ca[a] === t
  );
  return n ? Z[n] : Z.ENGLISH;
}
function j_(t) {
  const n = Object.keys(Z).find(
    (a) => Z[a] === t
  );
  return n ? Ca[n] : Ca.ENGLISH;
}
function Y_(t) {
  return G.t(Bu[t]);
}
const Ru = Dl(null), W_ = ({
  children: t,
  locale: n
}) => (de(() => {
  if (!G.isInitialized) return;
  const a = so(n);
  G.language !== a && G.changeLanguage(a);
}, [n]), /* @__PURE__ */ _(Ru.Provider, { value: { locale: n }, children: t }));
var ir = /* @__PURE__ */ ((t) => (t.Afghanistan = "AF", t.AlandIslands = "AX", t.Albania = "AL", t.Algeria = "DZ", t.AmericanSamoa = "AS", t.Andorra = "AD", t.Angola = "AO", t.Anguilla = "AI", t.Antarctica = "AQ", t.AntiguaAndBarbuda = "AG", t.Argentina = "AR", t.Armenia = "AM", t.Aruba = "AW", t.Australia = "AU", t.Austria = "AT", t.Azerbaijan = "AZ", t.Bahamas = "BS", t.Bahrain = "BH", t.Bangladesh = "BD", t.Barbados = "BB", t.Belarus = "BY", t.Belgium = "BE", t.Belize = "BZ", t.Benin = "BJ", t.Bermuda = "BM", t.Bhutan = "BT", t.Bolivia = "BO", t.BonaireSintEustatiusSaba = "BQ", t.BosniaAndHerzegovina = "BA", t.Botswana = "BW", t.BouvetIsland = "BV", t.Brazil = "BR", t.BritishIndianOceanTerritory = "IO", t.BruneiDarussalam = "BN", t.Bulgaria = "BG", t.BurkinaFaso = "BF", t.Burundi = "BI", t.Cambodia = "KH", t.Cameroon = "CM", t.Canada = "CA", t.CapeVerde = "CV", t.CaymanIslands = "KY", t.CentralAfricanRepublic = "CF", t.Chad = "TD", t.Chile = "CL", t.China = "CN", t.ChristmasIsland = "CX", t.CocosKeelingIslands = "CC", t.Colombia = "CO", t.Comoros = "KM", t.Congo = "CG", t.CongoDemocraticRepublic = "CD", t.CookIslands = "CK", t.CostaRica = "CR", t.CoteDIvoire = "CI", t.Croatia = "HR", t.Cuba = "CU", t.Curaçao = "CW", t.Cyprus = "CY", t.CzechRepublic = "CZ", t.Denmark = "DK", t.Djibouti = "DJ", t.Dominica = "DM", t.DominicanRepublic = "DO", t.Ecuador = "EC", t.Egypt = "EG", t.ElSalvador = "SV", t.EquatorialGuinea = "GQ", t.Eritrea = "ER", t.Estonia = "EE", t.Ethiopia = "ET", t.FalklandIslands = "FK", t.FaroeIslands = "FO", t.Fiji = "FJ", t.Finland = "FI", t.France = "FR", t.FrenchGuiana = "GF", t.FrenchPolynesia = "PF", t.FrenchSouthernTerritories = "TF", t.Gabon = "GA", t.Gambia = "GM", t.Georgia = "GE", t.Germany = "DE", t.Ghana = "GH", t.Gibraltar = "GI", t.Greece = "GR", t.Greenland = "GL", t.Grenada = "GD", t.Guadeloupe = "GP", t.Guam = "GU", t.Guatemala = "GT", t.Guernsey = "GG", t.Guinea = "GN", t.GuineaBissau = "GW", t.Guyana = "GY", t.Haiti = "HT", t.HeardIslandMcdonaldIslands = "HM", t.HolySeeVaticanCityState = "VA", t.Honduras = "HN", t.HongKong = "HK", t.Hungary = "HU", t.Iceland = "IS", t.India = "IN", t.Indonesia = "ID", t.Iran = "IR", t.Iraq = "IQ", t.Ireland = "IE", t.IsleOfMan = "IM", t.Israel = "IL", t.Italy = "IT", t.Jamaica = "JM", t.Japan = "JP", t.Jersey = "JE", t.Jordan = "JO", t.Kazakhstan = "KZ", t.Kenya = "KE", t.Kiribati = "KI", t.Korea = "KR", t.KoreaDemocraticPeoplesRepublic = "KP", t.Kuwait = "KW", t.Kyrgyzstan = "KG", t.LaoPeoplesDemocraticRepublic = "LA", t.Latvia = "LV", t.Lebanon = "LB", t.Lesotho = "LS", t.Liberia = "LR", t.LibyanArabJamahiriya = "LY", t.Liechtenstein = "LI", t.Lithuania = "LT", t.Luxembourg = "LU", t.Macao = "MO", t.Macedonia = "MK", t.Madagascar = "MG", t.Malawi = "MW", t.Malaysia = "MY", t.Maldives = "MV", t.Mali = "ML", t.Malta = "MT", t.MarshallIslands = "MH", t.Martinique = "MQ", t.Mauritania = "MR", t.Mauritius = "MU", t.Mayotte = "YT", t.Mexico = "MX", t.Micronesia = "FM", t.Moldova = "MD", t.Monaco = "MC", t.Mongolia = "MN", t.Montenegro = "ME", t.Montserrat = "MS", t.Morocco = "MA", t.Mozambique = "MZ", t.Myanmar = "MM", t.Namibia = "NA", t.Nauru = "NR", t.Nepal = "NP", t.Netherlands = "NL", t.NewCaledonia = "NC", t.NewZealand = "NZ", t.Nicaragua = "NI", t.Niger = "NE", t.Nigeria = "NG", t.Niue = "NU", t.NorfolkIsland = "NF", t.NorthernMarianaIslands = "MP", t.Norway = "NO", t.Oman = "OM", t.Pakistan = "PK", t.Palau = "PW", t.PalestinianTerritory = "PS", t.Panama = "PA", t.PapuaNewGuinea = "PG", t.Paraguay = "PY", t.Peru = "PE", t.Philippines = "PH", t.Pitcairn = "PN", t.Poland = "PL", t.Portugal = "PT", t.PuertoRico = "PR", t.Qatar = "QA", t.Reunion = "RE", t.Romania = "RO", t.RussianFederation = "RU", t.Rwanda = "RW", t.SaintBarthelemy = "BL", t.SaintHelena = "SH", t.SaintKittsAndNevis = "KN", t.SaintLucia = "LC", t.SaintMartin = "MF", t.SaintPierreAndMiquelon = "PM", t.SaintVincentAndGrenadines = "VC", t.Samoa = "WS", t.SanMarino = "SM", t.SaoTomeAndPrincipe = "ST", t.SaudiArabia = "SA", t.Senegal = "SN", t.Serbia = "RS", t.Seychelles = "SC", t.SierraLeone = "SL", t.Singapore = "SG", t.SintMaarten = "SX", t.Slovakia = "SK", t.Slovenia = "SI", t.SolomonIslands = "SB", t.Somalia = "SO", t.SouthAfrica = "ZA", t.SouthGeorgiaAndSandwichIsl = "GS", t.SouthSudan = "SS", t.Spain = "ES", t.SriLanka = "LK", t.Sudan = "SD", t.Suriname = "SR", t.SvalbardAndJanMayen = "SJ", t.Swaziland = "SZ", t.Sweden = "SE", t.Switzerland = "CH", t.SyrianArabRepublic = "SY", t.Taiwan = "TW", t.Tajikistan = "TJ", t.Tanzania = "TZ", t.Thailand = "TH", t.TimorLeste = "TL", t.Togo = "TG", t.Tokelau = "TK", t.Tonga = "TO", t.TrinidadAndTobago = "TT", t.Tunisia = "TN", t.Turkey = "TR", t.Turkmenistan = "TM", t.TurksAndCaicosIslands = "TC", t.Tuvalu = "TV", t.Uganda = "UG", t.Ukraine = "UA", t.UnitedArabEmirates = "AE", t.UnitedKingdom = "GB", t.UnitedStates = "US", t.UnitedStatesOutlyingIslands = "UM", t.Uruguay = "UY", t.Uzbekistan = "UZ", t.Vanuatu = "VU", t.Venezuela = "VE", t.Vietnam = "VN", t.VirginIslandsBritish = "VG", t.VirginIslandsUS = "VI", t.WallisAndFutuna = "WF", t.WesternSahara = "EH", t.Yemen = "YE", t.Zambia = "ZM", t.Zimbabwe = "ZW", t))(ir || {}), Dn = {};
const Ou = /* @__PURE__ */ JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKK","983","ISO 3166-2:XK"]]'), Lu = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var et = {}, jr;
function Gu() {
  if (jr) return et;
  jr = 1, et.remove = i;
  for (var t = [
    {
      base: " ",
      chars: " "
    },
    {
      base: "0",
      chars: "߀"
    },
    {
      base: "A",
      chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
    },
    {
      base: "AA",
      chars: "Ꜳ"
    },
    {
      base: "AE",
      chars: "ÆǼǢ"
    },
    {
      base: "AO",
      chars: "Ꜵ"
    },
    {
      base: "AU",
      chars: "Ꜷ"
    },
    {
      base: "AV",
      chars: "ꜸꜺ"
    },
    {
      base: "AY",
      chars: "Ꜽ"
    },
    {
      base: "B",
      chars: "ⒷＢḂḄḆɃƁ"
    },
    {
      base: "C",
      chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
    },
    {
      base: "D",
      chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
    },
    {
      base: "Dh",
      chars: "Ð"
    },
    {
      base: "DZ",
      chars: "ǱǄ"
    },
    {
      base: "Dz",
      chars: "ǲǅ"
    },
    {
      base: "E",
      chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
    },
    {
      base: "F",
      chars: "ꝼⒻＦḞƑꝻ"
    },
    {
      base: "G",
      chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
    },
    {
      base: "H",
      chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    },
    {
      base: "I",
      chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
    },
    {
      base: "J",
      chars: "ⒿＪĴɈȷ"
    },
    {
      base: "K",
      chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    },
    {
      base: "L",
      chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    },
    {
      base: "LJ",
      chars: "Ǉ"
    },
    {
      base: "Lj",
      chars: "ǈ"
    },
    {
      base: "M",
      chars: "ⓂＭḾṀṂⱮƜϻ"
    },
    {
      base: "N",
      chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
    },
    {
      base: "NJ",
      chars: "Ǌ"
    },
    {
      base: "Nj",
      chars: "ǋ"
    },
    {
      base: "O",
      chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
    },
    {
      base: "OE",
      chars: "Œ"
    },
    {
      base: "OI",
      chars: "Ƣ"
    },
    {
      base: "OO",
      chars: "Ꝏ"
    },
    {
      base: "OU",
      chars: "Ȣ"
    },
    {
      base: "P",
      chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
    },
    {
      base: "Q",
      chars: "ⓆＱꝖꝘɊ"
    },
    {
      base: "R",
      chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    },
    {
      base: "S",
      chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    },
    {
      base: "T",
      chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    },
    {
      base: "Th",
      chars: "Þ"
    },
    {
      base: "TZ",
      chars: "Ꜩ"
    },
    {
      base: "U",
      chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    },
    {
      base: "V",
      chars: "ⓋＶṼṾƲꝞɅ"
    },
    {
      base: "VY",
      chars: "Ꝡ"
    },
    {
      base: "W",
      chars: "ⓌＷẀẂŴẆẄẈⱲ"
    },
    {
      base: "X",
      chars: "ⓍＸẊẌ"
    },
    {
      base: "Y",
      chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
    },
    {
      base: "Z",
      chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    },
    {
      base: "a",
      chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
    },
    {
      base: "aa",
      chars: "ꜳ"
    },
    {
      base: "ae",
      chars: "æǽǣ"
    },
    {
      base: "ao",
      chars: "ꜵ"
    },
    {
      base: "au",
      chars: "ꜷ"
    },
    {
      base: "av",
      chars: "ꜹꜻ"
    },
    {
      base: "ay",
      chars: "ꜽ"
    },
    {
      base: "b",
      chars: "ⓑｂḃḅḇƀƃɓƂ"
    },
    {
      base: "c",
      chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
    },
    {
      base: "d",
      chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
    },
    {
      base: "dh",
      chars: "ð"
    },
    {
      base: "dz",
      chars: "ǳǆ"
    },
    {
      base: "e",
      chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
    },
    {
      base: "f",
      chars: "ⓕｆḟƒ"
    },
    {
      base: "ff",
      chars: "ﬀ"
    },
    {
      base: "fi",
      chars: "ﬁ"
    },
    {
      base: "fl",
      chars: "ﬂ"
    },
    {
      base: "ffi",
      chars: "ﬃ"
    },
    {
      base: "ffl",
      chars: "ﬄ"
    },
    {
      base: "g",
      chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
    },
    {
      base: "h",
      chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    },
    {
      base: "hv",
      chars: "ƕ"
    },
    {
      base: "i",
      chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
    },
    {
      base: "j",
      chars: "ⓙｊĵǰɉ"
    },
    {
      base: "k",
      chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    },
    {
      base: "l",
      chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
    },
    {
      base: "lj",
      chars: "ǉ"
    },
    {
      base: "m",
      chars: "ⓜｍḿṁṃɱɯ"
    },
    {
      base: "n",
      chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
    },
    {
      base: "nj",
      chars: "ǌ"
    },
    {
      base: "o",
      chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
    },
    {
      base: "oe",
      chars: "œ"
    },
    {
      base: "oi",
      chars: "ƣ"
    },
    {
      base: "oo",
      chars: "ꝏ"
    },
    {
      base: "ou",
      chars: "ȣ"
    },
    {
      base: "p",
      chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
    },
    {
      base: "q",
      chars: "ⓠｑɋꝗꝙ"
    },
    {
      base: "r",
      chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    },
    {
      base: "s",
      chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
    },
    {
      base: "ss",
      chars: "ß"
    },
    {
      base: "t",
      chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    },
    {
      base: "th",
      chars: "þ"
    },
    {
      base: "tz",
      chars: "ꜩ"
    },
    {
      base: "u",
      chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    },
    {
      base: "v",
      chars: "ⓥｖṽṿʋꝟʌ"
    },
    {
      base: "vy",
      chars: "ꝡ"
    },
    {
      base: "w",
      chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
    },
    {
      base: "x",
      chars: "ⓧｘẋẍ"
    },
    {
      base: "y",
      chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
    },
    {
      base: "z",
      chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }
  ], n = {}, a = 0; a < t.length; a += 1)
    for (var e = t[a].chars, r = 0; r < e.length; r += 1)
      n[e[r]] = t[a].base;
  function i(o) {
    return o.replace(/[^\u0000-\u007e]/g, function(s) {
      return n[s] || s;
    });
  }
  return et.replacementList = t, et.diacriticsMap = n, et;
}
var Yr;
function Fu() {
  return Yr || (Yr = 1, (function(t) {
    const n = Ou, a = Lu, e = Gu().remove, r = {}, i = {}, o = {}, s = {}, l = {};
    n.forEach(function(v) {
      const S = v;
      i[S[0]] = S[1], o[S[1]] = S[0], s[S[2]] = S[0], l[S[0]] = S[2];
    });
    function c(v) {
      return ("000" + (v || "")).slice(-3);
    }
    function u(v, S) {
      return Object.prototype.hasOwnProperty.call(v, S);
    }
    function d(v, S) {
      return Object.keys(v).reduce(function(w, M) {
        const P = v[M];
        return w[M] = S(P, M), w;
      }, {});
    }
    function p(v, S) {
      switch (v) {
        case "official":
          return Array.isArray(S) ? S[0] : S;
        case "all":
          return typeof S == "string" ? [S] : S;
        case "alias":
          return Array.isArray(S) ? S[1] || S[0] : S;
        default:
          throw new TypeError(
            "LocaleNameType must be one of these: all, official, alias!"
          );
      }
    }
    t.registerLocale = function(v) {
      if (!v.locale)
        throw new TypeError("Missing localeData.locale");
      if (!v.countries)
        throw new TypeError("Missing localeData.countries");
      r[v.locale] = v.countries;
    };
    function m(v) {
      return o[v];
    }
    t.alpha3ToAlpha2 = m;
    function h(v) {
      return i[v];
    }
    t.alpha2ToAlpha3 = h;
    function f(v) {
      return l[m(v)];
    }
    t.alpha3ToNumeric = f;
    function g(v) {
      return l[v];
    }
    t.alpha2ToNumeric = g;
    function y(v) {
      const S = c(v);
      return h(s[S]);
    }
    t.numericToAlpha3 = y;
    function b(v) {
      const S = c(v);
      return s[S];
    }
    t.numericToAlpha2 = b;
    function k(v) {
      if (typeof v == "string") {
        if (/^[0-9]*$/.test(v))
          return y(v);
        if (v.length === 2)
          return h(v.toUpperCase());
        if (v.length === 3)
          return v.toUpperCase();
      }
      if (typeof v == "number")
        return y(v);
    }
    t.toAlpha3 = k;
    function D(v) {
      if (typeof v == "string") {
        if (/^[0-9]*$/.test(v))
          return b(v);
        if (v.length === 2)
          return v.toUpperCase();
        if (v.length === 3)
          return m(v.toUpperCase());
      }
      if (typeof v == "number")
        return b(v);
    }
    t.toAlpha2 = D, t.getName = function(v, S, w = {}) {
      "select" in w || (w.select = "official");
      try {
        const P = r[S.toLowerCase()][D(v)];
        return p(w.select, P);
      } catch {
        return;
      }
    }, t.getNames = function(v, S = {}) {
      "select" in S || (S.select = "official");
      const w = r[v.toLowerCase()];
      return w === void 0 ? {} : d(w, function(M) {
        return p(S.select, M);
      });
    }, t.getAlpha2Code = function(v, S) {
      const w = (P) => P.toLowerCase(), M = (P, N) => w(P) === w(N);
      try {
        const P = r[S.toLowerCase()];
        for (const N in P)
          if (u(P, N)) {
            if (typeof P[N] == "string" && M(P[N], v))
              return N;
            if (Array.isArray(P[N])) {
              for (const B of P[N])
                if (M(B, v))
                  return N;
            }
          }
        return;
      } catch {
        return;
      }
    }, t.getSimpleAlpha2Code = function(v, S) {
      const w = (P) => e(P.toLowerCase()), M = (P, N) => w(P) === w(N);
      try {
        const P = r[S.toLowerCase()];
        for (const N in P)
          if (u(P, N)) {
            if (typeof P[N] == "string" && M(P[N], v))
              return N;
            if (Array.isArray(P[N])) {
              for (const B of P[N])
                if (M(B, v))
                  return N;
            }
          }
        return;
      } catch {
        return;
      }
    }, t.getAlpha2Codes = function() {
      return i;
    }, t.getAlpha3Code = function(v, S) {
      const w = t.getAlpha2Code(v, S);
      if (w)
        return t.toAlpha3(w);
    }, t.getSimpleAlpha3Code = function(v, S) {
      const w = t.getSimpleAlpha2Code(v, S);
      if (w)
        return t.toAlpha3(w);
    }, t.getAlpha3Codes = function() {
      return o;
    }, t.getNumericCodes = function() {
      return s;
    }, t.langs = function() {
      return Object.keys(r);
    }, t.getSupportedLanguages = function() {
      return a;
    }, t.isValid = function(v) {
      if (!v)
        return !1;
      const S = v.toString().toUpperCase();
      return u(o, S) || u(i, S) || u(s, S);
    };
  })(Dn)), Dn;
}
var Ku = Fu();
const Vn = /* @__PURE__ */ Zl(Ku), lo = "ar", co = { AF: "أفغانستان", AL: "ألبانيا", DZ: "الجزائر", AS: "ساموا الأمريكية", AD: "أندورا", AO: "أنغولا", AI: "أنغويلا", AQ: "القارة القطبية الجنوبية", AG: "أنتيغوا وباربودا", AR: "الأرجنتين", AM: "أرمينيا", AW: "أروبا", AU: "أستراليا", AT: "النمسا", AZ: "أذربيجان", BS: "باهاماس", BH: "البحرين", BD: "بنغلاديش", BB: "باربادوس", BY: "روسيا البيضاء", BE: "بلجيكا", BZ: "بليز", BJ: "بنين", BM: "برمودا", BT: "بوتان", BO: "بوليفيا", BA: "البوسنة والهرسك", BW: "بوتسوانا", BV: "جزيرة بوفيه", BR: "البرازيل", IO: "إقليم المحيط الهندي البريطاني", BN: "بروناي", BG: "بلغاريا", BF: "بوركينا فاسو", BI: "بوروندي", KH: "كمبوديا", CM: "الكاميرون", CA: "كندا", CV: "الرأس الأخضر", KY: "جزر كايمان", CF: "جمهورية أفريقيا الوسطى", TD: "تشاد", CL: "تشيلي", CN: "الصين", CX: "جزيرة عيد الميلاد", CC: "جزر كوكوس", CO: "كولومبيا", KM: "جزر القمر", CG: "جمهورية الكونغو", CD: "جمهورية الكونغو الديمقراطية", CK: "جزر كوك", CR: "كوستاريكا", CI: "ساحل العاج", HR: "كرواتيا", CU: "كوبا", CY: "قبرص", CZ: "جمهورية التشيك", DK: "الدنمارك", DJ: "جيبوتي", DM: "دومينيكا", DO: "جمهورية الدومينيكان", EC: "الإكوادور", EG: "مصر", SV: "السلفادور", GQ: "غينيا الاستوائية", ER: "إريتريا", EE: "إستونيا", ET: "إثيوبيا", FK: "جزر فوكلاند", FO: "جزر فارو", FJ: "فيجي", FI: "فنلندا", FR: "فرنسا", GF: "غويانا الفرنسية", PF: "بولينزيا الفرنسية", TF: "أراض فرنسية جنوبية وأنتارتيكية", GA: "الغابون", GM: "غامبيا", GE: "جورجيا", DE: "ألمانيا", GH: "غانا", GI: "جبل طارق", GR: "اليونان", GL: "جرينلاند", GD: "غرينادا", GP: "غوادلوب", GU: "غوام", GT: "غواتيمالا", GN: "غينيا", GW: "غينيا بيساو", GY: "غيانا", HT: "هايتي", HM: "جزيرة هيرد وجزر ماكدونالد", VA: "الفاتيكان", HN: "هندوراس", HK: "هونغ كونغ", HU: "المجر", IS: "آيسلندا", IN: "الهند", ID: "إندونيسيا", IR: "إيران", IQ: "العراق", IE: "أيرلندا", IL: "إسرائيل", IT: "إيطاليا", JM: "جامايكا", JP: "اليابان", JO: "الأردن", KZ: "كازاخستان", KE: "كينيا", KI: "كيريباتي", KP: "كوريا الشمالية", KR: "كوريا الجنوبية", KW: "الكويت", KG: "قيرغيزستان", LA: "لاوس", LV: "لاتفيا", LB: "لبنان", LS: "ليسوتو", LR: "ليبيريا", LY: "ليبيا", LI: "ليختنشتاين", LT: "ليتوانيا", LU: "لوكسمبورغ", MO: "ماكاو", MK: "مقدونيا الشمالية", MG: "مدغشقر", MW: "مالاوي", MY: "ماليزيا", MV: "جزر المالديف", ML: "مالي", MT: "مالطا", MH: "جزر مارشال", MQ: "مارتينيك", MR: "موريتانيا", MU: "موريشيوس", YT: "مايوت", MX: "المكسيك", FM: "ولايات ميكرونيسيا المتحدة", MD: "مولدوفا", MC: "موناكو", MN: "منغوليا", MS: "مونتسرات", MA: "المغرب", MZ: "موزمبيق", MM: "بورما", NA: "ناميبيا", NR: "ناورو", NP: "نيبال", NL: "هولندا", NC: "كاليدونيا الجديدة", NZ: "نيوزيلندا", NI: "نيكاراغوا", NE: "النيجر", NG: "نيجيريا", NU: "نييوي", NF: "جزيرة نورفولك", MP: "جزر ماريانا الشمالية", NO: "النرويج", OM: "عمان", PK: "باكستان", PW: "بالاو", PS: "فلسطين", PA: "بنما", PG: "بابوا غينيا الجديدة", PY: "باراغواي", PE: "بيرو", PH: "الفلبين", PN: "جزر بيتكيرن", PL: "بولندا", PT: "البرتغال", PR: "بورتوريكو", QA: "قطر", RE: "لا ريونيون", RO: "رومانيا", RU: "روسيا", RW: "رواندا", SH: "سانت هيلينا وأسينشين وتريستان دا كونا", KN: "سانت كيتس ونيفيس", LC: "سانت لوسيا", PM: "سان بيير وميكلون", VC: "سانت فينسنت والغرينادين", WS: "ساموا", SM: "سان مارينو", ST: "ساو تومي وبرينسيب", SA: "السعودية", SN: "السنغال", SC: "سيشل", SL: "سيراليون", SG: "سنغافورة", SK: "سلوفاكيا", SI: "سلوفينيا", SB: "جزر سليمان", SO: "الصومال", ZA: "جنوب أفريقيا", GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية", ES: "إسبانيا", LK: "سريلانكا", SD: "السودان", SR: "سورينام", SJ: "سفالبارد ويان ماين", SZ: "سوازيلاند", SE: "السويد", CH: "سويسرا", SY: "سوريا", TW: "تايوان", TJ: "طاجيكستان", TZ: "تانزانيا", TH: "تايلاند", TL: "تيمور الشرقية", TG: "توغو", TK: "توكيلاو", TO: "تونغا", TT: "ترينيداد وتوباغو", TN: "تونس", TR: "تركيا", TM: "تركمانستان", TC: "جزر توركس وكايكوس", TV: "توفالو", UG: "أوغندا", UA: "أوكرانيا", AE: "الإمارات العربية المتحدة", GB: "المملكة المتحدة", US: "الولايات المتحدة", UM: "جزر الولايات المتحدة", UY: "الأوروغواي", UZ: "أوزبكستان", VU: "فانواتو", VE: "فنزويلا", VN: "فيتنام", VG: "جزر العذراء البريطانية", VI: "جزر العذراء الأمريكية", WF: "والس وفوتونا", EH: "الصحراء الغربية", YE: "اليمن", ZM: "زامبيا", ZW: "زيمبابوي", AX: "جزر أولاند", BQ: "الجزر الكاريبية الهولندية", CW: "كوراساو", GG: "غيرنزي", IM: "جزيرة مان", JE: "جيرزي", ME: "الجبل الأسود", BL: "سان بارتيلمي", MF: "سانت مارتن (الجزء الفرنسي)", RS: "صربيا", SX: "سانت مارتن (الجزء الهولندي)", SS: "جنوب السودان", XK: "كوسوفو" }, Hu = {
  locale: lo,
  countries: co
}, zu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: co,
  default: Hu,
  locale: lo
}, Symbol.toStringTag, { value: "Module" })), uo = "cs", po = { AF: "Afghánistán", AX: "Ålandy", AL: "Albánie", DZ: "Alžírsko", AS: "Americká Samoa", VI: "Americké Panenské ostrovy", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktida", AG: "Antigua a Barbuda", AR: "Argentina", AM: "Arménie", AW: "Aruba", AU: "Austrálie", AZ: "Ázerbájdžán", BS: "Bahamy", BH: "Bahrajn", BD: "Bangladéš", BB: "Barbados", BE: "Belgie", BZ: "Belize", BY: "Bělorusko", BJ: "Benin", BM: "Bermudy", BT: "Bhútán", BO: "Bolívie", BQ: "Bonaire, Svatý Eustach a Saba", BA: "Bosna a Hercegovina", BW: "Botswana", BV: "Bouvetův ostrov", BR: "Brazílie", IO: "Britské indickooceánské území", VG: "Britské Panenské ostrovy", BN: "Brunej", BG: "Bulharsko", BF: "Burkina Faso", BI: "Burundi", CK: "Cookovy ostrovy", CW: "Curaçao", TD: "Čad", ME: "Černá Hora", CZ: "Česká republika", CN: "Čína", DK: "Dánsko", CD: "Demokratická republika Kongo", DM: "Dominika", DO: "Dominikánská republika", DJ: "Džibutsko", EG: "Egypt", EC: "Ekvádor", ER: "Eritrea", EE: "Estonsko", ET: "Etiopie", FO: "Faerské ostrovy", FK: "Falklandy (Malvíny)", FJ: "Fidži", PH: "Filipíny", FI: "Finsko", FR: "Francie", GF: "Francouzská Guyana", TF: "Francouzská jižní a antarktická území", PF: "Francouzská Polynésie", GA: "Gabon", GM: "Gambie", GH: "Ghana", GI: "Gibraltar", GD: "Grenada", GL: "Grónsko", GE: "Gruzie", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GG: "Guernsey", GY: "Guyana", HT: "Haiti", HM: "Heardův ostrov a McDonaldovy ostrovy", HN: "Honduras", HK: "Hongkong", CL: "Chile", HR: "Chorvatsko", IN: "Indie", ID: "Indonésie", IQ: "Irák", IR: "Írán", IE: "Irsko", IS: "Island", IT: "Itálie", IL: "Izrael", JM: "Jamajka", JP: "Japonsko", YE: "Jemen", JE: "Jersey", ZA: "Jihoafrická republika", GS: "Jižní Georgie a Jižní Sandwichovy ostrovy", KR: "Jižní Korea", SS: "Jižní Súdán", JO: "Jordánsko", KY: "Kajmanské ostrovy", KH: "Kambodža", CM: "Kamerun", CA: "Kanada", CV: "Kapverdy", QA: "Katar", KZ: "Kazachstán", KE: "Keňa", KI: "Kiribati", CC: "Kokosové ostrovy", CO: "Kolumbie", KM: "Komory", CG: "Kongo", CR: "Kostarika", CU: "Kuba", KW: "Kuvajt", CY: "Kypr", KG: "Kyrgyzstán", LA: "Laos", LS: "Lesotho", LB: "Libanon", LR: "Libérie", LY: "Libye", LI: "Lichtenštejnsko", LT: "Litva", LV: "Lotyšsko", LU: "Lucembursko", MO: "Macao", MG: "Madagaskar", HU: "Maďarsko", MY: "Malajsie", MW: "Malawi", MV: "Maledivy", ML: "Mali", MT: "Malta", IM: "Ostrov Man", MA: "Maroko", MH: "Marshallovy ostrovy", MQ: "Martinik", MU: "Mauricius", MR: "Mauritánie", YT: "Mayotte", UM: "Menší odlehlé ostrovy USA", MX: "Mexiko", FM: "Mikronésie", MD: "Moldavsko", MC: "Monako", MN: "Mongolsko", MS: "Montserrat", MZ: "Mosambik", MM: "Myanmar", NA: "Namibie", NR: "Nauru", DE: "Německo", NP: "Nepál", NE: "Niger", NG: "Nigérie", NI: "Nikaragua", NU: "Niue", NL: "Nizozemsko", NF: "Norfolk", NO: "Norsko", NC: "Nová Kaledonie", NZ: "Nový Zéland", OM: "Omán", PK: "Pákistán", PW: "Palau", PS: "Palestinská autonomie", PA: "Panama", PG: "Papua-Nová Guinea", PY: "Paraguay", PE: "Peru", PN: "Pitcairnovy ostrovy", CI: "Pobřeží slonoviny", PL: "Polsko", PR: "Portoriko", PT: "Portugalsko", AT: "Rakousko", RE: "Réunion", GQ: "Rovníková Guinea", RO: "Rumunsko", RU: "Rusko", RW: "Rwanda", GR: "Řecko", PM: "Saint-Pierre a Miquelon", SV: "Salvador", WS: "Samoa", SM: "San Marino", SA: "Saúdská Arábie", SN: "Senegal", KP: "Severní Korea", MK: "Severní Makedonie", MP: "Severní Mariany", SC: "Seychely", SL: "Sierra Leone", SG: "Singapur", SK: "Slovensko", SI: "Slovinsko", SO: "Somálsko", AE: "Spojené arabské emiráty", GB: "Spojené království", US: "Spojené státy americké", RS: "Srbsko", CF: "Středoafrická republika", SD: "Súdán", SR: "Surinam", SH: "Svatá Helena, Ascension a Tristan da Cunha", LC: "Svatá Lucie", BL: "Svatý Bartoloměj", KN: "Svatý Kryštof a Nevis", MF: "Svatý Martin (francouzská část)", SX: "Svatý Martin (nizozemská část)", ST: "Svatý Tomáš a Princův ostrov", VC: "Svatý Vincenc a Grenadiny", SZ: "Svazijsko", SY: "Sýrie", SB: "Šalamounovy ostrovy", ES: "Španělsko", SJ: "Špicberky a Jan Mayen", LK: "Šrí Lanka", SE: "Švédsko", CH: "Švýcarsko", TJ: "Tádžikistán", TZ: "Tanzanie", TH: "Thajsko", TW: "Tchaj-wan", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad a Tobago", TN: "Tunisko", TR: "Turecko", TM: "Turkmenistán", TC: "Turks a Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ukrajina", UY: "Uruguay", UZ: "Uzbekistán", CX: "Vánoční ostrov", VU: "Vanuatu", VA: "Vatikán", VE: "Venezuela", VN: "Vietnam", TL: "Východní Timor", WF: "Wallis a Futuna", ZM: "Zambie", EH: "Západní Sahara", ZW: "Zimbabwe", XK: "Kosovo" }, Vu = {
  locale: uo,
  countries: po
}, Uu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: po,
  default: Vu,
  locale: uo
}, Symbol.toStringTag, { value: "Module" })), mo = "da", ho = { AF: "Afghanistan", AL: "Albanien", DZ: "Algeriet", AS: "Amerikansk Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua og Barbuda", AR: "Argentina", AM: "Armenien", AW: "Aruba", AU: "Australien", AT: "Østrig", AZ: "Aserbajdsjan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Hviderusland", BE: "Belgien", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnien-Hercegovina", BW: "Botswana", BV: "Bouvet Island", BR: "Brasilien", IO: "British Indian Ocean Territory", BN: "Brunei Darussalam", BG: "Bulgarien", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodja", CM: "Cameroun", CA: "Canada", CV: "Kap Verde", KY: "Caymanøerne", CF: "Den Centralafrikanske Republik", TD: "Tchad", CL: "Chile", CN: "Kina", CX: "Juløen", CC: "Cocosøerne", CO: "Colombia", KM: "Comorerne", CG: "Congo", CD: "Demokratiske Republik Congo", CK: "Cookøerne", CR: "Costa Rica", CI: "Elfenbenskysten", HR: "Kroatien", CU: "Cuba", CY: "Cypern", CZ: "Tjekkiet", DK: "Danmark", DJ: "Djibouti", DM: "Dominica", DO: "Dominikanske Republik", EC: "Ecuador", EG: "Egypten", SV: "El Salvador", GQ: "Ækvatorialguinea", ER: "Eritrea", EE: "Estland", ET: "Etiopien", FK: "Falklandsøerne", FO: "Færøerne", FJ: "Fiji", FI: "Finland", FR: "Frankrig", GF: "Fransk Guiana", PF: "Fransk Polynesien", TF: "Franske Sydterritorier", GA: "Gabon", GM: "Gambia", GE: "Georgien", DE: "Tyskland", GH: "Ghana", GI: "Gibraltar", GR: "Grækenland", GL: "Grønland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard-øen og McDonald-øerne", VA: "Vatikanstaten", HN: "Honduras", HK: "Hong Kong", HU: "Ungarn", IS: "Island", IN: "Indien", ID: "Indonesien", IR: "Iran", IQ: "Irak", IE: "Irland", IL: "Israel", IT: "Italien", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Nordkorea", KR: "Sydkorea", KW: "Kuwait", KG: "Kirgisistan", LA: "Laos", LV: "Letland", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libyen", LI: "Liechtenstein", LT: "Litauen", LU: "Luxembourg", MO: "Macao", MK: "Nordmakedonien", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldiverne", ML: "Mali", MT: "Malta", MH: "Marshalløerne", MQ: "Martinique", MR: "Mauretanien", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Mikronesien", MD: "Moldova", MC: "Monaco", MN: "Mongoliet", MS: "Montserrat", MA: "Marokko", MZ: "Mozambique", MM: "Myanmar (Burma)", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Holland", NC: "Ny Kaledonien", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk Island", MP: "Nordmarianerne", NO: "Norge", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palæstina", PA: "Panama", PG: "Papua Ny Guinea", PY: "Paraguay", PE: "Peru", PH: "Filippinerne", PN: "Pitcairn", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Rumænien", RU: "Rusland", RW: "Rwanda", SH: "Sankt Helena", KN: "Saint Kitts og Nevis", LC: "Saint Lucia", PM: "Saint-Pierre og Miquelon", VC: "Saint Vincent og Grenadinerne", WS: "Samoa", SM: "San Marino", ST: "São Tomé og Príncipe", SA: "Saudi-Arabien", SN: "Senegal", SC: "Seychellerne", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakiet", SI: "Slovenien", SB: "Salomonøerne", SO: "Somalia", ZA: "Sydafrika", GS: "South Georgia og South Sandwich Islands", ES: "Spanien", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Norge Svalbard og Jan Mayen", SZ: "Eswatini", SE: "Sverige", CH: "Schweiz", SY: "Syrien", TW: "Republikken Kina Taiwan", TJ: "Tadsjikistan", TZ: "Tanzania", TH: "Thailand", TL: "Østtimor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad og Tobago", TN: "Tunesien", TR: "Tyrkiet", TM: "Turkmenistan", TC: "Turks- og Caicosøerne", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", AE: "Forenede Arabiske Emirater", GB: "Storbritannien", US: "USA", UM: "USA's ydre småøer", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Britiske Jomfruøer", VI: "Amerikanske Jomfruøer", WF: "Wallis og Futuna", EH: "Vestsahara", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Ålandsøerne", BQ: "Nederlandske Antiller", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint-Barthélemy", MF: "Saint Martin (fransk side)", RS: "Serbien", SX: "Saint Martin (hollandsk side)", SS: "Sydsudan", XK: "Kosovo" }, ju = {
  locale: mo,
  countries: ho
}, Yu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ho,
  default: ju,
  locale: mo
}, Symbol.toStringTag, { value: "Module" })), fo = "de", go = { AF: "Afghanistan", EG: "Ägypten", AX: "Åland", AL: "Albanien", DZ: "Algerien", AS: "Amerikanisch-Samoa", VI: "Amerikanische Jungferninseln", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua und Barbuda", GQ: "Äquatorialguinea", AR: "Argentinien", AM: "Armenien", AW: "Aruba", AZ: "Aserbaidschan", ET: "Äthiopien", AU: "Australien", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesch", BB: "Barbados", BY: "Belarus", BE: "Belgien", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivien", BQ: "Bonaire", BA: "Bosnien und Herzegowina", BW: "Botswana", BV: "Bouvetinsel", BR: "Brasilien", VG: "Britische Jungferninseln", IO: "Britisches Territorium im Indischen Ozean", BN: "Brunei Darussalam", BG: "Bulgarien", BF: "Burkina Faso", BI: "Burundi", CL: "Chile", CN: "China", CK: "Cookinseln", CR: "Costa Rica", CI: "Elfenbeinküste", CW: "Curaçao", DK: "Dänemark", DE: "Deutschland", DM: "Dominica", DO: "Dominikanische Republik", DJ: "Dschibuti", EC: "Ecuador", SV: "El Salvador", ER: "Eritrea", EE: "Estland", FK: "Falklandinseln", FO: "Färöer", FJ: "Fidschi", FI: "Finnland", FR: "Frankreich", GF: "Französisch-Guayana", PF: "Französisch-Polynesien", TF: "Französische Süd- und Antarktisgebiete", GA: "Gabun", GM: "Gambia", GE: "Georgien", GH: "Ghana", GI: "Gibraltar", GD: "Grenada", GR: "Griechenland", GL: "Grönland", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GG: "Guernsey", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard und McDonaldinseln", HN: "Honduras", HK: ["Hongkong", "Hong Kong"], IN: "Indien", ID: "Indonesien", IM: "Insel Man", IQ: "Irak", IR: "Iran", IE: "Irland", IS: "Island", IL: "Israel", IT: "Italien", JM: "Jamaika", JP: "Japan", YE: "Jemen", JE: "Jersey", JO: "Jordanien", KY: "Kaimaninseln", KH: "Kambodscha", CM: "Kamerun", CA: "Kanada", CV: "Kap Verde", KZ: "Kasachstan", QA: "Katar", KE: "Kenia", KG: "Kirgisistan", KI: "Kiribati", CC: "Kokosinseln", CO: "Kolumbien", KM: "Komoren", CD: "Kongo", KP: "Nordkorea", KR: "Südkorea", HR: "Kroatien", CU: "Kuba", KW: "Kuwait", LA: "Laos", LS: "Lesotho", LV: "Lettland", LB: "Libanon", LR: "Liberia", LY: "Libyen", LI: "Liechtenstein", LT: "Litauen", LU: "Luxemburg", MO: "Macao", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Malediven", ML: "Mali", MT: "Malta", MA: "Marokko", MH: "Marshallinseln", MQ: "Martinique", MR: "Mauretanien", MU: "Mauritius", YT: "Mayotte", MX: "Mexiko", FM: "Mikronesien", MD: "Moldawien", MC: "Monaco", MN: "Mongolei", ME: "Montenegro", MS: "Montserrat", MZ: "Mosambik", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NC: "Neukaledonien", NZ: "Neuseeland", NI: "Nicaragua", NL: "Niederlande", NE: "Niger", NG: "Nigeria", NU: "Niue", MK: "Nordmazedonien", MP: "Nördliche Marianen", NF: "Norfolkinsel", NO: "Norwegen", OM: "Oman", AT: "Österreich", TL: "Osttimor", PK: "Pakistan", PS: "Staat Palästina", PW: "Palau", PA: "Panama", PG: "Papua-Neuguinea", PY: "Paraguay", PE: "Peru", PH: "Philippinen", PN: "Pitcairninseln", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", TW: "Taiwan", CG: "Republik Kongo", RE: "Réunion", RW: "Ruanda", RO: "Rumänien", RU: ["Russische Föderation", "Russland"], BL: "Saint-Barthélemy", MF: "Saint-Martin", SB: "Salomonen", ZM: "Sambia", WS: "Samoa", SM: "San Marino", ST: "São Tomé und Príncipe", SA: "Saudi-Arabien", SE: "Schweden", CH: "Schweiz", SN: "Senegal", RS: "Serbien", SC: "Seychellen", SL: "Sierra Leone", ZW: "Simbabwe", SG: "Singapur", SX: "Sint Maarten", SK: "Slowakei", SI: "Slowenien", SO: "Somalia", ES: "Spanien", LK: "Sri Lanka", SH: "St. Helena", KN: "St. Kitts und Nevis", LC: "St. Lucia", PM: "Saint-Pierre und Miquelon", VC: "St. Vincent und die Grenadinen", ZA: "Südafrika", SD: "Sudan", GS: "Südgeorgien und die Südlichen Sandwichinseln", SS: "Südsudan", SR: "Suriname", SJ: "Svalbard und Jan Mayen", SZ: "Eswatini", SY: "Syrien, Arabische Republik", TJ: "Tadschikistan", TZ: ["Tansania, Vereinigte Republik", "Tansania"], TH: "Thailand", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad und Tobago", TD: "Tschad", CZ: ["Tschechische Republik", "Tschechien"], TN: "Tunesien", TR: "Türkei", TM: "Turkmenistan", TC: "Turks- und Caicosinseln", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", HU: "Ungarn", UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VA: "Vatikanstadt", VE: "Venezuela", AE: "Vereinigte Arabische Emirate", US: ["Vereinigte Staaten von Amerika", "Vereinigte Staaten", "USA"], GB: ["Vereinigtes Königreich", "Großbritannien"], VN: "Vietnam", WF: "Wallis und Futuna", CX: "Weihnachtsinsel", EH: "Westsahara", CF: "Zentralafrikanische Republik", CY: "Zypern", XK: "Kosovo" }, Wu = {
  locale: fo,
  countries: go
}, Zu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: go,
  default: Wu,
  locale: fo
}, Symbol.toStringTag, { value: "Module" })), _o = "el", yo = { AF: "Αφγανιστάν", AL: "Αλβανία", DZ: "Αλγερία", AS: "Αμερικανική Σαμόα", AD: "Ανδόρρα", AO: "Ανγκόλα", AI: "Ανγκουίλα", AQ: "Ανταρκτική", AG: "Αντίγκουα και Μπαρμπούντα", AR: "Αργεντινή", AM: "Αρμενία", AW: "Αρούμπα", AU: "Αυστραλία", AT: "Αυστρία", AZ: "Αζερμπαϊτζάν", BS: "Μπαχάμες", BH: "Μπαχρέιν", BD: "Μπανγκλαντές", BB: "Μπαρμπάντος", BY: "Λευκορωσία", BE: "Βέλγιο", BZ: "Μπελίζ", BJ: "Μπενίν", BM: "Βερμούδες", BT: "Μπουτάν", BO: "Βολιβία", BA: "Βοσνία και Ερζεγοβίνη", BW: "Μποτσουάνα", BV: "Μπουβέ", BR: "Βραζιλία", IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού", BN: "Σουλτανάτο του Μπρουνέι", BG: "Βουλγαρία", BF: "Μπουρκίνα Φάσο", BI: "Μπουρουντί", KH: "Καμπότζη", CM: "Καμερούν", CA: "Καναδάς", CV: ["Δημοκρατία του Πράσινου Ακρωτηρίου", "Πράσινο Ακρωτήριο"], KY: "Κέιμαν Νήσοι", CF: "Κεντροαφρικανική Δημοκρατία", TD: "Τσάντ", CL: "Χιλή", CN: "Κίνα", CX: "Νήσος των Χριστουγέννων", CC: "Νησιά Κόκος", CO: "Κολομβία", KM: "Ένωση των Κομορών", CG: ["Δημοκρατία του Κονγκό", "Κονγκό"], CD: "Λαϊκή Δημοκρατία του Κονγκό", CK: "Νήσοι Κουκ", CR: "Κόστα Ρίκα", CI: "Ακτή Ελεφαντοστού", HR: "Κροατία", CU: "Κούβα", CY: "Κύπρος", CZ: ["Τσεχική Δημοκρατία", "Τσεχία"], DK: "Δανία", DJ: "Τζιμπουτί", DM: ["Κοινοπολιτεία της Δομινίκας", "Ντομίνικα"], DO: "Δομινικανή Δημοκρατία", EC: "Εκουαδόρ", EG: "Αίγυπτος", SV: "Ελ Σαλβαδόρ", GQ: "Ισημερινή-Γουινέα", ER: ["Κράτος της Ερυθραίας", "Ερυθραία"], EE: "Εσθονία", ET: "Αιθιοπία", FK: "Νήσοι Φώκλαντ (Μαλβίνας)", FO: "Νήσοι Φερόες", FJ: "Δημοκρατία των Φίτζι", FI: "Φινλανδία", FR: "Γαλλία", GF: "Γαλλική Γουιάνα", PF: "Γαλλική Πολυνησία", TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη", GA: "Γκαμπόν", GM: "Γκάμπια", GE: "Γεωργία", DE: "Γερμανία", GH: "Γκάνα", GI: "Γιβραλτάρ", GR: "Ελλάδα", GL: "Γροιλανδία", GD: "Γρενάδα", GP: "Γουαδελούπη", GU: "Γκουάμ", GT: "Γουατεμάλα", GN: "Γουινέα", GW: "Γουινέα-Μπισσάου", GY: "Γουιάνα", HT: "Αϊτη", HM: "Νήσοι Χερντ και Μακντόναλντ", VA: ["Κράτος της Πόλης του Βατικανού", "Βατικανό"], HN: "Ονδούρα", HK: "Χονγκ Κόνγκ", HU: "Ουγγαρία", IS: "Ισλανδία", IN: "Ινδία", ID: "Ινδονησία", IR: ["Ισλαμική Δημοκρατία του Ιράν", "Ιράν"], IQ: "Ιράκ", IE: "Ιρλανδία", IL: "Ισραήλ", IT: "Ιταλία", JM: "Τζαμάικα", JP: "Ιαπωνία", JO: "Ιορδανία", KZ: "Καζακστάν", KE: "Κένυα", KI: "Κιριμπάτι", KP: ["Λαοκρατική Δημοκρατία της Κορέας", "Βόρεια Κορέα"], KR: ["Δημοκρατία της Κορέας", "Νότια Κορέα"], KW: "Κουβέιτ", KG: "Κιργιζία", LA: ["Λαϊκή Δημοκρατία του Λάος", "Λάος"], LV: "Λετονία", LB: "Λίβανο", LS: ["Βασίλειο του Λεσότο", "Λεσότο"], LR: "Λιβερία", LY: ["Κράτος της Λιβύης", "Λιβύη"], LI: ["Πριγκιπάτο του Λίχτενσταϊν", "Λίχτενσταϊν"], LT: "Λιθουανία", LU: "Λουξεμβούργο", MO: "Μακάου", MK: ["Δημοκρατία της Βόρειας Μακεδονίας", "Βόρεια Μακεδονία"], MG: "Μαδαγασκάρη", MW: "Μαλάουι", MY: "Μαλαισία", MV: "Μαλβίδες", ML: "Μαλί", MT: "Μάλτα", MH: "Νήσοι Μάρσαλ", MQ: "Μαρτινίκα", MR: "Μαυριτανία", MU: "Μαυρίκιος", YT: "Μαγιότ", MX: "Μεξικό", FM: ["Ομόσπονδες Πολιτείες της Μικρονησίας", "Μικρονησία"], MD: ["Δημοκρατία της Μολδαβίας", "Μολδαβία"], MC: ["Πριγκιπάτο του Μονακό", "Μονακό"], MN: "Μογγολία", MS: "Μοντσερράτ", MA: "Μαρόκο", MZ: "Μοζαμβίκη", MM: "Μιανμάρ", NA: "Ναμίμπια", NR: "Ναουρού", NP: "Νεπάλ", NL: "Ολλανδία", NC: "Νέα Καληδονία", NZ: "Νέα Ζηλανδία", NI: "Νικαράγουα", NE: "Νίγηρας", NG: "Νιγηρία", NU: "Νιούε", NF: "Νησί Νόρφολκ", MP: "Βόρειες Μαριάνες Νήσοι", NO: "Νορβηγία", OM: "Ομάν", PK: "Πακιστάν", PW: "Παλάου", PS: ["Κράτος της Παλαιστίνης", "Παλαιστίνη"], PA: "Παναμάς", PG: "Παπούα Νέα Γουινέα", PY: "Παραγουάη", PE: "Περού", PH: "Φιλιππίνες", PN: "Νήσοι Πίτκαιρν", PL: "Πολωνία", PT: "Πορτογαλία", PR: "Πουέρτο Ρίκο", QA: "Κατάρ", RE: "Ρεϋνιόν", RO: "Ρουμανία", RU: ["Ρωσική Ομοσπονδία", "Ρωσία"], RW: "Ρουάντα", SH: "Νήσος Αγίας Ελένης", KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις", LC: "Αγία Λουκία", PM: "Σαιν Πιερ και Μικελόν", VC: "Άγιος Βικέντιος και Γρεναδίνες", WS: "Σαμόα", SM: "Άγιος Μαρίνος", ST: "Σάο Τομέ και Πρίνσιπε", SA: "Σαουδική Αραβία", SN: "Σενεγάλη", SC: "Σεϋχέλλες", SL: "Σιέρα Λεόνε", SG: "Σιγκαπούρη", SK: "Σλοβακία", SI: "Σλοβενία", SB: "Νήσοι Σολομώντα", SO: "Σομαλία", ZA: "Νότια Αφρική", GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι", ES: "Ισπανία", LK: "Σρι Λάνκα", SD: "Σουδάν", SR: "Σουρινάμ", SJ: "Σβάλμπαρντ και Γιαν Μαγιέν", SZ: "Σουαζιλάνδη", SE: "Σουηδία", CH: "Ελβετία", SY: ["Αραβική Δημοκρατία της Συρίας", "Συρία"], TW: "Δημοκρατία της Κίνας", TJ: "Τατζικιστάν", TZ: ["Ενωμένη Δημοκρατία της Τανζανίας", "Τανζανία"], TH: "Ταϊλάνδη", TL: "Ανατολικό Τιμόρ", TG: "Τογκό", TK: "Τοκελάου", TO: "Τόνγκα", TT: "Τρινιντάντ και Τομπάγκο", TN: "Τυνησία", TR: "Τουρκία", TM: "Τουρκμενιστάν", TC: "Τερκς και Κέικος", TV: "Τουβαλού", UG: "Ουγκάντα", UA: "Ουκρανια", AE: "Ηνωμένα Αραβικά Εμιράτα", GB: "Ηνωμένο Βασίλειο", US: ["Ηνωμένες Πολιτείες Αμερικής", "Αμερική", "ΗΠΑ"], UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών", UY: "Ουρουγουάη", UZ: "Ουζμπεκιστάν", VU: "Βανουάτου", VE: "Βενεζουέλα", VN: "Βιετνάμ", VG: "Βρετανικές Παρθένοι Νήσοι", VI: "Αμερικανικές Παρθένοι Νήσοι", WF: "Ουαλίς και Φουτουνά", EH: "Δυτική Σαχάρα", YE: "Υεμένη", ZM: "Ζάμπια", ZW: "Ζιμπάμπουε", AX: "Νήσοι Ώλαντ", BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα", CW: "Κουρασάο", GG: "Γκουέρνσεϊ", IM: "Νήσος του Μαν", JE: "Βαϊλάτο του Τζέρσεϊ", ME: "Μαυροβούνιο", BL: "Άγιος Βαρθολομαίος", MF: "Άγιος Μαρτίνος (Γαλλία)", RS: "Σερβία", SX: "Άγιος Μαρτίνος (Ολλανδία)", SS: "Νότιο Σουδάν", XK: "Κόσοβο" }, Ju = {
  locale: _o,
  countries: yo
}, Qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: yo,
  default: Ju,
  locale: _o
}, Symbol.toStringTag, { value: "Module" })), bo = "en", vo = { AF: "Afghanistan", AL: "Albania", DZ: "Algeria", AS: "American Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua and Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaijan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Belarus", BE: "Belgium", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia and Herzegovina", BW: "Botswana", BV: "Bouvet Island", BR: "Brazil", IO: "British Indian Ocean Territory", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodia", CM: "Cameroon", CA: "Canada", CV: "Cape Verde", KY: "Cayman Islands", CF: "Central African Republic", TD: "Chad", CL: "Chile", CN: ["People's Republic of China", "China"], CX: "Christmas Island", CC: "Cocos (Keeling) Islands", CO: "Colombia", KM: "Comoros", CG: ["Republic of the Congo", "Congo"], CD: ["Democratic Republic of the Congo", "Congo"], CK: "Cook Islands", CR: "Costa Rica", CI: ["Cote d'Ivoire", "Côte d'Ivoire", "Ivory Coast"], HR: "Croatia", CU: "Cuba", CY: "Cyprus", CZ: ["Czech Republic", "Czechia"], DK: "Denmark", DJ: "Djibouti", DM: "Dominica", DO: "Dominican Republic", EC: "Ecuador", EG: "Egypt", SV: "El Salvador", GQ: "Equatorial Guinea", ER: "Eritrea", EE: "Estonia", ET: "Ethiopia", FK: "Falkland Islands (Malvinas)", FO: "Faroe Islands", FJ: "Fiji", FI: "Finland", FR: "France", GF: "French Guiana", PF: "French Polynesia", TF: "French Southern Territories", GA: "Gabon", GM: ["Republic of The Gambia", "The Gambia", "Gambia"], GE: "Georgia", DE: "Germany", GH: "Ghana", GI: "Gibraltar", GR: "Greece", GL: "Greenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard Island and McDonald Islands", VA: "Holy See (Vatican City State)", HN: "Honduras", HK: "Hong Kong", HU: "Hungary", IS: "Iceland", IN: "India", ID: "Indonesia", IR: ["Islamic Republic of Iran", "Iran"], IQ: "Iraq", IE: "Ireland", IL: "Israel", IT: "Italy", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "North Korea", KR: ["South Korea", "Korea, Republic of", "Republic of Korea"], KW: "Kuwait", KG: "Kyrgyzstan", LA: "Lao People's Democratic Republic", LV: "Latvia", LB: "Lebanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Lithuania", LU: "Luxembourg", MO: "Macao", MG: "Madagascar", MW: "Malawi", MY: "Malaysia", MV: "Maldives", ML: "Mali", MT: "Malta", MH: "Marshall Islands", MQ: "Martinique", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Micronesia, Federated States of", MD: "Moldova, Republic of", MC: "Monaco", MN: "Mongolia", MS: "Montserrat", MA: "Morocco", MZ: "Mozambique", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"], NC: "New Caledonia", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk Island", MK: ["The Republic of North Macedonia", "North Macedonia"], MP: "Northern Mariana Islands", NO: "Norway", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: ["State of Palestine", "Palestine"], PA: "Panama", PG: "Papua New Guinea", PY: "Paraguay", PE: "Peru", PH: "Philippines", PN: ["Pitcairn", "Pitcairn Islands"], PL: "Poland", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Reunion", RO: "Romania", RU: ["Russian Federation", "Russia"], RW: "Rwanda", SH: "Saint Helena", KN: "Saint Kitts and Nevis", LC: "Saint Lucia", PM: "Saint Pierre and Miquelon", VC: "Saint Vincent and the Grenadines", WS: "Samoa", SM: "San Marino", ST: "Sao Tome and Principe", SA: "Saudi Arabia", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakia", SI: "Slovenia", SB: "Solomon Islands", SO: "Somalia", ZA: "South Africa", GS: "South Georgia and the South Sandwich Islands", ES: "Spain", LK: "Sri Lanka", SD: "Sudan", SR: "Suriname", SJ: "Svalbard and Jan Mayen", SZ: "Eswatini", SE: "Sweden", CH: "Switzerland", SY: "Syrian Arab Republic", TW: ["Taiwan, Province of China", "Taiwan"], TJ: "Tajikistan", TZ: ["United Republic of Tanzania", "Tanzania"], TH: "Thailand", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad and Tobago", TN: "Tunisia", TR: ["Türkiye", "Turkey"], TM: "Turkmenistan", TC: "Turks and Caicos Islands", TV: "Tuvalu", UG: "Uganda", UA: "Ukraine", AE: ["United Arab Emirates", "UAE"], GB: ["United Kingdom", "UK", "Great Britain"], US: ["United States of America", "United States", "USA", "U.S.A.", "US", "U.S."], UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Virgin Islands, British", VI: "Virgin Islands, U.S.", WF: "Wallis and Futuna", EH: "Western Sahara", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabwe", AX: ["Åland Islands", "Aland Islands"], BQ: "Bonaire, Sint Eustatius and Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (French part)", RS: "Serbia", SX: "Sint Maarten (Dutch part)", SS: "South Sudan", XK: "Kosovo" }, $u = {
  locale: bo,
  countries: vo
}, qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: vo,
  default: $u,
  locale: bo
}, Symbol.toStringTag, { value: "Module" })), So = "es", ko = { AF: "Afganistán", AL: "Albania", DZ: "Argelia", AS: "Samoa Americana", AD: "Andorra", AO: "Angola", AI: "Anguila", AQ: "Antártida", AG: "Antigua y Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaiyán", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Bielorrusia", BE: "Bélgica", BZ: "Belice", BJ: "Benin", BM: "Bermudas", BT: "Bután", BO: "Bolivia", BA: "Bosnia y Herzegovina", BW: "Botswana", BV: "Isla Bouvet", BR: "Brasil", IO: "Territorio Británico del Océano Índico", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Camboya", CM: "Camerún", CA: "Canadá", CV: "Cabo Verde", KY: "Islas Caimán", CF: "República Centroafricana", TD: "Chad", CL: "Chile", CN: "China", CX: "Isla de Navidad", CC: "Islas Cocos (Keeling)", CO: "Colombia", KM: "Comoras", CG: "Congo", CD: "Congo (República Democrática del)", CK: "Islas Cook", CR: "Costa Rica", CI: "Costa de Marfil", HR: "Croacia", CU: "Cuba", CY: "Chipre", CZ: "República Checa", DK: "Dinamarca", DJ: "Yibuti", DM: "Dominica", DO: "República Dominicana", EC: "Ecuador", EG: "Egipto", SV: "El Salvador", GQ: "Guinea Ecuatorial", ER: "Eritrea", EE: "Estonia", ET: "Etiopía", FK: "Islas Malvinas", FO: "Islas Feroe", FJ: "Fiji", FI: "Finlandia", FR: "Francia", GF: "Guayana Francesa", PF: "Polinesia Francesa", TF: "Tierras Australes Francesas", GA: "Gabón", GM: "Gambia", GE: "Georgia", DE: "Alemania", GH: "Ghana", GI: "Gibraltar", GR: "Grecia", GL: "Groenlandia", GD: "Granada", GP: "Guadalupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea Bissau", GY: "Guyana", HT: "Haití", HM: "Heard e Islas McDonald", VA: "Santa Sede", HN: "Honduras", HK: "Hong Kong", HU: "Hungría", IS: "Islandia", IN: "India", ID: "Indonesia", IR: ["Irán", "República Islámica de Irán"], IQ: "Iraq", IE: "Irlanda", IL: "Israel", IT: "Italia", JM: "Jamaica", JP: "Japón", JO: "Jordania", KZ: "Kazajistán", KE: "Kenia", KI: "Kiribati", KP: "República Popular Democrática de Corea", KR: "República de Corea", KW: "Kuwait", KG: "Kirguistán", LA: "República Democrática Popular de Lao", LV: "Letonia", LB: "Líbano", LS: "Lesoto", LR: "Liberia", LY: "Libia", LI: "Liechtenstein", LT: "Lituania", LU: "Luxemburgo", MO: "Macao", MK: "Macedonia del Norte", MG: "Madagascar", MW: "Malaui", MY: "Malasia", MV: "Maldivas", ML: "Malí", MT: "Malta", MH: "Islas Marshall", MQ: "Martinica", MR: "Mauritania", MU: "Mauricio", YT: "Mayotte", MX: "México", FM: "Micronesia", MD: "Moldavia", MC: "Mónaco", MN: "Mongolia", MS: "Montserrat", MA: "Marruecos", MZ: "Mozambique", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Países Bajos", NC: "Nueva Caledonia", NZ: "Nueva Zelanda", NI: "Nicaragua", NE: "Níger", NG: "Nigeria", NU: "Niue", NF: "Isla Norfolk", MP: "Islas Marianas del Norte", NO: "Noruega", OM: "Omán", PK: "Pakistán", PW: "Palau", PS: "Palestina", PA: "Panamá", PG: "Papua Nueva Guinea", PY: "Paraguay", PE: "Perú", PH: "Filipinas", PN: "Pitcairn", PL: "Polonia", PT: "Portugal", PR: "Puerto Rico", QA: "Catar", RE: "Reunión", RO: "Rumanía", RU: "Rusia", RW: "Ruanda", SH: "Santa Helena, Ascensión y Tristán de Acuña", KN: "Saint Kitts y Nevis", LC: "Santa Lucía", PM: "San Pedro y Miquelón", VC: "San Vicente y las Granadinas", WS: "Samoa", SM: "San Marino", ST: "Santo Tomé y Príncipe", SA: "Arabia Saudita", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leona", SG: "Singapur", SK: "Eslovaquia", SI: "Eslovenia", SB: "Islas Salomón", SO: "Somalia", ZA: "Sudáfrica", GS: "Georgia del Sur y las Islas Sandwich del Sur", ES: "España", LK: "Sri Lanka", SD: "Sudán", SR: "Suriname", SJ: "Svalbard y Jan Mayen", SZ: "Esuatini", SE: "Suecia", CH: "Suiza", SY: "República Árabe Siria", TW: "Taiwán", TJ: "Tayikistán", TZ: "Tanzania", TH: "Tailandia", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad y Tobago", TN: "Túnez", TR: "Turquía", TM: "Turkmenistán", TC: "Islas Turcas y Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ucrania", AE: "Emiratos Árabes Unidos", GB: "Reino Unido", US: "Estados Unidos", UM: "Islas Ultramarinas Menores de los Estados Unidos", UY: "Uruguay", UZ: "Uzbekistán", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Islas Vírgenes británicas", VI: "Islas Vírgenes de los Estados Unidos", WF: "Wallis y Futuna", EH: "Sahara Occidental", YE: "Yemen", ZM: "Zambia", ZW: "Zimbabue", AX: "Islas Åland", BQ: "Bonaire, San Eustaquio y Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isla de Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (francesa)", RS: "Serbia", SX: "Sint Maarten (neerlandesa)", SS: "Sudán del Sur", XK: "Kosovo" }, Xu = {
  locale: So,
  countries: ko
}, ed = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ko,
  default: Xu,
  locale: So
}, Symbol.toStringTag, { value: "Module" })), Mo = "fr", wo = { AF: "Afghanistan", AL: "Albanie", DZ: "Algérie", AS: "Samoa américaines", AD: "Andorre", AO: "Angola", AI: "Anguilla", AQ: "Antarctique", AG: "Antigua-et-Barbuda", AR: "Argentine", AM: "Arménie", AW: "Aruba", AU: "Australie", AT: "Autriche", AZ: "Azerbaïdjan", BS: "Bahamas", BH: "Bahreïn", BD: "Bangladesh", BB: "Barbade", BY: "Biélorussie", BE: "Belgique", BZ: "Belize", BJ: "Bénin", BM: "Bermudes", BT: "Bhoutan", BO: "Bolivie", BA: "Bosnie-Herzégovine", BW: "Botswana", BV: "Île Bouvet", BR: "Brésil", IO: "Océan Indien Britannique", BN: "Brunei Darussalam", BG: "Bulgarie", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodge", CM: "Cameroun", CA: "Canada", CV: "Cap-Vert", KY: "Îles Caïmans", CF: "République Centrafricaine", TD: "Tchad", CL: "Chili", CN: "Chine", CX: "Île Christmas", CC: "Îles Cocos", CO: "Colombie", KM: "Comores", CG: "République du Congo", CD: "République démocratique du Congo", CK: "Îles Cook", CR: "Costa Rica", CI: "Côte-d'Ivoire", HR: "Croatie", CU: "Cuba", CY: "Chypre", CZ: "République Tchèque", DK: "Danemark", DJ: "Djibouti", DM: "Dominique", DO: "République Dominicaine", EC: "Équateur", EG: "Égypte", SV: "El Salvador", GQ: "Guinée équatoriale", ER: "Érythrée", EE: "Estonie", ET: "Éthiopie", FK: "Îles Malouines", FO: "Îles Féroé", FJ: "Fidji", FI: "Finlande", FR: "France", GF: "Guyane française", PF: "Polynésie française", TF: "Terres australes françaises", GA: "Gabon", GM: "Gambie", GE: "Géorgie", DE: "Allemagne", GH: "Ghana", GI: "Gibraltar", GR: "Grèce", GL: "Groenland", GD: "Grenade", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinée", GW: "Guinée-Bissau", GY: "Guyana", HT: "Haïti", HM: "Îles Heard-et-MacDonald", VA: "Saint-Siège (Vatican)", HN: "Honduras", HK: "Hong Kong", HU: "Hongrie", IS: "Islande", IN: "Inde", ID: "Indonésie", IR: "Iran", IQ: "Irak", IE: "Irlande", IL: "Israël", IT: "Italie", JM: "Jamaïque", JP: "Japon", JO: "Jordanie", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Corée du Nord", KR: "Corée du Sud", KW: "Koweït", KG: "Kirghizistan", LA: "Laos", LV: "Lettonie", LB: "Liban", LS: "Lesotho", LR: "Libéria", LY: "Libye", LI: "Liechtenstein", LT: "Lituanie", LU: "Luxembourg", MO: "Macao", MK: "Macédoine du Nord", MG: "Madagascar", MW: "Malawi", MY: "Malaisie", MV: "Maldives", ML: "Mali", MT: "Malte", MH: "Îles Marshall", MQ: "Martinique", MR: "Mauritanie", MU: "Maurice", YT: "Mayotte", MX: "Mexique", FM: "Micronésie", MD: "Moldavie", MC: "Monaco", MN: "Mongolie", MS: "Montserrat", MA: "Maroc", MZ: "Mozambique", MM: "Myanmar", NA: "Namibie", NR: "Nauru", NP: "Népal", NL: "Pays-Bas", NC: "Nouvelle-Calédonie", NZ: "Nouvelle-Zélande", NI: "Nicaragua", NE: "Niger", NG: "Nigéria", NU: "Niué", NF: "Île Norfolk", MP: "Îles Mariannes du Nord", NO: "Norvège", OM: "Oman", PK: "Pakistan", PW: "Palaos", PS: "Palestine", PA: "Panama", PG: "Papouasie-Nouvelle-Guinée", PY: "Paraguay", PE: "Pérou", PH: "Philippines", PN: "Îles Pitcairn", PL: "Pologne", PT: "Portugal", PR: "Porto Rico", QA: "Qatar", RE: "Réunion", RO: "Roumanie", RU: "Russie", RW: "Rwanda", SH: "Sainte-Hélène", KN: "Saint-Christophe-et-Niévès", LC: "Sainte-Lucie", PM: "Saint-Pierre-et-Miquelon", VC: "Saint-Vincent-et-les-Grenadines", WS: "Samoa", SM: "Saint-Marin", ST: "São Tomé-et-Principe", SA: "Arabie Saoudite", SN: "Sénégal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapour", SK: "Slovaquie", SI: "Slovénie", SB: "Îles Salomon", SO: "Somalie", ZA: "Afrique du Sud", GS: "Géorgie du Sud-et-les Îles Sandwich du Sud", ES: "Espagne", LK: "Sri Lanka", SD: "Soudan", SR: "Suriname", SJ: "Svalbard et Île Jan Mayen", SZ: "Royaume d'Eswatini", SE: "Suède", CH: "Suisse", SY: "Syrie", TW: "Taïwan", TJ: "Tadjikistan", TZ: "République unie de Tanzanie", TH: "Thaïlande", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinité-et-Tobago", TN: "Tunisie", TR: "Turquie", TM: "Turkménistan", TC: "Îles Turques-et-Caïques", TV: "Tuvalu", UG: "Ouganda", UA: "Ukraine", AE: "Émirats Arabes Unis", GB: "Royaume-Uni", US: "États-Unis d'Amérique", UM: "Îles mineures éloignées des États-Unis", UY: "Uruguay", UZ: "Ouzbékistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Îles vierges britanniques", VI: "Îles vierges américaines", WF: "Wallis-et-Futuna", EH: "Sahara occidental", YE: "Yémen", ZM: "Zambie", ZW: "Zimbabwe", AX: "Åland", BQ: "Bonaire, Saint-Eustache et Saba", CW: "Curaçao", GG: "Guernesey", IM: "Île de Man", JE: "Jersey", ME: "Monténégro", BL: "Saint-Barthélemy", MF: "Saint-Martin (partie française)", RS: "Serbie", SX: "Saint-Martin (partie néerlandaise)", SS: "Soudan du Sud", XK: "Kosovo" }, ad = {
  locale: Mo,
  countries: wo
}, td = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: wo,
  default: ad,
  locale: Mo
}, Symbol.toStringTag, { value: "Module" })), Co = "hi", Do = { AD: "अंडोरा", AE: "संयुक्त अरब अमीरात", AF: "अफगानिस्तान", AG: "एंटीगुआ और बारबूडा", AI: "अंग्विला", AL: "अल्बानिया", AM: "अर्मेनिया", AO: "अंगोला", AQ: "अंटार्टिका", AR: "अर्जेंटिना", AS: "अमेरिकान सामोआ", AT: "आस्ट्रिया", AU: "आस्ट्रेलिया", AW: "अरुबा", AX: "ऑलैण्ड द्वीपसमूह", AZ: "अजरबेजान", BA: "बोस्निया हर्जेगोविना", BB: "बार्बाडोस", BD: "बांग्लादेश", BE: "बेल्जियम", BF: "बुर्किना फासो", BG: "बल्गारिया", BH: "बहरीन", BI: "बुरुंडी", BJ: "बानिन", BL: "सेंट_बार्थेलेमी", BM: "बर्मूडा", BN: "ब्रुनेई", BO: "बोलिविया", BQ: "कैरिबियन नीदरलैंड", BR: "ब्राजील", BS: "बहामास", BT: "भूटान", BV: "बाउवेट", BW: "बोत्सवाना", BY: "बेलारुस", BZ: "बेलिजे", CA: "कनाडा", CC: "कोकोस (कीलिंग) द्वीप", CD: "कांगो लोकतान्त्रिक गणराज्य", CF: "सेंट्रल अफ्रीका गणतंत्र", CG: "कांगो", CH: "स्विट्जरलैंड", CI: "आइवरी कोस्ट", CK: "कुक द्वीप", CL: "चिली", CM: "कैमरून", CN: "चीन", CO: "कोलंबिया", CR: "कोस्टा रिका", CU: "क्यूबा", CV: "केप वर्दे", CW: "कुराकाओ", CX: "क्रिसमस द्वीप", CY: "साइप्रस", CZ: "चेक", DE: "जर्मनी", DJ: "जिबॉती", DK: "डैनमार्क", DM: "डोमिनिक", DO: "डोमिनिक गणतंत्र", DZ: "अल्जीरिया", EC: "इक्वाडोर", EE: "एस्तोनिया", EG: "मिस्र", EH: "पश्चिमी सहारा", ER: "एरिट्रेया", ES: "स्पेन", ET: "इथियोपिया", FI: "फिनलैंड", FJ: "फिजी", FK: "फाकलैंड द्वीप समूह (मालविनास)", FM: "माइक्रोनेशिया", FO: "फराओ द्वीप समूह", FR: "फ्रांस", GA: "गैबोन", GB: "ग्रेट ब्रिटेन", GD: "ग्रेनेडा", GE: "जॉर्जिया", GF: "फ्रेंच गुआना", GG: "ग्वेर्नसे", GH: "घाना", GI: "जिब्राल्टर", GL: "ग्रीनलैंड", GM: "गाम्बिया", GN: "गिनी", GP: "ग्वाडेलोप", GQ: "एक्वेटोरियल गिनी", GR: "यूनान", GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह", GT: "ग्वाटेमाला", GU: "ग्वाम", GW: "गिनी-बिसाउ", GY: "गुआना", HK: "हांग कांग", HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह", HN: "होंडुरास", HR: "क्रोएशिया", HT: "हैती", HU: "हंगरी", ID: "इंडोनेशिया", IE: "आयरलैंड", IL: "इजराइल", IM: "आइसल ऑफ मैन", IN: "भारत", IO: "ब्रितानी हिंद महासागरीय क्षेत्र", IQ: "इराक", IR: "ईरान", IS: "आइसलैंड", IT: "इटली", JE: "जर्सी", JM: "जमैका", JO: "जॉर्डन", JP: "जापान", KE: "केन्या", KG: "किर्जिस्तान", KH: "कंबोडिया", KI: "किरिबिती", KM: "कोमोरोस", KN: "सेंट किट्स एंड नेविस", KP: "उत्तर कोरिया", KR: "दक्षिण कोरिया", KW: "कुवैत", KY: "केमैन आइसलैंड्स", KZ: "कज़ाखिस्तान", LA: "लाओस", LB: "लेबनान", LC: "सेंट लुसिया", LI: "लिक्टेनिस्टीन", LK: "श्री लंका", LR: "लाइबेरिया", LS: "लेसोथो", LT: "लिथुआनिया", LU: "लक्जमबर्ग", LV: "लात्विया", LY: "लीबिया", MA: "मोरक्को", MC: "मोनाको", MD: "मोलदोवा", ME: "मोंटेनेग्रो", MF: "सेंट मार्टिन की सामूहिकता", MG: "मैडागास्कर", MH: "मार्शल द्वीपसमूह", MK: "मकदूनिया", ML: "माली", MM: "म्यामांर (बर्मा)", MN: "मंगोलिया", MO: "मकाओ", MP: "उत्तर मैरिना द्वीपसमूह", MQ: "मार्टिनिक", MR: "मॉरितानिया", MS: "मोंटसेराट", MT: "माल्टा", MU: "मारीशस", MV: "मालदीव", MW: "मालावी", MX: "मेक्सिको", MY: "मलयेशिया", MZ: "मोजांबिक", NA: "नामीबिया", NC: "न्यू कैलेडोनिया", NE: "नाइजर", NF: "नोरफॉक द्वीप", NG: "नाइजीरिया", NI: "निकारागुआ", NL: "नीदरलैंड्स", NO: "नॉर्वे", NP: "नेपाल", NR: "नाउरू", NU: "नियू", NZ: "न्यूजीलैंड", OM: "ओमान", PA: "पनामा", PE: "पेरू", PF: "फ्रैंच गुआना", PG: "पापुआ न्यू गिनी", PH: "फिलीपींस", PK: "पाकिस्तान", PL: "पोलैंड", PM: "सेंट पिएरे एंड मिक्वेलॉन", PN: "पिटकैर्न द्वीपसमूह", PR: "पुएर्तो रिको", PS: "फिलिस्तीन राज्य", PT: "पुर्तगाल", PW: "पलाउ", PY: "पराग्वे", QA: "क़तार", RE: "रीयूनियन", RO: "रोमानिया", RS: "सर्बिया", RU: "रूस", RW: "रवांडा", SA: "सऊदी अरब", SB: "सोलोमन द्वीपसमूह", SC: "सेशेल्स", SD: "सूडान", SE: "स्वीडन", SG: "सिंगापुर", SH: "सेंट हेलेना", SI: "स्लोवानिया", SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)", SK: "स्लोवाकिया", SL: "सियारा लिओन", SM: "सैन मारिनो", SN: "सेनेगल", SO: "सोमालिया", SR: "सूरीनाम", SS: "दक्षिण सूडान", ST: "साओ टॉम एंड प्रिंसिपी", SV: "सल्वाडोर", SX: "सिण्ट मार्टेन", SY: "सीरिया", SZ: "स्वाजीलैंड", TC: "तुर्क एंड कैकोस द्वीपसमूह", TD: "चाड", TF: "फ्रांसीसी दक्षिणी क्षेत्र", TG: "टोगो", TH: "थाईलैंड", TJ: "तज़ाकिस्तान", TK: "टोकेलू", TL: "पूर्वी तिमोर", TM: "तुर्कमेनिस्तान", TN: "ट्यूनीशिया", TO: "टोंगा", TR: "तुर्की", TT: "ट्रिनिडाड एंड टोबैगो", TV: "तुवालू", TW: "ताइवान", TZ: "तंजानिया", UA: "उक्रेन", UG: "उगांडा", UM: "यूएस माइनर आउटलाइंग द्वीपसमूह", US: "यूएसए (संयुक्त राज्य अमेरिका)", UY: "उरुग्वे", UZ: "उजबेकिस्तान", VA: "वेटिकन", VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स", VE: "वेनेजुएला", VG: "ब्रितानी वर्जिन द्वीपसमूह", VI: "अमेरिकी वर्जिन द्वीपसमूह", VN: "विएतनाम", VU: "वनातू", WF: "वालीज एंड फुटुना", WS: "पश्चिमी सामोआ", XK: "कोसोवो", YE: "यमन", YT: "मायोते", ZA: "दक्षिण अफ्रीका", ZM: "जाम्बिया", ZW: "जिंबावे" }, nd = {
  locale: Co,
  countries: Do
}, rd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Do,
  default: nd,
  locale: Co
}, Symbol.toStringTag, { value: "Module" })), Po = "hu", Ao = { AF: "Afganisztán", AL: "Albánia", DZ: "Algéria", AS: "Amerikai Szamoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktisz", AG: "Antigua és Barbuda", AR: "Argentína", AM: "Örményország", AW: "Aruba", AU: "Ausztrália", AT: "Ausztria", AZ: "Azerbajdzsán", BS: "Bahama-szigetek", BH: "Bahrein", BD: "Banglades", BB: "Barbados", BY: "Fehéroroszország", BE: "Belgium", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhután", BO: "Bolívia", BA: "Bosznia-Hercegovina", BW: "Botswana", BV: "Bouvet-sziget", BR: "Brazília", IO: "Brit Indiai-óceáni Terület", BN: "Brunei", BG: "Bulgária", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodzsa", CM: "Kamerun", CA: "Kanada", CV: "Zöld-foki Köztársaság", KY: "Kajmán-szigetek", CF: "Közép-afrikai Köztársaság", TD: "Csád", CL: "Chile", CN: "Kína", CX: "Karácsony-sziget", CC: "Kókusz (Keeling)-szigetek", CO: "Kolumbia", KM: "Comore-szigetek", CG: "Kongói Köztársaság", CD: "Kongói Demokratikus Köztársaság", CK: "Cook-szigetek", CR: "Costa Rica", CI: "Elefántcsontpart", HR: "Horvátország", CU: "Kuba", CY: "Ciprus", CZ: "Csehország", DK: "Dánia", DJ: "Dzsibuti", DM: "Dominikai Közösség", DO: "Dominikai Köztársaság", EC: "Ecuador", EG: "Egyiptom", SV: "Salvador", GQ: "Egyenlítői-Guinea", ER: "Eritrea", EE: "Észtország", ET: "Etiópia", FK: "Falkland-szigetek", FO: "Feröer", FJ: "Fidzsi-szigetek", FI: "Finnország", FR: "Franciaország", GF: "Francia Guyana", PF: "Francia Polinézia", TF: "Francia déli területek", GA: "Gabon", GM: "Gambia", GE: "Grúzia", DE: "Németország", GH: "Ghána", GI: "Gibraltár", GR: "Görögország", GL: "Grönland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Bissau-Guinea", GY: "Guyana", HT: "Haiti", HM: "Heard-sziget és McDonald-szigetek", VA: "Vatikán", HN: "Honduras", HK: "Hong Kong", HU: "Magyarország", IS: "Izland", IN: "India", ID: "Indonézia", IR: "Irán", IQ: "Irak", IE: "Írország", IL: "Izrael", IT: "Olaszország", JM: "Jamaica", JP: "Japán", JO: "Jordánia", KZ: "Kazahsztán", KE: "Kenya", KI: "Kiribati", KP: "Észak-Korea", KR: "Dél-Korea", KW: "Kuvait", KG: "Kirgizisztán", LA: "Laosz", LV: "Lettország", LB: "Libanon", LS: "Lesotho", LR: "Libéria", LY: "Líbia", LI: "Liechtenstein", LT: "Litvánia", LU: "Luxemburg", MO: "Makao", MK: "Észak-Macedónia", MG: "Madagaszkár", MW: "Malawi", MY: "Malajzia", MV: "Maldív-szigetek", ML: "Mali", MT: "Málta", MH: "Marshall-szigetek", MQ: "Martinique", MR: "Mauritánia", MU: "Mauritius", YT: "Mayotte", MX: "Mexikó", FM: "Mikronéziai Szövetségi Államok", MD: "Moldova", MC: "Monaco", MN: "Mongólia", MS: "Montserrat", MA: "Marokkó", MZ: "Mozambik", MM: "Mianmar", NA: "Namíbia", NR: "Nauru", NP: "Nepál", NL: "Hollandia", NC: "Új-Kaledónia", NZ: "Új-Zéland", NI: "Nicaragua", NE: "Niger", NG: "Nigéria", NU: "Niue", NF: "Norfolk-sziget", MP: "Északi-Mariana-szigetek", NO: "Norvégia", OM: "Omán", PK: "Pakisztán", PW: "Palau", PS: "Palesztina", PA: "Panama", PG: "Pápua Új-Guinea", PY: "Paraguay", PE: "Peru", PH: "Fülöp-szigetek", PN: "Pitcairn-szigetek", PL: "Lengyelország", PT: "Portugália", PR: "Puerto Rico", QA: "Katar", RE: "Réunion", RO: "Románia", RU: "Oroszország", RW: "Ruanda", SH: "Saint Helena", KN: "Saint Kitts és Nevis", LC: "Saint Lucia", PM: "Saint Pierre and Miquelon", VC: "Saint Vincent és a Grenadine-szigetek", WS: "Szamoa", SM: "San Marino", ST: "São Tomé és Príncipe", SA: "Szaudi-Arábia", SN: "Szenegál", SC: "Seychelle-szigetek", SL: "Sierra Leone", SG: "Szingapúr", SK: "Szlovákia", SI: "Szlovénia", SB: "Salamon-szigetek", SO: "Szomália", ZA: "Dél-Afrika", GS: "Déli-Georgia és Déli-Sandwich-szigetek", ES: "Spanyolország", LK: "Sri Lanka", SD: "Szudán", SR: "Suriname", SJ: "Spitzbergák és Jan Mayen", SZ: "Szváziföld", SE: "Svédország", CH: "Svájc", SY: "Szíria", TW: "Tajvan", TJ: "Tádzsikisztán", TZ: "Tanzánia", TH: "Thaiföld", TL: "Kelet-Timor", TG: "Togo", TK: "Tokelau-szigetek", TO: "Tonga", TT: "Trinidad és Tobago", TN: "Tunézia", TR: "Törökország", TM: "Türkmenisztán", TC: "Turks- és Caicos-szigetek", TV: "Tuvalu", UG: "Uganda", UA: "Ukrajna", AE: "Egyesült Arab Emírségek", GB: "Egyesült Királyság", US: "Amerikai Egyesült Államok", UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai", UY: "Uruguay", UZ: "Üzbegisztán", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Brit Virgin-szigetek", VI: "Amerikai Virgin-szigetek", WF: "Wallis és Futuna", EH: "Nyugat-Szahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Karibi Hollandia", CW: "Curaçao", GG: "Guernsey", IM: "Man-sziget", JE: "Jersey", ME: "Montenegró", BL: "Saint Barthélemy", MF: "Szent Márton-sziget (francia rész)", RS: "Szerbia", SX: "Szent Márton-sziget (holland rész)", SS: "Dél-Szudán", XK: "Koszovó" }, id = {
  locale: Po,
  countries: Ao
}, od = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ao,
  default: id,
  locale: Po
}, Symbol.toStringTag, { value: "Module" })), No = "id", To = { AF: "Afghanistan", AL: "Albania", DZ: "Algeria", AS: "Samoa Amerika", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua dan Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbaijan", BS: "Bahama", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Belarusia", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia dan Herzegovina", BW: "Botswana", BV: "Kepulauan Bouvet", BR: "Brasil", IO: "Teritori Samudra Hindia Britania", BN: "Brunei Darussalam", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kamboja", CM: "Kamerun", CA: "Kanada", CV: "Tanjung Verde", KY: "Kepulauan Cayman", CF: "Afrika Tengah", TD: "Chad", CL: "Chile", CN: "China", CX: "Pulau Natal", CC: "Kepulauan Cocos (Keeling)", CO: "Kolombia", KM: "Komoro", CG: "Kongo", CD: "Republik Demokratik Kongo", CK: "Kepulauan Cook", CR: "Kosta Rika", CI: "Pantai Gading", HR: "Kroasia", CU: "Kuba", CY: "Siprus", CZ: "Republik Ceko", DK: "Denmark", DJ: "Djibouti", DM: "Dominika", DO: "Republik Dominika", EC: "Ekuador", EG: "Mesir", SV: "El Salvador", GQ: "Guinea Khatulistiwa", ER: "Eritrea", EE: "Estonia", ET: "Ethiopia", FK: "Kepulauan Falkland(Malvinas)", FO: "Kepulauan Faroe", FJ: "Fiji", FI: "Finlandia", FR: "Perancis", GF: "Guyana Perancis", PF: "Polinesia Perancis", TF: "Antartika Perancis", GA: "Gabon", GM: "Gambia", GE: "Georgia", DE: "Jerman", GH: "Ghana", GI: "Gibraltar", GR: "Yunani", GL: "Greenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatamala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Pulau Heard dan Kepulauan McDonald", VA: "Vatikan", HN: "Honduras", HK: "Hong Kong", HU: "Hungaria", IS: "Islandia", IN: "India", ID: "Indonesia", IR: "Iran", IQ: "Irak", IE: "Irlandia", IL: "Israel", IT: "Italia", JM: "Jamaika", JP: "Jepang", JO: "Yordania", KZ: "Kazakhstan", KE: "Kenya", KI: "Kiribati", KP: "Korea Utara", KR: "Korea Selatan", KW: "Kuwait", KG: "Kyrgyzstan", LA: "Laos", LV: "Latvia", LB: "Lebanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Lithuania", LU: "Luxemburg", MO: "Makau", MK: "Makedonia Utara", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldives", ML: "Mali", MT: "Malta", MH: "Kepulauan Marshall", MQ: "Martinik", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Meksiko", FM: "Federasi Mikronesia", MD: "Moldova", MC: "Monako", MN: "Mongolia", MS: "Montserrat", MA: "Moroko", MZ: "Mozambik", MM: "Myanmar", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Belanda", NC: "Kaledonia Baru", NZ: "Selandia Baru", NI: "Nikaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Kepulauan Norfolk", MP: "Kepulauan Mariana Utara", NO: "Norwegia", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestina", PA: "Panama", PG: "Papua Nugini", PY: "Paraguay", PE: "Peru", PH: "Filipina", PN: "Pitcairn", PL: "Polandia", PT: "Portugal", PR: "Puerto Riko", QA: "Qatar", RE: "Reunion", RO: "Rumania", RU: "Rusia", RW: "Rwanda", SH: "Saint Helena", KN: "Saint Kitts dan Nevis", LC: "Saint Lucia", PM: "Saint Pierre dan Miquelon", VC: "Saint Vincent dan the Grenadines", WS: "Samoa", SM: "San Marino", ST: "Sao Tome dan Principe", SA: "Arab Saudi", SN: "Senegal", SC: "Seychelles", SL: "Sierra Leone", SG: "Singapura", SK: "Slovakia", SI: "Slovenia", SB: "Kepulauan Solomon", SO: "Somalia", ZA: "Afrika Selatan", GS: "Georgia Selatan dan Kepulauan Sandwich Selatan", ES: "Spanyol", LK: "Sri Lanka", SD: "Sudan", SR: "Suriname", SJ: "Svalbard dan Jan Mayen", SZ: "Eswatini", SE: "Sweden", CH: "Swiss", SY: "Suriah", TW: "Taiwan", TJ: "Tajikistan", TZ: "Tanzania", TH: "Thailand", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad dan Tobago", TN: "Tunisia", TR: "Turki", TM: "Turkmenistan", TC: "Turks dan Caicos Islands", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "Uni Emirat Arab", GB: "Britania Raya", US: "Amerika Serikat", UM: "United States Minor Outlying Islands", UY: "Uruguay", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Viet Nam", VG: "Virgin Islands, British", VI: "Virgin Islands, U.S.", WF: "Wallis and Futuna", EH: "Sahara Barat", YE: "Yaman", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland Islands", BQ: "Bonaire, Sint Eustatius and Saba", CW: "Curaçao", GG: "Guernsey", IM: "Isle of Man", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: "Saint Martin (French part)", RS: "Serbia", SX: "Sint Maarten (Dutch part)", SS: "Sudan Selatan", XK: "Kosovo" }, sd = {
  locale: No,
  countries: To
}, ld = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: To,
  default: sd,
  locale: No
}, Symbol.toStringTag, { value: "Module" })), Io = "it", xo = { AD: "Andorra", AE: "Emirati Arabi Uniti", AF: "Afghanistan", AG: "Antigua e Barbuda", AI: "Anguilla", AL: "Albania", AM: "Armenia", AO: "Angola", AQ: "Antartide", AR: "Argentina", AS: "Samoa Americane", AT: "Austria", AU: "Australia", AW: "Aruba", AX: "Isole Åland", AZ: "Azerbaigian", BA: "Bosnia ed Erzegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgio", BF: "Burkina Faso", BG: "Bulgaria", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Saint-Barthélemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Isole BES", BR: "Brasile", BS: "Bahamas", BT: "Bhutan", BV: "Isola Bouvet", BW: "Botswana", BY: "Bielorussia", BZ: "Belize", CA: "Canada", CC: "Isole Cocos e Keeling", CD: "Repubblica Democratica del Congo", CF: "Repubblica Centrafricana", CG: "Repubblica del Congo", CH: "Svizzera", CI: "Costa d'Avorio", CK: "Isole Cook", CL: "Cile", CM: "Camerun", CN: "Cina", CO: "Colombia", CR: "Costa Rica", CU: "Cuba", CV: "Capo Verde", CW: "Curaçao", CX: "Isola del Natale", CY: "Cipro", CZ: "Repubblica Ceca", DE: "Germania", DJ: "Gibuti", DK: "Danimarca", DM: "Dominica", DO: "Repubblica Dominicana", DZ: "Algeria", EC: "Ecuador", EE: "Estonia", EG: "Egitto", EH: "Sahara Occidentale", ER: "Eritrea", ES: "Spagna", ET: "Etiopia", FI: "Finlandia", FJ: "Figi", FK: "Isole Falkland", FM: "Stati Federati di Micronesia", FO: "Isole Fær Øer", FR: "Francia", GA: "Gabon", GB: "Regno Unito", GD: "Grenada", GE: "Georgia", GF: "Guyana Francese", GG: "Guernsey", GH: "Ghana", GI: "Gibilterra", GL: "Groenlandia", GM: "Gambia", GN: "Guinea", GP: "Guadalupa", GQ: "Guinea Equatoriale", GR: "Grecia", GS: "Georgia del Sud e isole Sandwich meridionali", GT: "Guatemala", GU: "Guam", GW: "Guinea-Bissau", GY: "Guyana", HK: "Hong Kong", HM: "Isole Heard e McDonald", HN: "Honduras", HR: "Croazia", HT: "Haiti", HU: "Ungheria", ID: "Indonesia", IE: "Irlanda", IL: "Israele", IM: "Isola di Man", IN: "India", IO: "Territori Britannici dell'Oceano Indiano", IQ: "Iraq", IR: "Iran", IS: "Islanda", IT: "Italia", JE: "Jersey", JM: "Giamaica", JO: "Giordania", JP: "Giappone", KE: "Kenya", KG: "Kirghizistan", KH: "Cambogia", KI: "Kiribati", KM: "Comore", KN: "Saint Kitts e Nevis", KP: "Corea del Nord", KR: "Corea del Sud", KW: "Kuwait", KY: "Isole Cayman", KZ: "Kazakistan", LA: "Laos", LB: "Libano", LC: "Santa Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Lituania", LU: "Lussemburgo", LV: "Lettonia", LY: "Libia", MA: "Marocco", MC: "Monaco", MD: "Moldavia", ME: "Montenegro", MF: "Saint-Martin", MG: "Madagascar", MH: "Isole Marshall", MK: "Macedonia del Nord", ML: "Mali", MM: "Birmania  Myanmar", MN: "Mongolia", MO: "Macao", MP: "Isole Marianne Settentrionali", MQ: "Martinica", MR: "Mauritania", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldive", MW: "Malawi", MX: "Messico", MY: "Malesia", MZ: "Mozambico", NA: "Namibia", NC: "Nuova Caledonia", NE: "Niger", NF: "Isola Norfolk", NG: "Nigeria", NI: "Nicaragua", NL: "Paesi Bassi", NO: "Norvegia", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nuova Zelanda", OM: "Oman", PA: "Panamá", PE: "Perù", PF: "Polinesia Francese", PG: "Papua Nuova Guinea", PH: "Filippine", PK: "Pakistan", PL: "Polonia", PM: "Saint Pierre e Miquelon", PN: "Isole Pitcairn", PR: "Porto Rico", PS: "Stato di Palestina", PT: "Portogallo", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "Romania", RS: "Serbia", RU: "Russia", RW: "Ruanda", SA: "Arabia Saudita", SB: "Isole Salomone", SC: "Seychelles", SD: "Sudan", SE: "Svezia", SG: "Singapore", SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha", SI: "Slovenia", SJ: "Svalbard e Jan Mayen", SK: "Slovacchia", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Suriname", SS: "Sudan del Sud", ST: "São Tomé e Príncipe", SV: "El Salvador", SX: "Sint Maarten", SY: "Siria", SZ: "Eswatini", TC: "Isole Turks e Caicos", TD: "Ciad", TF: "Territori Francesi del Sud", TG: "Togo", TH: "Thailandia", TJ: "Tagikistan", TK: "Tokelau", TL: "Timor Est", TM: "Turkmenistan", TN: "Tunisia", TO: "Tonga", TR: "Turchia", TT: "Trinidad e Tobago", TV: "Tuvalu", TW: ["Repubblica di Cina", "Taiwan"], TZ: "Tanzania", UA: "Ucraina", UG: "Uganda", UM: "Isole minori esterne degli Stati Uniti", US: "Stati Uniti d'America", UY: "Uruguay", UZ: "Uzbekistan", VA: "Città del Vaticano", VC: "Saint Vincent e Grenadine", VE: "Venezuela", VG: "Isole Vergini Britanniche", VI: "Isole Vergini Americane", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis e Futuna", WS: "Samoa", YE: "Yemen", YT: "Mayotte", ZA: "Sudafrica", ZM: "Zambia", ZW: "Zimbabwe", XK: "Kosovo" }, cd = {
  locale: Io,
  countries: xo
}, ud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: xo,
  default: cd,
  locale: Io
}, Symbol.toStringTag, { value: "Module" })), Eo = "ja", Bo = { AF: "アフガニスタン", AL: "アルバニア", DZ: "アルジェリア", AS: "アメリカ領サモア", AD: "アンドラ", AO: "アンゴラ", AI: "アンギラ", AQ: "南極", AG: "アンティグア・バーブーダ", AR: "アルゼンチン", AM: "アルメニア", AW: "アルバ", AU: "オーストラリア", AT: "オーストリア", AZ: "アゼルバイジャン", BS: "バハマ", BH: "バーレーン", BD: "バングラデシュ", BB: "バルバドス", BY: "ベラルーシ", BE: "ベルギー", BZ: "ベリーズ", BJ: "ベナン", BM: "バミューダ", BT: "ブータン", BO: "ボリビア多民族国", BA: "ボスニア・ヘルツェゴビナ", BW: "ボツワナ", BV: "ブーベ島", BR: "ブラジル", IO: "イギリス領インド洋地域", BN: "ブルネイ・ダルサラーム", BG: "ブルガリア", BF: "ブルキナファソ", BI: "ブルンジ", KH: "カンボジア", CM: "カメルーン", CA: "カナダ", CV: "カーボベルデ", KY: "ケイマン諸島", CF: "中央アフリカ共和国", TD: "チャド", CL: "チリ", CN: "中華人民共和国", CX: "クリスマス島", CC: "ココス（キーリング）諸島", CO: "コロンビア", KM: "コモロ", CG: "コンゴ共和国", CD: "コンゴ民主共和国", CK: "クック諸島", CR: "コスタリカ", CI: "コートジボワール", HR: "クロアチア", CU: "キューバ", CY: "キプロス", CZ: "チェコ", DK: "デンマーク", DJ: "ジブチ", DM: "ドミニカ国", DO: "ドミニカ共和国", EC: "エクアドル", EG: "エジプト", SV: "エルサルバドル", GQ: "赤道ギニア", ER: "エリトリア", EE: "エストニア", ET: "エチオピア", FK: "フォークランド（マルビナス）諸島", FO: "フェロー諸島", FJ: "フィジー", FI: "フィンランド", FR: "フランス", GF: "フランス領ギアナ", PF: "フランス領ポリネシア", TF: "フランス領南方・南極地域", GA: "ガボン", GM: "ガンビア", GE: "ジョージア", DE: "ドイツ", GH: "ガーナ", GI: "ジブラルタル", GR: "ギリシャ", GL: "グリーンランド", GD: "グレナダ", GP: "グアドループ", GU: "グアム", GT: "グアテマラ", GN: "ギニア", GW: "ギニアビサウ", GY: "ガイアナ", HT: "ハイチ", HM: "ハード島とマクドナルド諸島", VA: "バチカン市国", HN: "ホンジュラス", HK: "香港", HU: "ハンガリー", IS: "アイスランド", IN: "インド", ID: "インドネシア", IR: "イラン・イスラム共和国", IQ: "イラク", IE: "アイルランド", IL: "イスラエル", IT: "イタリア", JM: "ジャマイカ", JP: "日本", JO: "ヨルダン", KZ: "カザフスタン", KE: "ケニア", KI: "キリバス", KP: "朝鮮民主主義人民共和国", KR: "大韓民国", KW: "クウェート", KG: "キルギス", LA: "ラオス人民民主共和国", LV: "ラトビア", LB: "レバノン", LS: "レソト", LR: "リベリア", LY: "リビア", LI: "リヒテンシュタイン", LT: "リトアニア", LU: "ルクセンブルク", MO: "マカオ", MG: "マダガスカル", MW: "マラウイ", MY: "マレーシア", MV: "モルディブ", ML: "マリ", MT: "マルタ", MH: "マーシャル諸島", MQ: "マルティニーク", MR: "モーリタニア", MU: "モーリシャス", YT: "マヨット", MX: "メキシコ", FM: "ミクロネシア連邦", MD: "モルドバ共和国", MC: "モナコ", MN: "モンゴル", MS: "モントセラト", MA: "モロッコ", MZ: "モザンビーク", MM: "ミャンマー", NA: "ナミビア", NR: "ナウル", NP: "ネパール", NL: "オランダ", NC: "ニューカレドニア", NZ: "ニュージーランド", NI: "ニカラグア", NE: "ニジェール", NG: "ナイジェリア", NU: "ニウエ", NF: "ノーフォーク島", MK: "北マケドニア", MP: "北マリアナ諸島", NO: "ノルウェー", OM: "オマーン", PK: "パキスタン", PW: "パラオ", PS: "パレスチナ", PA: "パナマ", PG: "パプアニューギニア", PY: "パラグアイ", PE: "ペルー", PH: "フィリピン", PN: "ピトケアン", PL: "ポーランド", PT: "ポルトガル", PR: "プエルトリコ", QA: "カタール", RE: "レユニオン", RO: "ルーマニア", RU: "ロシア連邦", RW: "ルワンダ", SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ", KN: "セントクリストファー・ネイビス", LC: "セントルシア", PM: "サンピエール島・ミクロン島", VC: "セントビンセントおよびグレナディーン諸島", WS: "サモア", SM: "サンマリノ", ST: "サントメ・プリンシペ", SA: "サウジアラビア", SN: "セネガル", SC: "セーシェル", SL: "シエラレオネ", SG: "シンガポール", SK: "スロバキア", SI: "スロベニア", SB: "ソロモン諸島", SO: "ソマリア", ZA: "南アフリカ", GS: "サウスジョージア・サウスサンドウィッチ諸島", ES: "スペイン", LK: "スリランカ", SD: "スーダン", SR: "スリナム", SJ: "スヴァールバル諸島およびヤンマイエン島", SZ: "スワジランド", SE: "スウェーデン", CH: "スイス", SY: "シリア・アラブ共和国", TW: "台湾", TJ: "タジキスタン", TZ: "タンザニア", TH: "タイ", TL: "東ティモール", TG: "トーゴ", TK: "トケラウ", TO: "トンガ", TT: "トリニダード・トバゴ", TN: "チュニジア", TR: "トルコ", TM: "トルクメニスタン", TC: "タークス・カイコス諸島", TV: "ツバル", UG: "ウガンダ", UA: "ウクライナ", AE: "アラブ首長国連邦", GB: "イギリス", US: "アメリカ合衆国", UM: "合衆国領有小離島", UY: "ウルグアイ", UZ: "ウズベキスタン", VU: "バヌアツ", VE: "ベネズエラ・ボリバル共和国", VN: "ベトナム", VG: "イギリス領ヴァージン諸島", VI: "アメリカ領ヴァージン諸島", WF: "ウォリス・フツナ", EH: "西サハラ", YE: "イエメン", ZM: "ザンビア", ZW: "ジンバブエ", AX: "オーランド諸島", BQ: "ボネール、シント・ユースタティウスおよびサバ", CW: "キュラソー", GG: "ガーンジー", IM: "マン島", JE: "ジャージー", ME: "モンテネグロ", BL: "サン・バルテルミー", MF: "サン・マルタン（フランス領）", RS: "セルビア", SX: "シント・マールテン（オランダ領）", SS: "南スーダン", XK: "コソボ" }, dd = {
  locale: Eo,
  countries: Bo
}, pd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Bo,
  default: dd,
  locale: Eo
}, Symbol.toStringTag, { value: "Module" })), Ro = "nl", Oo = { AF: "Afghanistan", AL: "Albanië", DZ: "Algerije", AS: "Amerikaans-Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarctica", AG: "Antigua en Barbuda", AR: "Argentinië", AM: "Armenië", AW: "Aruba", AU: "Australië", AT: "Oostenrijk", AZ: "Azerbeidzjan", BS: "Bahama's", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Wit-Rusland", BE: ["België", "Koninkrijk België"], BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivië", BA: "Bosnië-Herzegovina", BW: "Botswana", BV: "Bouvet Eiland", BR: "Brazilië", IO: "Brits Indische oceaan", BN: "Brunei Darussalam", BG: "Bulgarije", BF: "Burkina Faso", BI: "Burundi", KH: "Cambodja", CM: "Kameroen", CA: "Canada", CV: "Kaapverdië", KY: "Kaaimaneilanden", CF: "Centraal-Afrikaanse Republiek", TD: "Tsjaad", CL: "Chili", CN: "China", CX: "Christmaseiland", CC: "Cocoseilanden", CO: "Colombia", KM: "Comoren", CG: "Congo, Volksrepubliek", CD: "Congo, Democratische Republiek", CK: "Cookeilanden", CR: "Costa Rica", CI: "Ivoorkust", HR: "Kroatië", CU: "Cuba", CY: "Cyprus", CZ: "Tsjechië", DK: "Denemarken", DJ: "Djibouti", DM: "Dominica", DO: "Dominicaanse Republiek", EC: "Ecuador", EG: "Egypte", SV: "El Salvador", GQ: "Equatoriaal-Guinea", ER: "Eritrea", EE: "Estland", ET: "Ethiopië", FK: "Falklandeilanden", FO: "Faeröer", FJ: "Fiji", FI: "Finland", FR: "Frankrijk", GF: "Frans-Guyana", PF: "Frans-Polynesië", TF: "Franse Zuidelijke Gebieden", GA: "Gabon", GM: "Gambia", GE: "Georgië", DE: "Duitsland", GH: "Ghana", GI: "Gibraltar", GR: "Griekenland", GL: "Groenland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinee-Bissau", GY: "Guyana", HT: "Haïti", HM: "Heard en McDonaldeilanden", VA: "Heilige Stoel", HN: "Honduras", HK: "Hong Kong", HU: "Hongarije", IS: "IJsland", IN: "India", ID: "Indonesië", IR: "Iran", IQ: "Irak", IE: "Ierland", IL: "Israël", IT: "Italië", JM: "Jamaica", JP: "Japan", JO: "Jordanië", KZ: "Kazachstan", KE: "Kenia", KI: "Kiribati", KP: "Noord-Korea", KR: "Zuid-Korea", KW: "Koeweit", KG: "Kirgizstan", LA: "Laos", LV: "Letland", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libië", LI: "Liechtenstein", LT: "Litouwen", LU: "Luxemburg", MO: "Macao", MG: "Madagaskar", MW: "Malawi", MY: "Maleisië", MV: ["Maldiven", "Malediven"], ML: "Mali", MT: "Malta", MH: "Marshalleilanden", MQ: "Martinique", MR: "Mauritanië", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Micronesië, Federale Staten", MD: "Moldavië", MC: "Monaco", MN: "Mongolië", MS: "Montserrat", MA: "Marokko", MZ: "Mozambique", MM: "Myanmar", NA: "Namibië", NR: "Nauru", NP: "Nepal", NL: ["Nederland", "Koninkrijk der Nederlanden"], NC: "Nieuw-Caledonië", NZ: "Nieuw-Zeeland", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk", MP: "Noordelijke Marianen", MK: "Noord-Macedonië", NO: "Noorwegen", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestina", PA: "Panama", PG: "Papoea-Nieuw-Guinea", PY: "Paraguay", PE: "Peru", PH: "Filipijnen", PN: "Pitcairn", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Roemenië", RU: "Rusland", RW: "Rwanda", SH: "Sint-Helena", KN: "Saint Kitts en Nevis", LC: "Saint Lucia", PM: "Saint-Pierre en Miquelon", VC: "Saint Vincent en de Grenadines", WS: "Samoa", SM: "San Marino", ST: "São Tomé en Principe", SA: "Saudi-Arabië", SN: "Senegal", SC: "Seychellen", SL: "Sierra Leone", SG: "Singapore", SK: "Slowakije", SI: "Slovenië", SB: "Salomonseilanden", SO: "Somalië", ZA: "Zuid-Afrika", GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden", ES: "Spanje", LK: "Sri Lanka", SD: "Soedan", SR: "Suriname", SJ: "Spitsbergen en Jan Mayen", SZ: "Ngwane, Koninkrijk Eswatini", SE: "Zweden", CH: "Zwitserland", SY: "Syrië", TW: "Taiwan", TJ: "Tadzjikistan", TZ: ["Tanzania", "Tanzania, Verenigde Republiek"], TH: "Thailand", TL: "Timor Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad en Tobago", TN: "Tunesië", TR: "Turkije", TM: "Turkmenistan", TC: "Turks- en Caicoseilanden", TV: "Tuvalu", UG: "Oeganda", UA: "Oekraïne", AE: "Verenigde Arabische Emiraten", GB: ["Groot-Brittannië", "Verenigd Koninkrijk"], US: ["Verenigde Staten van Amerika", "Verenigde Staten"], UM: "Ver afgelegen eilandjes van de Verenigde Staten", UY: "Uruguay", UZ: "Oezbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "Maagdeneilanden, Britse", VI: "Maagdeneilanden, Amerikaanse", WF: "Wallis en Futuna", EH: "Westelijke Sahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Bonaire, Sint Eustatius en Saba", CW: "Curaçao", GG: "Guernsey", IM: "Man Eiland", JE: "Jersey", ME: "Montenegro", BL: "Saint Barthélemy", MF: ["Sint-Maarten (Frans deel)", "Sint-Maarten (Franse Antillen)", "Collectiviteit van Sint-Maarten"], RS: "Servië", SX: ["Sint Maarten", "Sint-Maarten", "Sint Maarten (Nederlands deel)", "Land Sint Maarten"], SS: "Zuid-Soedan", XK: "Kosovo" }, md = {
  locale: Ro,
  countries: Oo
}, hd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Oo,
  default: md,
  locale: Ro
}, Symbol.toStringTag, { value: "Module" })), Lo = "no", Go = { AF: "Afghanistan", AL: "Albania", DZ: "Algerie", AS: "Amerikansk Samoa", AD: "Andorra", AO: "Angola", AI: "Anguilla", AQ: "Antarktis", AG: "Antigua og Barbuda", AR: "Argentina", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Østerrike", AZ: "Aserbajdsjan", BS: "Bahamas", BH: "Bahrain", BD: "Bangladesh", BB: "Barbados", BY: "Hviterussland", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Bhutan", BO: "Bolivia", BA: "Bosnia-Hercegovina", BW: "Botswana", BV: "Bouvetøya", BR: "Brasil", IO: "Det britiske territoriet i Indiahavet", BN: "Brunei", BG: "Bulgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodsja", CM: "Kamerun", CA: "Canada", CV: "Kapp Verde", KY: "Caymanøyene", CF: "Den sentralafrikanske republikk", TD: "Tsjad", CL: "Chile", CN: "Kina", CX: "Christmasøya", CC: "Kokosøyene", CO: "Colombia", KM: "Komorene", CG: "Kongo-Brazzaville", CD: "Kongo", CK: "Cookøyene", CR: "Costa Rica", CI: "Elfenbenskysten", HR: "Kroatia", CU: "Cuba", CY: "Kypros", CZ: "Tsjekkia", DK: "Danmark", DJ: "Djibouti", DM: "Dominica", DO: "Den dominikanske republikk", EC: "Ecuador", EG: "Egypt", SV: "El Salvador", GQ: "Ekvatorial-Guinea", ER: "Eritrea", EE: "Estland", ET: "Etiopia", FK: "Falklandsøyene", FO: "Færøyene", FJ: "Fiji", FI: "Finland", FR: "Frankrike", GF: "Fransk Guyana", PF: "Fransk Polynesia", TF: "De franske sørterritorier", GA: "Gabon", GM: "Gambia", GE: "Georgia", DE: "Tyskland", GH: "Ghana", GI: "Gibraltar", GR: "Hellas", GL: "Grønland", GD: "Grenada", GP: "Guadeloupe", GU: "Guam", GT: "Guatemala", GN: "Guinea", GW: "Guinea-Bissau", GY: "Guyana", HT: "Haiti", HM: "Heard- og McDonaldøyene", VA: "Vatikanstaten", HN: "Honduras", HK: "Hongkong SAR Kina", HU: "Ungarn", IS: "Island", IN: "India", ID: "Indonesia", IR: "Iran", IQ: "Irak", IE: "Irland", IL: "Israel", IT: "Italia", JM: "Jamaica", JP: "Japan", JO: "Jordan", KZ: "Kasakhstan", KE: "Kenya", KI: "Kiribati", KP: "Nord-Korea", KR: "Sør-Korea", KW: "Kuwait", KG: "Kirgisistan", LA: "Laos", LV: "Latvia", LB: "Libanon", LS: "Lesotho", LR: "Liberia", LY: "Libya", LI: "Liechtenstein", LT: "Litauen", LU: "Luxemburg", MO: "Macao SAR Kina", MG: "Madagaskar", MW: "Malawi", MY: "Malaysia", MV: "Maldivene", ML: "Mali", MT: "Malta", MH: "Marshalløyene", MQ: "Martinique", MR: "Mauritania", MU: "Mauritius", YT: "Mayotte", MX: "Mexico", FM: "Mikronesiaføderasjonen", MD: "Moldova", MC: "Monaco", MN: "Mongolia", MS: "Montserrat", MA: "Marokko", MZ: "Mosambik", MM: "Myanmar (Burma)", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Nederland", NC: "Ny-Caledonia", NZ: "New Zealand", NI: "Nicaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolkøya", MK: "Nord-Makedonia", MP: "Nord-Marianene", NO: "Norge", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Det palestinske området", PA: "Panama", PG: "Papua Ny-Guinea", PY: "Paraguay", PE: "Peru", PH: "Filippinene", PN: "Pitcairnøyene", PL: "Polen", PT: "Portugal", PR: "Puerto Rico", QA: "Qatar", RE: "Réunion", RO: "Romania", RU: "Russland", RW: "Rwanda", SH: "St. Helena", KN: "Saint Kitts og Nevis", LC: "St. Lucia", PM: "Saint-Pierre-et-Miquelon", VC: "St. Vincent og Grenadinene", WS: "Samoa", SM: "San Marino", ST: "São Tomé og Príncipe", SA: "Saudi-Arabia", SN: "Senegal", SC: "Seychellene", SL: "Sierra Leone", SG: "Singapore", SK: "Slovakia", SI: "Slovenia", SB: "Salomonøyene", SO: "Somalia", ZA: "Sør-Afrika", GS: "Sør-Georgia og Sør-Sandwichøyene", ES: "Spania", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Svalbard og Jan Mayen", SZ: "Eswatini", SE: "Sverige", CH: "Sveits", SY: "Syria", TW: "Taiwan", TJ: "Tadsjikistan", TZ: "Tanzania", TH: "Thailand", TL: "Øst-Timor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad og Tobago", TN: "Tunisia", TR: "Tyrkia", TM: "Turkmenistan", TC: "Turks- og Caicosøyene", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "De forente arabiske emirater", GB: "Storbritannia", US: "USA", UM: "USAs ytre øyer", UY: "Uruguay", UZ: "Usbekistan", VU: "Vanuatu", VE: "Venezuela", VN: "Vietnam", VG: "De britiske jomfruøyene", VI: "De amerikanske jomfruøyene", WF: "Wallis og Futuna", EH: "Vest-Sahara", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Åland", BQ: "Karibisk Nederland", CW: "Curaçao", GG: "Guernsey", IM: "Man", JE: "Jersey", ME: "Montenegro", BL: "Saint-Barthélemy", MF: "Saint-Martin", RS: "Serbia", SX: "Sint Maarten", SS: "Sør-Sudan", XK: "Kosovo" }, fd = {
  locale: Lo,
  countries: Go
}, gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Go,
  default: fd,
  locale: Lo
}, Symbol.toStringTag, { value: "Module" })), Fo = "pl", Ko = { AF: "Afganistan", AL: "Albania", DZ: "Algieria", AS: "Samoa Amerykańskie", AD: "Andora", AO: "Angola", AI: "Anguilla", AQ: "Antarktyka", AG: "Antigua i Barbuda", AR: "Argentyna", AM: "Armenia", AW: "Aruba", AU: "Australia", AT: "Austria", AZ: "Azerbejdżan", BS: "Bahamy", BH: "Bahrajn", BD: "Bangladesz", BB: "Barbados", BY: "Białoruś", BE: "Belgia", BZ: "Belize", BJ: "Benin", BM: "Bermudy", BT: "Bhutan", BO: "Boliwia", BA: "Bośnia i Hercegowina", BW: "Botswana", BV: "Wyspa Bouveta", BR: "Brazylia", IO: "Brytyjskie Terytorium Oceanu Indyjskiego", BN: "Brunei", BG: "Bułgaria", BF: "Burkina Faso", BI: "Burundi", KH: "Kambodża", CM: "Kamerun", CA: "Kanada", CV: "Republika Zielonego Przylądka", KY: "Kajmany", CF: "Republika Środkowoafrykańska", TD: "Czad", CL: "Chile", CN: "Chiny", CX: "Wyspa Bożego Narodzenia", CC: "Wyspy Kokosowe", CO: "Kolumbia", KM: "Komory", CG: "Kongo", CD: "Demokratyczna Republika Konga", CK: "Wyspy Cooka", CR: "Kostaryka", CI: "Wybrzeże Kości Słoniowej", HR: "Chorwacja", CU: "Kuba", CY: "Cypr", CZ: "Czechy", DK: "Dania", DJ: "Dżibuti", DM: "Dominika", DO: "Dominikana", EC: "Ekwador", EG: "Egipt", SV: "Salwador", GQ: "Gwinea Równikowa", ER: "Erytrea", EE: "Estonia", ET: "Etiopia", FK: "Falklandy", FO: "Wyspy Owcze", FJ: "Fidżi", FI: "Finlandia", FR: "Francja", GF: "Gujana Francuska", PF: "Polinezja Francuska", TF: "Francuskie Terytoria Południowe i Antarktyczne", GA: "Gabon", GM: "Gambia", GE: "Gruzja", DE: "Niemcy", GH: "Ghana", GI: "Gibraltar", GR: "Grecja", GL: "Grenlandia", GD: "Grenada", GP: "Gwadelupa", GU: "Guam", GT: "Gwatemala", GN: "Gwinea", GW: "Gwinea Bissau", GY: "Gujana", HT: "Haiti", HM: "Wyspy Heard i McDonalda", VA: "Watykan", HN: "Honduras", HK: "Hongkong", HU: "Węgry", IS: "Islandia", IN: "Indie", ID: "Indonezja", IR: "Iran", IQ: "Irak", IE: "Irlandia", IL: "Izrael", IT: "Włochy", JM: "Jamajka", JP: "Japonia", JO: "Jordania", KZ: "Kazachstan", KE: "Kenia", KI: "Kiribati", KP: "Korea Północna", KR: "Korea Południowa", KW: "Kuwejt", KG: "Kirgistan", LA: "Laos", LV: "Łotwa", LB: "Liban", LS: "Lesotho", LR: "Liberia", LY: "Libia", LI: "Liechtenstein", LT: "Litwa", LU: "Luksemburg", MO: "Makau", MK: "Macedonia Północna", MG: "Madagaskar", MW: "Malawi", MY: "Malezja", MV: "Malediwy", ML: "Mali", MT: "Malta", MH: "Wyspy Marshalla", MQ: "Martynika", MR: "Mauretania", MU: "Mauritius", YT: "Majotta", MX: "Meksyk", FM: "Mikronezja", MD: "Mołdawia", MC: "Monako", MN: "Mongolia", MS: "Montserrat", MA: "Maroko", MZ: "Mozambik", MM: "Mjanma", NA: "Namibia", NR: "Nauru", NP: "Nepal", NL: "Holandia", NC: "Nowa Kaledonia", NZ: "Nowa Zelandia", NI: "Nikaragua", NE: "Niger", NG: "Nigeria", NU: "Niue", NF: "Norfolk", MP: "Mariany Północne", NO: "Norwegia", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Palestyna", PA: "Panama", PG: "Papua-Nowa Gwinea", PY: "Paragwaj", PE: "Peru", PH: "Filipiny", PN: "Pitcairn", PL: "Polska", PT: "Portugalia", PR: "Portoryko", QA: "Katar", RE: "Reunion", RO: "Rumunia", RU: "Rosja", RW: "Rwanda", SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha", KN: "Saint Kitts i Nevis", LC: "Saint Lucia", PM: "Saint-Pierre i Miquelon", VC: "Saint Vincent i Grenadyny", WS: "Samoa", SM: "San Marino", ST: "Wyspy Świętego Tomasza i Książęca", SA: "Arabia Saudyjska", SN: "Senegal", SC: "Seszele", SL: "Sierra Leone", SG: "Singapur", SK: "Słowacja", SI: "Słowenia", SB: "Wyspy Salomona", SO: "Somalia", ZA: "Południowa Afryka", GS: "Georgia Południowa i Sandwich Południowy", ES: "Hiszpania", LK: "Sri Lanka", SD: "Sudan", SR: "Surinam", SJ: "Svalbard i Jan Mayen", SZ: "Eswatini", SE: "Szwecja", CH: "Szwajcaria", SY: "Syria", TW: "Tajwan", TJ: "Tadżykistan", TZ: "Tanzania", TH: "Tajlandia", TL: "Timor Wschodni", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trynidad i Tobago", TN: "Tunezja", TR: "Turcja", TM: "Turkmenistan", TC: "Turks i Caicos", TV: "Tuvalu", UG: "Uganda", UA: "Ukraina", AE: "Zjednoczone Emiraty Arabskie", GB: "Wielka Brytania", US: "Stany Zjednoczone", UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych", UY: "Urugwaj", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Wenezuela", VN: "Wietnam", VG: "Brytyjskie Wyspy Dziewicze", VI: "Wyspy Dziewicze Stanów Zjednoczonych", WF: "Wallis i Futuna", EH: "Sahara Zachodnia", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabwe", AX: "Wyspy Alandzkie", BQ: "Bonaire, Sint Eustatius i Saba", CW: "Curaçao", GG: "Guernsey", IM: "Wyspa Man", JE: "Jersey", ME: "Czarnogóra", BL: "Saint-Barthélemy", MF: "Saint-Martin", RS: "Serbia", SX: "Sint Maarten", SS: "Sudan Południowy", XK: "Kosowo" }, _d = {
  locale: Fo,
  countries: Ko
}, yd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ko,
  default: _d,
  locale: Fo
}, Symbol.toStringTag, { value: "Module" })), Ho = "pt", zo = { AF: "Afeganistão", ZA: "África do Sul", AL: "Albânia", DE: "Alemanha", AD: "Andorra", AO: "Angola", AI: "Anguila", AQ: "Antártida", AG: "Antígua e Barbuda", SA: "Arábia Saudita", DZ: "Argélia", AR: "Argentina", AM: "Arménia", AW: "Aruba", AU: "Austrália", AT: "Áustria", AZ: "Azerbaijão", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BE: "Bélgica", BZ: "Belize", BJ: "Benim", BM: "Bermudas", BY: "Bielorrússia", BO: "Bolívia", BA: "Bósnia-Herzegovina", BW: "Botsuana", BR: "Brasil", BN: "Brunei", BG: "Bulgária", BF: "Burkina Faso", BI: "Burundi", BT: "Butão", CV: "Cabo Verde", KH: "Camboja", CA: "Canadá", QA: "Qatar", KZ: "Cazaquistão", TD: "Chade", CL: "Chile", CN: "China", CY: "Chipre", VA: "Santa Sé", SG: "Singapura", CO: "Colômbia", KM: "Comores", CG: "República Democrática do Congo", CD: "República Popular do Congo", KP: "Coreia do Norte", KR: "Coreia do Sul", CI: "Costa do Marfim", CR: "Costa Rica", HR: "Croácia", CU: "Cuba", CW: "Curaçao", DK: "Dinamarca", DJ: "Djibouti", DM: "Dominica", EG: "Egito", SV: "El Salvador", AE: "Emirados Árabes Unidos", EC: "Equador", ER: "Eritreia", SK: "Eslováquia", SI: "Eslovénia", ES: "Espanha", US: ["Estados Unidos", "Estados Unidos da América"], EE: "Estónia", ET: "Etiópia", FJ: "Fiji", PH: "Filipinas", FI: "Finlândia", FR: "França", GA: "Gabão", GM: "Gâmbia", GH: "Gana", GE: "Geórgia", GS: "Geórgia do Sul e Ilhas Sandwich do Sul", GI: "Gibraltar", GD: "Granada", GR: "Grécia", GL: "Gronelândia", GP: "Guadalupe", GU: "Guam", GT: "Guatemala", GG: "Guernsey", GY: "Guiana", GF: "Guiana Francesa", GN: "Guiné", GW: "Guiné-Bissau", GQ: "Guiné Equatorial", HT: "Haiti", NL: "Países Baixos", HN: "Honduras", HK: "Hong Kong", HU: "Hungria", YE: "Iémen", BV: "Ilha Bouvet", CX: "Ilha de Natal", IM: "Ilha de Man", NF: "Ilha Norfolk", AX: "Ilhas Åland", KY: "Ilhas Caimão", CC: "Ilhas Cocos (Keeling)", CK: "Ilhas Cook", UM: "Ilhas Distantes dos EUA", HM: "Ilha Heard e Ilhas McDonald", FO: "Ilhas Faroé", FK: "Ilhas Malvinas", MP: "Ilhas Marianas do Norte", MH: "Ilhas Marshall", PN: "Ilhas Pitcairn", SB: "Ilhas Salomão", TC: "Ilhas Turcas e Caicos", VG: "Ilhas Virgens Britânicas", VI: "Ilhas Virgens Americanas", IN: "Índia", ID: "Indonésia", IR: "Irão", IQ: "Iraque", IE: "Irlanda", IS: "Islândia", IL: "Israel", IT: "Itália", JM: "Jamaica", JP: "Japão", JE: "Jersey", JO: "Jordânia", KW: "Koweit", LA: "Laos", LS: "Lesoto", LV: "Letónia", LB: "Líbano", LR: "Libéria", LY: "Líbia", LI: "Liechtenstein", LT: "Lituânia", LU: "Luxemburgo", MO: "Macau", MK: "Macedónia do Norte", MG: "Madagáscar", MY: "Malásia", MW: "Maláui", MV: "Maldivas", ML: "Mali", MT: "Malta", MA: "Marrocos", MQ: "Martinica", MU: "Maurícia", MR: "Mauritânia", YT: "Mayotte", MX: "México", MM: "Mianmar (Birmânia)", FM: "Micronésia", MZ: "Moçambique", MD: "Moldávia", MC: "Mónaco", MN: "Mongólia", ME: "Montenegro", MS: "Monserrate", NA: "Namíbia", NR: "Nauru", NP: "Nepal", NI: "Nicarágua", NE: "Níger", NG: "Nigéria", NU: "Niue", NO: "Noruega", NC: "Nova Caledónia", NZ: "Nova Zelândia", OM: "Omã", BQ: "Países Baixos Caribenhos", PW: "Palau", PA: "Panamá", PG: "Papua-Nova Guiné", PK: "Paquistão", PY: "Paraguai", PE: "Peru", PF: "Polinésia Francesa", PL: "Polónia", PR: "Porto Rico", PT: "Portugal", KE: "Quénia", KG: "Quirguistão", KI: "Quiribati", GB: "Reino Unido", CF: "República Centro-Africana", DO: "República Dominicana", CM: "Camarões", CZ: "Chéquia", RE: "Reunião", RO: "Roménia", RW: "Ruanda", RU: "Rússia", EH: "Saara Ocidental", PM: "Saint Pierre e Miquelon", WS: "Samoa", AS: "Samoa Americana", SM: "San Marino", SH: "Santa Helena", LC: "Santa Lúcia", BL: "São Bartolomeu", KN: "São Cristóvão e Neves", MF: "São Martinho", ST: "São Tomé e Príncipe", VC: "São Vicente e Granadinas", SN: "Senegal", SL: "Serra Leoa", RS: "Sérvia", SC: "Seychelles", SX: "São Martinho", SY: "Síria", SO: "Somália", LK: "Sri Lanka", SZ: "Essuatíni", SD: "Sudão", SS: "Sudão do Sul", SE: "Suécia", CH: "Suíça", SR: "Suriname", SJ: "Svalbard e Jan Mayen", TH: "Tailândia", TW: "Taiwan", TJ: "Tajiquistão", TZ: "Tanzânia", IO: "Território Britânico do Oceano Índico", TF: "Terras Austrais e Antárticas Francesas", PS: "Territórios palestinos", TL: "Timor-Leste", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trindade e Tobago", TN: "Tunísia", TM: "Turquemenistão", TR: "Turquia", TV: "Tuvalu", UA: "Ucrânia", UG: "Uganda", UY: "Uruguai", UZ: "Uzbequistão", VU: "Vanuatu", VE: "Venezuela", VN: "Vietname", WF: "Wallis e Futuna", ZM: "Zâmbia", ZW: "Zimbábue", XK: "Kosovo" }, bd = {
  locale: Ho,
  countries: zo
}, vd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: zo,
  default: bd,
  locale: Ho
}, Symbol.toStringTag, { value: "Module" })), Vo = "ro", Uo = { AD: "Andorra", AE: "Emiratele Arabe Unite", AF: "Afganistan", AG: "Antigua și Barbuda", AI: "Anguilla", AL: "Albania", AM: "Armenia", AO: "Angola", AQ: "Antarctica", AR: "Argentina", AS: "Samoa Americană", AT: "Austria", AU: "Australia", AW: "Aruba", AX: "Insulele Åland", AZ: "Azerbaidjan", BA: "Bosnia și Herțegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgia", BF: "Burkina Faso", BG: "Bulgaria", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Sfântul Bartolomeu", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Insulele Caraibe Olandeze", BR: "Brazilia", BS: "Bahamas", BT: "Bhutan", BV: "Insula Bouvet", BW: "Botswana", BY: "Belarus", BZ: "Belize", CA: "Canada", CC: "Insulele Cocos (Keeling)", CD: "Congo - Kinshasa", CF: "Republica Centrafricană", CG: "Congo - Brazzaville", CH: "Elveția", CI: "Côte d’Ivoire", CK: "Insulele Cook", CL: "Chile", CM: "Camerun", CN: "China", CO: "Columbia", CR: "Costa Rica", CU: "Cuba", CV: "Capul Verde", CW: "Curaçao", CX: "Insula Christmas", CY: "Cipru", CZ: "Cehia", DE: "Germania", DJ: "Djibouti", DK: "Danemarca", DM: "Dominica", DO: "Republica Dominicană", DZ: "Algeria", EC: "Ecuador", EE: "Estonia", EG: "Egipt", EH: "Sahara Occidentală", ER: "Eritreea", ES: "Spania", ET: "Etiopia", FI: "Finlanda", FJ: "Fiji", FK: "Insulele Falkland", FM: "Micronezia", FO: "Insulele Feroe", FR: "Franța", GA: "Gabon", GB: "Regatul Unit", GD: "Grenada", GE: "Georgia", GF: "Guyana Franceză", GG: "Guernsey", GH: "Ghana", GI: "Gibraltar", GL: "Groenlanda", GM: "Gambia", GN: "Guineea", GP: "Guadelupa", GQ: "Guineea Ecuatorială", GR: "Grecia", GS: "Georgia de Sud și Insulele Sandwich de Sud", GT: "Guatemala", GU: "Guam", GW: "Guineea-Bissau", GY: "Guyana", HK: "R.A.S. Hong Kong a Chinei", HM: "Insula Heard și Insulele McDonald", HN: "Honduras", HR: "Croația", HT: "Haiti", HU: "Ungaria", ID: "Indonezia", IE: "Irlanda", IL: "Israel", IM: "Insula Man", IN: "India", IO: "Teritoriul Britanic din Oceanul Indian", IQ: "Irak", IR: "Iran", IS: "Islanda", IT: "Italia", JE: "Jersey", JM: "Jamaica", JO: "Iordania", JP: "Japonia", KE: "Kenya", KG: "Kârgâzstan", KH: "Cambodgia", KI: "Kiribati", KM: "Comore", KN: "Saint Kitts și Nevis", KP: "Coreea de Nord", KR: "Coreea de Sud", KW: "Kuweit", KY: "Insulele Cayman", KZ: "Kazahstan", LA: "Laos", LB: "Liban", LC: "Sfânta Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Lituania", LU: "Luxemburg", LV: "Letonia", LY: "Libia", MA: "Maroc", MC: "Monaco", MD: "Republica Moldova", ME: "Muntenegru", MF: "Sfântul Martin", MG: "Madagascar", MH: "Insulele Marshall", MK: "Macedonia de Nord", ML: "Mali", MM: "Myanmar", MN: "Mongolia", MO: "R.A.S. Macao a Chinei", MP: "Insulele Mariane de Nord", MQ: "Martinica", MR: "Mauritania", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldive", MW: "Malawi", MX: "Mexic", MY: "Malaysia", MZ: "Mozambic", NA: "Namibia", NC: "Noua Caledonie", NE: "Niger", NF: "Insula Norfolk", NG: "Nigeria", NI: "Nicaragua", NL: "Țările de Jos", NO: "Norvegia", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Noua Zeelandă", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Polinezia Franceză", PG: "Papua-Noua Guinee", PH: "Filipine", PK: "Pakistan", PL: "Polonia", PM: "Saint-Pierre și Miquelon", PN: "Insulele Pitcairn", PR: "Puerto Rico", PS: "Teritoriile Palestiniene", PT: "Portugalia", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "România", RS: "Serbia", RU: "Rusia", RW: "Rwanda", SA: "Arabia Saudită", SB: "Insulele Solomon", SC: "Seychelles", SD: "Sudan", SE: "Suedia", SG: "Singapore", SH: "Sfânta Elena", SI: "Slovenia", SJ: "Svalbard și Jan Mayen", SK: "Slovacia", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Suriname", SS: "Sudanul de Sud", ST: "Sao Tomé și Príncipe", SV: "El Salvador", SX: "Sint-Maarten", SY: "Siria", SZ: "Eswatini", TC: "Insulele Turks și Caicos", TD: "Ciad", TF: "Teritoriile Australe și Antarctice Franceze", TG: "Togo", TH: "Thailanda", TJ: "Tadjikistan", TK: "Tokelau", TL: "Timorul de Est", TM: "Turkmenistan", TN: "Tunisia", TO: "Tonga", TR: "Turcia", TT: "Trinidad și Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzania", UA: "Ucraina", UG: "Uganda", UM: "Insulele Îndepărtate ale S.U.A.", US: "Statele Unite ale Americii", UY: "Uruguay", UZ: "Uzbekistan", VA: "Statul Cetății Vaticanului", VC: "Saint Vincent și Grenadinele", VE: "Venezuela", VG: "Insulele Virgine Britanice", VI: "Insulele Virgine Americane", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis și Futuna", WS: "Samoa", XK: "Kosovo", YE: "Yemen", YT: "Mayotte", ZA: "Africa de Sud", ZM: "Zambia", ZW: "Zimbabwe" }, Sd = {
  locale: Vo,
  countries: Uo
}, kd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Uo,
  default: Sd,
  locale: Vo
}, Symbol.toStringTag, { value: "Module" })), jo = "ru", Yo = { AU: "Австралия", AT: "Австрия", AZ: "Азербайджан", AX: "Аландские острова", AL: "Албания", DZ: "Алжир", VI: "Виргинские Острова (США)", AS: "Американское Самоа", AI: "Ангилья", AO: "Ангола", AD: "Андорра", AQ: "Антарктида", AG: "Антигуа и Барбуда", AR: "Аргентина", AM: "Армения", AW: "Аруба", AF: "Афганистан", BS: "Багамы", BD: "Бангладеш", BB: "Барбадос", BH: "Бахрейн", BZ: "Белиз", BY: "Беларусь", BE: "Бельгия", BJ: "Бенин", BM: "Бермуды", BG: "Болгария", BO: "Боливия", BQ: "Бонэйр, Синт-Эстатиус и Саба", BA: "Босния и Герцеговина", BW: "Ботсвана", BR: "Бразилия", IO: "Британская территория в Индийском океане", VG: "Виргинские Острова (Великобритания)", BN: "Бруней", BF: "Буркина-Фасо", BI: "Бурунди", BT: "Бутан", VU: "Вануату", VA: "Ватикан", GB: "Великобритания", HU: "Венгрия", VE: "Венесуэла", UM: "Внешние малые острова (США)", TL: "Восточный Тимор", VN: "Вьетнам", GA: "Габон", HT: "Гаити", GY: "Гайана", GM: "Гамбия", GH: "Гана", GP: "Гваделупа", GT: "Гватемала", GF: "Гвиана", GN: "Гвинея", GW: "Гвинея-Бисау", DE: "Германия", GG: "Гернси", GI: "Гибралтар", HN: "Гондурас", HK: "Гонконг", GD: "Гренада", GL: "Гренландия", GR: "Греция", GE: "Грузия", GU: "Гуам", DK: "Дания", JE: "Джерси", DJ: "Джибути", DM: "Доминика", DO: "Доминиканская Республика", CD: "Демократическая Республика Конго", EG: "Египет", ZM: "Замбия", EH: "САДР", ZW: "Зимбабве", IL: "Израиль", IN: "Индия", ID: "Индонезия", JO: "Иордания", IQ: "Ирак", IR: "Иран", IE: "Ирландия", IS: "Исландия", ES: "Испания", IT: "Италия", YE: "Йемен", CV: "Кабо-Верде", KZ: "Казахстан", KY: "Острова Кайман", KH: "Камбоджа", CM: "Камерун", CA: "Канада", QA: "Катар", KE: "Кения", CY: "Кипр", KG: "Киргизия", KI: "Кирибати", TW: ["Тайвань", "Китайская Республика"], KP: "КНДР (Корейская Народно-Демократическая Республика)", CN: "КНР (Китайская Народная Республика)", CC: "Кокосовые острова", CO: "Колумбия", KM: "Коморы", CR: "Коста-Рика", CI: "Кот-д’Ивуар", CU: "Куба", KW: "Кувейт", CW: "Кюрасао", LA: "Лаос", LV: "Латвия", LS: "Лесото", LR: "Либерия", LB: "Ливан", LY: "Ливия", LT: "Литва", LI: "Лихтенштейн", LU: "Люксембург", MU: "Маврикий", MR: "Мавритания", MG: "Мадагаскар", YT: "Майотта", MO: "Макао", MW: "Малави", MY: "Малайзия", ML: "Мали", MV: "Мальдивы", MT: "Мальта", MA: "Марокко", MQ: "Мартиника", MH: "Маршалловы Острова", MX: "Мексика", FM: "Микронезия", MZ: "Мозамбик", MD: "Молдавия", MC: "Монако", MN: "Монголия", MS: "Монтсеррат", MM: "Мьянма", NA: "Намибия", NR: "Науру", NP: "Непал", NE: "Нигер", NG: "Нигерия", NL: "Нидерланды", NI: "Никарагуа", NU: "Ниуэ", NZ: "Новая Зеландия", NC: "Новая Каледония", NO: "Норвегия", AE: "ОАЭ", OM: "Оман", BV: "Остров Буве", IM: "Остров Мэн", CK: "Острова Кука", NF: "Остров Норфолк", CX: "Остров Рождества", PN: "Острова Питкэрн", SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья", PK: "Пакистан", PW: "Палау", PS: "Государство Палестина", PA: "Панама", PG: "Папуа — Новая Гвинея", PY: "Парагвай", PE: "Перу", PL: "Польша", PT: "Португалия", PR: "Пуэрто-Рико", CG: "Республика Конго", KR: "Республика Корея", RE: "Реюньон", RU: ["Российская Федерация", "Россия"], RW: "Руанда", RO: "Румыния", SV: "Сальвадор", WS: "Самоа", SM: "Сан-Марино", ST: "Сан-Томе и Принсипи", SA: "Саудовская Аравия", SZ: "Эсватини", MK: "Северная Македония", MP: "Северные Марианские Острова", SC: "Сейшельские Острова", BL: "Сен-Бартелеми", MF: "Сен-Мартен", PM: "Сен-Пьер и Микелон", SN: "Сенегал", VC: "Сент-Винсент и Гренадины", KN: "Сент-Китс и Невис", LC: "Сент-Люсия", RS: "Сербия", SG: "Сингапур", SX: "Синт-Мартен", SY: "Сирия", SK: "Словакия", SI: "Словения", SB: "Соломоновы Острова", SO: "Сомали", SD: "Судан", SR: "Суринам", US: "США", SL: "Сьерра-Леоне", TJ: "Таджикистан", TH: "Таиланд", TZ: "Танзания", TC: "Теркс и Кайкос", TG: "Того", TK: "Токелау", TO: "Тонга", TT: "Тринидад и Тобаго", TV: "Тувалу", TN: "Тунис", TM: "Туркмения", TR: "Турция", UG: "Уганда", UZ: "Узбекистан", UA: "Украина", WF: "Уоллис и Футуна", UY: "Уругвай", FO: "Фареры", FJ: "Фиджи", PH: "Филиппины", FI: "Финляндия", FK: "Фолклендские острова", FR: "Франция", PF: "Французская Полинезия", TF: "Французские Южные и Антарктические Территории", HM: "Херд и Макдональд", HR: "Хорватия", CF: "ЦАР", TD: "Чад", ME: "Черногория", CZ: "Чехия", CL: "Чили", CH: "Швейцария", SE: "Швеция", SJ: "Шпицберген и Ян-Майен", LK: "Шри-Ланка", EC: "Эквадор", GQ: "Экваториальная Гвинея", ER: "Эритрея", EE: "Эстония", ET: "Эфиопия", ZA: "ЮАР", GS: "Южная Георгия и Южные Сандвичевы Острова", SS: "Южный Судан", JM: "Ямайка", JP: "Япония", XK: "Косово" }, Md = {
  locale: jo,
  countries: Yo
}, wd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Yo,
  default: Md,
  locale: jo
}, Symbol.toStringTag, { value: "Module" })), Wo = "sk", Zo = { AD: "Andorra", AE: "Spojené arabské emiráty", AF: "Afganistan", AG: "Antigua a Barbuda", AI: "Anguilla", AL: "Albánsko", AM: "Arménsko", AO: "Angola", AQ: "Antarktída", AR: "Argentína", AS: "Americká Samoa", AT: "Rakúsko", AU: "Austrália", AW: "Aruba", AX: "Alandy", AZ: "Azerbajdžan", BA: "Bosna a Hercegovina", BB: "Barbados", BD: "Bangladéš", BE: "Belgicko", BF: "Burkina Faso", BG: "Bulharsko", BH: "Bahrajn", BI: "Burundi", BJ: "Benin", BL: "Svätý Bartolomej", BM: "Bermudy", BN: "Brunej", BO: "Bolívia", BQ: "Karibské Holandsko", BR: "Brazília", BS: "Bahamy", BT: "Bhután", BV: "Bouvetov ostrov", BW: "Botswana", BY: "Bielorusko", BZ: "Belize", CA: "Kanada", CC: "Kokosové ostrovy", CD: "Konžská demokratická republika", CF: "Stredoafrická republika", CG: "Konžská republika", CH: "Švajčiarsko", CI: "Pobrežie Slonoviny", CK: "Cookove ostrovy", CL: "Čile", CM: "Kamerun", CN: "Čína", CO: "Kolumbia", CR: "Kostarika", CU: "Kuba", CV: "Kapverdy", CW: "Curaçao", CX: "Vianočný ostrov", CY: "Cyprus", CZ: "Česko", DE: "Nemecko", DJ: "Džibutsko", DK: "Dánsko", DM: "Dominika", DO: "Dominikánska republika", DZ: "Alžírsko", EC: "Ekvádor", EE: "Estónsko", EG: "Egypt", EH: "Západná Sahara", ER: "Eritrea", ES: "Španielsko", ET: "Etiópia", FI: "Fínsko", FJ: "Fidži", FK: "Falklandy", FM: "Mikronézia", FO: "Faerské ostrovy", FR: "Francúzsko", GA: "Gabon", GB: "Spojené kráľovstvo", GD: "Grenada", GE: "Gruzínsko", GF: "Francúzska Guayana", GG: "Guernsey", GH: "Ghana", GI: "Gibraltár", GL: "Grónsko", GM: "Gambia", GN: "Guinea", GP: "Guadeloupe", GQ: "Rovníková Guinea", GR: "Grécko", GS: "Južná Georgia a Južné Sandwichove ostrovy", GT: "Guatemala", GU: "Guam", GW: "Guinea-Bissau", GY: "Guayana", HK: "Hongkong – OAO Číny", HM: "Heardov ostrov a Macdonaldove ostrovy", HN: "Honduras", HR: "Chorvátsko", HT: "Haiti", HU: "Maďarsko", ID: "Indonézia", IE: "Írsko", IL: "Izrael", IM: "Ostrov Man", IN: "India", IO: "Britské indickooceánske územie", IQ: "Irak", IR: "Irán", IS: "Island", IT: "Taliansko", JE: "Jersey", JM: "Jamajka", JO: "Jordánsko", JP: "Japonsko", KE: "Keňa", KG: "Kirgizsko", KH: "Kambodža", KI: "Kiribati", KM: "Komory", KN: "Svätý Krištof a Nevis", KP: "Severná Kórea", KR: "Južná Kórea", KW: "Kuvajt", KY: "Kajmanie ostrovy", KZ: "Kazachstan", LA: "Laos", LB: "Libanon", LC: "Svätá Lucia", LI: "Lichtenštajnsko", LK: "Srí Lanka", LR: "Libéria", LS: "Lesotho", LT: "Litva", LU: "Luxembursko", LV: "Lotyšsko", LY: "Líbya", MA: "Maroko", MC: "Monako", MD: "Moldavsko", ME: "Čierna Hora", MF: "Svätý Martin (fr.)", MG: "Madagaskar", MH: "Marshallove ostrovy", MK: "Severné Macedónsko", ML: "Mali", MM: "Mjanmarsko", MN: "Mongolsko", MO: "Macao – OAO Číny", MP: "Severné Mariány", MQ: "Martinik", MR: "Mauritánia", MS: "Montserrat", MT: "Malta", MU: "Maurícius", MV: "Maldivy", MW: "Malawi", MX: "Mexiko", MY: "Malajzia", MZ: "Mozambik", NA: "Namíbia", NC: "Nová Kaledónia", NE: "Niger", NF: "Norfolk", NG: "Nigéria", NI: "Nikaragua", NL: "Holandsko", NO: "Nórsko", NP: "Nepál", NR: "Nauru", NU: "Niue", NZ: "Nový Zéland", OM: "Omán", PA: "Panama", PE: "Peru", PF: "Francúzska Polynézia", PG: "Papua Nová Guinea", PH: "Filipíny", PK: "Pakistan", PL: "Poľsko", PM: "Saint Pierre a Miquelon", PN: "Pitcairnove ostrovy", PR: "Portoriko", PS: "Palestínske územia", PT: "Portugalsko", PW: "Palau", PY: "Paraguaj", QA: "Katar", RE: "Réunion", RO: "Rumunsko", RS: "Srbsko", RU: "Rusko", RW: "Rwanda", SA: "Saudská Arábia", SB: "Šalamúnove ostrovy", SC: "Seychely", SD: "Sudán", SE: "Švédsko", SG: "Singapur", SH: "Svätá Helena", SI: "Slovinsko", SJ: "Svalbard a Jan Mayen", SK: "Slovensko", SL: "Sierra Leone", SM: "San Maríno", SN: "Senegal", SO: "Somálsko", SR: "Surinam", SS: "Južný Sudán", ST: "Svätý Tomáš a Princov ostrov", SV: "Salvádor", SX: "Svätý Martin (hol.)", SY: "Sýria", SZ: "Svazijsko", TC: "Turks a Caicos", TD: "Čad", TF: "Francúzske južné a antarktické územia", TG: "Togo", TH: "Thajsko", TJ: "Tadžikistan", TK: "Tokelau", TL: "Východný Timor", TM: "Turkménsko", TN: "Tunisko", TO: "Tonga", TR: "Turecko", TT: "Trinidad a Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzánia", UA: "Ukrajina", UG: "Uganda", UM: "Menšie odľahlé ostrovy USA", US: "Spojené štáty", UY: "Uruguaj", UZ: "Uzbekistan", VA: "Vatikán", VC: "Svätý Vincent a Grenadíny", VE: "Venezuela", VG: "Britské Panenské ostrovy", VI: "Americké Panenské ostrovy", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis a Futuna", WS: "Samoa", XK: "Kosovo", YE: "Jemen", YT: "Mayotte", ZA: "Južná Afrika", ZM: "Zambia", ZW: "Zimbabwe" }, Cd = {
  locale: Wo,
  countries: Zo
}, Dd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Zo,
  default: Cd,
  locale: Wo
}, Symbol.toStringTag, { value: "Module" })), Jo = "sl", Qo = { AD: "Andora", AE: "Združeni arabski emirati", AF: "Afganistan", AG: "Antigva in Barbuda", AI: "Angvila", AL: "Albanija", AM: "Armenija", AO: "Angola", AQ: "Antarktika", AR: "Argentina", AS: "Ameriška Samoa", AT: "Avstrija", AU: "Avstralija", AW: "Aruba", AX: "Ålandski otoki", AZ: "Azerbajdžan", BA: "Bosna in Hercegovina", BB: "Barbados", BD: "Bangladeš", BE: "Belgija", BF: "Burkina Faso", BG: "Bolgarija", BH: "Bahrajn", BI: "Burundi", BJ: "Benin", BL: "Saint Barthélemy", BM: "Bermudi", BN: "Brunej", BO: "Bolivija", BQ: "Nizozemski Karibi", BR: "Brazilija", BS: "Bahami", BT: "Butan", BV: "Bouvetov otok", BW: "Bocvana", BY: "Belorusija", BZ: "Belize", CA: "Kanada", CC: "Kokosovi otoki", CD: "Demokratična republika Kongo", CF: "Centralnoafriška republika", CG: "Kongo - Brazzaville", CH: "Švica", CI: "Slonokoščena obala", CK: "Cookovi otoki", CL: "Čile", CM: "Kamerun", CN: "Kitajska", CO: "Kolumbija", CR: "Kostarika", CU: "Kuba", CV: "Zelenortski otoki", CW: "Curaçao", CX: "Božični otok", CY: "Ciper", CZ: "Češka", DE: "Nemčija", DJ: "Džibuti", DK: "Danska", DM: "Dominika", DO: "Dominikanska republika", DZ: "Alžirija", EC: "Ekvador", EE: "Estonija", EG: "Egipt", EH: "Zahodna Sahara", ER: "Eritreja", ES: "Španija", ET: "Etiopija", FI: "Finska", FJ: "Fidži", FK: "Falklandski otoki", FM: "Mikronezija", FO: "Ferski otoki", FR: "Francija", GA: "Gabon", GB: "Združeno kraljestvo", GD: "Grenada", GE: "Gruzija", GF: "Francoska Gvajana", GG: "Guernsey", GH: "Gana", GI: "Gibraltar", GL: "Grenlandija", GM: "Gambija", GN: "Gvineja", GP: "Gvadalupe", GQ: "Ekvatorialna Gvineja", GR: "Grčija", GS: "Južna Georgia in Južni Sandwichevi otoki", GT: "Gvatemala", GU: "Guam", GW: "Gvineja Bissau", GY: "Gvajana", HK: "Hongkong", HM: "Heardov otok in McDonaldovi otoki", HN: "Honduras", HR: "Hrvaška", HT: "Haiti", HU: "Madžarska", ID: "Indonezija", IE: "Irska", IL: "Izrael", IM: "Otok Man", IN: "Indija", IO: "Britansko ozemlje v Indijskem oceanu", IQ: "Irak", IR: "Iran", IS: "Islandija", IT: "Italija", JE: "Jersey", JM: "Jamajka", JO: "Jordanija", JP: "Japonska", KE: "Kenija", KG: "Kirgizistan", KH: "Kambodža", KI: "Kiribati", KM: "Komori", KN: "Saint Kitts in Nevis", KP: "Severna Koreja", KR: "Južna Koreja", KW: "Kuvajt", KY: "Kajmanski otoki", KZ: "Kazahstan", LA: "Laos", LB: "Libanon", LC: "Saint Lucia", LI: "Lihtenštajn", LK: "Šrilanka", LR: "Liberija", LS: "Lesoto", LT: "Litva", LU: "Luksemburg", LV: "Latvija", LY: "Libija", MA: "Maroko", MC: "Monako", MD: "Moldavija", ME: "Črna gora", MF: "Saint Martin", MG: "Madagaskar", MH: "Marshallovi otoki", MK: "Severna Makedonija", ML: "Mali", MM: "Mjanmar (Burma)", MN: "Mongolija", MO: "Macao", MP: "Severni Marianski otoki", MQ: "Martinik", MR: "Mavretanija", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldivi", MW: "Malavi", MX: "Mehika", MY: "Malezija", MZ: "Mozambik", NA: "Namibija", NC: "Nova Kaledonija", NE: "Niger", NF: "Norfolški otok", NG: "Nigerija", NI: "Nikaragva", NL: "Nizozemska", NO: "Norveška", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nova Zelandija", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Francoska Polinezija", PG: "Papua Nova Gvineja", PH: "Filipini", PK: "Pakistan", PL: "Poljska", PM: "Saint Pierre in Miquelon", PN: "Pitcairn", PR: "Portoriko", PS: "Palestinsko ozemlje", PT: "Portugalska", PW: "Palau", PY: "Paragvaj", QA: "Katar", RE: "Reunion", RO: "Romunija", RS: "Srbija", RU: "Rusija", RW: "Ruanda", SA: "Saudova Arabija", SB: "Salomonovi otoki", SC: "Sejšeli", SD: "Sudan", SE: "Švedska", SG: "Singapur", SH: "Sveta Helena", SI: "Slovenija", SJ: "Svalbard in Jan Mayen", SK: "Slovaška", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalija", SR: "Surinam", SS: "Južni Sudan", ST: "Sao Tome in Principe", SV: "Salvador", SX: "Sint Maarten", SY: "Sirija", SZ: "Svazi", TC: "Otoki Turks in Caicos", TD: "Čad", TF: "Francosko južno ozemlje", TG: "Togo", TH: "Tajska", TJ: "Tadžikistan", TK: "Tokelau", TL: "Timor-Leste", TM: "Turkmenistan", TN: "Tunizija", TO: "Tonga", TR: "Turčija", TT: "Trinidad in Tobago", TV: "Tuvalu", TW: "Tajvan", TZ: "Tanzanija", UA: "Ukrajina", UG: "Uganda", UM: "Stranski zunanji otoki Združenih držav", US: "Združene države Amerike", UY: "Urugvaj", UZ: "Uzbekistan", VA: "Vatikan", VC: "Saint Vincent in Grenadine", VE: "Venezuela", VG: "Britanski Deviški otoki", VI: "Ameriški Deviški otoki", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis in Futuna", WS: "Samoa", XK: "Kosovo", YE: "Jemen", YT: "Mayotte", ZA: "Južnoafriška republika", ZM: "Zambija", ZW: "Zimbabve" }, Pd = {
  locale: Jo,
  countries: Qo
}, Ad = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Qo,
  default: Pd,
  locale: Jo
}, Symbol.toStringTag, { value: "Module" })), $o = "sq", qo = { AF: "Afganistan", AL: "Shqipëri", DZ: "Algjeri", AS: "Samoa Amerikane", AD: "Andorrë", AO: "Angolë", AI: "Anguilë", AQ: "Antarktidë", AG: "Antigua & Barbuda", AR: "Argjentinë", AM: "Armeni", AW: "Arubë", AU: "Australi", AT: "Austri", AZ: "Azerbajxhan", BS: "Bahamas", BH: "Bahrein", BD: "Bangladesh", BB: "Barbados", BY: "Bjellorusi", BE: "Belgjikë", BZ: "Belize", BJ: "Benin", BM: "Bermuda", BT: "Butan", BO: "Bolivi", BA: "Bosnjë & Hercegovinë", BW: "Botsvanë", BV: "Ishulli Buve", BR: "Brazil", IO: "Territori Britanik i Oqeanit Indian", BN: "Brunej", BG: "Bullgari", BF: "Burkina Faso", BI: "Burund", KH: "Kamboxhia", CM: "Kamerun", CA: "Kanada", CV: "Kepi i Gjelbër", KY: "Ishujt Kajman", CF: "Republika Afrikano-Qendrore", TD: "Çad", CL: "Kili", CN: "Kinë", CX: "Ishulli i Krishtlindjes", CC: "Ishujt Kokos (Kiling)", CO: "Kolumbi", KM: "Komore", CG: "Kongo-Brazavil", CD: "Kongo-Kinshasa", CK: "Ishulli Kuk", CR: "Kosta Rikë", CI: "Bregu i Fildishtë", HR: "Kroaci", CU: "Kubë", CY: "Qipro", CZ: "Republika Çeke", DK: "Danimarkë", DJ: "Xhibut", DM: "Dominikë", DO: "Republika Dominikane", EC: "Ekuador", EG: "Egjipt", SV: "El Salvador", GQ: "Guineja Ekuatoriale", ER: "Eritre", EE: "Estoni", ET: "Etiopi", FK: "Ishujt Folkland", FO: "Ishujt Faroe", FJ: "Fixhi", FI: "Finlandë", FR: "Francë", GF: "Guajana Frënge", PF: "Polinezia Frënge", TF: "Territoret Frënge Jugore", GA: "Gabon", GM: "Gambia", GE: "Gjeorgji", DE: "Gjermani", GH: "Gana", GI: "Gjibraltar", GR: "Greqi", GL: "Groenlandë", GD: "Grenadë", GP: "Guadalup", GU: "Guam", GT: "Guatemalë", GN: "Guine", GW: "Guinea-Bisau", GY: "Guajanë", HT: "Haiti", HM: "Ishujt Hërd & Mekdonald", VA: "Vatikan", HN: "Honduras", HK: "RVA i Hong Kongut Kinë", HU: "Hungari", IS: "Islandë", IN: "Indi", ID: "Indonezi", IR: "Iran", IQ: "Irak", IE: "Irlandë", IL: "Izrael", IT: "Itali", JM: "Xhamajkë", JP: "Japoni", JO: "Jordani", KZ: "Kazakistan", KE: "Kenia", KI: "Kiribati", KP: "Koreja e Veriut", KR: "Koreja e Jugut", KW: "Kuvajt", KG: "Kirgizstan", LA: "Laos", LV: "Letoni", LB: "Liban", LS: "Lesoto", LR: "Liberi", LY: "Libi", LI: "Lihtenshtein", LT: "Lituani", LU: "Luksemburg", MO: "RVA i Makaos Kinë", MG: "Madagaskar", MW: "Malavi", MY: "Malajzi", MV: "Maldive", ML: "Mali", MT: "Maltë", MH: "Ishujt Marshall", MQ: "Martinikë", MR: "Mauritani", MU: "Mauritius", YT: "Majote", MX: "Meksikë", FM: "Mikronezi", MD: "Moldavi", MC: "Monako", MN: "Mongoli", MS: "Montserat", MA: "Marok", MZ: "Mozambik", MM: "Mianmar (Burma)", NA: "Namibi", NR: "Nauru", NP: "Nepal", NL: "Holandë", NC: "Kaledonia e Re", NZ: "Zelandë e Re", NI: "Nikaragua", NE: "Niger", NG: "Nigeri", NU: "Niue", NF: "Ishujt Norfolk", MK: "Maqedoni", MP: "Ishujt Veriorë Mariana", NO: "Norvegji", OM: "Oman", PK: "Pakistan", PW: "Palau", PS: "Territoret Palestineze", PA: "Panama", PG: "Papua Guineja e Re", PY: "Paraguai", PE: "Peru", PH: "Filipine", PN: "Ishujt Pitkern", PL: "Poloni", PT: "Portugali", PR: "Porto Riko", QA: "Katar", RE: "Reunion", RO: "Rumani", RU: "Rusi", RW: "Ruandë", SH: "Shën Helena", KN: "Shën Kits e Nevis", LC: "Shën Luçia", PM: "Shën Pier dhe Mikëlon", VC: "Shën Vinsent & Grenadinet", WS: "Samoa", SM: "San Marino", ST: "Sao Tome & Prinsipe", SA: "Arabi Saudite", SN: "Senegal", SC: "Sejshelle", SL: "Sierra Leone", SG: "Singapor", SK: "Sllovaki", SI: "Slloveni", SB: "Ishujt Solomon", SO: "Somali", ZA: "Afrikë e Jugut", GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut", ES: "Spanjë", LK: "Sri Lankë", SD: "Sudan", SR: "Surinam", SJ: "Svalbard & Zhan Majen", SZ: "Svaziland", SE: "Suedi", CH: "Zvicër", SY: "Siri", TW: "Tajvan", TJ: "Taxhikistan", TZ: "Tanzani", TH: "Tajlandë", TL: "Timori Lindor", TG: "Togo", TK: "Tokelau", TO: "Tonga", TT: "Trinidad & Tobago", TN: "Tunizi", TR: "Turqi", TM: "Turkmenistan", TC: "Ishujt Turk & Kaikos", TV: "Tuvalu", UG: "Ugandë", UA: "Ukrainë", AE: "Emiratet e Bashkuara Arabe", GB: "Mbretëria e Bashkuar", US: "Shtetet e Bashkuara të Amerikës", UM: "Ishujt e Përtejmë SHBA-së", UY: "Uruguai", UZ: "Uzbekistan", VU: "Vanuatu", VE: "Venezuelë", VN: "Vietnam", VG: "Ishujt e Virgjër Britanikë", VI: "Ishujt e Virgjër Amerikanë", WF: "Uollis e Futuna", EH: "Sahara Perëndimore", YE: "Jemen", ZM: "Zambia", ZW: "Zimbabve", AX: "Ishujt Aland", BQ: "Karaibet Holandeze", CW: "Kurasao", GG: "Gërnsi", IM: "Ishulli i Robit", JE: "Xhërsi", ME: "Mali i Zi", BL: "Shën Bartolomeo", MF: "Shën Martin", RS: "Serbi", SX: "Shën Martin", SS: "Sudan i Jugut", XK: "Kosovë" }, Nd = {
  locale: $o,
  countries: qo
}, Td = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: qo,
  default: Nd,
  locale: $o
}, Symbol.toStringTag, { value: "Module" })), Xo = "sr", es = { AD: "Андора", AE: "Уједињени Арапски Емирати", AF: "Авганистан", AG: "Антигва и Барбуда", AI: "Ангвила", AL: "Албанија", AM: "Јерменија", AO: "Ангола", AQ: "Антарктик", AR: "Аргентина", AS: "Америчка Самоа", AT: "Аустрија", AU: "Аустралија", AW: "Аруба", AX: "Оландска Острва", AZ: "Азербејџан", BA: "Босна и Херцеговина", BB: "Барбадос", BD: "Бангладеш", BE: "Белгија", BF: "Буркина Фасо", BG: "Бугарска", BH: "Бахреин", BI: "Бурунди", BJ: "Бенин", BL: "Сен Бартелеми", BM: "Бермуда", BN: "Брунеј", BO: "Боливија", BQ: "Карипска Холандија", BR: "Бразил", BS: "Бахами", BT: "Бутан", BV: "Острво Буве", BW: "Боцвана", BY: "Белорусија", BZ: "Белизе", CA: "Канада", CC: "Кокосова (Килингова) Острва", CD: "Конго - Киншаса", CF: "Централноафричка Република", CG: "Конго - Бразавил", CH: "Швајцарска", CI: "Обала Слоноваче", CK: "Кукова Острва", CL: "Чиле", CM: "Камерун", CN: "Кина", CO: "Колумбија", CR: "Костарика", CU: "Куба", CV: "Зеленортска Острва", CW: "Курасао", CX: "Божићно Острво", CY: "Кипар", CZ: "Чешка", DE: "Немачка", DJ: "Џибути", DK: "Данска", DM: "Доминика", DO: "Доминиканска Република", DZ: "Алжир", EC: "Еквадор", EE: "Естонија", EG: "Египат", EH: "Западна Сахара", ER: "Еритреја", ES: "Шпанија", ET: "Етиопија", FI: "Финска", FJ: "Фиџи", FK: "Фокландска Острва", FM: "Микронезија", FO: "Фарска Острва", FR: "Француска", GA: "Габон", GB: "Уједињено Краљевство", GD: "Гренада", GE: "Грузија", GF: "Француска Гвајана", GG: "Гернзи", GH: "Гана", GI: "Гибралтар", GL: "Гренланд", GM: "Гамбија", GN: "Гвинеја", GP: "Гваделуп", GQ: "Екваторијална Гвинеја", GR: "Грчка", GS: "Јужна Џорџија и Јужна Сендвичка Острва", GT: "Гватемала", GU: "Гуам", GW: "Гвинеја-Бисао", GY: "Гвајана", HK: "САР Хонгконг (Кина)", HM: "Острво Херд и Мекдоналдова острва", HN: "Хондурас", HR: "Хрватска", HT: "Хаити", HU: "Мађарска", ID: "Индонезија", IE: "Ирска", IL: "Израел", IM: "Острво Ман", IN: "Индија", IO: "Британска територија Индијског океана", IQ: "Ирак", IR: "Иран", IS: "Исланд", IT: "Италија", JE: "Џерзи", JM: "Јамајка", JO: "Јордан", JP: "Јапан", KE: "Кенија", KG: "Киргистан", KH: "Камбоџа", KI: "Кирибати", KM: "Коморска Острва", KN: "Сент Китс и Невис", KP: "Северна Кореја", KR: "Јужна Кореја", KW: "Кувајт", KY: "Кајманска Острва", KZ: "Казахстан", LA: "Лаос", LB: "Либан", LC: "Света Луција", LI: "Лихтенштајн", LK: "Шри Ланка", LR: "Либерија", LS: "Лесото", LT: "Литванија", LU: "Луксембург", LV: "Летонија", LY: "Либија", MA: "Мароко", MC: "Монако", MD: "Молдавија", ME: "Црна Гора", MF: "Свети Мартин (Француска)", MG: "Мадагаскар", MH: "Маршалска Острва", MK: "Северна Македонија", ML: "Мали", MM: "Мијанмар (Бурма)", MN: "Монголија", MO: "САР Макао (Кина)", MP: "Северна Маријанска Острва", MQ: "Мартиник", MR: "Мауританија", MS: "Монсерат", MT: "Малта", MU: "Маурицијус", MV: "Малдиви", MW: "Малави", MX: "Мексико", MY: "Малезија", MZ: "Мозамбик", NA: "Намибија", NC: "Нова Каледонија", NE: "Нигер", NF: "Острво Норфок", NG: "Нигерија", NI: "Никарагва", NL: "Холандија", NO: "Норвешка", NP: "Непал", NR: "Науру", NU: "Ниуе", NZ: "Нови Зеланд", OM: "Оман", PA: "Панама", PE: "Перу", PF: "Француска Полинезија", PG: "Папуа Нова Гвинеја", PH: "Филипини", PK: "Пакистан", PL: "Пољска", PM: "Сен Пјер и Микелон", PN: "Питкерн", PR: "Порторико", PS: "Палестинске територије", PT: "Португалија", PW: "Палау", PY: "Парагвај", QA: "Катар", RE: "Реинион", RO: "Румунија", RS: "Србија", RU: "Русија", RW: "Руанда", SA: "Саудијска Арабија", SB: "Соломонска Острва", SC: "Сејшели", SD: "Судан", SE: "Шведска", SG: "Сингапур", SH: "Света Јелена", SI: "Словенија", SJ: "Свалбард и Јан Мајен", SK: "Словачка", SL: "Сијера Леоне", SM: "Сан Марино", SN: "Сенегал", SO: "Сомалија", SR: "Суринам", SS: "Јужни Судан", ST: "Сао Томе и Принципе", SV: "Салвадор", SX: "Свети Мартин (Холандија)", SY: "Сирија", SZ: "Свазиленд", TC: "Острва Туркс и Каикос", TD: "Чад", TF: "Француске Јужне Територије", TG: "Того", TH: "Тајланд", TJ: "Таџикистан", TK: "Токелау", TL: "Источни Тимор", TM: "Туркменистан", TN: "Тунис", TO: "Тонга", TR: "Турска", TT: "Тринидад и Тобаго", TV: "Тувалу", TW: "Тајван", TZ: "Танзанија", UA: "Украјина", UG: "Уганда", UM: "Удаљена острва САД", US: "Сједињене Државе", UY: "Уругвај", UZ: "Узбекистан", VA: "Ватикан", VC: "Сент Винсент и Гренадини", VE: "Венецуела", VG: "Британска Девичанска Острва", VI: "Америчка Девичанска Острва", VN: "Вијетнам", VU: "Вануату", WF: "Валис и Футуна", WS: "Самоа", XK: "Косово", YE: "Јемен", YT: "Мајот", ZA: "Јужноафричка Република", ZM: "Замбија", ZW: "Зимбабве" }, Id = {
  locale: Xo,
  countries: es
}, xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: es,
  default: Id,
  locale: Xo
}, Symbol.toStringTag, { value: "Module" })), as = "sv", ts = { AD: "Andorra", AE: "Förenade Arabemiraten", AF: "Afghanistan", AG: "Antigua och Barbuda", AI: "Anguilla", AL: "Albanien", AM: "Armenien", AO: "Angola", AQ: "Antarktis", AR: "Argentina", AS: "Amerikanska Samoa", AT: "Österrike", AU: "Australien", AW: "Aruba", AX: "Åland", AZ: "Azerbajdzjan", BA: "Bosnien och Hercegovina", BB: "Barbados", BD: "Bangladesh", BE: "Belgien", BF: "Burkina Faso", BG: "Bulgarien", BH: "Bahrain", BI: "Burundi", BJ: "Benin", BL: "Saint-Barthélemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivia", BQ: "Bonaire, Saint Eustatius och Saba", BR: "Brasilien", BS: "Bahamas", BT: "Bhutan", BV: "Bouvetön", BW: "Botswana", BY: "Belarus", BZ: "Belize", CA: "Kanada", CC: "Kokosöarna", CD: "Demokratiska republiken Kongo", CF: "Centralafrikanska republiken", CG: "Kongo-Brazzaville", CH: "Schweiz", CI: "Elfenbenskusten", CK: "Cooköarna", CL: "Chile", CM: "Kamerun", CN: "Kina", CO: "Colombia", CR: "Costa Rica", CU: "Kuba", CV: "Kap Verde", CW: "Curacao", CX: "Julön", CY: "Cypern", CZ: "Tjeckien", DE: "Tyskland", DJ: "Djibouti", DK: "Danmark", DM: "Dominica", DO: "Dominikanska republiken", DZ: "Algeriet", EC: "Ecuador", EE: "Estland", EG: "Egypten", EH: "Västsahara", ER: "Eritrea", ES: "Spanien", ET: "Etiopien", FI: "Finland", FJ: "Fiji", FK: "Falklandsöarna", FM: "Mikronesiska federationen", FO: "Färöarna", FR: "Frankrike", GA: "Gabon", GB: "Storbritannien", GD: "Grenada", GE: "Georgien", GF: "Franska Guyana", GG: "Guernsey", GH: "Ghana", GI: "Gibraltar", GL: "Grönland", GM: "Gambia", GN: "Guinea", GP: "Guadeloupe", GQ: "Ekvatorialguinea", GR: "Grekland", GS: "Sydgeorgien och Sydsandwichöarna", GT: "Guatemala", GU: "Guam", GW: "Guinea Bissau", GY: "Guyana", HK: "Hongkong", HM: "Heard- och McDonaldsöarna", HN: "Honduras", HR: "Kroatien", HT: "Haiti", HU: "Ungern", ID: "Indonesien", IE: "Irland", IL: "Israel", IM: "Isle of Man", IN: "Indien", IO: "Brittiska territoriet i Indiska Oceanen", IQ: "Irak", IR: "Iran", IS: "Island", IT: "Italien", JE: "Jersey", JM: "Jamaica", JO: "Jordanien", JP: "Japan", KE: "Kenya", KG: "Kirgizistan", KH: "Kambodja", KI: "Kiribati", KM: "Komorerna", KN: "Saint Kitts och Nevis", KP: "Nordkorea", KR: "Sydkorea", KW: "Kuwait", KY: "Caymanöarna", KZ: "Kazakstan", LA: "Laos", LB: "Libanon", LC: "Saint Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberia", LS: "Lesotho", LT: "Litauen", LU: "Luxemburg", LV: "Lettland", LY: "Libyen", MA: "Marocko", MC: "Monaco", MD: "Moldavien", ME: "Montenegro", MF: "Saint Martin (franska delen)", MG: "Madagaskar", MH: "Marshallöarna", MK: "Nordmakedonien", ML: "Mali", MM: "Burma", MN: "Mongoliet", MO: "Macau", MP: "Nordmarianerna", MQ: "Martinique", MR: "Mauretanien", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldiverna", MW: "Malawi", MX: "Mexiko", MY: "Malaysia", MZ: "Moçambique", NA: "Namibia", NC: "Nya Kaledonien", NE: "Niger", NF: "Norfolkön", NG: "Nigeria", NI: "Nicaragua", NL: "Nederländerna", NO: "Norge", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Nya Zeeland", OM: "Oman", PA: "Panama", PE: "Peru", PF: "Franska Polynesien", PG: "Papua Nya Guinea", PH: "Filippinerna", PK: "Pakistan", PL: "Polen", PM: "Saint-Pierre och Miquelon", PN: "Pitcairnöarna", PR: "Puerto Rico", PS: "Palestinska territoriet, ockuperade", PT: "Portugal", PW: "Palau", PY: "Paraguay", QA: "Qatar", RE: "Réunion", RO: "Rumänien", RS: "Serbien", RU: "Ryssland", RW: "Rwanda", SA: "Saudiarabien", SB: "Salomonöarna", SC: "Seychellerna", SD: "Sudan", SE: "Sverige", SG: "Singapore", SH: "Sankta Helena", SI: "Slovenien", SJ: "Svalbard och Jan Mayen", SK: "Slovakien", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somalia", SR: "Surinam", SS: "Sydsudan", ST: "São Tomé och Príncipe", SV: "El Salvador", SX: "Sint Maarten (nederländska delen)", SY: "Syrien", SZ: "Eswatini", TC: "Turks- och Caicosöarna", TD: "Tchad", TF: "Franska södra territorierna", TG: "Togo", TH: "Thailand", TJ: "Tadzjikistan", TK: "Tokelauöarna", TL: "Östtimor", TM: "Turkmenistan", TN: "Tunisien", TO: "Tonga", TR: "Turkiet", TT: "Trinidad och Tobago", TV: "Tuvalu", TW: "Taiwan", TZ: "Tanzania", UA: "Ukraina", UG: "Uganda", UM: "USA:s yttre öar", US: "USA", UY: "Uruguay", UZ: "Uzbekistan", VA: "Vatikanstaten", VC: "Saint Vincent och Grenadinerna", VE: "Venezuela", VG: "Brittiska Jungfruöarna", VI: "Amerikanska Jungfruöarna", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis- och Futunaöarna", WS: "Samoa", YE: "Jemen", YT: "Mayotte", ZA: "Sydafrika", ZM: "Zambia", ZW: "Zimbabwe", XK: "Kosovo" }, Ed = {
  locale: as,
  countries: ts
}, Bd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ts,
  default: Ed,
  locale: as
}, Symbol.toStringTag, { value: "Module" })), ns = "th", rs = { BD: "บังกลาเทศ", BE: "เบลเยียม", BF: "บูร์กินาฟาโซ", BG: "บัลแกเรีย", BA: "บอสเนียและเฮอร์เซโกวีนา", BB: "บาร์เบโดส", WF: "วาลลิสและฟุตูนา", BL: "เซนต์บาร์เธเลมี", BM: "เบอร์มิวดา", BN: "บรูไน", BO: "โบลิเวีย", BH: "บาห์เรน", BI: "บุรุนดี", BJ: "เบนิน", BT: "ภูฏาน", JM: "จาเมกา", BV: "เกาะบูเวต", BW: "บอตสวานา", WS: "ซามัว", BR: "บราซิล", BS: "บาฮามาส", JE: "เจอร์ซีย์", BY: "เบลารุส", BZ: "เบลีซ", RU: "รัสเซีย", RW: "รวันดา", RS: "เซอร์เบีย", TL: "ติมอร์ตะวันออก", RE: "เรอูนียง", TM: "เติร์กเมนิสถาน", TJ: "ทาจิกิสถาน", RO: "โรมาเนีย", TK: "โตเกเลา", GW: "กินี-บิสเซา", GU: "กวม", GT: "กัวเตมาลา", GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช", GR: "กรีซ", GQ: "อิเควทอเรียลกินี", GP: "กวาเดอลูป", JP: "ญี่ปุ่น", GY: "กายอานา", GG: "เกิร์นซีย์", GF: "เฟรนช์เกียนา", GE: "จอร์เจีย", GD: "เกรเนดา", GB: "สหราชอาณาจักร", GA: "กาบอง", SV: "เอลซัลวาดอร์", GN: "กินี", GM: "แกมเบีย", GL: "กรีนแลนด์", GI: "ยิบรอลตาร์", GH: "กานา", OM: "โอมาน", TN: "ตูนิเซีย", JO: "จอร์แดน", HR: "โครเอเชีย", HT: "เฮติ", HU: "ฮังการี", HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน", HN: "ฮอนดูรัส", HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์", VE: "เวเนซุเอลา", PR: "เปอร์โตริโก", PS: "ปาเลสไตน์", PW: "ปาเลา", PT: "โปรตุเกส", SJ: "สฟาลบาร์และยานไมเอน", PY: "ปารากวัย", IQ: "อิรัก", PA: "ปานามา", PF: "เฟรนช์โปลินีเซีย", PG: "ปาปัวนิวกินี", PE: "เปรู", PK: "ปากีสถาน", PH: "ฟิลิปปินส์", PN: "พิตแคร์น", PL: "โปแลนด์", PM: "แซงปีแยร์และมีเกอลง", ZM: "แซมเบีย", EH: "ซาฮาราตะวันตก", EE: "เอสโตเนีย", EG: "อียิปต์", ZA: "แอฟริกาใต้", EC: "เอกวาดอร์", IT: "อิตาลี", VN: "เวียดนาม", SB: "หมู่เกาะโซโลมอน", ET: "เอธิโอเปีย", SO: "โซมาเลีย", ZW: "ซิมบับเว", SA: "ซาอุดีอาระเบีย", ES: "สเปน", ER: "เอริเทรีย", ME: "มอนเตเนโกร", MD: "มอลโดวา", MG: "มาดากัสการ์", MF: "เซนต์มาติน", MA: "โมร็อกโก", MC: "โมนาโก", UZ: "อุซเบกิสถาน", MM: "เมียนม่าร์ [พม่า]", ML: "มาลี", MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน", MN: "มองโกเลีย", MH: "หมู่เกาะมาร์แชลล์", MK: "มาซิโดเนีย", MU: "มอริเชียส", MT: "มอลตา", MW: "มาลาวี", MV: "มัลดีฟส์", MQ: "มาร์ตินีก", MP: "หมู่เกาะนอร์เทิร์นมาเรียนา", MS: "มอนต์เซอร์รัต", MR: "มอริเตเนีย", IM: "เกาะแมน", UG: "ยูกันดา", TZ: "แทนซาเนีย", MY: "มาเลเซีย", MX: "เม็กซิโก", IL: "อิสราเอล", FR: "ฝรั่งเศส", IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี", SH: "เซนต์เฮเลนา", FI: "ฟินแลนด์", FJ: "ฟิจิ", FK: "หมู่เกาะฟอล์กแลนด์", FM: "ไมโครนีเซีย", FO: "หมู่เกาะแฟโร", NI: "นิการากัว", NL: "เนเธอร์แลนด์", NO: "นอร์เวย์", NA: "นามิเบีย", VU: "วานูอาตู", NC: "นิวแคลิโดเนีย", NE: "ไนเจอร์", NF: "เกาะนอร์ฟอล์ก", NG: "ไนจีเรีย", NZ: "นิวซีแลนด์", NP: "เนปาล", NR: "นาอูรู", NU: "นีอูเอ", CK: "หมู่เกาะคุก", CI: "ไอวอรี่โคสต์", CH: "สวิตเซอร์แลนด์", CO: "โคลอมเบีย", CN: "จีน", CM: "แคเมอรูน", CL: "ชิลี", CC: "หมู่เกาะโคโคส", CA: "แคนาดา", CG: "คองโก-บราซซาวิล", CF: "สาธารณรัฐแอฟริกากลาง", CD: "คองโก-กินชาซา", CZ: "สาธารณรัฐเช็ก", CY: "ไซปรัส", CX: "เกาะคริสต์มาส", CR: "คอสตาริกา", CV: "เคปเวิร์ด", CU: "คิวบา", SZ: "สวาซิแลนด์", SY: "ซีเรีย", KG: "คีร์กีซสถาน", KE: "เคนยา", SR: "ซูรินาเม", KI: "คิริบาส", KH: "กัมพูชา", KN: "เซนต์คิตส์และเนวิส", KM: "คอโมโรส", ST: "เซาตูเมและปรินซิปี", SK: "สโลวะเกีย", KR: "เกาหลีใต้", SI: "สโลวีเนีย", KP: "เกาหลีเหนือ", KW: "คูเวต", SN: "เซเนกัล", SM: "ซานมารีโน", SL: "เซียร์ราลีโอน", SC: "เซเชลส์", KZ: "คาซัคสถาน", KY: "หมู่เกาะเคย์แมน", SG: "สิงคโปร์", SE: "สวีเดน", SD: "ซูดาน", DO: "สาธารณรัฐโดมินิกัน", DM: "โดมินิกา", DJ: "จิบูตี", DK: "เดนมาร์ก", VG: "หมู่เกาะบริติชเวอร์จิน", DE: "เยอรมนี", YE: "เยเมน", DZ: "แอลจีเรีย", US: "สหรัฐอเมริกา", UY: "อุรุกวัย", YT: "มายอต", UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง", LB: "เลบานอน", LC: "เซนต์ลูเซีย", LA: "ลาว", TV: "ตูวาลู", TW: "ไต้หวัน", TT: "ตรินิแดดและโตเบโก", TR: "ตุรกี", LK: "ศรีลังกา", LI: "ลิกเตนสไตน์", LV: "ลัตเวีย", TO: "ตองกา", LT: "ลิทัวเนีย", LU: "ลักเซมเบิร์ก", LR: "ไลบีเรีย", LS: "เลโซโท", TH: "ไทย", TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์", TG: "โตโก", TD: "ชาด", TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส", LY: "ลิเบีย", VA: "วาติกัน", VC: "เซนต์วินเซนต์และเกรนาดีนส์", AE: "สหรัฐอาหรับเอมิเรตส์", AD: "อันดอร์รา", AG: "แอนติกาและบาร์บูดา", AF: "อัฟกานิสถาน", AI: "แองกวิลลา", VI: "หมู่เกาะยูเอสเวอร์จิน", IS: "ไอซ์แลนด์", IR: "อิหร่าน", AM: "อาร์เมเนีย", AL: "แอลเบเนีย", AO: "แองโกลา", AQ: "แอนตาร์กติกา", AS: "อเมริกันซามัว", AR: "อาร์เจนตินา", AU: "ออสเตรเลีย", AT: "ออสเตรีย", AW: "อารูบา", IN: "อินเดีย", AX: "หมู่เกาะโอลันด์", AZ: "อาเซอร์ไบจาน", IE: "ไอร์แลนด์", ID: "อินโดนีเซีย", UA: "ยูเครน", QA: "กาตาร์", MZ: "โมซัมบิก", BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา", CW: "คูราเซา", SX: "Sint Maarten (ส่วนดัตช์)", SS: "ซูดานใต้", XK: "โคโซโว" }, Rd = {
  locale: ns,
  countries: rs
}, Od = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: rs,
  default: Rd,
  locale: ns
}, Symbol.toStringTag, { value: "Module" })), is = "tr", os = { AD: "Andorra", AE: "Birleşik Arap Emirlikleri", AF: "Afganistan", AG: "Antigua ve Barbuda", AI: "Anguilla", AL: "Arnavutluk", AM: "Ermenistan", AO: "Angola", AQ: "Antarktika", AR: "Arjantin", AS: "Amerikan Samoası", AT: "Avusturya", AU: "Avustralya", AW: "Aruba", AX: "Åland Adaları", AZ: "Azerbaycan", BA: "Bosna Hersek", BB: "Barbados", BD: "Bangladeş", BE: "Belçika", BF: "Burkina Faso", BG: "Bulgaristan", BH: "Bahreyn", BI: "Burundi", BJ: "Benin", BL: "Saint Barthelemy", BM: "Bermuda", BN: "Brunei", BO: "Bolivya", BQ: "Karayip Hollanda", BR: "Brezilya", BS: "Bahamalar", BT: "Butan", BV: "Bouvet Adası", BW: "Botsvana", BY: "Beyaz Rusya", BZ: "Belize", CA: "Kanada", CC: "Cocos (Keeling) Adaları", CD: "Kongo - Kinşasa", CF: "Orta Afrika Cumhuriyeti", CG: "Kongo - Brazavil", CH: "İsviçre", CI: "Fildişi Sahili", CK: "Cook Adaları", CL: "Şili", CM: "Kamerun", CN: "Çin", CO: "Kolombiya", CR: "Kosta Rika", CU: "Küba", CV: "Cape Verde", CW: "Curaçao", CX: "Christmas Adası", CY: "Güney Kıbrıs Rum Kesimi", CZ: "Çek Cumhuriyeti", DE: "Almanya", DJ: "Cibuti", DK: "Danimarka", DM: "Dominika", DO: "Dominik Cumhuriyeti", DZ: "Cezayir", EC: "Ekvador", EE: "Estonya", EG: "Mısır", EH: "Batı Sahara", ER: "Eritre", ES: "İspanya", ET: "Etiyopya", FI: "Finlandiya", FJ: "Fiji", FK: "Falkland Adaları", FM: "Mikronezya", FO: "Faroe Adaları", FR: "Fransa", GA: "Gabon", GB: "Birleşik Krallık", GD: "Grenada", GE: "Gürcistan", GF: "Fransız Guyanası", GG: "Guernsey", GH: "Gana", GI: "Cebelitarık", GL: "Grönland", GM: "Gambiya", GN: "Gine", GP: "Guadalupe", GQ: "Ekvator Ginesi", GR: "Yunanistan", GS: "Güney Georgia ve Güney Sandwich Adaları", GT: "Guatemala", GU: "Guam", GW: "Gine-Bissau", GY: "Guyana", HK: "Çin Hong Kong ÖYB", HM: "Heard Adası ve McDonald Adaları", HN: "Honduras", HR: "Hırvatistan", HT: "Haiti", HU: "Macaristan", ID: "Endonezya", IE: "İrlanda", IL: "İsrail", IM: "Man Adası", IN: "Hindistan", IO: "Britanya Hint Okyanusu Toprakları", IQ: "Irak", IR: "İran", IS: "İzlanda", IT: "İtalya", JE: "Jersey", JM: "Jamaika", JO: "Ürdün", JP: "Japonya", KE: "Kenya", KG: "Kırgızistan", KH: "Kamboçya", KI: "Kiribati", KM: "Komorlar", KN: "Saint Kitts ve Nevis", KP: "Kuzey Kore", KR: "Güney Kore", KW: "Kuveyt", KY: "Cayman Adaları", KZ: "Kazakistan", LA: "Laos", LB: "Lübnan", LC: "Saint Lucia", LI: "Liechtenstein", LK: "Sri Lanka", LR: "Liberya", LS: "Lesoto", LT: "Litvanya", LU: "Lüksemburg", LV: "Letonya", LY: "Libya", MA: "Fas", MC: "Monako", MD: "Moldova", ME: "Karadağ", MF: "Saint Martin", MG: "Madagaskar", MH: "Marshall Adaları", MK: "Kuzey Makedonya", ML: "Mali", MM: "Myanmar (Burma)", MN: "Moğolistan", MO: "Çin Makao ÖYB", MP: "Kuzey Mariana Adaları", MQ: "Martinik", MR: "Moritanya", MS: "Montserrat", MT: "Malta", MU: "Mauritius", MV: "Maldivler", MW: "Malavi", MX: "Meksika", MY: "Malezya", MZ: "Mozambik", NA: "Namibya", NC: "Yeni Kaledonya", NE: "Nijer", NF: "Norfolk Adası", NG: "Nijerya", NI: "Nikaragua", NL: "Hollanda", NO: "Norveç", NP: "Nepal", NR: "Nauru", NU: "Niue", NZ: "Yeni Zelanda", OM: "Umman", PA: "Panama", PE: "Peru", PF: "Fransız Polinezyası", PG: "Papua Yeni Gine", PH: "Filipinler", PK: "Pakistan", PL: "Polonya", PM: "Saint Pierre ve Miquelon", PN: "Pitcairn Adaları", PR: "Porto Riko", PS: "Filistin Bölgeleri", PT: "Portekiz", PW: "Palau", PY: "Paraguay", QA: "Katar", RE: "Réunion", RO: "Romanya", RS: "Sırbistan", RU: "Rusya", RW: "Ruanda", SA: "Suudi Arabistan", SB: "Solomon Adaları", SC: "Seyşeller", SD: "Sudan", SE: "İsveç", SG: "Singapur", SH: "Saint Helena", SI: "Slovenya", SJ: "Svalbard ve Jan Mayen Adaları", SK: "Slovakya", SL: "Sierra Leone", SM: "San Marino", SN: "Senegal", SO: "Somali", SR: "Surinam", SS: "Güney Sudan", ST: "São Tomé ve Príncipe", SV: "El Salvador", SX: "Sint Maarten", SY: "Suriye", SZ: "Svaziland", TC: "Turks ve Caicos Adaları", TD: "Çad", TF: "Fransız Güney Toprakları", TG: "Togo", TH: "Tayland", TJ: "Tacikistan", TK: "Tokelau", TL: "Timor-Leste", TM: "Türkmenistan", TN: "Tunus", TO: "Tonga", TR: "Türkiye", TT: "Trinidad ve Tobago", TV: "Tuvalu", TW: "Tayvan", TZ: "Tanzanya", UA: "Ukrayna", UG: "Uganda", UM: "ABD Uzak Adaları", US: ["ABD", "A.B.D.", "Amerika Birleşik Devletleri", "Birleşik Devletler", "Amerika"], UY: "Uruguay", UZ: "Özbekistan", VA: "Vatikan", VC: "Saint Vincent ve Grenadinler", VE: "Venezuela", VG: "Britanya Virjin Adaları", VI: "ABD Virjin Adaları", VN: "Vietnam", VU: "Vanuatu", WF: "Wallis ve Futuna Adaları", WS: "Samoa", YE: "Yemen", YT: "Mayotte", ZA: "Güney Afrika", ZM: "Zambiya", ZW: "Zimbabve", XK: "Kosova" }, Ld = {
  locale: is,
  countries: os
}, Gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: os,
  default: Ld,
  locale: is
}, Symbol.toStringTag, { value: "Module" })), ss = "uk", ls = { AU: "Австралія", AT: "Австрія", AZ: "Азербайджан", AX: "Аландські Острови", AL: "Албанія", DZ: "Алжир", AS: "Американське Самоа", AI: "Ангілья", AO: "Ангола", AD: "Андорра", AQ: "Антарктика", AG: "Антигуа і Барбуда", MO: "Макао", AR: "Аргентина", AM: "Вірменія", AW: "Аруба", AF: "Афганістан", BS: "Багамські Острови", BD: "Бангладеш", BB: "Барбадос", BH: "Бахрейн", BZ: "Беліз", BE: "Бельгія", BJ: "Бенін", BM: "Бермудські Острови", BY: "Білорусь", BG: "Болгарія", BO: "Болівія", BA: "Боснія і Герцеговина", BW: "Ботсвана", BR: "Бразилія", IO: "Британська Територія в Індійському Океані", VG: "Британські Віргінські Острови", BN: "Бруней-Даруссалам", BF: "Буркіна-Фасо", BI: "Бурунді", BT: "Бутан", VU: "Вануату", VA: "Ватикан", GB: "Великобританія", VE: "Венесуела", VI: "Віргінські Острови (США)", WF: "Волліс і Футуна", VN: "В'єтнам", UM: "Зовнішні Віддалені Острови (США)", GA: "Габон", HT: "Гаїті", GY: "Гаяна", GM: "Гамбія", GH: "Гана", GP: "Гваделупа", GT: "Гватемала", GF: "Гвіана", GN: "Гвінея", GW: "Гвінея-Бісау", GG: "Гернсі", GI: "Гібралтар", HN: "Гондурас", HK: "Гонконг", GD: "Гренада", GR: "Греція", GE: "Грузія", GU: "Гуам", GL: "Гренландія", DK: "Данія", JE: "Джерсі", DJ: "Джибуті", DM: "Домініка", DO: "Домініканська Республіка", CD: "Демократична Республіка Конго", EC: "Еквадор", GQ: "Екваторіальна Гвінея", ER: "Еритрея", EE: "Естонія", ET: "Ефіопія", EG: "Єгипет", YE: "Ємен", ZM: "Замбія", ZW: "Зімбабве", IL: "Ізраїль", IN: "Індія", ID: "Індонезія", IQ: "Ірак", IR: "Іран", IE: "Ірландія", IS: "Ісландія", ES: "Іспанія", IT: "Італія", JO: "Йорданія", CV: "Кабо-Верде", KZ: "Казахстан", KY: "Кайманові Острови", KH: "Камбоджа", CM: "Камерун", CA: "Канада", BQ: "Карибські Нідерланди", QA: "Катар", KE: "Кенія", CY: "Кіпр", KI: "Кірибаті", KG: "Киргизстан", TW: "Тайвань, Провінція Китаю", KP: "Корейська Народно-Демократична Республіка", CN: "Китай", CC: "Кокосові Острови", CO: "Колумбія", KM: "Комори", XK: "Косово", CR: "Коста-Рика", CI: "Кот-Д'Івуар", CU: "Куба", KW: "Кувейт", CW: "Кюрасао", LA: "Лаос", LV: "Латвія", LS: "Лесото", LR: "Ліберія", LB: "Ліван", LY: "Лівія", LT: "Литва", LI: "Ліхтенштейн", LU: "Люксембург", MU: "Маврикій", MR: "Мавританія", MG: "Мадагаскар", YT: "Майотта", MW: "Малаві", MY: "Малайзія", ML: "Малі", MV: "Мальдіви", MT: "Мальта", MA: "Марокко", MQ: "Мартиніка", MH: "Маршаллові Острови", MX: "Мексика", FM: "Мікронезія", MZ: "Мозамбік", MD: "Молдова", MC: "Монако", MN: "Монголія", MS: "Монтсеррат", MM: "М'янма", NA: "Намібія", NR: "Науру", NP: "Непал", NE: "Нігер", NG: "Нігерія", NL: "Нідерланди", NI: "Нікарагуа", DE: "Німеччина", NU: "Ніуе", NZ: "Нова Зеландія", NC: "Нова Каледонія", NO: "Норвегія", AE: "Об'єднані Арабські Емірати", OM: "Оман", BV: "Острів Буве", HM: "Острів Герд і Острови Макдоналд", IM: "Острів Мен", NF: "Острів Норфолк", CX: "Острів Різдва", CK: "Острови Кука", SH: "Острів Святої Єлени", TC: "Острови Теркс і Кайкос", PK: "Пакистан", PW: "Палау", PS: "Палестина", PA: "Панама", PG: "Папуа-Нова Гвінея", ZA: "Південна Африка", PY: "Парагвай", PE: "Перу", GS: "Південна Джорджія та Південні Сандвічеві Острови", KR: "Республіка Корея", SS: "Південний Судан", MK: "Північна Македонія", MP: "Північні Маріанські Острови", PN: "Піткерн", PL: "Польща", PT: "Португалія", PR: "Пуерто-Рико", CG: "Конго", RE: "Реюньйон", RU: "Росія", RW: "Руанда", RO: "Румунія", EH: "Західна Сахара", SV: "Сальвадор", WS: "Самоа", SM: "Сан-Марино", ST: "Сан-Томе і Принсіпі", SA: "Саудівська Аравія", SZ: "Есватіні", SJ: "Острови Шпіцберген та Ян-Маєн", SC: "Сейшельські Острови", BL: "Сен-Бартелемі", MF: "Сен-Мартен", PM: "Сен-П'єр і Мікелон", SN: "Сенегал", VC: "Сент-Вінсент і Гренадіни", KN: "Сент-Кітс і Невіс", LC: "Сент-Люсія", RS: "Сербія", SG: "Сингапур", SX: "Сінт-Мартен", SY: "Сирія", SK: "Словаччина", SI: "Словенія", SB: "Соломонові Острови", SO: "Сомалі", SD: "Судан", SR: "Суринам", TL: "Тимор-Лешті", US: "США", SL: "Сьєрра-Леоне", TJ: "Таджикистан", TH: "Таїланд", TZ: "Танзанія", TG: "Того", TK: "Токелау", TO: "Тонга", TT: "Тринідад і Тобаго", TV: "Тувалу", TN: "Туніс", TM: "Туркменистан", TR: "Туреччина", UG: "Уганда", HU: "Угорщина", UZ: "Узбекистан", UA: "Україна", UY: "Уругвай", FO: "Фарерські Острови", FJ: "Фіджі", PH: "Філіппіни", FI: "Фінляндія", FK: "Фолклендські Острови", FR: "Франція", PF: "Французька Полінезія", TF: "Французькі Південні і Антарктичні Території", HR: "Хорватія", CF: "Центральноафриканська Республіка", TD: "Чад", ME: "Чорногорія", CZ: "Чехія", CL: "Чилі", CH: "Швейцарія", SE: "Швеція", LK: "Шри-Ланка", JM: "Ямайка", JP: "Японія" }, Fd = {
  locale: ss,
  countries: ls
}, Kd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ls,
  default: Fd,
  locale: ss
}, Symbol.toStringTag, { value: "Module" })), cs = "zh", us = { AD: "安道尔", AE: "阿联酋", AF: "阿富汗", AG: "安提瓜和巴布达", AI: "安圭拉", AL: "阿尔巴尼亚", AM: "亚美尼亚", AO: "安哥拉", AQ: "南极洲", AR: "阿根廷", AS: "美属萨摩亚", AT: "奥地利", AU: "澳大利亚", AW: "阿鲁巴", AX: "奥兰", AZ: "阿塞拜疆", BA: "波黑", BB: "巴巴多斯", BD: "孟加拉国", BE: "比利时", BF: "布基纳法索", BG: "保加利亚", BH: "巴林", BI: "布隆迪", BJ: "贝宁", BL: "圣巴泰勒米", BM: "百慕大", BN: "文莱", BO: "玻利维亚", BQ: "荷兰加勒比区", BR: "巴西", BS: "巴哈马", BT: "不丹", BV: "布韦岛", BW: "博茨瓦纳", BY: "白俄罗斯", BZ: "伯利兹", CA: "加拿大", CC: "科科斯（基林）群岛", CD: "刚果（金）", CF: "中非", CG: "刚果（布）", CH: "瑞士", CI: "科特迪瓦", CK: "库克群岛", CL: "智利", CM: "喀麦隆", CN: "中国", CO: "哥伦比亚", CR: "哥斯达黎加", CU: "古巴", CV: "佛得角", CW: "库拉索", CX: "圣诞岛", CY: "塞浦路斯", CZ: "捷克", DE: "德国", DJ: "吉布提", DK: "丹麦", DM: "多米尼克", DO: "多米尼加", DZ: "阿尔及利亚", EC: "厄瓜多尔", EE: "爱沙尼亚", EG: "埃及", EH: "阿拉伯撒哈拉民主共和国", ER: "厄立特里亚", ES: "西班牙", ET: "埃塞俄比亚", FI: "芬兰", FJ: "斐济", FK: "福克兰群岛", FM: "密克罗尼西亚联邦", FO: "法罗群岛", FR: "法国", GA: "加蓬", GB: "英国", GD: "格林纳达", GE: "格鲁吉亚", GF: "法属圭亚那", GG: "根西", GH: "加纳", GI: "直布罗陀", GL: "格陵兰", GM: "冈比亚", GN: "几内亚", GP: "瓜德罗普", GQ: "赤道几内亚", GR: "希腊", GS: "南乔治亚和南桑威奇群岛", GT: "危地马拉", GU: "关岛", GW: "几内亚比绍", GY: "圭亚那", HK: "香港", HM: "赫德岛和麦克唐纳群岛", HN: "洪都拉斯", HR: "克罗地亚", HT: "海地", HU: "匈牙利", ID: "印尼", IE: "爱尔兰", IL: "以色列", IM: "马恩岛", IN: "印度", IO: "英属印度洋领地", IQ: "伊拉克", IR: "伊朗", IS: "冰岛", IT: "意大利", JE: "泽西", JM: "牙买加", JO: "约旦", JP: "日本", KE: "肯尼亚", KG: "吉尔吉斯斯坦", KH: "柬埔寨", KI: "基里巴斯", KM: "科摩罗", KN: "圣基茨和尼维斯", KP: "朝鲜", KR: "韩国", KW: "科威特", KY: "开曼群岛", KZ: "哈萨克斯坦", LA: "老挝", LB: "黎巴嫩", LC: "圣卢西亚", LI: "列支敦士登", LK: "斯里兰卡", LR: "利比里亚", LS: "莱索托", LT: "立陶宛", LU: "卢森堡", LV: "拉脱维亚", LY: "利比亚", MA: "摩洛哥", MC: "摩纳哥", MD: "摩尔多瓦", ME: "黑山", MF: "法属圣马丁", MG: "马达加斯加", MH: "马绍尔群岛", MK: "北马其顿", ML: "马里", MM: "缅甸", MN: "蒙古", MO: "澳门", MP: "北马里亚纳群岛", MQ: "马提尼克", MR: "毛里塔尼亚", MS: "蒙特塞拉特", MT: "马耳他", MU: "毛里求斯", MV: "马尔代夫", MW: "马拉维", MX: "墨西哥", MY: "马来西亚", MZ: "莫桑比克", NA: "纳米比亚", NC: "新喀里多尼亚", NE: "尼日尔", NF: "诺福克岛", NG: "尼日利亚", NI: "尼加拉瓜", NL: "荷兰", NO: "挪威", NP: "尼泊尔", NR: "瑙鲁", NU: "纽埃", NZ: "新西兰", OM: "阿曼", PA: "巴拿马", PE: "秘鲁", PF: "法属波利尼西亚", PG: "巴布亚新几内亚", PH: "菲律宾", PK: "巴基斯坦", PL: "波兰", PM: "圣皮埃尔和密克隆", PN: "皮特凯恩群岛", PR: "波多黎各", PS: "巴勒斯坦", PT: "葡萄牙", PW: "帕劳", PY: "巴拉圭", QA: "卡塔尔", RE: "留尼汪", RO: "罗马尼亚", RS: "塞尔维亚", RU: "俄罗斯", RW: "卢旺达", SA: "沙特阿拉伯", SB: "所罗门群岛", SC: "塞舌尔", SD: "苏丹", SE: "瑞典", SG: "新加坡", SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚", SI: "斯洛文尼亚", SJ: "斯瓦尔巴和扬马延", SK: "斯洛伐克", SL: "塞拉利昂", SM: "圣马力诺", SN: "塞内加尔", SO: "索马里", SR: "苏里南", SS: "南苏丹", ST: "圣多美和普林西比", SV: "萨尔瓦多", SX: "荷属圣马丁", SY: "叙利亚", SZ: "斯威士兰", TC: "特克斯和凯科斯群岛", TD: "乍得", TF: "法属南部领地", TG: "多哥", TH: "泰国", TJ: "塔吉克斯坦", TK: "托克劳", TL: "东帝汶", TM: "土库曼斯坦", TN: "突尼斯", TO: "汤加", TR: "土耳其", TT: "特立尼达和多巴哥", TV: "图瓦卢", TW: "中国台湾省", TZ: "坦桑尼亚", UA: "乌克兰", UG: "乌干达", UM: "美国本土外小岛屿", US: "美国", UY: "乌拉圭", UZ: "乌兹别克斯坦", VA: "梵蒂冈", VC: "圣文森特和格林纳丁斯", VE: "委内瑞拉", VG: "英属维尔京群岛", VI: "美属维尔京群岛", VN: "越南", VU: "瓦努阿图", WF: "瓦利斯和富图纳", WS: "萨摩亚", XK: "科索沃", YE: "也门", YT: "马约特", ZA: "南非", ZM: "赞比亚", ZW: "津巴布韦" }, Hd = {
  locale: cs,
  countries: us
}, zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: us,
  default: Hd,
  locale: cs
}, Symbol.toStringTag, { value: "Module" })), Vd = {
  ar: zu,
  cs: Uu,
  da: Yu,
  de: Zu,
  el: Qu,
  en: qu,
  es: ed,
  fr: td,
  hi: rd,
  hu: od,
  id: ld,
  it: ud,
  ja: pd,
  nl: hd,
  no: gd,
  pl: yd,
  pt: vd,
  ro: kd,
  ru: wd,
  sk: Dd,
  sl: Ad,
  sq: Td,
  sr: xd,
  sv: Bd,
  th: Od,
  tr: Gd,
  uk: Kd,
  zh: zd
};
Object.values(Vd).forEach((t) => {
  Vn.registerLocale(t.default);
});
const ds = (t, n) => {
  const a = so(n);
  switch (t) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case ir.Taiwan:
      return Vn.getName(t, a, { select: "alias" });
    default:
      return Vn.getName(t, a, { select: "official" });
  }
}, Z_ = (t = Ca.ENGLISH) => Object.values(ir).map((n) => ({
  id: n,
  caption: ds(n, t) ?? ""
})), J_ = (t, n = Ca.ENGLISH) => ds(t, n) ?? "";
var we = /* @__PURE__ */ ((t) => (t.Email = "email", t.FirstName = "first_name", t.Surname = "surname", t.Country = "country", t.City = "city", t.Neighborhood = "neighborhood", t.StreetAddress = "street_address", t.StreetNumber = "street_number", t.Postcode = "postcode", t.PhoneNumber = "phone_number", t.CompanyName = "company_name", t.TaxNumber = "tax_number", t.State = "state", t))(we || {});
const Ud = {
  [we.Email]: "public_pages_purchase.contact_slug.email",
  [we.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [we.Surname]: "public_pages_purchase.contact_slug.last_name",
  [we.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [we.Country]: "public_pages_purchase.contact_slug.country",
  [we.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [we.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [we.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [we.City]: "public_pages_purchase.contact_slug.city",
  [we.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [we.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [we.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [we.State]: "public_pages_purchase.contact_slug.state_province"
}, jd = (t) => G.t(Ud[t]), Q_ = (t) => {
  const { slug: n, fieldName: a } = t;
  return Object.values(we).includes(n) ? jd(n) : a;
};
var Yd = /* @__PURE__ */ ((t) => (t.ARGENTINE_PESO = "ars", t.AUSTRALIAN_DOLLAR = "aud", t.BULGARIAN_LEV = "bgn", t.BRAZILIAN_REAL = "brl", t.CANADIAN_DOLLAR = "cad", t.CENTRAL_AFRICAN_FRANC = "xaf", t.CHILEAN_PESO = "clp", t.CHINESE_YUAN = "cny", t.COLOMBIAN_PESO = "cop", t.CZECH_CROWN = "czk", t.DANISH_KRONE = "dkk", t.EGYPTIAN_POUND = "egp", t.EURO = "eur", t.GHANAIAN_CEDI = "ghs", t.GUINEAN_FRANC = "gnf", t.HONG_KONG_DOLLAR = "hkd", t.HUNGARIAN_FORINT = "huf", t.ICELANDIC_KRONA = "isk", t.INDIAN_RUPEE = "inr", t.INDONESIAN_RUPIAH = "idr", t.ISRAELI_NEW_SHEKEL = "ils", t.JAPANESE_YEN = "jpy", t.KENYAN_SHILLING = "kes", t.MALAWIAN_KWACHA = "mwk", t.MALAYSIAN_RINGGIT = "myr", t.MEXICAN_PESO = "mxn", t.MOROCCAN_DIRHAM = "mad", t.NEW_ZEALAND_DOLLAR = "nzd", t.NIGERIAN_NAIRA = "ngn", t.NORWEGIAN_KRONE = "nok", t.PHILIPPINE_PESO = "php", t.POLISH_ZLOTY = "pln", t.POUND_STERLING = "gbp", t.ROMANIA_LEI = "ron", t.RUSSIAN_RUBLE = "rub", t.RWANDAN_FRANC = "rwf", t.SAO_TOME_AND_PRINCIPE_DOBRA = "std", t.SAUDI_RIYAL = "sar", t.SIERRA_LEONEAN_LEONE = "sll", t.SINGAPORE_DOLLAR = "sgd", t.SOUTH_AFRICAN_RAND = "zar", t.SRI_LANKAN_RUPEE = "lkr", t.SWEDISH_KRONA = "sek", t.SWISS_FRANC = "chf", t.TANZANIAN_SHILLING = "tzs", t.THAI_BAHT = "thb", t.TURKISH_LIRA = "try", t.UGANDAN_SHILLING = "ugx", t.US_DOLLAR = "usd", t.UNITED_ARAB_EMIRATES_DIRHAM = "aed", t.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", t.ZAMBIAN_KWACHA = "zmw", t.SERBIAN_DINAR = "rsd", t.UKRAINIAN_HRYVNIA = "uah", t.ALBANIAN_LEK = "all", t.VIETNAM_DONG = "vnd", t.PERUVIAN_SOL = "pen", t))(Yd || {});
const Pn = (t, n) => new Date(
  new Intl.DateTimeFormat(Z.ENGLISH, {
    timeZone: n,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).format(t)
), ce = (t, n) => t ? t instanceof Date ? Pn(t, n) : t.match(/([-+]\d+:?\d+)$/) ? Pn(new Date(t), n) : new Date(t) : Pn(/* @__PURE__ */ new Date(), n), ba = (t) => {
  const n = function(a) {
    return (a < 10 ? "0" : "") + a;
  };
  return t.getFullYear() + "-" + n(t.getMonth() + 1) + "-" + n(t.getDate()) + "T" + n(t.getHours()) + ":" + n(t.getMinutes()) + ":" + n(t.getSeconds());
}, Wd = (t) => {
  switch (t) {
    case zn.dateFirst:
      return "en-GB";
    case zn.monthFirst:
      return "en-US";
    default:
      return;
  }
}, Wr = (t, n) => (typeof t == "string" ? new Date(t) : t).toLocaleString(Wd(n == null ? void 0 : n.dateFormat), {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: n == null ? void 0 : n.timeZone
}), $_ = (t, n) => {
  if (!n && !t) return "";
  const r = new Intl.DateTimeFormat(t, {
    timeZone: n,
    timeZoneName: "shortOffset"
  }).formatToParts(/* @__PURE__ */ new Date()).find((i) => i.type === "timeZoneName");
  if (r)
    return r.value.replace("GMT", "UTC");
}, Ot = (t, n) => ce(t, n);
async function Zd(t, n) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(t), n && Fn.success(n);
  } catch {
    Fn.error(G.t("public_pages_purchase.copy_clipboard_error"));
  }
}
const q_ = (t) => Number(t), X_ = (t) => Number(t), ey = (t) => t / 100, ay = (t) => Number(t) * 100, Jd = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", Qd = "flex items-center justify-center gap-2", $d = (t) => "href" in t, qd = ({
  as: t = "a",
  href: n,
  isFetching: a,
  className: e,
  children: r,
  buttonTextClassName: i,
  ...o
}) => o["aria-disabled"] || a ? /* @__PURE__ */ _("button", { className: e, disabled: !!o["aria-disabled"], children: /* @__PURE__ */ _(Un, { buttonTextClassName: i, isFetching: a, children: r }) }) : /* @__PURE__ */ _(t, { className: e, href: n, ...o, children: /* @__PURE__ */ _(Un, { buttonTextClassName: i, isFetching: a, children: r }) }), Un = ({
  children: t,
  isFetching: n,
  buttonTextClassName: a
}) => /* @__PURE__ */ _(
  "div",
  {
    className: A(
      "flex items-center justify-center gap-2 truncate",
      n && "opacity-0",
      a
    ),
    children: t
  }
), Ta = ({
  width: t = "small",
  isFetching: n,
  backgroundColor: a,
  color: e,
  hoverColor: r,
  hoverBackgroundColor: i,
  borderColor: o,
  hoverBorderColor: s,
  loaderType: l,
  testAttributePostfix: c,
  className: u,
  buttonTextClassName: d,
  loaderClassName: p,
  as: m,
  ...h
}) => {
  const f = h, g = A(
    Gn(
      Jd,
      Qd,
      a,
      e,
      r,
      i,
      t === "small" ? "px-4" : "px-10",
      o && `border ${o}`,
      s,
      n && "pointer-events-none select-none"
    ),
    u
  ), y = A(
    Gn("absolute", n ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    p
  );
  if ($d(f)) {
    const { "aria-disabled": b, ...k } = f;
    return /* @__PURE__ */ _(
      qd,
      {
        as: m,
        isFetching: n,
        "aria-disabled": b || n,
        className: A(g, b && "bg-text-secondary/50 pointer-events-none"),
        ...k,
        ...Hn(!!c, `${c}`),
        children: /* @__PURE__ */ L(Ee, { children: [
          /* @__PURE__ */ _(Vt, { small: !0, type: l, className: y }),
          f.children
        ] })
      }
    );
  } else {
    const { disabled: b, ...k } = f;
    return /* @__PURE__ */ L(
      "button",
      {
        disabled: n || b,
        className: A(g, b && "bg-text-secondary/50 pointer-events-none"),
        ...k,
        ...Hn(!!c, `${c}`),
        children: [
          /* @__PURE__ */ _(Vt, { small: !0, type: l, className: y }),
          /* @__PURE__ */ _(Un, { buttonTextClassName: d, isFetching: n, children: f.children })
        ]
      }
    );
  }
}, ty = (t) => /* @__PURE__ */ _(
  Ta,
  {
    color: "text-text-primary/50",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary",
    ...t
  }
);
var Va = /* @__PURE__ */ ((t) => (t.danger = "danger", t.blue = "blue", t))(Va || {});
const Xd = (t) => {
  switch (t) {
    case Va.danger:
      return "hover:text-danger";
    case Va.blue:
      return "hover:text-brand-primary";
    default:
      return "text-brand-primary";
  }
}, ep = (t) => {
  switch (t) {
    case Va.danger:
      return "hover:border-danger";
    case Va.blue:
      return "hover:border-brand-primary";
    default:
      return "border-brand-primary";
  }
}, ny = ({
  neutralType: t = Va.blue,
  ...n
}) => /* @__PURE__ */ _(
  Ta,
  {
    color: "text-text-primary",
    hoverColor: Xd(t),
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-background-secondary",
    borderColor: "border-text-secondary/30",
    hoverBorderColor: ep(t),
    ...n
  }
), ry = (t) => /* @__PURE__ */ _(
  Ta,
  {
    color: "text-text-primary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-transparent",
    hoverBackgroundColor: "hover:bg-text-primary",
    borderColor: "border-text-primary",
    loaderType: "dark",
    ...t
  }
), iy = (t) => /* @__PURE__ */ _(
  Ta,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-green",
    hoverBackgroundColor: "hover:bg-green",
    ...t
  }
), Zr = ({ selected: t, ...n }) => /* @__PURE__ */ _(
  Ta,
  {
    color: t ? "text-brand-primary" : "text-text-primary",
    hoverColor: t ? "hover:text-brand-primary" : "hover:text-text-primary",
    backgroundColor: t ? "bg-brand-primary/10" : "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary/10",
    borderColor: t ? "border-brand-primary" : "border-text-secondary/30",
    hoverBorderColor: "border-brand-primary",
    type: "button",
    ...n
  }
), ps = (t) => /* @__PURE__ */ _(
  Ta,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-brand-primary",
    hoverBackgroundColor: "hover:bg-brand-primary-hover",
    ...t
  }
), ms = (t) => /* @__PURE__ */ _(
  Ta,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-danger",
    hoverBackgroundColor: "hover:bg-danger",
    ...t
  }
);
function ap({
  active: t,
  isFetching: n,
  iconClassName: a,
  menuButtonClassName: e,
  dataTestAttributes: r,
  children: i,
  ...o
}) {
  return /* @__PURE__ */ _(
    Sl,
    {
      disabled: n,
      className: A(
        !i && "hover:bg-brand-primary focus-ring group h-[30px] rounded-lg px-3 py-1 transition-colors lg:h-[20px]",
        !i && (t ? "bg-brand-primary" : "bg-background-primary"),
        n && "pointer-events-none animate-pulse",
        e
      ),
      ...r,
      ...o,
      children: typeof i == "function" ? (s) => i({ ...s, active: t }) : i ?? /* @__PURE__ */ _(
        Nl,
        {
          className: A(
            "group-hover:fill-background-secondary",
            t && "fill-background-secondary",
            a
          )
        }
      )
    }
  );
}
const oy = ({
  menuItems: t,
  anchor: n = {
    to: "left start",
    gap: 4,
    padding: 4
  },
  menuItemsClassName: a,
  toggleOnHover: e = !0,
  ...r
}) => {
  const { show: i, close: o, delayOpen: s, delayClose: l } = ro();
  return /* @__PURE__ */ _(kl, { children: ({ open: c, close: u }) => /* @__PURE__ */ L(Ee, { children: [
    /* @__PURE__ */ _(
      ap,
      {
        ...r,
        active: e && i || c,
        onMouseEnter: s,
        onMouseLeave: l
      }
    ),
    /* @__PURE__ */ _(
      Ka,
      {
        show: e && i || c,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        children: /* @__PURE__ */ _(
          Ml,
          {
            onClick: () => {
              u(), o();
            },
            static: !0,
            anchor: n,
            className: A(
              "bg-background-secondary border-background-tertiary overflow-hidden rounded-lg border shadow-lg focus:outline-hidden",
              a
            ),
            portal: !0,
            onMouseEnter: s,
            onMouseLeave: l,
            children: t
          }
        )
      }
    )
  ] }) });
}, tp = "group aria-pressed:text-brand-primary hover:text-brand-primary flex items-center gap-2 w-full px-4 py-3 lg:py-2 text-left text-sm transition-colors border-b border-background-tertiary last:border-0", sy = ({
  dataTestAttributes: t,
  onClick: n,
  label: a,
  buttonClassName: e,
  labelClassName: r,
  children: i,
  ...o
}) => /* @__PURE__ */ _(wl, { ...o, children: i || (({ focus: s }) => /* @__PURE__ */ _(
  "button",
  {
    onClick: n,
    "aria-pressed": s,
    type: "button",
    className: A(
      tp,
      o.disabled && "hover:text-text-secondary text-text-secondary cursor-not-allowed",
      e
    ),
    ...t,
    children: /* @__PURE__ */ _("span", { className: r, children: a })
  }
)) }, "action-settings"), np = (t) => {
  switch (t) {
    case "success":
      return "border-green";
    case "error":
      return "border-danger";
    default:
      return "border-brand-primary";
  }
}, rp = (t) => {
  switch (t) {
    case "success":
      return "hover:fill-green group-focus-visible:fill-green";
    case "error":
      return "hover:fill-danger group-focus-visible:fill-danger";
    default:
      return "hover:fill-brand-primary group-focus-visible:fill-brand-primary";
  }
}, hs = ({
  t,
  afterClose: n,
  className: a,
  titleClassName: e,
  buttonClassName: r,
  hideCloseButton: i
}) => {
  const o = ue(null), s = np(t.type), l = rp(t.type);
  return /* @__PURE__ */ L(
    "div",
    {
      className: A(
        "bg-background-secondary text-text-tertiary flex max-w-[350px] items-center gap-2.5 rounded-lg border px-2.5 py-2 shadow-lg",
        t.visible ? "animate-toast-enter" : "animate-toast-leave",
        s,
        a
      ),
      "data-test-id": `toast-${t.type}`,
      children: [
        t.icon,
        /* @__PURE__ */ _("div", { className: A("break-words", e), children: t.message }),
        !i && /* @__PURE__ */ _(
          "button",
          {
            ref: o,
            className: A("group h-fit outline-hidden", r),
            onClick: () => {
              Kl.dismiss(t.id), n && n();
            },
            children: /* @__PURE__ */ _(
              bt,
              {
                className: A("fill-fill-primary main-transition-colors", l)
              }
            )
          }
        )
      ]
    }
  );
}, ly = ({
  className: t,
  titleClassName: n,
  buttonClassName: a,
  afterClose: e
}) => /* @__PURE__ */ _(
  Hl,
  {
    position: "top-center",
    containerStyle: {
      top: 80,
      right: 20
    },
    containerClassName: "[&_a]:primary-link",
    toastOptions: {
      success: {
        icon: /* @__PURE__ */ _(Il, { className: "fill-green h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      },
      error: {
        icon: /* @__PURE__ */ _(Tl, { className: "fill-danger h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      }
    },
    children: (r) => /* @__PURE__ */ _(
      hs,
      {
        t: r,
        className: t,
        titleClassName: n,
        buttonClassName: a,
        afterClose: e
      }
    )
  }
), cy = ({
  className: t,
  titleClassName: n,
  buttonClassName: a
} = {}) => ({ infoToast: Sa(
  (r, i, o, s) => Fn.custom(
    (l) => /* @__PURE__ */ _(
      hs,
      {
        t: { ...l, message: r },
        className: t,
        titleClassName: n,
        buttonClassName: a,
        afterClose: o,
        hideCloseButton: s
      }
    ),
    {
      duration: 6e5,
      icon: /* @__PURE__ */ _($i, { className: "fill-brand-primary h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
      ...i
    }
  ),
  []
) }), uy = ({
  options: t,
  selected: n,
  onChange: a,
  disabled: e,
  error: r,
  label: i,
  required: o,
  className: s,
  labelClassName: l,
  optionsWrapperClassName: c,
  optionWrapperClassName: u,
  selectedOptionWrapperClassName: d,
  optionClassName: p,
  inputClassName: m
}) => /* @__PURE__ */ L("div", { className: A("flex flex-col gap-1", s), children: [
  /* @__PURE__ */ _(Na, { label: i, labelClassName: l, required: o }),
  /* @__PURE__ */ _("ul", { className: A("flex items-center gap-5", c), children: t ? t.map((h) => /* @__PURE__ */ _(
    rr,
    {
      label: h.tooltipLabel ?? "",
      disabled: !h.showTooltip,
      children: /* @__PURE__ */ _(
        "li",
        {
          className: A(
            u,
            h.id === n && d
          ),
          children: /* @__PURE__ */ L(
            "label",
            {
              className: A(
                "r relative flex w-fit items-center gap-2",
                !e && "cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ _(
                  "input",
                  {
                    className: A(
                      "border-2 outline-hidden",
                      e ? "border-fill-primary/70" : "border-fill-primary",
                      "h-[20px] w-[20px] rounded-full",
                      h.id === n ? "bg-background-secondary" : "bg-transparent",
                      "main-transition-colors focus-ring shrink-0 appearance-none",
                      m
                    ),
                    disabled: e || h.disabled,
                    checked: h.id === n,
                    value: h.caption,
                    onChange: () => a(h.id),
                    type: "radio"
                  }
                ),
                /* @__PURE__ */ _(
                  "svg",
                  {
                    width: 20,
                    height: 20,
                    className: A(
                      "main-transition-colors absolute",
                      h.id === n ? "fill-green" : "fill-transparent",
                      e && "opacity-70"
                    ),
                    children: /* @__PURE__ */ _(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ L("div", { className: "flex items-center gap-3", children: [
                  h.caption && /* @__PURE__ */ _(
                    "span",
                    {
                      className: A(
                        "main-transition-colors",
                        h.id === n ? "text-text-primary" : "text-text-primary/50",
                        e && "opacity-70",
                        p,
                        "text-left"
                      ),
                      children: h.caption
                    }
                  ),
                  h.additionalInfo
                ] })
              ]
            }
          )
        }
      )
    },
    h.id
  )) : /* @__PURE__ */ L(Ee, { children: [
    /* @__PURE__ */ _(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ _(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ _(ha, { error: r })
] });
function or({
  arrowButtonClassName: t,
  open: n,
  isDisabled: a,
  As: e = er
}) {
  return /* @__PURE__ */ _(
    e,
    {
      as: "div",
      role: "button",
      className: A(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        a && "cursor-not-allowed",
        t
      ),
      disabled: a,
      children: /* @__PURE__ */ _(
        qi,
        {
          className: A("stroke-text-primary main-transition", n && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function sr({ onClick: t, closeButtonClassName: n, isDisabled: a }) {
  return /* @__PURE__ */ _(
    "button",
    {
      type: "button",
      className: A(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        a && "cursor-not-allowed",
        n
      ),
      onClick: t,
      disabled: a,
      children: /* @__PURE__ */ _(bt, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
function ip({
  children: t,
  selectedData: n,
  virtual: a,
  disabled: e,
  onClose: r,
  onChange: i
}) {
  return /* @__PURE__ */ _(
    Yi,
    {
      immediate: !0,
      multiple: !0,
      value: n,
      virtual: a,
      onChange: (o) => i((o == null ? void 0 : o.filter((s) => s.id !== void 0).map((s) => s.id)) ?? []),
      disabled: e,
      onClose: r,
      children: ({ open: o }) => t(o)
    }
  );
}
function op({
  children: t,
  selectedData: n,
  virtual: a,
  disabled: e,
  onClose: r,
  onChange: i
}) {
  return /* @__PURE__ */ _(
    Yi,
    {
      immediate: !0,
      value: n,
      virtual: a,
      onChange: (o) => {
        o !== null && i(o == null ? void 0 : o.id);
      },
      disabled: e,
      onClose: r,
      children: ({ open: o }) => t(o)
    }
  );
}
const fs = "text-[16px] sm:text-sm", lr = "px-4 py-2.5";
function gs({
  isDisabled: t,
  open: n,
  hasError: a,
  className: e,
  placeholder: r,
  selectedCaption: i,
  isPreFetching: o,
  onFocus: s,
  onChange: l,
  inputRef: c,
  dataTest: u
}) {
  return /* @__PURE__ */ _(
    Cl,
    {
      ref: c,
      className: A(
        "w-full truncate",
        fs,
        "flex items-center justify-between",
        lr,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        t ? "bg-skeleton-primary/20" : "bg-background-secondary",
        n ? "border-brand-primary" : a ? "border-danger" : "border-text-secondary/30",
        o && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        e
      ),
      onChange: (d) => l == null ? void 0 : l(d.target.value),
      onKeyDown: (d) => d.stopPropagation(),
      onFocus: s,
      displayValue: i ? () => i : void 0,
      placeholder: r ?? G.t("public_pages_purchase.form_select.select"),
      ...u
    }
  );
}
function cr({ loaderWrapperClassName: t, loaderClassName: n }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: A(
        "flex h-full items-center justify-center",
        "scale-75",
        t
      ),
      children: /* @__PURE__ */ _(Vt, { className: A(n) })
    }
  );
}
const ur = ({
  item: t,
  optionClassName: n,
  optionIconWrapperClassName: a,
  optionRef: e,
  as: r
}) => {
  const i = (t == null ? void 0 : t.customCaption) ?? (t == null ? void 0 : t.caption), o = ({ disabled: l, selected: c }) => A(
    "bg-background-secondary text-text-primary",
    lr,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    c && "bg-brand-primary text-background-secondary",
    l && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    n,
    t == null ? void 0 : t.className
  ), s = ({ selected: l }) => /* @__PURE__ */ L(Ee, { children: [
    i,
    /* @__PURE__ */ L("div", { className: A("flex items-center gap-3", a), children: [
      l && /* @__PURE__ */ _(
        xl,
        {
          className: Gn(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      t == null ? void 0 : t.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ _(
    r,
    {
      disabled: t == null ? void 0 : t.disabled,
      ref: e,
      value: t,
      className: o,
      "data-test-id": t == null ? void 0 : t.dataTestAttribute,
      children: s
    },
    t == null ? void 0 : t.id
  );
}, un = yt(
  ({ children: t, style: n, optionsClassName: a, as: e, optionsProps: r }, i) => /* @__PURE__ */ _(
    e,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: i,
      style: n,
      className: A(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "data-[closed]:opacity-0 transition duration-200 ease-out empty:invisible",
        "customScroll",
        fs,
        a
      ),
      ...r,
      children: t
    }
  )
);
un.displayName = "ListOptionsWrapper";
const Jr = 240, _s = () => ({
  id: void 0,
  caption: G.t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
}), dr = (t, n) => {
  let a = 0;
  return t && (t.querySelectorAll('[role="option"]').forEach((r) => {
    a += r.getBoundingClientRect().height;
  }), a = n ? Math.min(a, Jr) || Jr : 42), a;
};
function ys({
  optionsClassName: t,
  data: n,
  loaderWrapperClassName: a,
  loaderClassName: e,
  asOptions: r,
  asOption: i,
  ...o
}) {
  const [s, l] = ee(null), c = dr(s, n);
  return /* @__PURE__ */ _(
    un,
    {
      as: r,
      ref: l,
      optionsClassName: t,
      style: { height: c },
      children: ({ option: u }) => n ? ur({ ...o, as: i, item: u }) : /* @__PURE__ */ _(
        cr,
        {
          loaderWrapperClassName: a,
          loaderClassName: e
        }
      )
    }
  );
}
const bs = (t, n) => (n == null ? void 0 : n.find((a) => a.id === t)) ?? null, vs = (t) => {
  const [n, a] = ee(""), [e, r] = ee(t);
  return de(() => {
    const i = n === "" ? t : (t == null ? void 0 : t.filter(
      (o) => o.caption.toLowerCase().replace(/\s+/g, "").includes(n.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    r(() => i);
  }, [t, n]), { filteredData: e, setFilteredData: r, query: n, setQuery: a };
}, Ss = (t = []) => ({
  options: t.length > 0 ? t : [_s()],
  disabled: (n) => (n == null ? void 0 : n.disabled) ?? !1
});
function dy({
  label: t,
  data: n,
  staticData: a,
  onChange: e,
  labelClassName: r,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: c,
  description: u,
  className: d,
  containerClassName: p,
  closeButtonClassName: m,
  arrowButtonClassName: h,
  fieldClassName: f,
  disabled: g,
  withoutCloseIcon: y,
  onOpen: b,
  onClose: k,
  dataTest: D,
  wrapperProps: v,
  loaderClassName: S,
  loaderWrapperClassName: w,
  inputWrapperClassName: M,
  inputRef: P,
  statusIcon: N,
  statusIconClassName: B,
  ...R
}) {
  const [F, x] = ee(!1);
  de(() => {
    F && b && (b(), x(!1));
  }, [F]);
  const K = bs(i, n ?? a) ?? null, { filteredData: z, setQuery: T } = vs(n), I = i !== void 0, ae = g || o || I && (!n && !a), me = I && !y && !ae;
  return /* @__PURE__ */ L("div", { className: A("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ _(
      op,
      {
        selectedData: K,
        virtual: Ss(z),
        onChange: e,
        disabled: ae,
        onClose: () => {
          T(""), k == null || k();
        },
        children: (ge) => /* @__PURE__ */ L(Ee, { children: [
          /* @__PURE__ */ L(ln, { className: A("relative flex flex-col gap-1", f), children: [
            /* @__PURE__ */ _(
              Na,
              {
                wrapperAs: "label",
                wrapperProps: v,
                label: t,
                required: c,
                labelClassName: A("text-sm font-medium", r)
              }
            ),
            /* @__PURE__ */ L(er, { as: "button", className: A("relative", M), children: [
              /* @__PURE__ */ _(
                gs,
                {
                  dataTest: D,
                  inputRef: P,
                  isDisabled: ae,
                  hasError: !!l,
                  open: ge,
                  className: d,
                  placeholder: s,
                  selectedCaption: (K == null ? void 0 : K.caption) ?? "",
                  isPreFetching: o,
                  onFocus: () => x(!0),
                  onChange: (Me) => {
                    x(!0), T(Me);
                  }
                }
              ),
              N ? /* @__PURE__ */ _(
                "div",
                {
                  className: A(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    B
                  ),
                  children: N
                }
              ) : /* @__PURE__ */ _(
                or,
                {
                  isDisabled: ae,
                  arrowButtonClassName: A(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    h
                  ),
                  open: ge
                }
              )
            ] }),
            me && /* @__PURE__ */ _(
              sr,
              {
                isDisabled: ae,
                closeButtonClassName: A(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  m
                ),
                onClick: () => e(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ _(
            ys,
            {
              asOptions: Zi,
              asOption: Wi,
              data: z,
              ...R
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ _(ha, { error: l, description: u })
  ] });
}
function py({
  data: t,
  staticData: n,
  onChange: a,
  value: e,
  isPreFetching: r,
  placeholder: i,
  required: o,
  description: s,
  className: l,
  closeButtonClassName: c,
  arrowButtonClassName: u,
  fieldClassName: d,
  disabled: p,
  withoutCloseIcon: m,
  onOpen: h,
  onClose: f,
  dataTest: g,
  wrapperProps: y,
  loaderClassName: b,
  loaderWrapperClassName: k,
  captionClassName: D,
  inputRef: v,
  optionsClassName: S,
  ...w
}) {
  const [M, P] = ee(!1);
  de(() => {
    M && h && (h(), P(!1));
  }, [M]);
  const N = bs(e, t ?? n) ?? null, B = e !== void 0, x = p || r || B && (!t && !n), K = B && !m && !x, z = Qa(() => {
    if (t)
      return t.length > 0 ? t : [_s()];
  }, [t]), [T, I] = ee(null), V = dr(T, t);
  return /* @__PURE__ */ _(
    ar,
    {
      value: N,
      onChange: (U) => {
        U !== null && a(U == null ? void 0 : U.id);
      },
      disabled: x,
      children: ({ open: U }) => /* @__PURE__ */ L(Ee, { children: [
        /* @__PURE__ */ L(ln, { className: A("relative flex w-fit flex-col gap-1", d), children: [
          /* @__PURE__ */ L(
            zt,
            {
              className: A(
                "inline-grid w-fit",
                "pr-6",
                K && "pr-10",
                "focus-ring rounded-md outline-hidden",
                l
              ),
              children: [
                /* @__PURE__ */ _(
                  "span",
                  {
                    className: A(
                      "text-start truncate underline decoration-dashed",
                      D
                    ),
                    children: (N == null ? void 0 : N.caption) ?? i ?? G.t("public_pages_purchase.form_select.select")
                  }
                ),
                /* @__PURE__ */ _(
                  or,
                  {
                    As: zt,
                    isDisabled: x,
                    arrowButtonClassName: A(
                      "absolute bottom-0 right-0",
                      "h-6 w-4",
                      u
                    ),
                    open: U
                  }
                )
              ]
            }
          ),
          K && /* @__PURE__ */ _(
            sr,
            {
              isDisabled: x,
              closeButtonClassName: A(
                "absolute bottom-0 right-5 ",
                "h-6 w-4",
                c
              ),
              onClick: () => a(void 0)
            }
          )
        ] }),
        /* @__PURE__ */ _(
          un,
          {
            ref: I,
            style: { height: V },
            as: tr,
            optionsClassName: A("h-fit w-fit outline-hidden", S),
            children: z ? z.map(
              (ae) => ur({
                item: ae,
                as: Ji,
                optionClassName: w == null ? void 0 : w.optionClassName,
                optionIconWrapperClassName: w == null ? void 0 : w.optionIconWrapperClassName
              })
            ) : /* @__PURE__ */ _(
              cr,
              {
                loaderWrapperClassName: A("p-2", k),
                loaderClassName: b
              }
            )
          }
        )
      ] })
    }
  );
}
function my({
  label: t,
  data: n,
  staticData: a,
  onChange: e,
  labelClassName: r,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: c,
  description: u,
  className: d,
  containerClassName: p,
  closeButtonClassName: m,
  arrowButtonClassName: h,
  fieldClassName: f,
  disabled: g,
  withoutCloseIcon: y,
  onOpen: b,
  onClose: k,
  dataTest: D,
  wrapperProps: v,
  loaderClassName: S,
  loaderWrapperClassName: w,
  hideSelectedValues: M,
  inputWrapperClassName: P,
  inputRef: N,
  ...B
}) {
  const [R, F] = ee(!1);
  de(() => {
    R && b && (b(), F(!1));
  }, [R]);
  const x = Qa(
    () => {
      var me;
      return ((me = n ?? a) == null ? void 0 : me.filter((ge) => i == null ? void 0 : i.includes(ge.id))) ?? [];
    },
    [n, a, i]
  ), { filteredData: K, setQuery: z } = vs(n), T = i.length > 0, U = g || o || T && (!n && !a), ae = T && !y && !U;
  return /* @__PURE__ */ L("div", { className: A("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ _(
      ip,
      {
        selectedData: x,
        virtual: Ss(K),
        onChange: e,
        disabled: U,
        onClose: () => {
          z(""), k == null || k();
        },
        children: (me) => /* @__PURE__ */ L(Ee, { children: [
          /* @__PURE__ */ L(ln, { className: A("flex flex-col gap-1", f), children: [
            /* @__PURE__ */ _(
              Na,
              {
                wrapperAs: "label",
                wrapperProps: v,
                label: t,
                required: c,
                labelClassName: A("text-sm font-medium", r)
              }
            ),
            /* @__PURE__ */ L(er, { as: "div", className: A("relative", P), children: [
              /* @__PURE__ */ _(
                gs,
                {
                  dataTest: D,
                  inputRef: N,
                  isDisabled: U,
                  hasError: !!l,
                  open: me,
                  className: d,
                  placeholder: s,
                  isPreFetching: o,
                  selectedCaption: M ? "" : x.map((ge) => ge.caption).join(", "),
                  onFocus: () => F(!0),
                  onChange: (ge) => {
                    F(!0), z(ge);
                  }
                }
              ),
              /* @__PURE__ */ _(
                or,
                {
                  isDisabled: U,
                  arrowButtonClassName: A(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    h
                  ),
                  open: me
                }
              )
            ] }),
            ae && /* @__PURE__ */ _(
              sr,
              {
                isDisabled: U,
                closeButtonClassName: A(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  m
                ),
                onClick: () => e([])
              }
            )
          ] }),
          /* @__PURE__ */ _(
            ys,
            {
              asOptions: Zi,
              asOption: Wi,
              data: K,
              ...B
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ _(ha, { error: l, description: u })
  ] });
}
function hy({
  value: t,
  onChange: n,
  children: a,
  optionsClassName: e,
  data: r,
  loaderClassName: i,
  loaderWrapperClassName: o,
  optionClassName: s,
  optionIconWrapperClassName: l,
  disabled: c,
  buttonClassName: u,
  optionsProps: d
}) {
  const p = r == null ? void 0 : r.find((g) => g.id === t), [m, h] = ee(null), f = dr(m, r);
  return /* @__PURE__ */ _(ar, { disabled: c, value: p, onChange: (g) => n(g == null ? void 0 : g.id), children: ({ open: g }) => /* @__PURE__ */ L(Ee, { children: [
    /* @__PURE__ */ _(
      zt,
      {
        className: A(
          "ring-brand-primary outline-hidden focus-visible:ring-2",
          u
        ),
        children: a(g)
      }
    ),
    /* @__PURE__ */ _(
      un,
      {
        ref: h,
        style: { height: f },
        as: tr,
        optionsClassName: A("h-fit outline-hidden", e),
        optionsProps: d,
        children: r ? r.map(
          (y) => ur({
            item: y,
            as: Ji,
            optionClassName: s,
            optionIconWrapperClassName: l
          })
        ) : /* @__PURE__ */ _(
          cr,
          {
            loaderWrapperClassName: o,
            loaderClassName: i
          }
        )
      }
    )
  ] }) });
}
function fy({ amount: t, className: n }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: A(
        "text-background-secondary bg-green flex min-h-6 min-w-6 items-center justify-center rounded-full p-1 text-xs",
        n
      ),
      children: t
    }
  );
}
const gy = ({
  children: t,
  className: n,
  color: a = "blue",
  showHint: e = !0,
  ...r
}) => /* @__PURE__ */ L("div", { className: A("flex items-center gap-0.5", n), children: [
  t,
  e && /* @__PURE__ */ _(
    rr,
    {
      mode: "click",
      ...r,
      className: A("focus-ring rounded-full"),
      popoverClassName: A("!max-w-[200px] sm:!max-w-[350px]", r.popoverClassName),
      wrapperClassName: "m-1",
      children: (i) => /* @__PURE__ */ _(
        $i,
        {
          className: A(
            `group-focus-visible:fill-${a} h-[16px] w-[16px]`,
            i ? `fill-${a}` : "fill-fill-primary"
          )
        }
      )
    }
  )
] }), sp = {}, lp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sp
}, Symbol.toStringTag, { value: "Module" })), cp = /* @__PURE__ */ Jl(lp);
function ks(t) {
  var n, a, e = "";
  if (typeof t == "string" || typeof t == "number") e += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var r = t.length;
    for (n = 0; n < r; n++) t[n] && (a = ks(t[n])) && (e && (e += " "), e += a);
  } else for (a in t) t[a] && (e && (e += " "), e += a);
  return e;
}
function _e() {
  for (var t, n, a = 0, e = "", r = arguments.length; a < r; a++) (t = arguments[a]) && (n = ks(t)) && (e && (e += " "), e += n);
  return e;
}
const Ms = 6048e5, up = 864e5, dn = 6e4, pn = 36e5, dp = 1e3, Qr = Symbol.for("constructDateFrom");
function ne(t, n) {
  return typeof t == "function" ? t(n) : t && typeof t == "object" && Qr in t ? t[Qr](n) : t instanceof Date ? new t.constructor(n) : new Date(n);
}
function H(t, n) {
  return ne(n || t, t);
}
function Ge(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  return isNaN(n) ? ne((a == null ? void 0 : a.in) || t, NaN) : (n && e.setDate(e.getDate() + n), e);
}
function Fe(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  if (isNaN(n)) return ne(t, NaN);
  if (!n)
    return e;
  const r = e.getDate(), i = ne(t, e.getTime());
  i.setMonth(e.getMonth() + n + 1, 0);
  const o = i.getDate();
  return r >= o ? i : (e.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), e);
}
function ws(t, n, a) {
  return ne(t, +H(t) + n);
}
function pp(t, n, a) {
  return ws(t, n * pn);
}
let mp = {};
function Ia() {
  return mp;
}
function ia(t, n) {
  var s, l, c, u;
  const a = Ia(), e = (n == null ? void 0 : n.weekStartsOn) ?? ((l = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? a.weekStartsOn ?? ((u = (c = a.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = H(t, n == null ? void 0 : n.in), i = r.getDay(), o = (i < e ? 7 : 0) + i - e;
  return r.setDate(r.getDate() - o), r.setHours(0, 0, 0, 0), r;
}
function Ua(t, n) {
  return ia(t, { ...n, weekStartsOn: 1 });
}
function Cs(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = a.getFullYear(), r = ne(a, 0);
  r.setFullYear(e + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Ua(r), o = ne(a, 0);
  o.setFullYear(e, 0, 4), o.setHours(0, 0, 0, 0);
  const s = Ua(o);
  return a.getTime() >= i.getTime() ? e + 1 : a.getTime() >= s.getTime() ? e : e - 1;
}
function Zt(t) {
  const n = H(t), a = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return a.setUTCFullYear(n.getFullYear()), +t - +a;
}
function oa(t, ...n) {
  const a = ne.bind(
    null,
    t || n.find((e) => typeof e == "object")
  );
  return n.map(a);
}
function Da(t, n) {
  const a = H(t, n == null ? void 0 : n.in);
  return a.setHours(0, 0, 0, 0), a;
}
function ja(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  ), i = Da(e), o = Da(r), s = +i - Zt(i), l = +o - Zt(o);
  return Math.round((s - l) / up);
}
function hp(t, n) {
  const a = Cs(t, n), e = ne(t, 0);
  return e.setFullYear(a, 0, 4), e.setHours(0, 0, 0, 0), Ua(e);
}
function ht(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  return e.setTime(e.getTime() + n * dn), e;
}
function pr(t, n, a) {
  return Fe(t, n * 3, a);
}
function fp(t, n, a) {
  return ws(t, n * 1e3);
}
function Jt(t, n, a) {
  return Ge(t, n * 7, a);
}
function aa(t, n, a) {
  return Fe(t, n * 12, a);
}
function $r(t, n) {
  let a, e = n == null ? void 0 : n.in;
  return t.forEach((r) => {
    !e && typeof r == "object" && (e = ne.bind(null, r));
    const i = H(r, e);
    (!a || a < i || isNaN(+i)) && (a = i);
  }), ne(e, a || NaN);
}
function qr(t, n) {
  let a, e = n == null ? void 0 : n.in;
  return t.forEach((r) => {
    !e && typeof r == "object" && (e = ne.bind(null, r));
    const i = H(r, e);
    (!a || a > i || isNaN(+i)) && (a = i);
  }), ne(e, a || NaN);
}
function gp(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  );
  return +Da(e) == +Da(r);
}
function ta(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Qt(t) {
  return !(!ta(t) && typeof t != "number" || isNaN(+H(t)));
}
function $t(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  ), i = e.getFullYear() - r.getFullYear(), o = e.getMonth() - r.getMonth();
  return i * 12 + o;
}
function la(t, n) {
  const a = H(t, n == null ? void 0 : n.in);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function qt(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  ), i = e.getFullYear() - r.getFullYear(), o = la(e) - la(r);
  return i * 4 + o;
}
function Xt(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  );
  return e.getFullYear() - r.getFullYear();
}
function Ds(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  ), i = Xr(e, r), o = Math.abs(
    ja(e, r)
  );
  e.setDate(e.getDate() - i * o);
  const s = +(Xr(e, r) === -i), l = i * (o - s);
  return l === 0 ? 0 : l;
}
function Xr(t, n) {
  const a = t.getFullYear() - n.getFullYear() || t.getMonth() - n.getMonth() || t.getDate() - n.getDate() || t.getHours() - n.getHours() || t.getMinutes() - n.getMinutes() || t.getSeconds() - n.getSeconds() || t.getMilliseconds() - n.getMilliseconds();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
function Ps(t, n) {
  const a = H(t, n == null ? void 0 : n.in);
  return a.setHours(23, 59, 59, 999), a;
}
function As(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = a.getMonth();
  return a.setFullYear(a.getFullYear(), e + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function jn(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = a.getMonth(), r = e - e % 3;
  return a.setMonth(r, 1), a.setHours(0, 0, 0, 0), a;
}
function Ns(t, n) {
  const a = H(t, n == null ? void 0 : n.in);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function Ts(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = a.getFullYear();
  return a.setFullYear(e + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function mn(t, n) {
  const a = H(t, n == null ? void 0 : n.in);
  return a.setFullYear(a.getFullYear(), 0, 1), a.setHours(0, 0, 0, 0), a;
}
function _p(t, n) {
  var s, l;
  const a = Ia(), e = a.weekStartsOn ?? ((l = (s = a.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? 0, r = H(t, n == null ? void 0 : n.in), i = r.getDay(), o = (i < e ? -7 : 0) + 6 - (i - e);
  return r.setDate(r.getDate() + o), r.setHours(23, 59, 59, 999), r;
}
const yp = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bp = (t, n, a) => {
  let e;
  const r = yp[t];
  return typeof r == "string" ? e = r : n === 1 ? e = r.one : e = r.other.replace("{{count}}", n.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + e : e + " ago" : e;
};
function An(t) {
  return (n = {}) => {
    const a = n.width ? String(n.width) : t.defaultWidth;
    return t.formats[a] || t.formats[t.defaultWidth];
  };
}
const vp = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Sp = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, kp = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Mp = {
  date: An({
    formats: vp,
    defaultWidth: "full"
  }),
  time: An({
    formats: Sp,
    defaultWidth: "full"
  }),
  dateTime: An({
    formats: kp,
    defaultWidth: "full"
  })
}, wp = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Cp = (t, n, a, e) => wp[t];
function at(t) {
  return (n, a) => {
    const e = a != null && a.context ? String(a.context) : "standalone";
    let r;
    if (e === "formatting" && t.formattingValues) {
      const o = t.defaultFormattingWidth || t.defaultWidth, s = a != null && a.width ? String(a.width) : o;
      r = t.formattingValues[s] || t.formattingValues[o];
    } else {
      const o = t.defaultWidth, s = a != null && a.width ? String(a.width) : t.defaultWidth;
      r = t.values[s] || t.values[o];
    }
    const i = t.argumentCallback ? t.argumentCallback(n) : n;
    return r[i];
  };
}
const Dp = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Pp = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ap = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Np = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Tp = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ip = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, xp = (t, n) => {
  const a = Number(t), e = a % 100;
  if (e > 20 || e < 10)
    switch (e % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, Ep = {
  ordinalNumber: xp,
  era: at({
    values: Dp,
    defaultWidth: "wide"
  }),
  quarter: at({
    values: Pp,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: at({
    values: Ap,
    defaultWidth: "wide"
  }),
  day: at({
    values: Np,
    defaultWidth: "wide"
  }),
  dayPeriod: at({
    values: Tp,
    defaultWidth: "wide",
    formattingValues: Ip,
    defaultFormattingWidth: "wide"
  })
};
function tt(t) {
  return (n, a = {}) => {
    const e = a.width, r = e && t.matchPatterns[e] || t.matchPatterns[t.defaultMatchWidth], i = n.match(r);
    if (!i)
      return null;
    const o = i[0], s = e && t.parsePatterns[e] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? Rp(s, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      Bp(s, (d) => d.test(o))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = a.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      a.valueCallback(c)
    ) : c;
    const u = n.slice(o.length);
    return { value: c, rest: u };
  };
}
function Bp(t, n) {
  for (const a in t)
    if (Object.prototype.hasOwnProperty.call(t, a) && n(t[a]))
      return a;
}
function Rp(t, n) {
  for (let a = 0; a < t.length; a++)
    if (n(t[a]))
      return a;
}
function Op(t) {
  return (n, a = {}) => {
    const e = n.match(t.matchPattern);
    if (!e) return null;
    const r = e[0], i = n.match(t.parsePattern);
    if (!i) return null;
    let o = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    o = a.valueCallback ? a.valueCallback(o) : o;
    const s = n.slice(r.length);
    return { value: o, rest: s };
  };
}
const Lp = /^(\d+)(th|st|nd|rd)?/i, Gp = /\d+/i, Fp = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Kp = {
  any: [/^b/i, /^(a|c)/i]
}, Hp = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Vp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Up = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jp = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Yp = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Wp = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Zp = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Jp = {
  ordinalNumber: Op({
    matchPattern: Lp,
    parsePattern: Gp,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: tt({
    matchPatterns: Fp,
    defaultMatchWidth: "wide",
    parsePatterns: Kp,
    defaultParseWidth: "any"
  }),
  quarter: tt({
    matchPatterns: Hp,
    defaultMatchWidth: "wide",
    parsePatterns: zp,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: tt({
    matchPatterns: Vp,
    defaultMatchWidth: "wide",
    parsePatterns: Up,
    defaultParseWidth: "any"
  }),
  day: tt({
    matchPatterns: jp,
    defaultMatchWidth: "wide",
    parsePatterns: Yp,
    defaultParseWidth: "any"
  }),
  dayPeriod: tt({
    matchPatterns: Wp,
    defaultMatchWidth: "any",
    parsePatterns: Zp,
    defaultParseWidth: "any"
  })
}, xa = {
  code: "en-US",
  formatDistance: bp,
  formatLong: Mp,
  formatRelative: Cp,
  localize: Ep,
  match: Jp,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  enUS: xa
}, Symbol.toStringTag, { value: "Module" }));
function Qp(t, n) {
  const a = H(t, n == null ? void 0 : n.in);
  return ja(a, mn(a)) + 1;
}
function mr(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = +Ua(a) - +hp(a);
  return Math.round(e / Ms) + 1;
}
function hr(t, n) {
  var u, d, p, m;
  const a = H(t, n == null ? void 0 : n.in), e = a.getFullYear(), r = Ia(), i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, o = ne((n == null ? void 0 : n.in) || t, 0);
  o.setFullYear(e + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = ia(o, n), l = ne((n == null ? void 0 : n.in) || t, 0);
  l.setFullYear(e, 0, i), l.setHours(0, 0, 0, 0);
  const c = ia(l, n);
  return +a >= +s ? e + 1 : +a >= +c ? e : e - 1;
}
function $p(t, n) {
  var s, l, c, u;
  const a = Ia(), e = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((l = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((u = (c = a.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, r = hr(t, n), i = ne((n == null ? void 0 : n.in) || t, 0);
  return i.setFullYear(r, 0, e), i.setHours(0, 0, 0, 0), ia(i, n);
}
function Is(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = +ia(a, n) - +$p(a, n);
  return Math.round(e / Ms) + 1;
}
function te(t, n) {
  const a = t < 0 ? "-" : "", e = Math.abs(t).toString().padStart(n, "0");
  return a + e;
}
const sa = {
  // Year
  y(t, n) {
    const a = t.getFullYear(), e = a > 0 ? a : 1 - a;
    return te(n === "yy" ? e % 100 : e, n.length);
  },
  // Month
  M(t, n) {
    const a = t.getMonth();
    return n === "M" ? String(a + 1) : te(a + 1, 2);
  },
  // Day of the month
  d(t, n) {
    return te(t.getDate(), n.length);
  },
  // AM or PM
  a(t, n) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, n) {
    return te(t.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(t, n) {
    return te(t.getHours(), n.length);
  },
  // Minute
  m(t, n) {
    return te(t.getMinutes(), n.length);
  },
  // Second
  s(t, n) {
    return te(t.getSeconds(), n.length);
  },
  // Fraction of second
  S(t, n) {
    const a = n.length, e = t.getMilliseconds(), r = Math.trunc(
      e * Math.pow(10, a - 3)
    );
    return te(r, n.length);
  }
}, Oa = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ei = {
  // Era
  G: function(t, n, a) {
    const e = t.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return a.era(e, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return a.era(e, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return a.era(e, { width: "wide" });
    }
  },
  // Year
  y: function(t, n, a) {
    if (n === "yo") {
      const e = t.getFullYear(), r = e > 0 ? e : 1 - e;
      return a.ordinalNumber(r, { unit: "year" });
    }
    return sa.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, a, e) {
    const r = hr(t, e), i = r > 0 ? r : 1 - r;
    if (n === "YY") {
      const o = i % 100;
      return te(o, 2);
    }
    return n === "Yo" ? a.ordinalNumber(i, { unit: "year" }) : te(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    const a = Cs(t);
    return te(a, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    const a = t.getFullYear();
    return te(a, n.length);
  },
  // Quarter
  Q: function(t, n, a) {
    const e = Math.ceil((t.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(e);
      // 01, 02, 03, 04
      case "QQ":
        return te(e, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return a.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return a.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return a.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, a) {
    const e = Math.ceil((t.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(e);
      // 01, 02, 03, 04
      case "qq":
        return te(e, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return a.ordinalNumber(e, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return a.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return a.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, a) {
    const e = t.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return sa.M(t, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return a.ordinalNumber(e + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return a.month(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return a.month(e, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return a.month(e, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, n, a) {
    const e = t.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(e + 1);
      // 01, 02, ..., 12
      case "LL":
        return te(e + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return a.ordinalNumber(e + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return a.month(e, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return a.month(e, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return a.month(e, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, n, a, e) {
    const r = Is(t, e);
    return n === "wo" ? a.ordinalNumber(r, { unit: "week" }) : te(r, n.length);
  },
  // ISO week of year
  I: function(t, n, a) {
    const e = mr(t);
    return n === "Io" ? a.ordinalNumber(e, { unit: "week" }) : te(e, n.length);
  },
  // Day of the month
  d: function(t, n, a) {
    return n === "do" ? a.ordinalNumber(t.getDate(), { unit: "date" }) : sa.d(t, n);
  },
  // Day of year
  D: function(t, n, a) {
    const e = Qp(t);
    return n === "Do" ? a.ordinalNumber(e, { unit: "dayOfYear" }) : te(e, n.length);
  },
  // Day of week
  E: function(t, n, a) {
    const e = t.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return a.day(e, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return a.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, a, e) {
    const r = t.getDay(), i = (r - e.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return te(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return a.ordinalNumber(i, { unit: "day" });
      case "eee":
        return a.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return a.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return a.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return a.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, a, e) {
    const r = t.getDay(), i = (r - e.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return te(i, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return a.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return a.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return a.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return a.day(r, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return a.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, a) {
    const e = t.getDay(), r = e === 0 ? 7 : e;
    switch (n) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return te(r, n.length);
      // 2nd
      case "io":
        return a.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return a.day(e, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return a.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, a) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, a) {
    const e = t.getHours();
    let r;
    switch (e === 12 ? r = Oa.noon : e === 0 ? r = Oa.midnight : r = e / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, a) {
    const e = t.getHours();
    let r;
    switch (e >= 17 ? r = Oa.evening : e >= 12 ? r = Oa.afternoon : e >= 4 ? r = Oa.morning : r = Oa.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, a) {
    if (n === "ho") {
      let e = t.getHours() % 12;
      return e === 0 && (e = 12), a.ordinalNumber(e, { unit: "hour" });
    }
    return sa.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, a) {
    return n === "Ho" ? a.ordinalNumber(t.getHours(), { unit: "hour" }) : sa.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, a) {
    const e = t.getHours() % 12;
    return n === "Ko" ? a.ordinalNumber(e, { unit: "hour" }) : te(e, n.length);
  },
  // Hour [1-24]
  k: function(t, n, a) {
    let e = t.getHours();
    return e === 0 && (e = 24), n === "ko" ? a.ordinalNumber(e, { unit: "hour" }) : te(e, n.length);
  },
  // Minute
  m: function(t, n, a) {
    return n === "mo" ? a.ordinalNumber(t.getMinutes(), { unit: "minute" }) : sa.m(t, n);
  },
  // Second
  s: function(t, n, a) {
    return n === "so" ? a.ordinalNumber(t.getSeconds(), { unit: "second" }) : sa.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return sa.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, a) {
    const e = t.getTimezoneOffset();
    if (e === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return ti(e);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return _a(e);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return _a(e, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, a) {
    const e = t.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return ti(e);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return _a(e);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return _a(e, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, a) {
    const e = t.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ai(e, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + _a(e, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, a) {
    const e = t.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ai(e, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + _a(e, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, a) {
    const e = Math.trunc(+t / 1e3);
    return te(e, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, a) {
    return te(+t, n.length);
  }
};
function ai(t, n = "") {
  const a = t > 0 ? "-" : "+", e = Math.abs(t), r = Math.trunc(e / 60), i = e % 60;
  return i === 0 ? a + String(r) : a + String(r) + n + te(i, 2);
}
function ti(t, n) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + te(Math.abs(t) / 60, 2) : _a(t, n);
}
function _a(t, n = "") {
  const a = t > 0 ? "-" : "+", e = Math.abs(t), r = te(Math.trunc(e / 60), 2), i = te(e % 60, 2);
  return a + r + n + i;
}
const ni = (t, n) => {
  switch (t) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, xs = (t, n) => {
  switch (t) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, qp = (t, n) => {
  const a = t.match(/(P+)(p+)?/) || [], e = a[1], r = a[2];
  if (!r)
    return ni(t, n);
  let i;
  switch (e) {
    case "P":
      i = n.dateTime({ width: "short" });
      break;
    case "PP":
      i = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = n.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", ni(e, n)).replace("{{time}}", xs(r, n));
}, Yn = {
  p: xs,
  P: qp
}, Xp = /^D+$/, em = /^Y+$/, am = ["D", "DD", "YY", "YYYY"];
function tm(t) {
  return Xp.test(t);
}
function nm(t) {
  return em.test(t);
}
function rm(t, n, a) {
  const e = im(t, n, a);
  if (console.warn(e), am.includes(t)) throw new RangeError(e);
}
function im(t, n, a) {
  const e = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${n}\`) for formatting ${e} to the input \`${a}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const om = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sm = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, lm = /^'([^]*?)'?$/, cm = /''/g, um = /[a-zA-Z]/;
function ri(t, n, a) {
  var u, d, p, m, h, f, g, y;
  const e = Ia(), r = (a == null ? void 0 : a.locale) ?? e.locale ?? xa, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((d = (u = a == null ? void 0 : a.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? e.firstWeekContainsDate ?? ((m = (p = e.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((f = (h = a == null ? void 0 : a.locale) == null ? void 0 : h.options) == null ? void 0 : f.weekStartsOn) ?? e.weekStartsOn ?? ((y = (g = e.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = H(t, a == null ? void 0 : a.in);
  if (!Qt(s))
    throw new RangeError("Invalid time value");
  let l = n.match(sm).map((b) => {
    const k = b[0];
    if (k === "p" || k === "P") {
      const D = Yn[k];
      return D(b, r.formatLong);
    }
    return b;
  }).join("").match(om).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const k = b[0];
    if (k === "'")
      return { isToken: !1, value: dm(b) };
    if (ei[k])
      return { isToken: !0, value: b };
    if (k.match(um))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + k + "`"
      );
    return { isToken: !1, value: b };
  });
  r.localize.preprocessor && (l = r.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: r
  };
  return l.map((b) => {
    if (!b.isToken) return b.value;
    const k = b.value;
    (!(a != null && a.useAdditionalWeekYearTokens) && nm(k) || !(a != null && a.useAdditionalDayOfYearTokens) && tm(k)) && rm(k, n, String(t));
    const D = ei[k[0]];
    return D(s, k, r.localize, c);
  }).join("");
}
function dm(t) {
  const n = t.match(lm);
  return n ? n[1].replace(cm, "'") : t;
}
function ii(t, n) {
  return H(t, n == null ? void 0 : n.in).getDate();
}
function pm(t, n) {
  return H(t, n == null ? void 0 : n.in).getDay();
}
function mm(t, n) {
  const a = H(t, n == null ? void 0 : n.in), e = a.getFullYear(), r = a.getMonth(), i = ne(a, 0);
  return i.setFullYear(e, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function hm() {
  return Object.assign({}, Ia());
}
function ve(t, n) {
  return H(t, n == null ? void 0 : n.in).getHours();
}
function fm(t, n) {
  const a = H(t, n == null ? void 0 : n.in).getDay();
  return a === 0 ? 7 : a;
}
function Se(t, n) {
  return H(t, n == null ? void 0 : n.in).getMinutes();
}
function Te(t, n) {
  return H(t, n == null ? void 0 : n.in).getMonth();
}
function ua(t) {
  return H(t).getSeconds();
}
function Wn(t) {
  return +H(t);
}
function J(t, n) {
  return H(t, n == null ? void 0 : n.in).getFullYear();
}
function na(t, n) {
  return +H(t) > +H(n);
}
function Ye(t, n) {
  return +H(t) < +H(n);
}
function gm(t, n) {
  return +H(t) == +H(n);
}
function _m(t, n) {
  const a = ym(n) ? new n(0) : ne(n, 0);
  return a.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), a.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), a;
}
function ym(t) {
  var n;
  return typeof t == "function" && ((n = t.prototype) == null ? void 0 : n.constructor) === t;
}
const bm = 10;
class Es {
  constructor() {
    O(this, "subPriority", 0);
  }
  validate(n, a) {
    return !0;
  }
}
class vm extends Es {
  constructor(n, a, e, r, i) {
    super(), this.value = n, this.validateValue = a, this.setValue = e, this.priority = r, i && (this.subPriority = i);
  }
  validate(n, a) {
    return this.validateValue(n, this.value, a);
  }
  set(n, a, e) {
    return this.setValue(n, a, this.value, e);
  }
}
class Sm extends Es {
  constructor(a, e) {
    super();
    O(this, "priority", bm);
    O(this, "subPriority", -1);
    this.context = a || ((r) => ne(e, r));
  }
  set(a, e) {
    return e.timestampIsSet ? a : ne(a, _m(a, this.context));
  }
}
class X {
  run(n, a, e, r) {
    const i = this.parse(n, a, e, r);
    return i ? {
      setter: new vm(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(n, a, e) {
    return !0;
  }
}
class km extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 140);
    O(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, { width: "abbreviated" }) || r.era(a, { width: "narrow" });
      // A, B
      case "GGGGG":
        return r.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(a, { width: "wide" }) || r.era(a, { width: "abbreviated" }) || r.era(a, { width: "narrow" });
    }
  }
  set(a, e, r) {
    return e.era = r, a.setFullYear(r, 0, 1), a.setHours(0, 0, 0, 0), a;
  }
}
const he = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ve = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function fe(t, n) {
  return t && {
    value: n(t.value),
    rest: t.rest
  };
}
function le(t, n) {
  const a = n.match(t);
  return a ? {
    value: parseInt(a[0], 10),
    rest: n.slice(a[0].length)
  } : null;
}
function Ue(t, n) {
  const a = n.match(t);
  if (!a)
    return null;
  if (a[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const e = a[1] === "+" ? 1 : -1, r = a[2] ? parseInt(a[2], 10) : 0, i = a[3] ? parseInt(a[3], 10) : 0, o = a[5] ? parseInt(a[5], 10) : 0;
  return {
    value: e * (r * pn + i * dn + o * dp),
    rest: n.slice(a[0].length)
  };
}
function Bs(t) {
  return le(he.anyDigitsSigned, t);
}
function pe(t, n) {
  switch (t) {
    case 1:
      return le(he.singleDigit, n);
    case 2:
      return le(he.twoDigits, n);
    case 3:
      return le(he.threeDigits, n);
    case 4:
      return le(he.fourDigits, n);
    default:
      return le(new RegExp("^\\d{1," + t + "}"), n);
  }
}
function en(t, n) {
  switch (t) {
    case 1:
      return le(he.singleDigitSigned, n);
    case 2:
      return le(he.twoDigitsSigned, n);
    case 3:
      return le(he.threeDigitsSigned, n);
    case 4:
      return le(he.fourDigitsSigned, n);
    default:
      return le(new RegExp("^-?\\d{1," + t + "}"), n);
  }
}
function fr(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Rs(t, n) {
  const a = n > 0, e = a ? n : 1 - n;
  let r;
  if (e <= 50)
    r = t || 100;
  else {
    const i = e + 50, o = Math.trunc(i / 100) * 100, s = t >= i % 100;
    r = t + o - (s ? 100 : 0);
  }
  return a ? r : 1 - r;
}
function Os(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class Mm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 130);
    O(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(a, e, r) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return fe(pe(4, a), i);
      case "yo":
        return fe(
          r.ordinalNumber(a, {
            unit: "year"
          }),
          i
        );
      default:
        return fe(pe(e.length, a), i);
    }
  }
  validate(a, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(a, e, r) {
    const i = a.getFullYear();
    if (r.isTwoDigitYear) {
      const s = Rs(
        r.year,
        i
      );
      return a.setFullYear(s, 0, 1), a.setHours(0, 0, 0, 0), a;
    }
    const o = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return a.setFullYear(o, 0, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class wm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 130);
    O(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    const i = (o) => ({
      year: o,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return fe(pe(4, a), i);
      case "Yo":
        return fe(
          r.ordinalNumber(a, {
            unit: "year"
          }),
          i
        );
      default:
        return fe(pe(e.length, a), i);
    }
  }
  validate(a, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(a, e, r, i) {
    const o = hr(a, i);
    if (r.isTwoDigitYear) {
      const l = Rs(
        r.year,
        o
      );
      return a.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), a.setHours(0, 0, 0, 0), ia(a, i);
    }
    const s = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return a.setFullYear(s, 0, i.firstWeekContainsDate), a.setHours(0, 0, 0, 0), ia(a, i);
  }
}
class Cm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 130);
    O(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e) {
    return en(e === "R" ? 4 : e.length, a);
  }
  set(a, e, r) {
    const i = ne(a, 0);
    return i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0), Ua(i);
  }
}
class Dm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 130);
    O(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(a, e) {
    return en(e === "u" ? 4 : e.length, a);
  }
  set(a, e, r) {
    return a.setFullYear(r, 0, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class Pm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 120);
    O(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return pe(e.length, a);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 4;
  }
  set(a, e, r) {
    return a.setMonth((r - 1) * 3, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class Am extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 120);
    O(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    switch (e) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return pe(e.length, a);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 4;
  }
  set(a, e, r) {
    return a.setMonth((r - 1) * 3, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class Nm extends X {
  constructor() {
    super(...arguments);
    O(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    O(this, "priority", 110);
  }
  parse(a, e, r) {
    const i = (o) => o - 1;
    switch (e) {
      // 1, 2, ..., 12
      case "M":
        return fe(
          le(he.month, a),
          i
        );
      // 01, 02, ..., 12
      case "MM":
        return fe(pe(2, a), i);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return fe(
          r.ordinalNumber(a, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(a, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(a, { width: "wide", context: "formatting" }) || r.month(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(a, { width: "narrow", context: "formatting" });
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 11;
  }
  set(a, e, r) {
    return a.setMonth(r, 1), a.setHours(0, 0, 0, 0), a;
  }
}
class Tm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 110);
    O(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    const i = (o) => o - 1;
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return fe(
          le(he.month, a),
          i
        );
      // 01, 02, ..., 12
      case "LL":
        return fe(pe(2, a), i);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return fe(
          r.ordinalNumber(a, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(a, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(a, { width: "wide", context: "standalone" }) || r.month(a, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(a, { width: "narrow", context: "standalone" });
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 11;
  }
  set(a, e, r) {
    return a.setMonth(r, 1), a.setHours(0, 0, 0, 0), a;
  }
}
function Im(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in), r = Is(e, a) - n;
  return e.setDate(e.getDate() - r * 7), H(e, a == null ? void 0 : a.in);
}
class xm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 100);
    O(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    switch (e) {
      case "w":
        return le(he.week, a);
      case "wo":
        return r.ordinalNumber(a, { unit: "week" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 53;
  }
  set(a, e, r, i) {
    return ia(Im(a, r, i), i);
  }
}
function Em(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in), r = mr(e, a) - n;
  return e.setDate(e.getDate() - r * 7), e;
}
class Bm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 100);
    O(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    switch (e) {
      case "I":
        return le(he.week, a);
      case "Io":
        return r.ordinalNumber(a, { unit: "week" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 53;
  }
  set(a, e, r) {
    return Ua(Em(a, r));
  }
}
const Rm = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Om = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Lm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 90);
    O(this, "subPriority", 1);
    O(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    switch (e) {
      case "d":
        return le(he.date, a);
      case "do":
        return r.ordinalNumber(a, { unit: "date" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    const r = a.getFullYear(), i = Os(r), o = a.getMonth();
    return i ? e >= 1 && e <= Om[o] : e >= 1 && e <= Rm[o];
  }
  set(a, e, r) {
    return a.setDate(r), a.setHours(0, 0, 0, 0), a;
  }
}
class Gm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 90);
    O(this, "subpriority", 1);
    O(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return le(he.dayOfYear, a);
      case "Do":
        return r.ordinalNumber(a, { unit: "date" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    const r = a.getFullYear();
    return Os(r) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(a, e, r) {
    return a.setMonth(0, r), a.setHours(0, 0, 0, 0), a;
  }
}
function gr(t, n, a) {
  var d, p, m, h;
  const e = Ia(), r = (a == null ? void 0 : a.weekStartsOn) ?? ((p = (d = a == null ? void 0 : a.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? e.weekStartsOn ?? ((h = (m = e.locale) == null ? void 0 : m.options) == null ? void 0 : h.weekStartsOn) ?? 0, i = H(t, a == null ? void 0 : a.in), o = i.getDay(), l = (n % 7 + 7) % 7, c = 7 - r, u = n < 0 || n > 6 ? n - (o + c) % 7 : (l + c) % 7 - (o + c) % 7;
  return Ge(i, u, a);
}
class Fm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 90);
    O(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(a, { width: "short", context: "formatting" }) || r.day(a, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(a, { width: "short", context: "formatting" }) || r.day(a, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return r.day(a, { width: "wide", context: "formatting" }) || r.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(a, { width: "short", context: "formatting" }) || r.day(a, { width: "narrow", context: "formatting" });
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 6;
  }
  set(a, e, r, i) {
    return a = gr(a, r, i), a.setHours(0, 0, 0, 0), a;
  }
}
class Km extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 90);
    O(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r, i) {
    const o = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + l;
    };
    switch (e) {
      // 3
      case "e":
      case "ee":
        return fe(pe(e.length, a), o);
      // 3rd
      case "eo":
        return fe(
          r.ordinalNumber(a, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(a, { width: "short", context: "formatting" }) || r.day(a, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, { width: "short", context: "formatting" }) || r.day(a, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, { width: "wide", context: "formatting" }) || r.day(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(a, { width: "short", context: "formatting" }) || r.day(a, { width: "narrow", context: "formatting" });
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 6;
  }
  set(a, e, r, i) {
    return a = gr(a, r, i), a.setHours(0, 0, 0, 0), a;
  }
}
class Hm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 90);
    O(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(a, e, r, i) {
    const o = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + i.weekStartsOn + 6) % 7 + l;
    };
    switch (e) {
      // 3
      case "c":
      case "cc":
        return fe(pe(e.length, a), o);
      // 3rd
      case "co":
        return fe(
          r.ordinalNumber(a, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(a, { width: "short", context: "standalone" }) || r.day(a, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, { width: "short", context: "standalone" }) || r.day(a, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, { width: "wide", context: "standalone" }) || r.day(a, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(a, { width: "short", context: "standalone" }) || r.day(a, { width: "narrow", context: "standalone" });
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 6;
  }
  set(a, e, r, i) {
    return a = gr(a, r, i), a.setHours(0, 0, 0, 0), a;
  }
}
function zm(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in), r = fm(e, a), i = n - r;
  return Ge(e, i, a);
}
class Vm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 90);
    O(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(a, e, r) {
    const i = (o) => o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
      case "ii":
        return pe(e.length, a);
      // 2nd
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return fe(
          r.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(a, {
            width: "short",
            context: "formatting"
          }) || r.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // T
      case "iiiii":
        return fe(
          r.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tu
      case "iiiiii":
        return fe(
          r.day(a, {
            width: "short",
            context: "formatting"
          }) || r.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tuesday
      case "iiii":
      default:
        return fe(
          r.day(a, {
            width: "wide",
            context: "formatting"
          }) || r.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(a, {
            width: "short",
            context: "formatting"
          }) || r.day(a, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 7;
  }
  set(a, e, r) {
    return a = zm(a, r), a.setHours(0, 0, 0, 0), a;
  }
}
class Um extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 80);
    O(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(a, e, r) {
    return a.setHours(fr(r), 0, 0, 0), a;
  }
}
class jm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 80);
    O(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(a, e, r) {
    return a.setHours(fr(r), 0, 0, 0), a;
  }
}
class Ym extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 80);
    O(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(a, e, r) {
    return a.setHours(fr(r), 0, 0, 0), a;
  }
}
class Wm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 70);
    O(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "h":
        return le(he.hour12h, a);
      case "ho":
        return r.ordinalNumber(a, { unit: "hour" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 12;
  }
  set(a, e, r) {
    const i = a.getHours() >= 12;
    return i && r < 12 ? a.setHours(r + 12, 0, 0, 0) : !i && r === 12 ? a.setHours(0, 0, 0, 0) : a.setHours(r, 0, 0, 0), a;
  }
}
class Zm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 70);
    O(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "H":
        return le(he.hour23h, a);
      case "Ho":
        return r.ordinalNumber(a, { unit: "hour" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 23;
  }
  set(a, e, r) {
    return a.setHours(r, 0, 0, 0), a;
  }
}
class Jm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 70);
    O(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "K":
        return le(he.hour11h, a);
      case "Ko":
        return r.ordinalNumber(a, { unit: "hour" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 11;
  }
  set(a, e, r) {
    return a.getHours() >= 12 && r < 12 ? a.setHours(r + 12, 0, 0, 0) : a.setHours(r, 0, 0, 0), a;
  }
}
class Qm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 70);
    O(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "k":
        return le(he.hour24h, a);
      case "ko":
        return r.ordinalNumber(a, { unit: "hour" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 1 && e <= 24;
  }
  set(a, e, r) {
    const i = r <= 24 ? r % 24 : r;
    return a.setHours(i, 0, 0, 0), a;
  }
}
class $m extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 60);
    O(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "m":
        return le(he.minute, a);
      case "mo":
        return r.ordinalNumber(a, { unit: "minute" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 59;
  }
  set(a, e, r) {
    return a.setMinutes(r, 0, 0), a;
  }
}
class qm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 50);
    O(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(a, e, r) {
    switch (e) {
      case "s":
        return le(he.second, a);
      case "so":
        return r.ordinalNumber(a, { unit: "second" });
      default:
        return pe(e.length, a);
    }
  }
  validate(a, e) {
    return e >= 0 && e <= 59;
  }
  set(a, e, r) {
    return a.setSeconds(r, 0), a;
  }
}
class Xm extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 30);
    O(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(a, e) {
    const r = (i) => Math.trunc(i * Math.pow(10, -e.length + 3));
    return fe(pe(e.length, a), r);
  }
  set(a, e, r) {
    return a.setMilliseconds(r), a;
  }
}
class eh extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 10);
    O(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(a, e) {
    switch (e) {
      case "X":
        return Ue(
          Ve.basicOptionalMinutes,
          a
        );
      case "XX":
        return Ue(Ve.basic, a);
      case "XXXX":
        return Ue(
          Ve.basicOptionalSeconds,
          a
        );
      case "XXXXX":
        return Ue(
          Ve.extendedOptionalSeconds,
          a
        );
      case "XXX":
      default:
        return Ue(Ve.extended, a);
    }
  }
  set(a, e, r) {
    return e.timestampIsSet ? a : ne(
      a,
      a.getTime() - Zt(a) - r
    );
  }
}
class ah extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 10);
    O(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(a, e) {
    switch (e) {
      case "x":
        return Ue(
          Ve.basicOptionalMinutes,
          a
        );
      case "xx":
        return Ue(Ve.basic, a);
      case "xxxx":
        return Ue(
          Ve.basicOptionalSeconds,
          a
        );
      case "xxxxx":
        return Ue(
          Ve.extendedOptionalSeconds,
          a
        );
      case "xxx":
      default:
        return Ue(Ve.extended, a);
    }
  }
  set(a, e, r) {
    return e.timestampIsSet ? a : ne(
      a,
      a.getTime() - Zt(a) - r
    );
  }
}
class th extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 40);
    O(this, "incompatibleTokens", "*");
  }
  parse(a) {
    return Bs(a);
  }
  set(a, e, r) {
    return [ne(a, r * 1e3), { timestampIsSet: !0 }];
  }
}
class nh extends X {
  constructor() {
    super(...arguments);
    O(this, "priority", 20);
    O(this, "incompatibleTokens", "*");
  }
  parse(a) {
    return Bs(a);
  }
  set(a, e, r) {
    return [ne(a, r), { timestampIsSet: !0 }];
  }
}
const rh = {
  G: new km(),
  y: new Mm(),
  Y: new wm(),
  R: new Cm(),
  u: new Dm(),
  Q: new Pm(),
  q: new Am(),
  M: new Nm(),
  L: new Tm(),
  w: new xm(),
  I: new Bm(),
  d: new Lm(),
  D: new Gm(),
  E: new Fm(),
  e: new Km(),
  c: new Hm(),
  i: new Vm(),
  a: new Um(),
  b: new jm(),
  B: new Ym(),
  h: new Wm(),
  H: new Zm(),
  K: new Jm(),
  k: new Qm(),
  m: new $m(),
  s: new qm(),
  S: new Xm(),
  X: new eh(),
  x: new ah(),
  t: new th(),
  T: new nh()
}, ih = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, oh = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, sh = /^'([^]*?)'?$/, lh = /''/g, ch = /\S/, uh = /[a-zA-Z]/;
function dh(t, n, a, e) {
  var g, y, b, k, D, v, S, w;
  const r = () => ne((e == null ? void 0 : e.in) || a, NaN), i = hm(), o = (e == null ? void 0 : e.locale) ?? i.locale ?? xa, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((y = (g = e == null ? void 0 : e.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((k = (b = i.locale) == null ? void 0 : b.options) == null ? void 0 : k.firstWeekContainsDate) ?? 1, l = (e == null ? void 0 : e.weekStartsOn) ?? ((v = (D = e == null ? void 0 : e.locale) == null ? void 0 : D.options) == null ? void 0 : v.weekStartsOn) ?? i.weekStartsOn ?? ((w = (S = i.locale) == null ? void 0 : S.options) == null ? void 0 : w.weekStartsOn) ?? 0;
  if (!n)
    return t ? r() : H(a, e == null ? void 0 : e.in);
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: l,
    locale: o
  }, u = [new Sm(e == null ? void 0 : e.in, a)], d = n.match(oh).map((M) => {
    const P = M[0];
    if (P in Yn) {
      const N = Yn[P];
      return N(M, o.formatLong);
    }
    return M;
  }).join("").match(ih), p = [];
  for (let M of d) {
    const P = M[0], N = rh[P];
    if (N) {
      const { incompatibleTokens: B } = N;
      if (Array.isArray(B)) {
        const F = p.find(
          (x) => B.includes(x.token) || x.token === P
        );
        if (F)
          throw new RangeError(
            `The format string mustn't contain \`${F.fullToken}\` and \`${M}\` at the same time`
          );
      } else if (N.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${M}\` and any other token at the same time`
        );
      p.push({ token: P, fullToken: M });
      const R = N.run(
        t,
        M,
        o.match,
        c
      );
      if (!R)
        return r();
      u.push(R.setter), t = R.rest;
    } else {
      if (P.match(uh))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + P + "`"
        );
      if (M === "''" ? M = "'" : P === "'" && (M = ph(M)), t.indexOf(M) === 0)
        t = t.slice(M.length);
      else
        return r();
    }
  }
  if (t.length > 0 && ch.test(t))
    return r();
  const m = u.map((M) => M.priority).sort((M, P) => P - M).filter((M, P, N) => N.indexOf(M) === P).map(
    (M) => u.filter((P) => P.priority === M).sort((P, N) => N.subPriority - P.subPriority)
  ).map((M) => M[0]);
  let h = H(a, e == null ? void 0 : e.in);
  if (isNaN(+h)) return r();
  const f = {};
  for (const M of m) {
    if (!M.validate(h, c))
      return r();
    const P = M.set(h, f, c);
    Array.isArray(P) ? (h = P[0], Object.assign(f, P[1])) : h = P;
  }
  return h;
}
function ph(t) {
  return t.match(sh)[1].replace(lh, "'");
}
function mh(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  );
  return e.getFullYear() === r.getFullYear() && e.getMonth() === r.getMonth();
}
function hh(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  );
  return +jn(e) == +jn(r);
}
function fh(t, n, a) {
  const [e, r] = oa(
    a == null ? void 0 : a.in,
    t,
    n
  );
  return e.getFullYear() === r.getFullYear();
}
function ft(t, n, a) {
  const e = +H(t, a == null ? void 0 : a.in), [r, i] = [
    +H(n.start, a == null ? void 0 : a.in),
    +H(n.end, a == null ? void 0 : a.in)
  ].sort((o, s) => o - s);
  return e >= r && e <= i;
}
function gh(t, n, a) {
  return Ge(t, -1, a);
}
function _h(t, n) {
  const a = () => ne(n == null ? void 0 : n.in, NaN), r = Sh(t);
  let i;
  if (r.date) {
    const c = kh(r.date, 2);
    i = Mh(c.restDateString, c.year);
  }
  if (!i || isNaN(+i)) return a();
  const o = +i;
  let s = 0, l;
  if (r.time && (s = wh(r.time), isNaN(s)))
    return a();
  if (r.timezone) {
    if (l = Ch(r.timezone), isNaN(l)) return a();
  } else {
    const c = new Date(o + s), u = H(0, n == null ? void 0 : n.in);
    return u.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), u.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), u;
  }
  return H(o + s + l, n == null ? void 0 : n.in);
}
const At = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, yh = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, bh = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, vh = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Sh(t) {
  const n = {}, a = t.split(At.dateTimeDelimiter);
  let e;
  if (a.length > 2)
    return n;
  if (/:/.test(a[0]) ? e = a[0] : (n.date = a[0], e = a[1], At.timeZoneDelimiter.test(n.date) && (n.date = t.split(At.timeZoneDelimiter)[0], e = t.substr(
    n.date.length,
    t.length
  ))), e) {
    const r = At.timezone.exec(e);
    r ? (n.time = e.replace(r[1], ""), n.timezone = r[1]) : n.time = e;
  }
  return n;
}
function kh(t, n) {
  const a = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"
  ), e = t.match(a);
  if (!e) return { year: NaN, restDateString: "" };
  const r = e[1] ? parseInt(e[1]) : null, i = e[2] ? parseInt(e[2]) : null;
  return {
    year: i === null ? r : i * 100,
    restDateString: t.slice((e[1] || e[2]).length)
  };
}
function Mh(t, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  const a = t.match(yh);
  if (!a) return /* @__PURE__ */ new Date(NaN);
  const e = !!a[4], r = nt(a[1]), i = nt(a[2]) - 1, o = nt(a[3]), s = nt(a[4]), l = nt(a[5]) - 1;
  if (e)
    return Th(n, s, l) ? Dh(n, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !Ah(n, i, o) || !Nh(n, r) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(n, i, Math.max(r, o)), c);
  }
}
function nt(t) {
  return t ? parseInt(t) : 1;
}
function wh(t) {
  const n = t.match(bh);
  if (!n) return NaN;
  const a = Tn(n[1]), e = Tn(n[2]), r = Tn(n[3]);
  return Ih(a, e, r) ? a * pn + e * dn + r * 1e3 : NaN;
}
function Tn(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function Ch(t) {
  if (t === "Z") return 0;
  const n = t.match(vh);
  if (!n) return 0;
  const a = n[1] === "+" ? -1 : 1, e = parseInt(n[2]), r = n[3] && parseInt(n[3]) || 0;
  return xh(e, r) ? a * (e * pn + r * dn) : NaN;
}
function Dh(t, n, a) {
  const e = /* @__PURE__ */ new Date(0);
  e.setUTCFullYear(t, 0, 4);
  const r = e.getUTCDay() || 7, i = (n - 1) * 7 + a + 1 - r;
  return e.setUTCDate(e.getUTCDate() + i), e;
}
const Ph = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Ls(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Ah(t, n, a) {
  return n >= 0 && n <= 11 && a >= 1 && a <= (Ph[n] || (Ls(t) ? 29 : 28));
}
function Nh(t, n) {
  return n >= 1 && n <= (Ls(t) ? 366 : 365);
}
function Th(t, n, a) {
  return n >= 1 && n <= 53 && a >= 0 && a <= 6;
}
function Ih(t, n, a) {
  return t === 24 ? n === 0 && a === 0 : a >= 0 && a < 60 && n >= 0 && n < 60 && t >= 0 && t < 25;
}
function xh(t, n) {
  return n >= 0 && n <= 59;
}
function Ie(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in), r = e.getFullYear(), i = e.getDate(), o = ne(t, 0);
  o.setFullYear(r, n, 15), o.setHours(0, 0, 0, 0);
  const s = mm(o);
  return e.setMonth(n, Math.min(i, s)), e;
}
function Lt(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  return e.setHours(n), e;
}
function Gt(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  return e.setMinutes(n), e;
}
function Ga(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in), r = Math.trunc(e.getMonth() / 3) + 1, i = n - r;
  return Ie(e, e.getMonth() + i * 3);
}
function Ft(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  return e.setSeconds(n), e;
}
function Ke(t, n, a) {
  const e = H(t, a == null ? void 0 : a.in);
  return isNaN(+e) ? ne(t, NaN) : (e.setFullYear(n), e);
}
function ka(t, n, a) {
  return Fe(t, -n, a);
}
function Gs(t, n, a) {
  return pr(t, -1, a);
}
function oi(t, n, a) {
  return Jt(t, -1, a);
}
function Ya(t, n, a) {
  return aa(t, -n, a);
}
function hn() {
  return typeof window < "u";
}
function $a(t) {
  return Fs(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function xe(t) {
  var n;
  return (t == null || (n = t.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Qe(t) {
  var n;
  return (n = (Fs(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : n.documentElement;
}
function Fs(t) {
  return hn() ? t instanceof Node || t instanceof xe(t).Node : !1;
}
function ke(t) {
  return hn() ? t instanceof Element || t instanceof xe(t).Element : !1;
}
function Je(t) {
  return hn() ? t instanceof HTMLElement || t instanceof xe(t).HTMLElement : !1;
}
function si(t) {
  return !hn() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof xe(t).ShadowRoot;
}
const Eh = /* @__PURE__ */ new Set(["inline", "contents"]);
function vt(t) {
  const {
    overflow: n,
    overflowX: a,
    overflowY: e,
    display: r
  } = Oe(t);
  return /auto|scroll|overlay|hidden|clip/.test(n + e + a) && !Eh.has(r);
}
const Bh = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Rh(t) {
  return Bh.has($a(t));
}
const Oh = [":popover-open", ":modal"];
function fn(t) {
  return Oh.some((n) => {
    try {
      return t.matches(n);
    } catch {
      return !1;
    }
  });
}
const Lh = ["transform", "translate", "scale", "rotate", "perspective"], Gh = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Fh = ["paint", "layout", "strict", "content"];
function _r(t) {
  const n = yr(), a = ke(t) ? Oe(t) : t;
  return Lh.some((e) => a[e] ? a[e] !== "none" : !1) || (a.containerType ? a.containerType !== "normal" : !1) || !n && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !n && (a.filter ? a.filter !== "none" : !1) || Gh.some((e) => (a.willChange || "").includes(e)) || Fh.some((e) => (a.contain || "").includes(e));
}
function Kh(t) {
  let n = ma(t);
  for (; Je(n) && !Wa(n); ) {
    if (_r(n))
      return n;
    if (fn(n))
      return null;
    n = ma(n);
  }
  return null;
}
function yr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Hh = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Wa(t) {
  return Hh.has($a(t));
}
function Oe(t) {
  return xe(t).getComputedStyle(t);
}
function gn(t) {
  return ke(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function ma(t) {
  if ($a(t) === "html")
    return t;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    si(t) && t.host || // Fallback.
    Qe(t)
  );
  return si(n) ? n.host : n;
}
function Ks(t) {
  const n = ma(t);
  return Wa(n) ? t.ownerDocument ? t.ownerDocument.body : t.body : Je(n) && vt(n) ? n : Ks(n);
}
function gt(t, n, a) {
  var e;
  n === void 0 && (n = []), a === void 0 && (a = !0);
  const r = Ks(t), i = r === ((e = t.ownerDocument) == null ? void 0 : e.body), o = xe(r);
  if (i) {
    const s = Zn(o);
    return n.concat(o, o.visualViewport || [], vt(r) ? r : [], s && a ? gt(s) : []);
  }
  return n.concat(r, gt(r, [], a));
}
function Zn(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
const Za = Math.min, Ma = Math.max, an = Math.round, Nt = Math.floor, Ze = (t) => ({
  x: t,
  y: t
}), zh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Vh = {
  start: "end",
  end: "start"
};
function Jn(t, n, a) {
  return Ma(t, Za(n, a));
}
function St(t, n) {
  return typeof t == "function" ? t(n) : t;
}
function Pa(t) {
  return t.split("-")[0];
}
function kt(t) {
  return t.split("-")[1];
}
function Hs(t) {
  return t === "x" ? "y" : "x";
}
function br(t) {
  return t === "y" ? "height" : "width";
}
const Uh = /* @__PURE__ */ new Set(["top", "bottom"]);
function ca(t) {
  return Uh.has(Pa(t)) ? "y" : "x";
}
function vr(t) {
  return Hs(ca(t));
}
function jh(t, n, a) {
  a === void 0 && (a = !1);
  const e = kt(t), r = vr(t), i = br(r);
  let o = r === "x" ? e === (a ? "end" : "start") ? "right" : "left" : e === "start" ? "bottom" : "top";
  return n.reference[i] > n.floating[i] && (o = tn(o)), [o, tn(o)];
}
function Yh(t) {
  const n = tn(t);
  return [Qn(t), n, Qn(n)];
}
function Qn(t) {
  return t.replace(/start|end/g, (n) => Vh[n]);
}
const li = ["left", "right"], ci = ["right", "left"], Wh = ["top", "bottom"], Zh = ["bottom", "top"];
function Jh(t, n, a) {
  switch (t) {
    case "top":
    case "bottom":
      return a ? n ? ci : li : n ? li : ci;
    case "left":
    case "right":
      return n ? Wh : Zh;
    default:
      return [];
  }
}
function Qh(t, n, a, e) {
  const r = kt(t);
  let i = Jh(Pa(t), a === "start", e);
  return r && (i = i.map((o) => o + "-" + r), n && (i = i.concat(i.map(Qn)))), i;
}
function tn(t) {
  return t.replace(/left|right|bottom|top/g, (n) => zh[n]);
}
function $h(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function zs(t) {
  return typeof t != "number" ? $h(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function nn(t) {
  const {
    x: n,
    y: a,
    width: e,
    height: r
  } = t;
  return {
    width: e,
    height: r,
    top: a,
    left: n,
    right: n + e,
    bottom: a + r,
    x: n,
    y: a
  };
}
var qh = typeof document < "u", Xh = function() {
}, rn = qh ? nr : Xh;
const ef = {
  ...j
}, af = ef.useInsertionEffect, tf = af || ((t) => t());
function nf(t) {
  const n = j.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return tf(() => {
    n.current = t;
  }), j.useCallback(function() {
    for (var a = arguments.length, e = new Array(a), r = 0; r < a; r++)
      e[r] = arguments[r];
    return n.current == null ? void 0 : n.current(...e);
  }, []);
}
function ui(t, n, a) {
  let {
    reference: e,
    floating: r
  } = t;
  const i = ca(n), o = vr(n), s = br(o), l = Pa(n), c = i === "y", u = e.x + e.width / 2 - r.width / 2, d = e.y + e.height / 2 - r.height / 2, p = e[s] / 2 - r[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: u,
        y: e.y - r.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: e.y + e.height
      };
      break;
    case "right":
      m = {
        x: e.x + e.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: e.x - r.width,
        y: d
      };
      break;
    default:
      m = {
        x: e.x,
        y: e.y
      };
  }
  switch (kt(n)) {
    case "start":
      m[o] -= p * (a && c ? -1 : 1);
      break;
    case "end":
      m[o] += p * (a && c ? -1 : 1);
      break;
  }
  return m;
}
const rf = async (t, n, a) => {
  const {
    placement: e = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: o
  } = a, s = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(n));
  let c = await o.getElementRects({
    reference: t,
    floating: n,
    strategy: r
  }), {
    x: u,
    y: d
  } = ui(c, e, l), p = e, m = {}, h = 0;
  for (let f = 0; f < s.length; f++) {
    const {
      name: g,
      fn: y
    } = s[f], {
      x: b,
      y: k,
      data: D,
      reset: v
    } = await y({
      x: u,
      y: d,
      initialPlacement: e,
      placement: p,
      strategy: r,
      middlewareData: m,
      rects: c,
      platform: o,
      elements: {
        reference: t,
        floating: n
      }
    });
    u = b ?? u, d = k ?? d, m = {
      ...m,
      [g]: {
        ...m[g],
        ...D
      }
    }, v && h <= 50 && (h++, typeof v == "object" && (v.placement && (p = v.placement), v.rects && (c = v.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: n,
      strategy: r
    }) : v.rects), {
      x: u,
      y: d
    } = ui(c, p, l)), f = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: r,
    middlewareData: m
  };
};
async function Vs(t, n) {
  var a;
  n === void 0 && (n = {});
  const {
    x: e,
    y: r,
    platform: i,
    rects: o,
    elements: s,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = St(n, t), h = zs(m), g = s[p ? d === "floating" ? "reference" : "floating" : d], y = nn(await i.getClippingRect({
    element: (a = await (i.isElement == null ? void 0 : i.isElement(g))) == null || a ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    x: e,
    y: r,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, k = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), D = await (i.isElement == null ? void 0 : i.isElement(k)) ? await (i.getScale == null ? void 0 : i.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, v = nn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: k,
    strategy: l
  }) : b);
  return {
    top: (y.top - v.top + h.top) / D.y,
    bottom: (v.bottom - y.bottom + h.bottom) / D.y,
    left: (y.left - v.left + h.left) / D.x,
    right: (v.right - y.right + h.right) / D.x
  };
}
const of = (t) => ({
  name: "arrow",
  options: t,
  async fn(n) {
    const {
      x: a,
      y: e,
      placement: r,
      rects: i,
      platform: o,
      elements: s,
      middlewareData: l
    } = n, {
      element: c,
      padding: u = 0
    } = St(t, n) || {};
    if (c == null)
      return {};
    const d = zs(u), p = {
      x: a,
      y: e
    }, m = vr(r), h = br(m), f = await o.getDimensions(c), g = m === "y", y = g ? "top" : "left", b = g ? "bottom" : "right", k = g ? "clientHeight" : "clientWidth", D = i.reference[h] + i.reference[m] - p[m] - i.floating[h], v = p[m] - i.reference[m], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let w = S ? S[k] : 0;
    (!w || !await (o.isElement == null ? void 0 : o.isElement(S))) && (w = s.floating[k] || i.floating[h]);
    const M = D / 2 - v / 2, P = w / 2 - f[h] / 2 - 1, N = Za(d[y], P), B = Za(d[b], P), R = N, F = w - f[h] - B, x = w / 2 - f[h] / 2 + M, K = Jn(R, x, F), z = !l.arrow && kt(r) != null && x !== K && i.reference[h] / 2 - (x < R ? N : B) - f[h] / 2 < 0, T = z ? x < R ? x - R : x - F : 0;
    return {
      [m]: p[m] + T,
      data: {
        [m]: K,
        centerOffset: x - K - T,
        ...z && {
          alignmentOffset: T
        }
      },
      reset: z
    };
  }
}), sf = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(n) {
      var a, e;
      const {
        placement: r,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: c
      } = n, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: f = !0,
        ...g
      } = St(t, n);
      if ((a = i.arrow) != null && a.alignmentOffset)
        return {};
      const y = Pa(r), b = ca(s), k = Pa(s) === s, D = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), v = p || (k || !f ? [tn(s)] : Yh(s)), S = h !== "none";
      !p && S && v.push(...Qh(s, f, h, D));
      const w = [s, ...v], M = await Vs(n, g), P = [];
      let N = ((e = i.flip) == null ? void 0 : e.overflows) || [];
      if (u && P.push(M[y]), d) {
        const x = jh(r, o, D);
        P.push(M[x[0]], M[x[1]]);
      }
      if (N = [...N, {
        placement: r,
        overflows: P
      }], !P.every((x) => x <= 0)) {
        var B, R;
        const x = (((B = i.flip) == null ? void 0 : B.index) || 0) + 1, K = w[x];
        if (K && (!(d === "alignment" ? b !== ca(K) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        N.every((I) => ca(I.placement) === b ? I.overflows[0] > 0 : !0)))
          return {
            data: {
              index: x,
              overflows: N
            },
            reset: {
              placement: K
            }
          };
        let z = (R = N.filter((T) => T.overflows[0] <= 0).sort((T, I) => T.overflows[1] - I.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!z)
          switch (m) {
            case "bestFit": {
              var F;
              const T = (F = N.filter((I) => {
                if (S) {
                  const V = ca(I.placement);
                  return V === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  V === "y";
                }
                return !0;
              }).map((I) => [I.placement, I.overflows.filter((V) => V > 0).reduce((V, U) => V + U, 0)]).sort((I, V) => I[1] - V[1])[0]) == null ? void 0 : F[0];
              T && (z = T);
              break;
            }
            case "initialPlacement":
              z = s;
              break;
          }
        if (r !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
}, lf = /* @__PURE__ */ new Set(["left", "top"]);
async function cf(t, n) {
  const {
    placement: a,
    platform: e,
    elements: r
  } = t, i = await (e.isRTL == null ? void 0 : e.isRTL(r.floating)), o = Pa(a), s = kt(a), l = ca(a) === "y", c = lf.has(o) ? -1 : 1, u = i && l ? -1 : 1, d = St(n, t);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof h == "number" && (m = s === "end" ? h * -1 : h), l ? {
    x: m * u,
    y: p * c
  } : {
    x: p * c,
    y: m * u
  };
}
const uf = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(n) {
      var a, e;
      const {
        x: r,
        y: i,
        placement: o,
        middlewareData: s
      } = n, l = await cf(n, t);
      return o === ((a = s.offset) == null ? void 0 : a.placement) && (e = s.arrow) != null && e.alignmentOffset ? {} : {
        x: r + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, df = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(n) {
      const {
        x: a,
        y: e,
        placement: r
      } = n, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: y,
              y: b
            } = g;
            return {
              x: y,
              y: b
            };
          }
        },
        ...l
      } = St(t, n), c = {
        x: a,
        y: e
      }, u = await Vs(n, l), d = ca(Pa(r)), p = Hs(d);
      let m = c[p], h = c[d];
      if (i) {
        const g = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", b = m + u[g], k = m - u[y];
        m = Jn(b, m, k);
      }
      if (o) {
        const g = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", b = h + u[g], k = h - u[y];
        h = Jn(b, h, k);
      }
      const f = s.fn({
        ...n,
        [p]: m,
        [d]: h
      });
      return {
        ...f,
        data: {
          x: f.x - a,
          y: f.y - e,
          enabled: {
            [p]: i,
            [d]: o
          }
        }
      };
    }
  };
};
function Us(t) {
  const n = Oe(t);
  let a = parseFloat(n.width) || 0, e = parseFloat(n.height) || 0;
  const r = Je(t), i = r ? t.offsetWidth : a, o = r ? t.offsetHeight : e, s = an(a) !== i || an(e) !== o;
  return s && (a = i, e = o), {
    width: a,
    height: e,
    $: s
  };
}
function Sr(t) {
  return ke(t) ? t : t.contextElement;
}
function Ha(t) {
  const n = Sr(t);
  if (!Je(n))
    return Ze(1);
  const a = n.getBoundingClientRect(), {
    width: e,
    height: r,
    $: i
  } = Us(n);
  let o = (i ? an(a.width) : a.width) / e, s = (i ? an(a.height) : a.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const pf = /* @__PURE__ */ Ze(0);
function js(t) {
  const n = xe(t);
  return !yr() || !n.visualViewport ? pf : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function mf(t, n, a) {
  return n === void 0 && (n = !1), !a || n && a !== xe(t) ? !1 : n;
}
function Aa(t, n, a, e) {
  n === void 0 && (n = !1), a === void 0 && (a = !1);
  const r = t.getBoundingClientRect(), i = Sr(t);
  let o = Ze(1);
  n && (e ? ke(e) && (o = Ha(e)) : o = Ha(t));
  const s = mf(i, a, e) ? js(i) : Ze(0);
  let l = (r.left + s.x) / o.x, c = (r.top + s.y) / o.y, u = r.width / o.x, d = r.height / o.y;
  if (i) {
    const p = xe(i), m = e && ke(e) ? xe(e) : e;
    let h = p, f = Zn(h);
    for (; f && e && m !== h; ) {
      const g = Ha(f), y = f.getBoundingClientRect(), b = Oe(f), k = y.left + (f.clientLeft + parseFloat(b.paddingLeft)) * g.x, D = y.top + (f.clientTop + parseFloat(b.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += k, c += D, h = xe(f), f = Zn(h);
    }
  }
  return nn({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function _n(t, n) {
  const a = gn(t).scrollLeft;
  return n ? n.left + a : Aa(Qe(t)).left + a;
}
function Ys(t, n) {
  const a = t.getBoundingClientRect(), e = a.left + n.scrollLeft - _n(t, a), r = a.top + n.scrollTop;
  return {
    x: e,
    y: r
  };
}
function hf(t) {
  let {
    elements: n,
    rect: a,
    offsetParent: e,
    strategy: r
  } = t;
  const i = r === "fixed", o = Qe(e), s = n ? fn(n.floating) : !1;
  if (e === o || s && i)
    return a;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Ze(1);
  const u = Ze(0), d = Je(e);
  if ((d || !d && !i) && (($a(e) !== "body" || vt(o)) && (l = gn(e)), Je(e))) {
    const m = Aa(e);
    c = Ha(e), u.x = m.x + e.clientLeft, u.y = m.y + e.clientTop;
  }
  const p = o && !d && !i ? Ys(o, l) : Ze(0);
  return {
    width: a.width * c.x,
    height: a.height * c.y,
    x: a.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: a.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function ff(t) {
  return Array.from(t.getClientRects());
}
function gf(t) {
  const n = Qe(t), a = gn(t), e = t.ownerDocument.body, r = Ma(n.scrollWidth, n.clientWidth, e.scrollWidth, e.clientWidth), i = Ma(n.scrollHeight, n.clientHeight, e.scrollHeight, e.clientHeight);
  let o = -a.scrollLeft + _n(t);
  const s = -a.scrollTop;
  return Oe(e).direction === "rtl" && (o += Ma(n.clientWidth, e.clientWidth) - r), {
    width: r,
    height: i,
    x: o,
    y: s
  };
}
const di = 25;
function _f(t, n) {
  const a = xe(t), e = Qe(t), r = a.visualViewport;
  let i = e.clientWidth, o = e.clientHeight, s = 0, l = 0;
  if (r) {
    i = r.width, o = r.height;
    const u = yr();
    (!u || u && n === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  const c = _n(e);
  if (c <= 0) {
    const u = e.ownerDocument, d = u.body, p = getComputedStyle(d), m = u.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, h = Math.abs(e.clientWidth - d.clientWidth - m);
    h <= di && (i -= h);
  } else c <= di && (i += c);
  return {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
const yf = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function bf(t, n) {
  const a = Aa(t, !0, n === "fixed"), e = a.top + t.clientTop, r = a.left + t.clientLeft, i = Je(t) ? Ha(t) : Ze(1), o = t.clientWidth * i.x, s = t.clientHeight * i.y, l = r * i.x, c = e * i.y;
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function pi(t, n, a) {
  let e;
  if (n === "viewport")
    e = _f(t, a);
  else if (n === "document")
    e = gf(Qe(t));
  else if (ke(n))
    e = bf(n, a);
  else {
    const r = js(t);
    e = {
      x: n.x - r.x,
      y: n.y - r.y,
      width: n.width,
      height: n.height
    };
  }
  return nn(e);
}
function Ws(t, n) {
  const a = ma(t);
  return a === n || !ke(a) || Wa(a) ? !1 : Oe(a).position === "fixed" || Ws(a, n);
}
function vf(t, n) {
  const a = n.get(t);
  if (a)
    return a;
  let e = gt(t, [], !1).filter((s) => ke(s) && $a(s) !== "body"), r = null;
  const i = Oe(t).position === "fixed";
  let o = i ? ma(t) : t;
  for (; ke(o) && !Wa(o); ) {
    const s = Oe(o), l = _r(o);
    !l && s.position === "fixed" && (r = null), (i ? !l && !r : !l && s.position === "static" && !!r && yf.has(r.position) || vt(o) && !l && Ws(t, o)) ? e = e.filter((u) => u !== o) : r = s, o = ma(o);
  }
  return n.set(t, e), e;
}
function Sf(t) {
  let {
    element: n,
    boundary: a,
    rootBoundary: e,
    strategy: r
  } = t;
  const o = [...a === "clippingAncestors" ? fn(n) ? [] : vf(n, this._c) : [].concat(a), e], s = o[0], l = o.reduce((c, u) => {
    const d = pi(n, u, r);
    return c.top = Ma(d.top, c.top), c.right = Za(d.right, c.right), c.bottom = Za(d.bottom, c.bottom), c.left = Ma(d.left, c.left), c;
  }, pi(n, s, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function kf(t) {
  const {
    width: n,
    height: a
  } = Us(t);
  return {
    width: n,
    height: a
  };
}
function Mf(t, n, a) {
  const e = Je(n), r = Qe(n), i = a === "fixed", o = Aa(t, !0, i, n);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ze(0);
  function c() {
    l.x = _n(r);
  }
  if (e || !e && !i)
    if (($a(n) !== "body" || vt(r)) && (s = gn(n)), e) {
      const m = Aa(n, !0, i, n);
      l.x = m.x + n.clientLeft, l.y = m.y + n.clientTop;
    } else r && c();
  i && !e && r && c();
  const u = r && !e && !i ? Ys(r, s) : Ze(0), d = o.left + s.scrollLeft - l.x - u.x, p = o.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: p,
    width: o.width,
    height: o.height
  };
}
function In(t) {
  return Oe(t).position === "static";
}
function mi(t, n) {
  if (!Je(t) || Oe(t).position === "fixed")
    return null;
  if (n)
    return n(t);
  let a = t.offsetParent;
  return Qe(t) === a && (a = a.ownerDocument.body), a;
}
function Zs(t, n) {
  const a = xe(t);
  if (fn(t))
    return a;
  if (!Je(t)) {
    let r = ma(t);
    for (; r && !Wa(r); ) {
      if (ke(r) && !In(r))
        return r;
      r = ma(r);
    }
    return a;
  }
  let e = mi(t, n);
  for (; e && Rh(e) && In(e); )
    e = mi(e, n);
  return e && Wa(e) && In(e) && !_r(e) ? a : e || Kh(t) || a;
}
const wf = async function(t) {
  const n = this.getOffsetParent || Zs, a = this.getDimensions, e = await a(t.floating);
  return {
    reference: Mf(t.reference, await n(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: e.width,
      height: e.height
    }
  };
};
function Cf(t) {
  return Oe(t).direction === "rtl";
}
const Df = {
  convertOffsetParentRelativeRectToViewportRelativeRect: hf,
  getDocumentElement: Qe,
  getClippingRect: Sf,
  getOffsetParent: Zs,
  getElementRects: wf,
  getClientRects: ff,
  getDimensions: kf,
  getScale: Ha,
  isElement: ke,
  isRTL: Cf
};
function Js(t, n) {
  return t.x === n.x && t.y === n.y && t.width === n.width && t.height === n.height;
}
function Pf(t, n) {
  let a = null, e;
  const r = Qe(t);
  function i() {
    var s;
    clearTimeout(e), (s = a) == null || s.disconnect(), a = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: p,
      height: m
    } = c;
    if (s || n(), !p || !m)
      return;
    const h = Nt(d), f = Nt(r.clientWidth - (u + p)), g = Nt(r.clientHeight - (d + m)), y = Nt(u), k = {
      rootMargin: -h + "px " + -f + "px " + -g + "px " + -y + "px",
      threshold: Ma(0, Za(1, l)) || 1
    };
    let D = !0;
    function v(S) {
      const w = S[0].intersectionRatio;
      if (w !== l) {
        if (!D)
          return o();
        w ? o(!1, w) : e = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      w === 1 && !Js(c, t.getBoundingClientRect()) && o(), D = !1;
    }
    try {
      a = new IntersectionObserver(v, {
        ...k,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(v, k);
    }
    a.observe(t);
  }
  return o(!0), i;
}
function Af(t, n, a, e) {
  e === void 0 && (e = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = e, c = Sr(t), u = r || i ? [...c ? gt(c) : [], ...gt(n)] : [];
  u.forEach((y) => {
    r && y.addEventListener("scroll", a, {
      passive: !0
    }), i && y.addEventListener("resize", a);
  });
  const d = c && s ? Pf(c, a) : null;
  let p = -1, m = null;
  o && (m = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && m && (m.unobserve(n), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var k;
      (k = m) == null || k.observe(n);
    })), a();
  }), c && !l && m.observe(c), m.observe(n));
  let h, f = l ? Aa(t) : null;
  l && g();
  function g() {
    const y = Aa(t);
    f && !Js(f, y) && a(), f = y, h = requestAnimationFrame(g);
  }
  return a(), () => {
    var y;
    u.forEach((b) => {
      r && b.removeEventListener("scroll", a), i && b.removeEventListener("resize", a);
    }), d == null || d(), (y = m) == null || y.disconnect(), m = null, l && cancelAnimationFrame(h);
  };
}
const Nf = uf, Tf = df, If = sf, hi = of, xf = (t, n, a) => {
  const e = /* @__PURE__ */ new Map(), r = {
    platform: Df,
    ...a
  }, i = {
    ...r.platform,
    _c: e
  };
  return rf(t, n, {
    ...r,
    platform: i
  });
};
var Ef = typeof document < "u", Bf = function() {
}, Kt = Ef ? nr : Bf;
function on(t, n) {
  if (t === n)
    return !0;
  if (typeof t != typeof n)
    return !1;
  if (typeof t == "function" && t.toString() === n.toString())
    return !0;
  let a, e, r;
  if (t && n && typeof t == "object") {
    if (Array.isArray(t)) {
      if (a = t.length, a !== n.length) return !1;
      for (e = a; e-- !== 0; )
        if (!on(t[e], n[e]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), a = r.length, a !== Object.keys(n).length)
      return !1;
    for (e = a; e-- !== 0; )
      if (!{}.hasOwnProperty.call(n, r[e]))
        return !1;
    for (e = a; e-- !== 0; ) {
      const i = r[e];
      if (!(i === "_owner" && t.$$typeof) && !on(t[i], n[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}
function Qs(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function fi(t, n) {
  const a = Qs(t);
  return Math.round(n * a) / a;
}
function xn(t) {
  const n = j.useRef(t);
  return Kt(() => {
    n.current = t;
  }), n;
}
function Rf(t) {
  t === void 0 && (t = {});
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: e = [],
    platform: r,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = j.useState({
    x: 0,
    y: 0,
    strategy: a,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = j.useState(e);
  on(p, e) || m(e);
  const [h, f] = j.useState(null), [g, y] = j.useState(null), b = j.useCallback((I) => {
    I !== S.current && (S.current = I, f(I));
  }, []), k = j.useCallback((I) => {
    I !== w.current && (w.current = I, y(I));
  }, []), D = i || h, v = o || g, S = j.useRef(null), w = j.useRef(null), M = j.useRef(u), P = l != null, N = xn(l), B = xn(r), R = xn(c), F = j.useCallback(() => {
    if (!S.current || !w.current)
      return;
    const I = {
      placement: n,
      strategy: a,
      middleware: p
    };
    B.current && (I.platform = B.current), xf(S.current, w.current, I).then((V) => {
      const U = {
        ...V,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: R.current !== !1
      };
      x.current && !on(M.current, U) && (M.current = U, zl.flushSync(() => {
        d(U);
      }));
    });
  }, [p, n, a, B, R]);
  Kt(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [c]);
  const x = j.useRef(!1);
  Kt(() => (x.current = !0, () => {
    x.current = !1;
  }), []), Kt(() => {
    if (D && (S.current = D), v && (w.current = v), D && v) {
      if (N.current)
        return N.current(D, v, F);
      F();
    }
  }, [D, v, F, N, P]);
  const K = j.useMemo(() => ({
    reference: S,
    floating: w,
    setReference: b,
    setFloating: k
  }), [b, k]), z = j.useMemo(() => ({
    reference: D,
    floating: v
  }), [D, v]), T = j.useMemo(() => {
    const I = {
      position: a,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return I;
    const V = fi(z.floating, u.x), U = fi(z.floating, u.y);
    return s ? {
      ...I,
      transform: "translate(" + V + "px, " + U + "px)",
      ...Qs(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: a,
      left: V,
      top: U
    };
  }, [a, s, z.floating, u.x, u.y]);
  return j.useMemo(() => ({
    ...u,
    update: F,
    refs: K,
    elements: z,
    floatingStyles: T
  }), [u, F, K, z, T]);
}
const Of = (t) => {
  function n(a) {
    return {}.hasOwnProperty.call(a, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(a) {
      const {
        element: e,
        padding: r
      } = typeof t == "function" ? t(a) : t;
      return e && n(e) ? e.current != null ? hi({
        element: e.current,
        padding: r
      }).fn(a) : {} : e ? hi({
        element: e,
        padding: r
      }).fn(a) : {};
    }
  };
}, Lf = (t, n) => ({
  ...Nf(t),
  options: [t, n]
}), yn = (t, n) => ({
  ...Tf(t),
  options: [t, n]
}), Mt = (t, n) => ({
  ...If(t),
  options: [t, n]
}), Gf = (t, n) => ({
  ...Of(t),
  options: [t, n]
}), Ff = {
  ...j
};
let gi = !1, Kf = 0;
const _i = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Kf++
);
function Hf() {
  const [t, n] = j.useState(() => gi ? _i() : void 0);
  return rn(() => {
    t == null && n(_i());
  }, []), j.useEffect(() => {
    gi = !0;
  }, []), t;
}
const zf = Ff.useId, $s = zf || Hf;
let _t;
process.env.NODE_ENV !== "production" && (_t = /* @__PURE__ */ new Set());
function Vf() {
  for (var t, n = arguments.length, a = new Array(n), e = 0; e < n; e++)
    a[e] = arguments[e];
  const r = "Floating UI: " + a.join(" ");
  if (!((t = _t) != null && t.has(r))) {
    var i;
    (i = _t) == null || i.add(r), console.warn(r);
  }
}
function Uf() {
  for (var t, n = arguments.length, a = new Array(n), e = 0; e < n; e++)
    a[e] = arguments[e];
  const r = "Floating UI: " + a.join(" ");
  if (!((t = _t) != null && t.has(r))) {
    var i;
    (i = _t) == null || i.add(r), console.error(r);
  }
}
const jf = /* @__PURE__ */ j.forwardRef(function(n, a) {
  const {
    context: {
      placement: e,
      elements: {
        floating: r
      },
      middlewareData: {
        arrow: i,
        shift: o
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: u = 0,
    staticOffset: d,
    stroke: p,
    d: m,
    style: {
      transform: h,
      ...f
    } = {},
    ...g
  } = n;
  process.env.NODE_ENV !== "production" && (a || Vf("The `ref` prop is required for `FloatingArrow`."));
  const y = $s(), [b, k] = j.useState(!1);
  if (rn(() => {
    if (!r) return;
    Oe(r).direction === "rtl" && k(!0);
  }, [r]), !r)
    return null;
  const [D, v] = e.split("-"), S = D === "top" || D === "bottom";
  let w = d;
  (S && o != null && o.x || !S && o != null && o.y) && (w = null);
  const M = u * 2, P = M / 2, N = s / 2 * (c / -8 + 1), B = l / 2 * c / 4, R = !!m, F = w && v === "end" ? "bottom" : "top";
  let x = w && v === "end" ? "right" : "left";
  w && b && (x = v === "end" ? "left" : "right");
  const K = (i == null ? void 0 : i.x) != null ? w || i.x : "", z = (i == null ? void 0 : i.y) != null ? w || i.y : "", T = m || "M0,0" + (" H" + s) + (" L" + (s - N) + "," + (l - B)) + (" Q" + s / 2 + "," + l + " " + N + "," + (l - B)) + " Z", I = {
    top: R ? "rotate(180deg)" : "",
    left: R ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: R ? "" : "rotate(180deg)",
    right: R ? "rotate(-90deg)" : "rotate(90deg)"
  }[D];
  return /* @__PURE__ */ L("svg", {
    ...g,
    "aria-hidden": !0,
    ref: a,
    width: R ? s : s + M,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [x]: K,
      [F]: z,
      [D]: S || R ? "100%" : "calc(100% - " + M / 2 + "px)",
      transform: [I, h].filter((V) => !!V).join(" "),
      ...f
    },
    children: [M > 0 && /* @__PURE__ */ _("path", {
      clipPath: "url(#" + y + ")",
      fill: "none",
      stroke: p,
      strokeWidth: M + (m ? 0 : 1),
      d: T
    }), /* @__PURE__ */ _("path", {
      stroke: M && !m ? g.fill : "none",
      d: T
    }), /* @__PURE__ */ _("clipPath", {
      id: y,
      children: /* @__PURE__ */ _("rect", {
        x: -P,
        y: P * (R ? -1 : 1),
        width: s + M,
        height: s
      })
    })]
  });
});
function Yf() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(n, a) {
      var e;
      (e = t.get(n)) == null || e.forEach((r) => r(a));
    },
    on(n, a) {
      t.has(n) || t.set(n, /* @__PURE__ */ new Set()), t.get(n).add(a);
    },
    off(n, a) {
      var e;
      (e = t.get(n)) == null || e.delete(a);
    }
  };
}
const Wf = /* @__PURE__ */ j.createContext(null), Zf = /* @__PURE__ */ j.createContext(null), Jf = () => {
  var t;
  return ((t = j.useContext(Wf)) == null ? void 0 : t.id) || null;
}, Qf = () => j.useContext(Zf);
function $f(t) {
  const {
    open: n = !1,
    onOpenChange: a,
    elements: e
  } = t, r = $s(), i = j.useRef({}), [o] = j.useState(() => Yf()), s = Jf() != null;
  if (process.env.NODE_ENV !== "production") {
    const m = e.reference;
    m && !ke(m) && Uf("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = j.useState(e.reference), u = nf((m, h, f) => {
    i.current.openEvent = m ? h : void 0, o.emit("openchange", {
      open: m,
      event: h,
      reason: f,
      nested: s
    }), a == null || a(m, h, f);
  }), d = j.useMemo(() => ({
    setPositionReference: c
  }), []), p = j.useMemo(() => ({
    reference: l || e.reference || null,
    floating: e.floating || null,
    domReference: e.reference
  }), [l, e.reference, e.floating]);
  return j.useMemo(() => ({
    dataRef: i,
    open: n,
    onOpenChange: u,
    elements: p,
    events: o,
    floatingId: r,
    refs: d
  }), [n, u, p, o, r, d]);
}
function qf(t) {
  t === void 0 && (t = {});
  const {
    nodeId: n
  } = t, a = $f({
    ...t,
    elements: {
      reference: null,
      floating: null,
      ...t.elements
    }
  }), e = t.rootContext || a, r = e.elements, [i, o] = j.useState(null), [s, l] = j.useState(null), u = (r == null ? void 0 : r.domReference) || i, d = j.useRef(null), p = Qf();
  rn(() => {
    u && (d.current = u);
  }, [u]);
  const m = Rf({
    ...t,
    elements: {
      ...r,
      ...s && {
        reference: s
      }
    }
  }), h = j.useCallback((k) => {
    const D = ke(k) ? {
      getBoundingClientRect: () => k.getBoundingClientRect(),
      getClientRects: () => k.getClientRects(),
      contextElement: k
    } : k;
    l(D), m.refs.setReference(D);
  }, [m.refs]), f = j.useCallback((k) => {
    (ke(k) || k === null) && (d.current = k, o(k)), (ke(m.refs.reference.current) || m.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    k !== null && !ke(k)) && m.refs.setReference(k);
  }, [m.refs]), g = j.useMemo(() => ({
    ...m.refs,
    setReference: f,
    setPositionReference: h,
    domReference: d
  }), [m.refs, f, h]), y = j.useMemo(() => ({
    ...m.elements,
    domReference: u
  }), [m.elements, u]), b = j.useMemo(() => ({
    ...m,
    ...e,
    refs: g,
    elements: y,
    nodeId: n
  }), [m, g, y, n, e]);
  return rn(() => {
    e.dataRef.current.floatingContext = b;
    const k = p == null ? void 0 : p.nodesRef.current.find((D) => D.id === n);
    k && (k.context = b);
  }), j.useMemo(() => ({
    ...m,
    context: b,
    refs: g,
    elements: y
  }), [m, g, y, b]);
}
/*!
  react-datepicker v9.0.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var $n = function(n, a) {
  return $n = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
  }, $n(n, a);
};
function be(t, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  $n(t, n);
  function a() {
    this.constructor = t;
  }
  t.prototype = n === null ? Object.create(n) : (a.prototype = n.prototype, new a());
}
var W = function() {
  return W = Object.assign || function(a) {
    for (var e, r = 1, i = arguments.length; r < i; r++) {
      e = arguments[r];
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && (a[o] = e[o]);
    }
    return a;
  }, W.apply(this, arguments);
};
function We(t, n, a) {
  if (a || arguments.length === 2) for (var e = 0, r = n.length, i; e < r; e++)
    (i || !(e in n)) && (i || (i = Array.prototype.slice.call(n, 0, e)), i[e] = n[e]);
  return t.concat(i || Array.prototype.slice.call(n));
}
var Xf = function(t) {
  var n = t.showTimeSelectOnly, a = n === void 0 ? !1 : n, e = t.showTime, r = e === void 0 ? !1 : e, i = t.className, o = t.children, s = t.inline, l = a ? "Choose Time" : "Choose Date".concat(r ? " and Time" : "");
  return C.createElement("div", { className: i, "aria-label": l, role: s ? void 0 : "dialog", "aria-modal": s ? void 0 : "true" }, o);
}, eg = function(t, n) {
  var a = ue(null), e = ue(t);
  de(function() {
    e.current = t;
  }, [t]);
  var r = Sa(function(i) {
    var o, s = i.composed && i.composedPath && i.composedPath().find(function(l) {
      return l instanceof Node;
    }) || i.target;
    a.current && !a.current.contains(s) && (n && s instanceof HTMLElement && s.classList.contains(n) || (o = e.current) === null || o === void 0 || o.call(e, i));
  }, [n]);
  return de(function() {
    return document.addEventListener("mousedown", r), function() {
      document.removeEventListener("mousedown", r);
    };
  }, [r]), a;
}, bn = function(t) {
  var n = t.children, a = t.onClickOutside, e = t.className, r = t.containerRef, i = t.style, o = t.ignoreClass, s = eg(a, o);
  return C.createElement("div", { className: e, style: i, ref: function(l) {
    s.current = l, r && (r.current = l);
  } }, n);
}, Tt = null, yi = !1;
function qs() {
  if (yi)
    return Tt;
  yi = !0;
  try {
    Tt = cp;
  } catch {
    Tt = null;
  }
  return Tt;
}
function bi(t, n) {
  if (!n)
    return t;
  var a = qs();
  return a ? a.toZonedTime(t, n) : (process.env.NODE_ENV !== "production" && console.warn('react-datepicker: timeZone prop requires "date-fns-tz" package. Please install it: npm install date-fns-tz'), t);
}
function qe(t, n) {
  if (!n)
    return t;
  var a = qs();
  return a ? a.fromZonedTime(t, n) : (process.env.NODE_ENV !== "production" && console.warn('react-datepicker: timeZone prop requires "date-fns-tz" package. Please install it: npm install date-fns-tz'), t);
}
var E;
(function(t) {
  t.ArrowUp = "ArrowUp", t.ArrowDown = "ArrowDown", t.ArrowLeft = "ArrowLeft", t.ArrowRight = "ArrowRight", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Home = "Home", t.End = "End", t.Enter = "Enter", t.Space = " ", t.Tab = "Tab", t.Escape = "Escape", t.Backspace = "Backspace", t.X = "x";
})(E || (E = {}));
function Xs() {
  var t = typeof window < "u" ? window : globalThis;
  return t;
}
var wt = 12;
function $(t) {
  if (t == null)
    return /* @__PURE__ */ new Date();
  var n = typeof t == "string" ? _h(t) : H(t);
  return Ne(n) ? n : /* @__PURE__ */ new Date();
}
function ga(t, n, a, e, r) {
  r === void 0 && (r = $());
  for (var i = Ja(a) || Ja(kr()), o = Array.isArray(n) ? n : [n], s = 0, l = o; s < l.length; s++) {
    var c = l[s], u = dh(t, c, r, {
      locale: i
    });
    if (Ne(u) && (!e || t === ie(u, c, a)))
      return u;
  }
  return null;
}
function ag(t, n) {
  if (n === void 0 && (n = $()), !t)
    return null;
  var a = t.match(/\b(1\d{3}|2\d{3})\b/);
  if (!a || !a[1])
    return null;
  var e = parseInt(a[1], 10), r = t.match(/(?:^|[/\-\s])?(0?[1-9]|1[0-2])(?:[/\-\s]|$)/), i = r && r[1] ? parseInt(r[1], 10) - 1 : n.getMonth();
  return new Date(e, i, 1);
}
function Ne(t) {
  return Qt(t);
}
function ie(t, n, a) {
  if (a === "en")
    return ri(t, n, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var e = a ? Ja(a) : void 0;
  return a && !e && console.warn('A locale object was not found for the provided string ["'.concat(a, '"].')), e = e || Ja(kr()), ri(t, n, {
    locale: e,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function Pe(t, n) {
  var a = n.dateFormat, e = n.locale, r = Array.isArray(a) && a.length > 0 ? a[0] : a;
  return t && ie(t, r, e) || "";
}
var el = " - ";
function tg(t, n, a) {
  if (!t && !n)
    return "";
  var e = t ? Pe(t, a) : "", r = n ? Pe(n, a) : "", i = a.rangeSeparator || el;
  return "".concat(e).concat(i).concat(r);
}
function ng(t, n) {
  if (!(t != null && t.length))
    return "";
  var a = t[0] ? Pe(t[0], n) : "";
  if (t.length === 1)
    return a;
  if (t.length === 2 && t[1]) {
    var e = Pe(t[1], n);
    return "".concat(a, ", ").concat(e);
  }
  var r = t.length - 1;
  return "".concat(a, " (+").concat(r, ")");
}
function Xe(t, n) {
  var a = n.hour, e = a === void 0 ? 0 : a, r = n.minute, i = r === void 0 ? 0 : r, o = n.second, s = o === void 0 ? 0 : o;
  return Lt(Gt(Ft(t, s), i), e);
}
function rg(t) {
  return mr(t);
}
function ig(t, n) {
  return ie(t, "ddd", n);
}
function st(t) {
  return Da(t);
}
function da(t, n, a) {
  var e = Ja(n || kr());
  return ia(t, {
    locale: e,
    weekStartsOn: a
  });
}
function ra(t) {
  return Ns(t);
}
function lt(t) {
  return mn(t);
}
function vi(t) {
  return jn(t);
}
function Si() {
  return Da($());
}
function ki(t) {
  return Ps(t);
}
function og(t) {
  return _p(t);
}
function sg(t) {
  return As(t);
}
function He(t, n) {
  return t && n ? fh(t, n) : !t && !n;
}
function Ce(t, n) {
  return t && n ? mh(t, n) : !t && !n;
}
function sn(t, n) {
  return t && n ? hh(t, n) : !t && !n;
}
function Q(t, n) {
  return t && n ? gp(t, n) : !t && !n;
}
function va(t, n) {
  return t && n ? gm(t, n) : !t && !n;
}
function ya(t, n, a) {
  var e, r = Da(n), i = Ps(a);
  try {
    e = ft(t, { start: r, end: i });
  } catch {
    e = !1;
  }
  return e;
}
function kr() {
  var t = Xs();
  return t.__localeId__;
}
function Ja(t) {
  if (typeof t == "string") {
    var n = Xs();
    return n.__localeData__ ? n.__localeData__[t] : void 0;
  } else
    return t;
}
function lg(t, n, a) {
  return n(ie(t, "EEEE", a));
}
function cg(t, n) {
  return ie(t, "EEEEEE", n);
}
function ug(t, n) {
  return ie(t, "EEE", n);
}
function Mr(t, n) {
  return ie(Ie($(), t), "LLLL", n);
}
function al(t, n) {
  return ie(Ie($(), t), "LLL", n);
}
function dg(t, n) {
  return ie(Ga($(), t), "QQQ", n);
}
function Re(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.maxDate, i = a.excludeDates, o = a.excludeDateIntervals, s = a.includeDates, l = a.includeDateIntervals, c = a.filterDate, u = a.disabled;
  return u ? !0 : Ct(t, { minDate: e, maxDate: r }) || i && i.some(function(d) {
    return d instanceof Date ? Q(t, d) : Q(t, d.date);
  }) || o && o.some(function(d) {
    var p = d.start, m = d.end;
    return ft(t, { start: p, end: m });
  }) || s && !s.some(function(d) {
    return Q(t, d);
  }) || l && !l.some(function(d) {
    var p = d.start, m = d.end;
    return ft(t, { start: p, end: m });
  }) || c && !c($(t)) || !1;
}
function wr(t, n) {
  var a = n === void 0 ? {} : n, e = a.excludeDates, r = a.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(i) {
    var o = i.start, s = i.end;
    return ft(t, { start: o, end: s });
  }) : e && e.some(function(i) {
    var o;
    return i instanceof Date ? Q(t, i) : Q(t, (o = i.date) !== null && o !== void 0 ? o : /* @__PURE__ */ new Date());
  }) || !1;
}
function tl(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.maxDate, i = a.excludeDates, o = a.includeDates, s = a.filterDate;
  return Ct(t, {
    minDate: e ? Ns(e) : void 0,
    maxDate: r ? As(r) : void 0
  }) || (i == null ? void 0 : i.some(function(l) {
    return Ce(t, l instanceof Date ? l : l.date);
  })) || o && !o.some(function(l) {
    return Ce(t, l);
  }) || s && !s($(t)) || !1;
}
function It(t, n, a, e) {
  var r = J(t), i = Te(t), o = J(n), s = Te(n), l = J(e);
  return r === o && r === l ? i <= a && a <= s : r < o ? l === r && i <= a || l === o && s >= a || l < o && l > r : !1;
}
function pg(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.maxDate, i = a.excludeDates, o = a.includeDates;
  return Ct(t, { minDate: e, maxDate: r }) || i && i.some(function(s) {
    return Ce(s instanceof Date ? s : s.date, t);
  }) || o && !o.some(function(s) {
    return Ce(s, t);
  }) || !1;
}
function xt(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.maxDate, i = a.excludeDates, o = a.includeDates, s = a.filterDate, l = a.disabled;
  return l ? !0 : Ct(t, { minDate: e, maxDate: r }) || (i == null ? void 0 : i.some(function(c) {
    return sn(t, c instanceof Date ? c : c.date);
  })) || o && !o.some(function(c) {
    return sn(t, c);
  }) || s && !s($(t)) || !1;
}
function Et(t, n, a) {
  if (!n || !a || !Qt(n) || !Qt(a))
    return !1;
  var e = J(n), r = J(a);
  return e <= t && r >= t;
}
function Ht(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.maxDate, i = a.excludeDates, o = a.includeDates, s = a.filterDate, l = a.disabled;
  if (l)
    return !0;
  var c = new Date(t, 0, 1);
  return Ct(c, {
    minDate: e ? mn(e) : void 0,
    maxDate: r ? Ts(r) : void 0
  }) || (i == null ? void 0 : i.some(function(u) {
    return He(c, u instanceof Date ? u : u.date);
  })) || o && !o.some(function(u) {
    return He(c, u);
  }) || s && !s($(c)) || !1;
}
function Bt(t, n, a, e) {
  var r = J(t), i = la(t), o = J(n), s = la(n), l = J(e);
  return r === o && r === l ? i <= a && a <= s : r < o ? l === r && i <= a || l === o && s >= a || l < o && l > r : !1;
}
function Ct(t, n) {
  var a, e = n === void 0 ? {} : n, r = e.minDate, i = e.maxDate;
  return (a = r && ja(t, r) < 0 || i && ja(t, i) > 0) !== null && a !== void 0 ? a : !1;
}
function Mi(t, n) {
  return n.some(function(a) {
    return ve(a) === ve(t) && Se(a) === Se(t) && ua(a) === ua(t);
  });
}
function wi(t, n) {
  var a = n === void 0 ? {} : n, e = a.excludeTimes, r = a.includeTimes, i = a.filterTime;
  return e && Mi(t, e) || r && !Mi(t, r) || i && !i(t) || !1;
}
function Ci(t, n) {
  var a = n.minTime, e = n.maxTime;
  if (!a || !e)
    throw new Error("Both minTime and maxTime props required");
  var r = $();
  r = Lt(r, ve(t)), r = Gt(r, Se(t)), r = Ft(r, ua(t));
  var i = $();
  i = Lt(i, ve(a)), i = Gt(i, Se(a)), i = Ft(i, ua(a));
  var o = $();
  o = Lt(o, ve(e)), o = Gt(o, Se(e)), o = Ft(o, ua(e));
  var s;
  try {
    s = !ft(r, { start: i, end: o });
  } catch {
    s = !1;
  }
  return s;
}
function Di(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.includeDates, i = ka(t, 1);
  return e && $t(e, i) > 0 || r && r.every(function(o) {
    return $t(o, i) > 0;
  }) || !1;
}
function Pi(t, n) {
  var a = n === void 0 ? {} : n, e = a.maxDate, r = a.includeDates, i = Fe(t, 1);
  return e && $t(i, e) > 0 || r && r.every(function(o) {
    return $t(i, o) > 0;
  }) || !1;
}
function mg(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.includeDates, i = mn(t), o = Gs(i);
  return e && qt(e, o) > 0 || r && r.every(function(s) {
    return qt(s, o) > 0;
  }) || !1;
}
function hg(t, n) {
  var a = n === void 0 ? {} : n, e = a.maxDate, r = a.includeDates, i = Ts(t), o = pr(i, 1);
  return e && qt(o, e) > 0 || r && r.every(function(s) {
    return qt(o, s) > 0;
  }) || !1;
}
function Ai(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.includeDates, i = Ya(t, 1);
  return e && Xt(e, i) > 0 || r && r.every(function(o) {
    return Xt(o, i) > 0;
  }) || !1;
}
function fg(t, n) {
  var a = n === void 0 ? {} : n, e = a.minDate, r = a.yearItemNumber, i = r === void 0 ? wt : r, o = lt(Ya(t, i)), s = ea(o, i).endPeriod, l = e && J(e);
  return l && l > s || !1;
}
function Ni(t, n) {
  var a = n === void 0 ? {} : n, e = a.maxDate, r = a.includeDates, i = aa(t, 1);
  return e && Xt(i, e) > 0 || r && r.every(function(o) {
    return Xt(i, o) > 0;
  }) || !1;
}
function gg(t, n) {
  var a = n === void 0 ? {} : n, e = a.maxDate, r = a.yearItemNumber, i = r === void 0 ? wt : r, o = aa(t, i), s = ea(o, i).startPeriod, l = e && J(e);
  return l && l < s || !1;
}
function nl(t) {
  var n = t.minDate, a = t.includeDates;
  if (a && n) {
    var e = a.filter(function(r) {
      return ja(r, n) >= 0;
    });
    return qr(e);
  } else return a ? qr(a) : n;
}
function rl(t) {
  var n = t.maxDate, a = t.includeDates;
  if (a && n) {
    var e = a.filter(function(r) {
      return ja(r, n) <= 0;
    });
    return $r(e);
  } else return a ? $r(a) : n;
}
function Ti(t, n) {
  var a;
  t === void 0 && (t = []), n === void 0 && (n = "react-datepicker__day--highlighted");
  for (var e = /* @__PURE__ */ new Map(), r = 0, i = t.length; r < i; r++) {
    var o = t[r];
    if (ta(o)) {
      var s = ie(o, "MM.dd.yyyy"), l = e.get(s) || [];
      l.includes(n) || (l.push(n), e.set(s, l));
    } else if (typeof o == "object") {
      var c = Object.keys(o), u = (a = c[0]) !== null && a !== void 0 ? a : "", d = o[u];
      if (typeof u == "string" && Array.isArray(d))
        for (var p = 0, m = d.length; p < m; p++) {
          var h = d[p];
          if (h) {
            var s = ie(h, "MM.dd.yyyy"), l = e.get(s) || [];
            l.includes(u) || (l.push(u), e.set(s, l));
          }
        }
    }
  }
  return e;
}
function _g(t, n) {
  return t.length !== n.length ? !1 : t.every(function(a, e) {
    return a === n[e];
  });
}
function yg(t, n) {
  t === void 0 && (t = []), n === void 0 && (n = "react-datepicker__day--holidays");
  var a = /* @__PURE__ */ new Map();
  return t.forEach(function(e) {
    var r = e.date, i = e.holidayName;
    if (ta(r)) {
      var o = ie(r, "MM.dd.yyyy"), s = a.get(o) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in s && s.className === n && _g(s.holidayNames, [i]))) {
        s.className = n;
        var l = s.holidayNames;
        s.holidayNames = l ? We(We([], l, !0), [i], !1) : [i], a.set(o, s);
      }
    }
  }), a;
}
function bg(t, n, a, e, r) {
  for (var i = r.length, o = [], s = 0; s < i; s++) {
    var l = t, c = r[s];
    c && (l = pp(l, ve(c)), l = ht(l, Se(c)), l = fp(l, ua(c)));
    var u = ht(t, (a + 1) * e);
    na(l, n) && Ye(l, u) && c != null && o.push(c);
  }
  return o;
}
function La(t) {
  return t < 10 ? "0".concat(t) : "".concat(t);
}
function ea(t, n) {
  n === void 0 && (n = wt);
  var a = Math.ceil(J(t) / n) * n, e = a - (n - 1);
  return { startPeriod: e, endPeriod: a };
}
function vg(t) {
  var n = new Date(t.getFullYear(), t.getMonth(), t.getDate()), a = new Date(t.getFullYear(), t.getMonth(), t.getDate(), 24);
  return Math.round((+a - +n) / 36e5);
}
function Ii(t) {
  var n = t.getSeconds(), a = t.getMilliseconds();
  return H(t.getTime() - n * 1e3 - a);
}
function il(t, n) {
  return Ii(t).getTime() === Ii(n).getTime();
}
function xi(t) {
  if (!ta(t))
    throw new Error("Invalid date");
  var n = new Date(t);
  return n.setHours(0, 0, 0, 0), n;
}
function En(t, n) {
  if (!ta(t) || !ta(n))
    throw new Error("Invalid date received");
  var a = xi(t), e = xi(n);
  return Ye(a, e);
}
function ol(t) {
  return t.key === E.Space;
}
var Bn = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.inputRef = C.createRef(), e.onTimeChange = function(r) {
        var i, o;
        e.setState({ time: r });
        var s = e.props.date, l = s instanceof Date && !isNaN(+s), c = l ? s : /* @__PURE__ */ new Date();
        if (r != null && r.includes(":")) {
          var u = r.split(":"), d = u[0], p = u[1];
          c.setHours(Number(d)), c.setMinutes(Number(p));
        }
        (o = (i = e.props).onChange) === null || o === void 0 || o.call(i, c);
      }, e.renderTimeInput = function() {
        var r = e.state.time, i = e.props, o = i.date, s = i.timeString, l = i.customTimeInput;
        return l ? Qi(l, {
          date: o,
          value: r,
          onChange: e.onTimeChange
        }) : C.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: e.inputRef, onClick: function() {
          var c;
          (c = e.inputRef.current) === null || c === void 0 || c.focus();
        }, required: !0, value: r, onChange: function(c) {
          e.onTimeChange(c.target.value || s);
        } });
      }, e.state = {
        time: e.props.timeString
      }, e;
    }
    return n.getDerivedStateFromProps = function(a, e) {
      return a.timeString !== e.time ? {
        time: a.timeString
      } : null;
    }, n.prototype.render = function() {
      return C.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        C.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        C.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          C.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, n;
  })(ye)
), Sg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.dayEl = pa(), a.handleClick = function(e) {
        !a.isDisabled() && a.props.onClick && a.props.onClick(e);
      }, a.handleMouseEnter = function(e) {
        !a.isDisabled() && a.props.onMouseEnter && a.props.onMouseEnter(e);
      }, a.handleOnKeyDown = function(e) {
        var r, i, o = e.key;
        o === E.Space && (e.preventDefault(), e.key = E.Enter), (i = (r = a.props).handleOnKeyDown) === null || i === void 0 || i.call(r, e);
      }, a.isSameDay = function(e) {
        return Q(a.props.day, e);
      }, a.isKeyboardSelected = function() {
        var e;
        if (a.props.disabledKeyboardNavigation)
          return !1;
        var r = a.props.selectsMultiple ? (e = a.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(o) {
          return a.isSameDayOrWeek(o);
        }) : a.isSameDayOrWeek(a.props.selected), i = a.props.preSelection && a.isDisabled(a.props.preSelection);
        return !r && a.isSameDayOrWeek(a.props.preSelection) && !i;
      }, a.isDisabled = function(e) {
        return e === void 0 && (e = a.props.day), Re(e, {
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals,
          includeDateIntervals: a.props.includeDateIntervals,
          includeDates: a.props.includeDates,
          filterDate: a.props.filterDate,
          disabled: a.props.disabled
        });
      }, a.isExcluded = function() {
        return wr(a.props.day, {
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals
        });
      }, a.isStartOfWeek = function() {
        return Q(a.props.day, da(a.props.day, a.props.locale, a.props.calendarStartDay));
      }, a.isSameWeek = function(e) {
        return a.props.showWeekPicker && Q(e, da(a.props.day, a.props.locale, a.props.calendarStartDay));
      }, a.isSameDayOrWeek = function(e) {
        return a.isSameDay(e) || a.isSameWeek(e);
      }, a.getHighLightedClass = function() {
        var e = a.props, r = e.day, i = e.highlightDates;
        if (!i)
          return !1;
        var o = ie(r, "MM.dd.yyyy");
        return i.get(o);
      }, a.getHolidaysClass = function() {
        var e, r = a.props, i = r.day, o = r.holidays;
        if (!o)
          return [void 0];
        var s = ie(i, "MM.dd.yyyy");
        return o.has(s) ? [(e = o.get(s)) === null || e === void 0 ? void 0 : e.className] : [void 0];
      }, a.isInRange = function() {
        var e = a.props, r = e.day, i = e.startDate, o = e.endDate;
        return !i || !o ? !1 : ya(r, i, o);
      }, a.isInSelectingRange = function() {
        var e, r = a.props, i = r.day, o = r.selectsStart, s = r.selectsEnd, l = r.selectsRange, c = r.selectsDisabledDaysInRange, u = r.startDate, d = r.swapRange, p = r.endDate, m = (e = a.props.selectingDate) !== null && e !== void 0 ? e : a.props.preSelection;
        if (a.isAfterMonth() || a.isBeforeMonth() || !(o || s || l) || !m || !c && a.isDisabled())
          return !1;
        if (o && p && (Ye(m, p) || va(m, p)))
          return ya(i, m, p);
        if (s && u && (na(m, u) || va(m, u)))
          return ya(i, u, m);
        if (l && u && !p) {
          if (va(m, u) || na(m, u))
            return ya(i, u, m);
          if (d && Ye(m, u))
            return ya(i, m, u);
        }
        return !1;
      }, a.isSelectingRangeStart = function() {
        var e;
        if (!a.isInSelectingRange())
          return !1;
        var r = a.props, i = r.day, o = r.startDate, s = r.selectsStart, l = r.swapRange, c = r.selectsRange, u = (e = a.props.selectingDate) !== null && e !== void 0 ? e : a.props.preSelection;
        return s ? Q(i, u) : c && l && o && u ? Q(i, Ye(u, o) ? u : o) : Q(i, o);
      }, a.isSelectingRangeEnd = function() {
        var e;
        if (!a.isInSelectingRange())
          return !1;
        var r = a.props, i = r.day, o = r.endDate, s = r.selectsEnd, l = r.selectsRange, c = r.swapRange, u = r.startDate, d = (e = a.props.selectingDate) !== null && e !== void 0 ? e : a.props.preSelection;
        return s ? Q(i, d) : l && c && u && d ? Q(i, Ye(d, u) ? u : d) : l ? Q(i, d) : Q(i, o);
      }, a.isRangeStart = function() {
        var e = a.props, r = e.day, i = e.startDate, o = e.endDate;
        return !i || !o ? !1 : Q(i, r);
      }, a.isRangeEnd = function() {
        var e = a.props, r = e.day, i = e.startDate, o = e.endDate;
        return !i || !o ? !1 : Q(o, r);
      }, a.isWeekend = function() {
        var e = pm(a.props.day);
        return e === 0 || e === 6;
      }, a.isAfterMonth = function() {
        return a.props.month !== void 0 && (a.props.month + 1) % 12 === Te(a.props.day);
      }, a.isBeforeMonth = function() {
        return a.props.month !== void 0 && (Te(a.props.day) + 1) % 12 === a.props.month;
      }, a.isCurrentDay = function() {
        return a.isSameDay($());
      }, a.isSelected = function() {
        var e;
        return a.props.selectsMultiple ? (e = a.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(r) {
          return a.isSameDayOrWeek(r);
        }) : a.isSameDayOrWeek(a.props.selected);
      }, a.getClassNames = function(e) {
        var r = a.props.dayClassName ? a.props.dayClassName(e) : void 0;
        return _e("react-datepicker__day", r, "react-datepicker__day--" + ig(a.props.day), {
          "react-datepicker__day--disabled": a.isDisabled(),
          "react-datepicker__day--excluded": a.isExcluded(),
          "react-datepicker__day--selected": a.isSelected(),
          "react-datepicker__day--keyboard-selected": a.isKeyboardSelected(),
          "react-datepicker__day--range-start": a.isRangeStart(),
          "react-datepicker__day--range-end": a.isRangeEnd(),
          "react-datepicker__day--in-range": a.isInRange(),
          "react-datepicker__day--in-selecting-range": a.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": a.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": a.isSelectingRangeEnd(),
          "react-datepicker__day--today": a.isCurrentDay(),
          "react-datepicker__day--weekend": a.isWeekend(),
          "react-datepicker__day--outside-month": a.isAfterMonth() || a.isBeforeMonth()
        }, a.getHighLightedClass(), a.getHolidaysClass());
      }, a.getAriaLabel = function() {
        var e = a.props, r = e.day, i = e.ariaLabelPrefixWhenEnabled, o = i === void 0 ? "Choose" : i, s = e.ariaLabelPrefixWhenDisabled, l = s === void 0 ? "Not available" : s, c = a.isDisabled() || a.isExcluded() ? l : o;
        return "".concat(c, " ").concat(ie(r, "PPPP", a.props.locale));
      }, a.getTitle = function() {
        var e = a.props, r = e.day, i = e.holidays, o = i === void 0 ? /* @__PURE__ */ new Map() : i, s = e.excludeDates, l = ie(r, "MM.dd.yyyy"), c = [];
        return o.has(l) && c.push.apply(c, o.get(l).holidayNames), a.isExcluded() && c.push(s == null ? void 0 : s.filter(function(u) {
          return u instanceof Date ? Q(u, r) : Q(u == null ? void 0 : u.date, r);
        }).map(function(u) {
          if (!(u instanceof Date))
            return u == null ? void 0 : u.message;
        })), c.join(", ");
      }, a.getTabIndex = function() {
        var e = a.props.selected, r = a.props.preSelection, i = !(a.props.showWeekPicker && (a.props.showWeekNumber || !a.isStartOfWeek())) && (a.isKeyboardSelected() || a.isSameDay(e) && Q(r, e)) ? 0 : -1;
        return i;
      }, a.handleFocusDay = function() {
        var e;
        a.shouldFocusDay() && ((e = a.dayEl.current) === null || e === void 0 || e.focus({ preventScroll: !0 }));
      }, a.renderDayContents = function() {
        return a.props.monthShowsDuplicateDaysEnd && a.isAfterMonth() || a.props.monthShowsDuplicateDaysStart && a.isBeforeMonth() ? null : a.props.renderDayContents ? a.props.renderDayContents(ii(a.props.day), a.props.day) : ii(a.props.day);
      }, a.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          C.createElement(
            "div",
            { ref: a.dayEl, className: a.getClassNames(a.props.day), onKeyDown: a.handleOnKeyDown, onClick: a.handleClick, onMouseEnter: a.props.usePointerEvent ? void 0 : a.handleMouseEnter, onPointerEnter: a.props.usePointerEvent ? a.handleMouseEnter : void 0, tabIndex: a.getTabIndex(), "aria-label": a.getAriaLabel(), role: "gridcell", title: a.getTitle(), "aria-disabled": a.isDisabled(), "aria-current": a.isCurrentDay() ? "date" : void 0, "aria-selected": a.isSelected() || a.isInRange() },
            a.renderDayContents(),
            a.getTitle() !== "" && C.createElement("span", { className: "overlay" }, a.getTitle())
          )
        );
      }, a;
    }
    return n.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, n.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, n.prototype.shouldFocusDay = function() {
      var a = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (a = !0), this.props.inline && !this.props.shouldFocusDayInline && (a = !1), this.isDayActiveElement() && (a = !0), this.isDuplicateDay() && (a = !1)), a;
    }, n.prototype.isDayActiveElement = function() {
      var a, e, r;
      return ((e = (a = this.props.containerRef) === null || a === void 0 ? void 0 : a.current) === null || e === void 0 ? void 0 : e.contains(document.activeElement)) && ((r = document.activeElement) === null || r === void 0 ? void 0 : r.classList.contains("react-datepicker__day"));
    }, n.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, n;
  })(ye)
), kg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.weekNumberEl = pa(), a.handleClick = function(e) {
        a.props.onClick && a.props.onClick(e);
      }, a.handleOnKeyDown = function(e) {
        var r, i, o = e.key;
        o === E.Space && (e.preventDefault(), e.key = E.Enter), (i = (r = a.props).handleOnKeyDown) === null || i === void 0 || i.call(r, e);
      }, a.isKeyboardSelected = function() {
        return !a.props.disabledKeyboardNavigation && !Q(a.props.date, a.props.selected) && Q(a.props.date, a.props.preSelection);
      }, a.getTabIndex = function() {
        return a.props.showWeekPicker && a.props.showWeekNumber && (a.isKeyboardSelected() || Q(a.props.date, a.props.selected) && Q(a.props.preSelection, a.props.selected)) ? 0 : -1;
      }, a.handleFocusWeekNumber = function(e) {
        var r = !1;
        a.getTabIndex() === 0 && !(e != null && e.isInputFocused) && Q(a.props.date, a.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (r = !0), a.props.inline && !a.props.shouldFocusDayInline && (r = !1), a.props.containerRef && a.props.containerRef.current && a.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && a.weekNumberEl.current && a.weekNumberEl.current.focus({ preventScroll: !0 });
      }, a;
    }
    return Object.defineProperty(n, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, n.prototype.componentDidUpdate = function(a) {
      this.handleFocusWeekNumber(a);
    }, n.prototype.render = function() {
      var a = this.props, e = a.weekNumber, r = a.isWeekDisabled, i = a.ariaLabelPrefix, o = i === void 0 ? n.defaultProps.ariaLabelPrefix : i, s = a.onClick, l = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!s && !r,
        "react-datepicker__week-number--selected": !!s && Q(this.props.date, this.props.selected)
      };
      return C.createElement("div", { ref: this.weekNumberEl, className: _e(l), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex(), role: "gridcell" }, e);
    }, n;
  })(ye)
), Mg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.isDisabled = function(e) {
        return Re(e, {
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals,
          includeDateIntervals: a.props.includeDateIntervals,
          includeDates: a.props.includeDates,
          filterDate: a.props.filterDate
        });
      }, a.handleDayClick = function(e, r) {
        a.props.onDayClick && a.props.onDayClick(e, r);
      }, a.handleDayMouseEnter = function(e) {
        a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
      }, a.handleWeekClick = function(e, r, i) {
        for (var o, s, l, c = new Date(e), u = 0; u < 7; u++) {
          var d = new Date(e);
          d.setDate(d.getDate() + u);
          var p = !a.isDisabled(d);
          if (p) {
            c = d;
            break;
          }
        }
        typeof a.props.onWeekSelect == "function" && a.props.onWeekSelect(c, r, i), a.props.showWeekPicker && a.handleDayClick(c, i), ((o = a.props.shouldCloseOnSelect) !== null && o !== void 0 ? o : n.defaultProps.shouldCloseOnSelect) && ((l = (s = a.props).setOpen) === null || l === void 0 || l.call(s, !1));
      }, a.formatWeekNumber = function(e) {
        return a.props.formatWeekNumber ? a.props.formatWeekNumber(e) : rg(e);
      }, a.isWeekDisabled = function() {
        for (var e = a.startOfWeek(), r = Ge(e, 6), i = new Date(e); i <= r; ) {
          if (!a.isDisabled(i))
            return !1;
          i = Ge(i, 1);
        }
        return !0;
      }, a.renderDays = function() {
        var e = a.startOfWeek(), r = [], i = a.formatWeekNumber(e);
        if (a.props.showWeekNumber) {
          var o = a.props.onWeekSelect || a.props.showWeekPicker ? a.handleWeekClick.bind(a, e, i) : void 0;
          r.push(C.createElement(kg, W({ key: "W" }, n.defaultProps, a.props, { weekNumber: i, isWeekDisabled: a.isWeekDisabled(), date: e, onClick: o })));
        }
        return r.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = Ge(e, s);
          return C.createElement(Sg, W({}, n.defaultProps, a.props, { ariaLabelPrefixWhenEnabled: a.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: a.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: a.handleDayClick.bind(a, l), onMouseEnter: a.handleDayMouseEnter.bind(a, l) }));
        }));
      }, a.startOfWeek = function() {
        return da(a.props.day, a.props.locale, a.props.calendarStartDay);
      }, a.isKeyboardSelected = function() {
        return !a.props.disabledKeyboardNavigation && !Q(a.startOfWeek(), a.props.selected) && Q(a.startOfWeek(), a.props.preSelection);
      }, a;
    }
    return Object.defineProperty(n, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.render = function() {
      var a = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": Q(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      }, e = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : void 0;
      return C.createElement("div", { className: _e(a, e), role: "row" }, this.renderDays());
    }, n;
  })(ye)
), rt, wg = 6, za = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, Rn = (rt = {}, rt[za.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, rt[za.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, rt[za.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, rt), Rt = 1;
function Ei(t, n) {
  return t ? za.FOUR_COLUMNS : n ? za.TWO_COLUMNS : za.THREE_COLUMNS;
}
var Cg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.MONTH_REFS = We([], Array(12), !0).map(function() {
        return pa();
      }), a.QUARTER_REFS = We([], Array(4), !0).map(function() {
        return pa();
      }), a.isDisabled = function(e) {
        return Re(e, {
          minDate: a.props.minDate,
          maxDate: a.props.maxDate,
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals,
          includeDateIntervals: a.props.includeDateIntervals,
          includeDates: a.props.includeDates,
          filterDate: a.props.filterDate,
          disabled: a.props.disabled
        });
      }, a.isExcluded = function(e) {
        return wr(e, {
          excludeDates: a.props.excludeDates,
          excludeDateIntervals: a.props.excludeDateIntervals
        });
      }, a.handleDayClick = function(e, r) {
        var i, o;
        (o = (i = a.props).onDayClick) === null || o === void 0 || o.call(i, e, r, a.props.orderInDisplay);
      }, a.handleDayMouseEnter = function(e) {
        var r, i;
        (i = (r = a.props).onDayMouseEnter) === null || i === void 0 || i.call(r, e);
      }, a.handleMouseLeave = function() {
        var e, r;
        (r = (e = a.props).onMouseLeave) === null || r === void 0 || r.call(e);
      }, a.isRangeStartMonth = function(e) {
        var r = a.props, i = r.day, o = r.startDate, s = r.endDate;
        return !o || !s ? !1 : Ce(Ie(i, e), o);
      }, a.isRangeStartQuarter = function(e) {
        var r = a.props, i = r.day, o = r.startDate, s = r.endDate;
        return !o || !s ? !1 : sn(Ga(i, e), o);
      }, a.isRangeEndMonth = function(e) {
        var r = a.props, i = r.day, o = r.startDate, s = r.endDate;
        return !o || !s ? !1 : Ce(Ie(i, e), s);
      }, a.isRangeEndQuarter = function(e) {
        var r = a.props, i = r.day, o = r.startDate, s = r.endDate;
        return !o || !s ? !1 : sn(Ga(i, e), s);
      }, a.isInSelectingRangeMonth = function(e) {
        var r, i = a.props, o = i.day, s = i.selectsStart, l = i.selectsEnd, c = i.selectsRange, u = i.startDate, d = i.endDate, p = (r = a.props.selectingDate) !== null && r !== void 0 ? r : a.props.preSelection;
        return !(s || l || c) || !p ? !1 : s && d ? It(p, d, e, o) : l && u || c && u && !d ? It(u, p, e, o) : !1;
      }, a.isSelectingMonthRangeStart = function(e) {
        var r;
        if (!a.isInSelectingRangeMonth(e))
          return !1;
        var i = a.props, o = i.day, s = i.startDate, l = i.selectsStart, c = Ie(o, e), u = (r = a.props.selectingDate) !== null && r !== void 0 ? r : a.props.preSelection;
        return l ? Ce(c, u) : Ce(c, s);
      }, a.isSelectingMonthRangeEnd = function(e) {
        var r;
        if (!a.isInSelectingRangeMonth(e))
          return !1;
        var i = a.props, o = i.day, s = i.endDate, l = i.selectsEnd, c = i.selectsRange, u = Ie(o, e), d = (r = a.props.selectingDate) !== null && r !== void 0 ? r : a.props.preSelection;
        return l || c ? Ce(u, d) : Ce(u, s);
      }, a.isInSelectingRangeQuarter = function(e) {
        var r, i = a.props, o = i.day, s = i.selectsStart, l = i.selectsEnd, c = i.selectsRange, u = i.startDate, d = i.endDate, p = (r = a.props.selectingDate) !== null && r !== void 0 ? r : a.props.preSelection;
        return !(s || l || c) || !p ? !1 : s && d ? Bt(p, d, e, o) : l && u || c && u && !d ? Bt(u, p, e, o) : !1;
      }, a.isWeekInMonth = function(e) {
        var r = a.props.day, i = Ge(e, 6);
        return Ce(e, r) || Ce(i, r);
      }, a.isCurrentMonth = function(e, r) {
        return J(e) === J($()) && r === Te($());
      }, a.isCurrentQuarter = function(e, r) {
        return J(e) === J($()) && r === la($());
      }, a.isSelectedMonth = function(e, r, i) {
        return Te(i) === r && J(e) === J(i);
      }, a.isSelectMonthInList = function(e, r, i) {
        return i.some(function(o) {
          return a.isSelectedMonth(e, r, o);
        });
      }, a.isSelectedQuarter = function(e, r, i) {
        return la(i) === r && J(e) === J(i);
      }, a.isSelectQuarterInList = function(e, r, i) {
        return i.some(function(o) {
          return a.isSelectedQuarter(e, r, o);
        });
      }, a.isMonthSelected = function() {
        var e = a.props, r = e.day, i = e.selected, o = e.selectedDates, s = e.selectsMultiple, l = Te(r);
        return s ? o == null ? void 0 : o.some(function(c) {
          return a.isSelectedMonth(r, l, c);
        }) : !!i && a.isSelectedMonth(r, l, i);
      }, a.isQuarterSelected = function() {
        var e = a.props, r = e.day, i = e.selected, o = e.selectedDates, s = e.selectsMultiple, l = la(r);
        return s ? o == null ? void 0 : o.some(function(c) {
          return a.isSelectedQuarter(r, l, c);
        }) : !!i && a.isSelectedQuarter(r, l, i);
      }, a.renderWeeks = function() {
        if (!Ne(a.props.day))
          return [];
        for (var e = [], r = a.props.fixedHeight, i = 0, o = !1, s = da(ra(a.props.day), a.props.locale, a.props.calendarStartDay), l = function(h) {
          return a.props.showWeekPicker ? da(h, a.props.locale, a.props.calendarStartDay) : a.props.preSelection;
        }, c = function(h) {
          return a.props.showWeekPicker ? da(h, a.props.locale, a.props.calendarStartDay) : a.props.selected;
        }, u = a.props.selected ? c(a.props.selected) : void 0, d = a.props.preSelection ? l(a.props.preSelection) : void 0; e.push(C.createElement(Mg, W({}, a.props, { ariaLabelPrefix: a.props.weekAriaLabelPrefix, key: i, day: s, month: Te(a.props.day), onDayClick: a.handleDayClick, onDayMouseEnter: a.handleDayMouseEnter, selected: u, preSelection: d, showWeekNumber: a.props.showWeekNumbers }))), !o; ) {
          i++, s = Jt(s, 1);
          var p = r && i >= wg, m = !r && !a.isWeekInMonth(s);
          if (p || m)
            if (a.props.peekNextMonth)
              o = !0;
            else
              break;
        }
        return e;
      }, a.onMonthClick = function(e, r) {
        var i = a.isMonthDisabledForLabelDate(r), o = i.isDisabled, s = i.labelDate;
        o || a.handleDayClick(ra(s), e);
      }, a.onMonthMouseEnter = function(e) {
        var r = a.isMonthDisabledForLabelDate(e), i = r.isDisabled, o = r.labelDate;
        i || a.handleDayMouseEnter(ra(o));
      }, a.handleMonthNavigation = function(e, r) {
        var i, o, s, l;
        (o = (i = a.props).setPreSelection) === null || o === void 0 || o.call(i, r), (l = (s = a.MONTH_REFS[e]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus();
      }, a.handleKeyboardNavigation = function(e, r, i) {
        var o, s = a.props, l = s.selected, c = s.preSelection, u = s.setPreSelection, d = s.minDate, p = s.maxDate, m = s.showFourColumnMonthYearPicker, h = s.showTwoColumnMonthYearPicker;
        if (c) {
          var f = Ei(m, h), g = a.getVerticalOffset(f), y = (o = Rn[f]) === null || o === void 0 ? void 0 : o.grid, b = function(w, M, P) {
            var N, B, R = M, F = P;
            switch (w) {
              case E.ArrowRight:
                R = Fe(M, Rt), F = P === 11 ? 0 : P + Rt;
                break;
              case E.ArrowLeft:
                R = ka(M, Rt), F = P === 0 ? 11 : P - Rt;
                break;
              case E.ArrowUp:
                R = ka(M, g), F = !((N = y == null ? void 0 : y[0]) === null || N === void 0) && N.includes(P) ? P + 12 - g : P - g;
                break;
              case E.ArrowDown:
                R = Fe(M, g), F = !((B = y == null ? void 0 : y[y.length - 1]) === null || B === void 0) && B.includes(P) ? P - 12 + g : P + g;
                break;
            }
            return { newCalculatedDate: R, newCalculatedMonth: F };
          }, k = function(w, M, P) {
            for (var N = 40, B = w, R = !1, F = 0, x = b(B, M, P), K = x.newCalculatedDate, z = x.newCalculatedMonth; !R; ) {
              if (F >= N) {
                K = M, z = P;
                break;
              }
              if (d && K < d) {
                B = E.ArrowRight;
                var T = b(B, K, z);
                K = T.newCalculatedDate, z = T.newCalculatedMonth;
              }
              if (p && K > p) {
                B = E.ArrowLeft;
                var T = b(B, K, z);
                K = T.newCalculatedDate, z = T.newCalculatedMonth;
              }
              if (pg(K, a.props)) {
                var T = b(B, K, z);
                K = T.newCalculatedDate, z = T.newCalculatedMonth;
              } else
                R = !0;
              F++;
            }
            return { newCalculatedDate: K, newCalculatedMonth: z };
          };
          if (r === E.Enter) {
            a.isMonthDisabled(i) || (a.onMonthClick(e, i), u == null || u(l));
            return;
          }
          var D = k(r, c, i), v = D.newCalculatedDate, S = D.newCalculatedMonth;
          switch (r) {
            case E.ArrowRight:
            case E.ArrowLeft:
            case E.ArrowUp:
            case E.ArrowDown:
              a.handleMonthNavigation(S, v);
              break;
          }
        }
      }, a.getVerticalOffset = function(e) {
        var r, i;
        return (i = (r = Rn[e]) === null || r === void 0 ? void 0 : r.verticalNavigationOffset) !== null && i !== void 0 ? i : 0;
      }, a.onMonthKeyDown = function(e, r) {
        var i = a.props, o = i.disabledKeyboardNavigation, s = i.handleOnMonthKeyDown, l = e.key;
        l !== E.Tab && e.preventDefault(), o || a.handleKeyboardNavigation(e, l, r), s && s(e);
      }, a.onQuarterClick = function(e, r) {
        var i = Ga(a.props.day, r);
        xt(i, a.props) || a.handleDayClick(vi(i), e);
      }, a.onQuarterMouseEnter = function(e) {
        var r = Ga(a.props.day, e);
        xt(r, a.props) || a.handleDayMouseEnter(vi(r));
      }, a.handleQuarterNavigation = function(e, r) {
        var i, o, s, l;
        a.isDisabled(r) || a.isExcluded(r) || ((o = (i = a.props).setPreSelection) === null || o === void 0 || o.call(i, r), (l = (s = a.QUARTER_REFS[e - 1]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus());
      }, a.onQuarterKeyDown = function(e, r) {
        var i, o, s = e.key;
        if (!a.props.disabledKeyboardNavigation)
          switch (s) {
            case E.Enter:
              a.onQuarterClick(e, r), (o = (i = a.props).setPreSelection) === null || o === void 0 || o.call(i, a.props.selected);
              break;
            case E.ArrowRight:
              if (!a.props.preSelection)
                break;
              a.handleQuarterNavigation(r === 4 ? 1 : r + 1, pr(a.props.preSelection, 1));
              break;
            case E.ArrowLeft:
              if (!a.props.preSelection)
                break;
              a.handleQuarterNavigation(r === 1 ? 4 : r - 1, Gs(a.props.preSelection));
              break;
          }
      }, a.isMonthDisabledForLabelDate = function(e) {
        var r, i = a.props, o = i.day, s = i.disabled, l = i.minDate, c = i.maxDate, u = i.excludeDates, d = i.includeDates, p = Ie(o, e);
        return s ? {
          isDisabled: !0,
          labelDate: Ie(o, e)
        } : {
          isDisabled: (r = (l || c || u || d) && tl(p, a.props)) !== null && r !== void 0 ? r : !1,
          labelDate: p
        };
      }, a.isMonthDisabled = function(e) {
        var r = a.isMonthDisabledForLabelDate(e).isDisabled;
        return r;
      }, a.getMonthClassNames = function(e) {
        var r = a.props, i = r.day, o = r.startDate, s = r.endDate, l = r.preSelection, c = r.monthClassName, u = c ? c(Ie(i, e)) : void 0, d = a.getSelection();
        return _e("react-datepicker__month-text", "react-datepicker__month-".concat(e), u, {
          "react-datepicker__month-text--disabled": a.isMonthDisabled(e),
          "react-datepicker__month-text--selected": d ? a.isSelectMonthInList(i, e, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !a.props.disabledKeyboardNavigation && l && a.isSelectedMonth(i, e, l) && !a.isMonthSelected() && !a.isMonthDisabled(e),
          "react-datepicker__month-text--in-selecting-range": a.isInSelectingRangeMonth(e),
          "react-datepicker__month-text--in-range": o && s ? It(o, s, e, i) : void 0,
          "react-datepicker__month-text--range-start": a.isRangeStartMonth(e),
          "react-datepicker__month-text--range-end": a.isRangeEndMonth(e),
          "react-datepicker__month-text--selecting-range-start": a.isSelectingMonthRangeStart(e),
          "react-datepicker__month-text--selecting-range-end": a.isSelectingMonthRangeEnd(e),
          "react-datepicker__month-text--today": a.isCurrentMonth(i, e)
        });
      }, a.getTabIndex = function(e) {
        if (a.props.preSelection == null)
          return "-1";
        var r = Te(a.props.preSelection), i = a.isMonthDisabledForLabelDate(r).isDisabled, o = e === r && !(i || a.props.disabledKeyboardNavigation) ? "0" : "-1";
        return o;
      }, a.getQuarterTabIndex = function(e) {
        if (a.props.preSelection == null)
          return "-1";
        var r = la(a.props.preSelection), i = xt(a.props.day, a.props), o = e === r && !(i || a.props.disabledKeyboardNavigation) ? "0" : "-1";
        return o;
      }, a.getAriaLabel = function(e) {
        var r = a.props, i = r.chooseDayAriaLabelPrefix, o = i === void 0 ? "Choose" : i, s = r.disabledDayAriaLabelPrefix, l = s === void 0 ? "Not available" : s, c = r.day, u = r.locale, d = Ie(c, e), p = a.isDisabled(d) || a.isExcluded(d) ? l : o;
        return "".concat(p, " ").concat(ie(d, "MMMM yyyy", u));
      }, a.getQuarterClassNames = function(e) {
        var r = a.props, i = r.day, o = r.startDate, s = r.endDate, l = r.minDate, c = r.maxDate, u = r.excludeDates, d = r.includeDates, p = r.filterDate, m = r.preSelection, h = r.disabledKeyboardNavigation, f = r.disabled, g = (l || c || u || d || p || f) && xt(Ga(i, e), a.props), y = a.getSelection();
        return _e("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
          "react-datepicker__quarter-text--disabled": g,
          "react-datepicker__quarter-text--selected": y ? a.isSelectQuarterInList(i, e, y) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !h && m && a.isSelectedQuarter(i, e, m) && !a.isQuarterSelected() && !g,
          "react-datepicker__quarter-text--in-selecting-range": a.isInSelectingRangeQuarter(e),
          "react-datepicker__quarter-text--in-range": o && s ? Bt(o, s, e, i) : void 0,
          "react-datepicker__quarter-text--range-start": a.isRangeStartQuarter(e),
          "react-datepicker__quarter-text--range-end": a.isRangeEndQuarter(e),
          "react-datepicker__quarter-text--today": a.isCurrentQuarter(i, e)
        });
      }, a.getMonthContent = function(e) {
        var r = a.props, i = r.showFullMonthYearPicker, o = r.renderMonthContent, s = r.locale, l = r.day, c = al(e, s), u = Mr(e, s);
        return o ? o(e, c, u, l) : i ? u : c;
      }, a.getQuarterContent = function(e) {
        var r, i = a.props, o = i.renderQuarterContent, s = i.locale, l = dg(e, s);
        return (r = o == null ? void 0 : o(e, l)) !== null && r !== void 0 ? r : l;
      }, a.renderMonths = function() {
        var e, r = a.props, i = r.showTwoColumnMonthYearPicker, o = r.showFourColumnMonthYearPicker, s = r.day, l = r.selected, c = (e = Rn[Ei(o, i)]) === null || e === void 0 ? void 0 : e.grid;
        return c == null ? void 0 : c.map(function(u, d) {
          return C.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, u.map(function(p, m) {
            return C.createElement("div", { ref: a.MONTH_REFS[p], key: m, onClick: function(h) {
              a.onMonthClick(h, p);
            }, onKeyDown: function(h) {
              ol(h) && (h.preventDefault(), h.key = E.Enter), a.onMonthKeyDown(h, p);
            }, onMouseEnter: a.props.usePointerEvent ? void 0 : function() {
              return a.onMonthMouseEnter(p);
            }, onPointerEnter: a.props.usePointerEvent ? function() {
              return a.onMonthMouseEnter(p);
            } : void 0, tabIndex: Number(a.getTabIndex(p)), className: a.getMonthClassNames(p), "aria-disabled": a.isMonthDisabled(p), role: "option", "aria-label": a.getAriaLabel(p), "aria-current": a.isCurrentMonth(s, p) ? "date" : void 0, "aria-selected": l ? a.isSelectedMonth(s, p, l) : void 0 }, a.getMonthContent(p));
          }));
        });
      }, a.renderQuarters = function() {
        var e = a.props, r = e.day, i = e.selected, o = [1, 2, 3, 4];
        return C.createElement("div", { className: "react-datepicker__quarter-wrapper" }, o.map(function(s, l) {
          return C.createElement("div", { key: l, ref: a.QUARTER_REFS[l], role: "option", onClick: function(c) {
            a.onQuarterClick(c, s);
          }, onKeyDown: function(c) {
            a.onQuarterKeyDown(c, s);
          }, onMouseEnter: a.props.usePointerEvent ? void 0 : function() {
            return a.onQuarterMouseEnter(s);
          }, onPointerEnter: a.props.usePointerEvent ? function() {
            return a.onQuarterMouseEnter(s);
          } : void 0, className: a.getQuarterClassNames(s), "aria-selected": i ? a.isSelectedQuarter(r, s, i) : void 0, tabIndex: Number(a.getQuarterTabIndex(s)), "aria-current": a.isCurrentQuarter(r, s) ? "date" : void 0 }, a.getQuarterContent(s));
        }));
      }, a.getClassNames = function() {
        var e = a.props, r = e.selectingDate, i = e.selectsStart, o = e.selectsEnd, s = e.showMonthYearPicker, l = e.showQuarterYearPicker, c = e.showWeekPicker;
        return _e("react-datepicker__month", {
          "react-datepicker__month--selecting-range": r && (i || o)
        }, { "react-datepicker__monthPicker": s }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": c });
      }, a;
    }
    return n.prototype.getSelection = function() {
      var a = this.props, e = a.selected, r = a.selectedDates, i = a.selectsMultiple;
      if (i)
        return r;
      if (e)
        return [e];
    }, n.prototype.render = function() {
      var a = this.props, e = a.showMonthYearPicker, r = a.showQuarterYearPicker, i = a.day, o = a.ariaLabelPrefix, s = o === void 0 ? "Month " : o, l = s ? s.trim() + " " : "", c = Ne(i) ? "".concat(l).concat(ie(i, "MMMM, yyyy", this.props.locale)) : "", u = e || r;
      return u ? C.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": c, role: "listbox" }, e ? this.renderMonths() : this.renderQuarters()) : C.createElement(
        "div",
        { role: "table" },
        this.props.dayNamesHeader && C.createElement("div", { role: "rowgroup" }, this.props.dayNamesHeader),
        this.props.monthHeader && C.createElement("div", { role: "rowgroup" }, this.props.monthHeader),
        C.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": c, role: "rowgroup" }, this.renderWeeks()),
        this.props.monthFooter && C.createElement("div", { role: "rowgroup" }, this.props.monthFooter)
      );
    }, n;
  })(ye)
), Dg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.monthOptionButtonsRef = {}, a.isSelectedMonth = function(e) {
        return a.props.month === e;
      }, a.handleOptionKeyDown = function(e, r) {
        var i;
        switch (r.key) {
          case "Enter":
            r.preventDefault(), a.onChange(e);
            break;
          case "Escape":
            r.preventDefault(), a.props.onCancel();
            break;
          case "ArrowUp":
          case "ArrowDown": {
            r.preventDefault();
            var o = (e + (r.key === "ArrowUp" ? -1 : 1) + a.props.monthNames.length) % a.props.monthNames.length;
            (i = a.monthOptionButtonsRef[o]) === null || i === void 0 || i.focus();
            break;
          }
        }
      }, a.renderOptions = function() {
        return a.monthOptionButtonsRef = {}, a.props.monthNames.map(function(e, r) {
          return C.createElement(
            "div",
            { ref: function(i) {
              a.monthOptionButtonsRef[r] = i, a.isSelectedMonth(r) && (i == null || i.focus());
            }, role: "button", tabIndex: 0, className: a.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: e, onClick: a.onChange.bind(a, r), onKeyDown: a.handleOptionKeyDown.bind(a, r), "aria-selected": a.isSelectedMonth(r) ? "true" : void 0 },
            a.isSelectedMonth(r) ? C.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            e
          );
        });
      }, a.onChange = function(e) {
        return a.props.onChange(e);
      }, a.handleClickOutside = function() {
        return a.props.onCancel();
      }, a;
    }
    return n.prototype.render = function() {
      return C.createElement(bn, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, n;
  })(ye)
), Pg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.state = {
        dropdownVisible: !1
      }, a.renderSelectOptions = function(e) {
        return e.map(function(r, i) {
          return C.createElement("option", { key: r, value: i }, r);
        });
      }, a.renderSelectMode = function(e) {
        return C.createElement("select", { value: a.props.month, className: "react-datepicker__month-select", onChange: function(r) {
          return a.onChange(parseInt(r.target.value));
        } }, a.renderSelectOptions(e));
      }, a.renderReadView = function(e, r) {
        return C.createElement(
          "button",
          { key: "read", type: "button", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: a.toggleDropdown },
          C.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          C.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, r[a.props.month])
        );
      }, a.renderDropdown = function(e) {
        return C.createElement(Dg, W({ key: "dropdown" }, a.props, { monthNames: e, onChange: a.onChange, onCancel: a.toggleDropdown }));
      }, a.renderScrollMode = function(e) {
        var r = a.state.dropdownVisible, i = [a.renderReadView(!r, e)];
        return r && i.unshift(a.renderDropdown(e)), i;
      }, a.onChange = function(e) {
        a.toggleDropdown(), e !== a.props.month && a.props.onChange(e);
      }, a.toggleDropdown = function() {
        return a.setState({
          dropdownVisible: !a.state.dropdownVisible
        });
      }, a;
    }
    return n.prototype.render = function() {
      var a = this, e = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(i) {
        return al(i, a.props.locale);
      } : function(i) {
        return Mr(i, a.props.locale);
      }), r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode(e);
          break;
        case "select":
          r = this.renderSelectMode(e);
          break;
      }
      return C.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
    }, n;
  })(ye)
);
function Ag(t, n) {
  for (var a = [], e = ra(t), r = ra(n); !na(e, r); )
    a.push($(e)), e = Fe(e, 1);
  return a;
}
var Ng = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.renderOptions = function() {
        return e.state.monthYearsList.map(function(r) {
          var i = Wn(r), o = He(e.props.date, r) && Ce(e.props.date, r);
          return C.createElement(
            "div",
            { className: o ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: i, onClick: e.onChange.bind(e, i), "aria-selected": o ? "true" : void 0 },
            o ? C.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            ie(r, e.props.dateFormat, e.props.locale)
          );
        });
      }, e.onChange = function(r) {
        return e.props.onChange(r);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.state = {
        monthYearsList: Ag(e.props.minDate, e.props.maxDate)
      }, e;
    }
    return n.prototype.render = function() {
      var a = _e({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return C.createElement(bn, { className: a, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, n;
  })(ye)
), Tg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.state = {
        dropdownVisible: !1
      }, a.renderSelectOptions = function() {
        for (var e = ra(a.props.minDate), r = ra(a.props.maxDate), i = []; !na(e, r); ) {
          var o = Wn(e);
          i.push(C.createElement("option", { key: o, value: o }, ie(e, a.props.dateFormat, a.props.locale))), e = Fe(e, 1);
        }
        return i;
      }, a.onSelectChange = function(e) {
        a.onChange(parseInt(e.target.value));
      }, a.renderSelectMode = function() {
        return C.createElement("select", { value: Wn(ra(a.props.date)), className: "react-datepicker__month-year-select", onChange: a.onSelectChange }, a.renderSelectOptions());
      }, a.renderReadView = function(e) {
        var r = ie(a.props.date, a.props.dateFormat, a.props.locale);
        return C.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: a.toggleDropdown },
          C.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          C.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, r)
        );
      }, a.renderDropdown = function() {
        return C.createElement(Ng, W({ key: "dropdown" }, a.props, { onChange: a.onChange, onCancel: a.toggleDropdown }));
      }, a.renderScrollMode = function() {
        var e = a.state.dropdownVisible, r = [a.renderReadView(!e)];
        return e && r.unshift(a.renderDropdown()), r;
      }, a.onChange = function(e) {
        a.toggleDropdown();
        var r = $(e);
        He(a.props.date, r) && Ce(a.props.date, r) || a.props.onChange(r);
      }, a.toggleDropdown = function() {
        return a.setState({
          dropdownVisible: !a.state.dropdownVisible
        });
      }, a;
    }
    return n.prototype.render = function() {
      var a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode();
          break;
        case "select":
          a = this.renderSelectMode();
          break;
      }
      return C.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, a);
    }, n;
  })(ye)
), Ig = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.state = {
        height: null
      }, a.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var e, r, i;
          a.list && (a.list.scrollTop = (i = a.centerLi && n.calcCenterPosition(a.props.monthRef ? a.props.monthRef.clientHeight - ((r = (e = a.header) === null || e === void 0 ? void 0 : e.clientHeight) !== null && r !== void 0 ? r : 0) : a.list.clientHeight, a.centerLi)) !== null && i !== void 0 ? i : 0);
        });
      }, a.handleClick = function(e) {
        var r, i;
        (a.props.minTime || a.props.maxTime) && Ci(e, a.props) || (a.props.excludeTimes || a.props.includeTimes || a.props.filterTime) && wi(e, a.props) || (i = (r = a.props).onChange) === null || i === void 0 || i.call(r, e);
      }, a.isSelectedTime = function(e) {
        return a.props.selected && il(a.props.selected, e);
      }, a.isDisabledTime = function(e) {
        return (a.props.minTime || a.props.maxTime) && Ci(e, a.props) || (a.props.excludeTimes || a.props.includeTimes || a.props.filterTime) && wi(e, a.props);
      }, a.liClasses = function(e) {
        var r, i = [
          "react-datepicker__time-list-item",
          a.props.timeClassName ? a.props.timeClassName(e) : void 0
        ];
        return a.isSelectedTime(e) && i.push("react-datepicker__time-list-item--selected"), a.isDisabledTime(e) && i.push("react-datepicker__time-list-item--disabled"), a.props.injectTimes && (ve(e) * 3600 + Se(e) * 60 + ua(e)) % (((r = a.props.intervals) !== null && r !== void 0 ? r : n.defaultProps.intervals) * 60) !== 0 && i.push("react-datepicker__time-list-item--injected"), i.join(" ");
      }, a.handleOnKeyDown = function(e, r) {
        var i, o;
        e.key === E.Space && (e.preventDefault(), e.key = E.Enter), (e.key === E.ArrowUp || e.key === E.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === E.ArrowDown || e.key === E.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === E.Enter && a.handleClick(r), (o = (i = a.props).handleOnKeyDown) === null || o === void 0 || o.call(i, e);
      }, a.renderTimes = function() {
        for (var e, r = [], i = typeof a.props.format == "string" ? a.props.format : "p", o = (e = a.props.intervals) !== null && e !== void 0 ? e : n.defaultProps.intervals, s = a.props.selected || a.props.openToDate || $(), l = st(s), c = a.props.injectTimes && a.props.injectTimes.sort(function(g, y) {
          return g.getTime() - y.getTime();
        }), u = 60 * vg(s), d = u / o, p = 0; p < d; p++) {
          var m = ht(l, p * o);
          if (r.push(m), c) {
            var h = bg(l, m, p, o, c);
            r = r.concat(h);
          }
        }
        var f = r.reduce(function(g, y) {
          return y.getTime() <= s.getTime() ? y : g;
        }, r[0]);
        return r.map(function(g) {
          return C.createElement("li", { key: g.valueOf(), onClick: a.handleClick.bind(a, g), className: a.liClasses(g), ref: function(y) {
            g === f && (a.centerLi = y);
          }, onKeyDown: function(y) {
            a.handleOnKeyDown(y, g);
          }, tabIndex: g === f ? 0 : -1, role: "option", "aria-selected": a.isSelectedTime(g) ? "true" : void 0, "aria-disabled": a.isDisabledTime(g) ? "true" : void 0 }, ie(g, i, a.props.locale));
        });
      }, a.renderTimeCaption = function() {
        return a.props.showTimeCaption === !1 ? C.createElement(C.Fragment, null) : C.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(a.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(e) {
            a.header = e;
          } },
          C.createElement("div", { className: "react-datepicker-time__header" }, a.props.timeCaption)
        );
      }, a;
    }
    return Object.defineProperty(n, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.observeDatePickerHeightChanges();
    }, n.prototype.componentWillUnmount = function() {
      var a;
      (a = this.resizeObserver) === null || a === void 0 || a.disconnect();
    }, n.prototype.observeDatePickerHeightChanges = function() {
      var a = this, e = this.props.monthRef;
      this.updateContainerHeight(), e && (this.resizeObserver = new ResizeObserver(function() {
        a.updateContainerHeight();
      }), this.resizeObserver.observe(e));
    }, n.prototype.updateContainerHeight = function() {
      if (this.props.monthRef && this.header) {
        var a = this.props.monthRef.clientHeight - this.header.clientHeight;
        this.state.height !== a && this.setState({
          height: a
        });
      }
    }, n.prototype.render = function() {
      var a = this, e, r = this.state.height;
      return C.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((e = this.props.todayButton) !== null && e !== void 0 ? e : n.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        C.createElement(
          "div",
          { className: "react-datepicker__time" },
          C.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            C.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
              a.list = i;
            }, style: r ? { height: r } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, n.calcCenterPosition = function(a, e) {
      return e.offsetTop - (a / 2 - e.clientHeight / 2);
    }, n;
  })(ye)
), Bi = 3, xg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.YEAR_REFS = We([], Array(e.props.yearItemNumber), !0).map(function() {
        return pa();
      }), e.isDisabled = function(r) {
        return Re(r, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function(r) {
        return wr(r, {
          excludeDates: e.props.excludeDates
        });
      }, e.selectingDate = function() {
        var r;
        return (r = e.props.selectingDate) !== null && r !== void 0 ? r : e.props.preSelection;
      }, e.updateFocusOnPaginate = function(r) {
        var i = function() {
          var o, s;
          (s = (o = e.YEAR_REFS[r]) === null || o === void 0 ? void 0 : o.current) === null || s === void 0 || s.focus();
        };
        window.requestAnimationFrame(i);
      }, e.handleYearClick = function(r, i) {
        e.props.onDayClick && e.props.onDayClick(r, i);
      }, e.handleYearNavigation = function(r, i) {
        var o, s, l, c, u = e.props, d = u.date, p = u.yearItemNumber;
        if (!(d === void 0 || p === void 0)) {
          var m = ea(d, p).startPeriod;
          e.isDisabled(i) || e.isExcluded(i) || ((s = (o = e.props).setPreSelection) === null || s === void 0 || s.call(o, i), r - m < 0 ? e.updateFocusOnPaginate(p - (m - r)) : r - m >= p ? e.updateFocusOnPaginate(Math.abs(p - (r - m))) : (c = (l = e.YEAR_REFS[r - m]) === null || l === void 0 ? void 0 : l.current) === null || c === void 0 || c.focus());
        }
      }, e.isSameDay = function(r, i) {
        return Q(r, i);
      }, e.isCurrentYear = function(r) {
        return r === J($());
      }, e.isRangeStart = function(r) {
        return e.props.startDate && e.props.endDate && He(Ke($(), r), e.props.startDate);
      }, e.isRangeEnd = function(r) {
        return e.props.startDate && e.props.endDate && He(Ke($(), r), e.props.endDate);
      }, e.isInRange = function(r) {
        return Et(r, e.props.startDate, e.props.endDate);
      }, e.isInSelectingRange = function(r) {
        var i = e.props, o = i.selectsStart, s = i.selectsEnd, l = i.selectsRange, c = i.startDate, u = i.endDate;
        return !(o || s || l) || !e.selectingDate() ? !1 : o && u ? Et(r, e.selectingDate(), u) : s && c || l && c && !u ? Et(r, c, e.selectingDate()) : !1;
      }, e.isSelectingRangeStart = function(r) {
        var i;
        if (!e.isInSelectingRange(r))
          return !1;
        var o = e.props, s = o.startDate, l = o.selectsStart, c = Ke($(), r);
        return l ? He(c, (i = e.selectingDate()) !== null && i !== void 0 ? i : null) : He(c, s ?? null);
      }, e.isSelectingRangeEnd = function(r) {
        var i;
        if (!e.isInSelectingRange(r))
          return !1;
        var o = e.props, s = o.endDate, l = o.selectsEnd, c = o.selectsRange, u = Ke($(), r);
        return l || c ? He(u, (i = e.selectingDate()) !== null && i !== void 0 ? i : null) : He(u, s ?? null);
      }, e.isKeyboardSelected = function(r) {
        if (!(e.props.disabledKeyboardNavigation || e.props.date === void 0 || e.props.preSelection == null)) {
          var i = e.props, o = i.minDate, s = i.maxDate, l = i.excludeDates, c = i.includeDates, u = i.filterDate, d = i.selected, p = lt(Ke(e.props.date, r)), m = (o || s || l || c || u) && Ht(r, e.props), h = !!d && Q(p, lt(d)), f = Q(p, lt(e.props.preSelection));
          return !e.props.inline && !h && f && !m;
        }
      }, e.isSelectedYear = function(r) {
        var i = e.props, o = i.selectsMultiple, s = i.selected, l = i.selectedDates;
        return o ? l == null ? void 0 : l.some(function(c) {
          return r === J(c);
        }) : !!s && r === J(s);
      }, e.onYearClick = function(r, i) {
        var o = e.props.date;
        o !== void 0 && e.handleYearClick(lt(Ke(o, i)), r);
      }, e.onYearKeyDown = function(r, i) {
        var o, s, l = r.key, c = e.props, u = c.date, d = c.yearItemNumber, p = c.handleOnKeyDown;
        if (l !== E.Tab && r.preventDefault(), !e.props.disabledKeyboardNavigation)
          switch (l) {
            case E.Enter:
              if (e.props.selected == null)
                break;
              e.onYearClick(r, i), (s = (o = e.props).setPreSelection) === null || s === void 0 || s.call(o, e.props.selected);
              break;
            case E.ArrowRight:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(i + 1, aa(e.props.preSelection, 1));
              break;
            case E.ArrowLeft:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(i - 1, Ya(e.props.preSelection, 1));
              break;
            case E.ArrowUp: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var m = ea(u, d).startPeriod, h = Bi, f = i - h;
              if (f < m) {
                var g = d % h;
                i >= m && i < m + g ? h = g : h += g, f = i - h;
              }
              e.handleYearNavigation(f, Ya(e.props.preSelection, h));
              break;
            }
            case E.ArrowDown: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var y = ea(u, d).endPeriod, h = Bi, f = i + h;
              if (f > y) {
                var g = d % h;
                i <= y && i > y - g ? h = g : h += g, f = i + h;
              }
              e.handleYearNavigation(f, aa(e.props.preSelection, h));
              break;
            }
          }
        p && p(r);
      }, e.getYearClassNames = function(r) {
        var i = e.props, o = i.date, s = i.disabled, l = i.minDate, c = i.maxDate, u = i.excludeDates, d = i.includeDates, p = i.filterDate, m = i.yearClassName;
        return _e("react-datepicker__year-text", "react-datepicker__year-".concat(r), o ? m == null ? void 0 : m(Ke(o, r)) : void 0, {
          "react-datepicker__year-text--selected": e.isSelectedYear(r),
          "react-datepicker__year-text--disabled": (l || c || u || d || p || s) && Ht(r, e.props),
          "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(r),
          "react-datepicker__year-text--range-start": e.isRangeStart(r),
          "react-datepicker__year-text--range-end": e.isRangeEnd(r),
          "react-datepicker__year-text--in-range": e.isInRange(r),
          "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(r),
          "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(r),
          "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(r),
          "react-datepicker__year-text--today": e.isCurrentYear(r)
        });
      }, e.getYearTabIndex = function(r) {
        if (e.props.disabledKeyboardNavigation || e.props.preSelection == null)
          return "-1";
        var i = J(e.props.preSelection), o = Ht(r, e.props);
        return r === i && !o ? "0" : "-1";
      }, e.getYearContent = function(r) {
        return e.props.renderYearContent ? e.props.renderYearContent(r) : r;
      }, e;
    }
    return n.prototype.render = function() {
      var a = this, e = [], r = this.props, i = r.date, o = r.yearItemNumber, s = r.onYearMouseEnter, l = r.onYearMouseLeave;
      if (i === void 0)
        return null;
      for (var c = ea(i, o), u = c.startPeriod, d = c.endPeriod, p = function(f) {
        e.push(C.createElement("div", { ref: m.YEAR_REFS[f - u], onClick: function(g) {
          a.onYearClick(g, f);
        }, onKeyDown: function(g) {
          ol(g) && (g.preventDefault(), g.key = E.Enter), a.onYearKeyDown(g, f);
        }, tabIndex: Number(m.getYearTabIndex(f)), className: m.getYearClassNames(f), onMouseEnter: m.props.usePointerEvent ? void 0 : function(g) {
          return s(g, f);
        }, onPointerEnter: m.props.usePointerEvent ? function(g) {
          return s(g, f);
        } : void 0, onMouseLeave: m.props.usePointerEvent ? void 0 : function(g) {
          return l(g, f);
        }, onPointerLeave: m.props.usePointerEvent ? function(g) {
          return l(g, f);
        } : void 0, key: f, "aria-current": m.isCurrentYear(f) ? "date" : void 0 }, m.getYearContent(f)));
      }, m = this, h = u; h <= d; h++)
        p(h);
      return C.createElement(
        "div",
        { className: "react-datepicker__year" },
        C.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, e)
      );
    }, n;
  })(ye)
);
function Eg(t, n, a, e) {
  for (var r = [], i = 0; i < 2 * n + 1; i++) {
    var o = t + n - i, s = !0;
    a && (s = J(a) <= o), e && s && (s = J(e) >= o), s && r.push(o);
  }
  return r;
}
var Bg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      e.yearOptionButtonsRef = {}, e.handleOptionKeyDown = function(s, l) {
        var c;
        switch (l.key) {
          case "Enter":
            l.preventDefault(), e.onChange(s);
            break;
          case "Escape":
            l.preventDefault(), e.props.onCancel();
            break;
          case "ArrowUp":
          case "ArrowDown": {
            l.preventDefault();
            var u = s + (l.key === "ArrowUp" ? 1 : -1);
            e.yearOptionButtonsRef[u] && ((c = e.yearOptionButtonsRef[u]) === null || c === void 0 || c.focus());
            break;
          }
        }
      }, e.renderOptions = function() {
        e.yearOptionButtonsRef = {};
        var s = e.props.year, l = e.state.yearsList.map(function(d) {
          return C.createElement(
            "div",
            { ref: function(p) {
              e.yearOptionButtonsRef[d] = p, d === s && (p == null || p.focus());
            }, role: "button", tabIndex: 0, className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: e.onChange.bind(e, d), onKeyDown: e.handleOptionKeyDown.bind(e, d), "aria-selected": s === d ? "true" : void 0 },
            s === d ? C.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), c = e.props.minDate ? J(e.props.minDate) : null, u = e.props.maxDate ? J(e.props.maxDate) : null;
        return (!u || !e.state.yearsList.find(function(d) {
          return d === u;
        })) && l.unshift(C.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: e.incrementYears },
          C.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!c || !e.state.yearsList.find(function(d) {
          return d === c;
        })) && l.push(C.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: e.decrementYears },
          C.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, e.onChange = function(s) {
        e.props.onChange(s);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.shiftYears = function(s) {
        var l = e.state.yearsList.map(function(c) {
          return c + s;
        });
        e.setState({
          yearsList: l
        });
      }, e.incrementYears = function() {
        return e.shiftYears(1);
      }, e.decrementYears = function() {
        return e.shiftYears(-1);
      };
      var r = a.yearDropdownItemNumber, i = a.scrollableYearDropdown, o = r || (i ? 10 : 5);
      return e.state = {
        yearsList: Eg(e.props.year, o, e.props.minDate, e.props.maxDate)
      }, e.dropdownRef = pa(), e;
    }
    return n.prototype.componentDidMount = function() {
      var a = this.dropdownRef.current;
      if (a) {
        var e = a.children ? Array.from(a.children) : null, r = e ? e.find(function(i) {
          return i.ariaSelected;
        }) : null;
        a.scrollTop = r && r instanceof HTMLElement ? r.offsetTop + (r.clientHeight - a.clientHeight) / 2 : (a.scrollHeight - a.clientHeight) / 2;
      }
    }, n.prototype.render = function() {
      var a = _e({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return C.createElement(bn, { className: a, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, n;
  })(ye)
), Rg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.state = {
        dropdownVisible: !1
      }, a.renderSelectOptions = function() {
        for (var e = a.props.minDate ? J(a.props.minDate) : 1900, r = a.props.maxDate ? J(a.props.maxDate) : 2100, i = [], o = e; o <= r; o++)
          i.push(C.createElement("option", { key: o, value: o }, o));
        return i;
      }, a.onSelectChange = function(e) {
        a.onChange(parseInt(e.target.value));
      }, a.renderSelectMode = function() {
        return C.createElement("select", { value: a.props.year, className: "react-datepicker__year-select", onChange: a.onSelectChange }, a.renderSelectOptions());
      }, a.renderReadView = function(e) {
        return C.createElement(
          "button",
          { key: "read", type: "button", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: a.toggleDropdown },
          C.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          C.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, a.props.year)
        );
      }, a.renderDropdown = function() {
        return C.createElement(Bg, W({ key: "dropdown" }, a.props, { onChange: a.onChange, onCancel: a.toggleDropdown }));
      }, a.renderScrollMode = function() {
        var e = a.state.dropdownVisible, r = [a.renderReadView(!e)];
        return e && r.unshift(a.renderDropdown()), r;
      }, a.onChange = function(e) {
        a.toggleDropdown(), e !== a.props.year && a.props.onChange(e);
      }, a.toggleDropdown = function(e) {
        a.setState({
          dropdownVisible: !a.state.dropdownVisible
        }, function() {
          a.props.adjustDateOnChange && a.handleYearChange(a.props.date, e);
        });
      }, a.handleYearChange = function(e, r) {
        var i;
        (i = a.onSelect) === null || i === void 0 || i.call(a, e, r), a.setOpen();
      }, a.onSelect = function(e, r) {
        var i, o;
        (o = (i = a.props).onSelect) === null || o === void 0 || o.call(i, e, r);
      }, a.setOpen = function() {
        var e, r;
        (r = (e = a.props).setOpen) === null || r === void 0 || r.call(e, !0);
      }, a;
    }
    return n.prototype.render = function() {
      var a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode();
          break;
        case "select":
          a = this.renderSelectMode();
          break;
      }
      return C.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, a);
    }, n;
  })(ye)
), Og = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], sl = "react-datepicker-ignore-onclickoutside", Lg = function(t) {
  var n = (t.className || "").split(/\s+/);
  return Og.some(function(a) {
    return n.indexOf(a) >= 0;
  });
}, Gg = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.monthContainer = void 0, e.handleClickOutside = function(r) {
        e.props.onClickOutside(r);
      }, e.setClickOutsideRef = function() {
        return e.containerRef.current;
      }, e.handleDropdownFocus = function(r) {
        var i, o;
        Lg(r.target) && ((o = (i = e.props).onDropdownFocus) === null || o === void 0 || o.call(i, r));
      }, e.getDateInView = function() {
        var r = e.props, i = r.preSelection, o = r.selected, s = r.openToDate, l = nl(e.props), c = rl(e.props), u = $(), d = s || o || i;
        return d || (l && Ye(u, l) ? l : c && na(u, c) ? c : u);
      }, e.increaseMonth = function() {
        e.setState(function(r) {
          var i = r.date;
          return {
            date: Fe(i, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.decreaseMonth = function() {
        e.setState(function(r) {
          var i = r.date;
          return {
            date: ka(i, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.handleDayClick = function(r, i, o) {
        e.props.onSelect(r, i, o), e.props.setPreSelection && e.props.setPreSelection(r);
      }, e.handleDayMouseEnter = function(r) {
        e.setState({ selectingDate: r }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(r);
      }, e.handleMonthMouseLeave = function() {
        e.setState({ selectingDate: void 0 }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
      }, e.handleYearMouseEnter = function(r, i) {
        e.setState({ selectingDate: Ke($(), i) }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(r, i);
      }, e.handleYearMouseLeave = function(r, i) {
        e.props.onYearMouseLeave && e.props.onYearMouseLeave(r, i);
      }, e.handleYearChange = function(r) {
        var i, o, s, l;
        (o = (i = e.props).onYearChange) === null || o === void 0 || o.call(i, r), e.setState({ isRenderAriaLiveMessage: !0 }), e.props.adjustDateOnChange && (e.props.onSelect(r), (l = (s = e.props).setOpen) === null || l === void 0 || l.call(s, !0)), e.props.setPreSelection && e.props.setPreSelection(r);
      }, e.getEnabledPreSelectionDateForMonth = function(r) {
        if (!Re(r, e.props))
          return r;
        for (var i = ra(r), o = sg(r), s = Ds(o, i), l = null, c = 0; c <= s; c++) {
          var u = Ge(i, c);
          if (!Re(u, e.props)) {
            l = u;
            break;
          }
        }
        return l;
      }, e.handleMonthChange = function(r) {
        var i, o, s, l = (i = e.getEnabledPreSelectionDateForMonth(r)) !== null && i !== void 0 ? i : r;
        e.handleCustomMonthChange(l), e.props.adjustDateOnChange && (e.props.onSelect(l), (s = (o = e.props).setOpen) === null || s === void 0 || s.call(o, !0)), e.props.setPreSelection && e.props.setPreSelection(l);
      }, e.handleCustomMonthChange = function(r) {
        var i, o;
        (o = (i = e.props).onMonthChange) === null || o === void 0 || o.call(i, r), e.setState({ isRenderAriaLiveMessage: !0 });
      }, e.handleMonthYearChange = function(r) {
        e.handleYearChange(r), e.handleMonthChange(r);
      }, e.changeYear = function(r) {
        e.setState(function(i) {
          var o = i.date;
          return {
            date: Ke(o, Number(r))
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.changeMonth = function(r) {
        e.setState(function(i) {
          var o = i.date;
          return {
            date: Ie(o, Number(r))
          };
        }, function() {
          var i, o;
          e.handleMonthChange(e.state.date), (o = (i = e.props).onMonthSelectedInChange) === null || o === void 0 || o.call(i, 0);
        });
      }, e.changeMonthYear = function(r) {
        e.setState(function(i) {
          var o = i.date;
          return {
            date: Ke(Ie(o, Te(r)), J(r))
          };
        }, function() {
          return e.handleMonthYearChange(e.state.date);
        });
      }, e.header = function(r, i) {
        if (r === void 0 && (r = e.state.date), i === void 0 && (i = 0), !Ne(r))
          return [];
        var o = e.props.disabled, s = da(r, e.props.locale, e.props.calendarStartDay), l = [];
        return e.props.showWeekNumbers && l.push(C.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name ".concat(o ? "react-datepicker__day-name--disabled" : ""), role: "columnheader" },
          C.createElement("span", { className: "react-datepicker__sr-only" }, "Week number"),
          C.createElement("span", { "aria-hidden": "true" }, e.props.weekLabel || "#")
        )), l.concat([0, 1, 2, 3, 4, 5, 6].map(function(c) {
          var u = Ge(s, c), d = e.formatWeekday(u, e.props.locale), p = ie(u, "EEEE", e.props.locale), m = e.props.weekDayClassName ? e.props.weekDayClassName(u) : void 0;
          if (e.props.renderCustomDayName) {
            var h = e.props.renderCustomDayName({
              day: u,
              shortName: d,
              fullName: p,
              locale: e.props.locale,
              customDayNameCount: i
            });
            return C.createElement("div", { key: c, role: "columnheader", className: _e("react-datepicker__day-name", m, o ? "react-datepicker__day-name--disabled" : "") }, h);
          }
          return C.createElement(
            "div",
            { key: c, role: "columnheader", className: _e("react-datepicker__day-name", m, o ? "react-datepicker__day-name--disabled" : "") },
            C.createElement("span", { className: "react-datepicker__sr-only" }, p),
            C.createElement("span", { "aria-hidden": "true" }, d)
          );
        }));
      }, e.formatWeekday = function(r, i) {
        return e.props.formatWeekDay ? lg(r, e.props.formatWeekDay, i) : e.props.useWeekdaysShort ? ug(r, i) : cg(r, i);
      }, e.decreaseYear = function() {
        e.setState(function(r) {
          var i, o = r.date;
          return {
            date: Ya(o, e.props.showYearPicker ? (i = e.props.yearItemNumber) !== null && i !== void 0 ? i : n.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.clearSelectingDate = function() {
        e.setState({ selectingDate: void 0 });
      }, e.renderPreviousButton = function() {
        var r, i, o;
        if (!e.props.renderCustomHeader) {
          var s = (r = e.props.monthsShown) !== null && r !== void 0 ? r : n.defaultProps.monthsShown, l = e.props.showPreviousMonths ? s - 1 : 0, c = (i = e.props.monthSelectedIn) !== null && i !== void 0 ? i : l, u = ka(e.state.date, c), d;
          switch (!0) {
            case e.props.disabled:
              d = !0;
              break;
            case e.props.showMonthYearPicker:
              d = Ai(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              d = fg(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              d = mg(e.state.date, e.props);
              break;
            default:
              d = Di(u, e.props);
              break;
          }
          if (!(!((o = e.props.forceShowMonthNavigation) !== null && o !== void 0 ? o : n.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && d || e.props.showTimeSelectOnly)) {
            var p = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], m = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], h = e.decreaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (h = e.decreaseYear), d && e.props.showDisabledMonthNavigation && (m.push("react-datepicker__navigation--previous--disabled"), h = void 0);
            var f = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, g = e.props, y = g.previousMonthButtonLabel, b = y === void 0 ? n.defaultProps.previousMonthButtonLabel : y, k = g.previousYearButtonLabel, D = k === void 0 ? n.defaultProps.previousYearButtonLabel : k, v = e.props, S = v.previousMonthAriaLabel, w = S === void 0 ? typeof b == "string" ? b : "Previous Month" : S, M = v.previousYearAriaLabel, P = M === void 0 ? typeof D == "string" ? D : "Previous Year" : M;
            return C.createElement(
              "button",
              { type: "button", className: m.join(" "), onClick: h, onKeyDown: e.props.handleOnKeyDown, "aria-label": f ? P : w },
              C.createElement("span", { className: p.join(" ") }, f ? D : b)
            );
          }
        }
      }, e.increaseYear = function() {
        e.setState(function(r) {
          var i, o = r.date;
          return {
            date: aa(o, e.props.showYearPicker ? (i = e.props.yearItemNumber) !== null && i !== void 0 ? i : n.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.renderNextButton = function() {
        var r;
        if (!e.props.renderCustomHeader) {
          var i;
          switch (!0) {
            case e.props.disabled:
              i = !0;
              break;
            case e.props.showMonthYearPicker:
              i = Ni(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              i = gg(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              i = hg(e.state.date, e.props);
              break;
            default:
              i = Pi(e.state.date, e.props);
              break;
          }
          if (!(!((r = e.props.forceShowMonthNavigation) !== null && r !== void 0 ? r : n.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && i || e.props.showTimeSelectOnly)) {
            var o = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            e.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
            var l = e.increaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (l = e.increaseYear), i && e.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, d = u.nextMonthButtonLabel, p = d === void 0 ? n.defaultProps.nextMonthButtonLabel : d, m = u.nextYearButtonLabel, h = m === void 0 ? n.defaultProps.nextYearButtonLabel : m, f = e.props, g = f.nextMonthAriaLabel, y = g === void 0 ? typeof p == "string" ? p : "Next Month" : g, b = f.nextYearAriaLabel, k = b === void 0 ? typeof h == "string" ? h : "Next Year" : b;
            return C.createElement(
              "button",
              { type: "button", className: o.join(" "), onClick: l, onKeyDown: e.props.handleOnKeyDown, "aria-label": c ? k : y },
              C.createElement("span", { className: s.join(" ") }, c ? h : p)
            );
          }
        }
      }, e.renderCurrentMonth = function(r) {
        r === void 0 && (r = e.state.date);
        var i = ["react-datepicker__current-month"];
        return e.props.showYearDropdown && i.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && i.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && i.push("react-datepicker__current-month--hasMonthYearDropdown"), C.createElement("h2", { className: i.join(" ") }, Ne(r) ? ie(r, e.props.dateFormat, e.props.locale) : "");
      }, e.renderYearDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showYearDropdown || r))
          return C.createElement(Rg, W({}, n.defaultProps, e.props, { date: e.state.date, onChange: e.changeYear, year: J(e.state.date) }));
      }, e.renderMonthDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showMonthDropdown || r))
          return C.createElement(Pg, W({}, n.defaultProps, e.props, { month: Te(e.state.date), onChange: e.changeMonth }));
      }, e.renderMonthYearDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showMonthYearDropdown || r))
          return C.createElement(Tg, W({}, n.defaultProps, e.props, { date: e.state.date, onChange: e.changeMonthYear }));
      }, e.handleTodayButtonClick = function(r) {
        e.props.onSelect(Si(), r), e.props.setPreSelection && e.props.setPreSelection(Si());
      }, e.renderTodayButton = function() {
        if (!(!e.props.todayButton || e.props.showTimeSelectOnly))
          return C.createElement("div", { className: "react-datepicker__today-button", onClick: e.handleTodayButtonClick }, e.props.todayButton);
      }, e.renderDayNamesHeader = function(r, i) {
        return i === void 0 && (i = 0), C.createElement("div", { className: "react-datepicker__day-names", role: "row" }, e.header(r, i));
      }, e.renderDefaultHeader = function(r) {
        var i = r.monthDate, o = r.i, s = C.createElement(
          "div",
          { className: _e("react-datepicker__header", {
            "react-datepicker__header--has-time-select": e.props.showTimeSelect,
            "react-datepicker__header--middle": e.props.monthHeaderPosition === "middle",
            "react-datepicker__header--bottom": e.props.monthHeaderPosition === "bottom"
          }) },
          e.renderCurrentMonth(i),
          C.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode), onFocus: e.handleDropdownFocus },
            e.renderMonthDropdown(o !== 0),
            e.renderMonthYearDropdown(o !== 0),
            e.renderYearDropdown(o !== 0)
          )
        );
        return e.props.monthHeaderPosition === "top" ? s : C.createElement(
          "div",
          { className: "react-datepicker__header-wrapper" },
          e.renderPreviousButton() || null,
          e.renderNextButton() || null,
          s
        );
      }, e.renderCustomHeader = function(r) {
        var i, o, s = r.monthDate, l = r.i;
        if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly)
          return null;
        var c = e.props, u = c.showYearPicker, d = c.yearItemNumber, p;
        if (u) {
          var m = ea(s, d), h = m.startPeriod, f = m.endPeriod;
          p = {
            startYear: h,
            endYear: f
          };
        }
        var g = Di(e.state.date, e.props), y = Pi(e.state.date, e.props), b = Ai(e.state.date, e.props), k = Ni(e.state.date, e.props);
        return C.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: e.props.onDropdownFocus }, (o = (i = e.props).renderCustomHeader) === null || o === void 0 ? void 0 : o.call(i, W(W(W({}, e.state), u && { visibleYearsRange: p }), { customHeaderCount: l, monthDate: s, changeMonth: e.changeMonth, changeYear: e.changeYear, decreaseMonth: e.decreaseMonth, increaseMonth: e.increaseMonth, decreaseYear: e.decreaseYear, increaseYear: e.increaseYear, prevMonthButtonDisabled: g, nextMonthButtonDisabled: y, prevYearButtonDisabled: b, nextYearButtonDisabled: k })));
      }, e.renderYearHeader = function(r) {
        var i = r.monthDate, o = e.props, s = o.showYearPicker, l = o.yearItemNumber, c = l === void 0 ? n.defaultProps.yearItemNumber : l, u = ea(i, c), d = u.startPeriod, p = u.endPeriod;
        return C.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(d, " - ").concat(p) : J(i));
      }, e.renderHeader = function(r) {
        var i = r.monthDate, o = r.i, s = o === void 0 ? 0 : o, l = { monthDate: i, i: s };
        switch (!0) {
          case e.props.renderCustomHeader !== void 0:
            return e.renderCustomHeader(l);
          case (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker):
            return e.renderYearHeader(l);
          default:
            return e.renderDefaultHeader(l);
        }
      }, e.renderMonths = function() {
        var r, i;
        if (!(e.props.showTimeSelectOnly || e.props.showYearPicker)) {
          for (var o = [], s = (r = e.props.monthsShown) !== null && r !== void 0 ? r : n.defaultProps.monthsShown, l = e.props.showPreviousMonths ? s - 1 : 0, c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? aa(e.state.date, l) : ka(e.state.date, l), u = (i = e.props.monthSelectedIn) !== null && i !== void 0 ? i : l, d = 0; d < s; ++d) {
            var p = d - u + l, m = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? aa(c, p) : Fe(c, p), h = "month-".concat(d), f = d < s - 1, g = d > 0;
            o.push(C.createElement(
              "div",
              { key: h, ref: function(y) {
                e.monthContainer = y ?? void 0;
              }, className: "react-datepicker__month-container" },
              e.props.monthHeaderPosition === "top" && e.renderHeader({ monthDate: m, i: d }),
              C.createElement(Cg, W({}, n.defaultProps, e.props, { containerRef: e.containerRef, ariaLabelPrefix: e.props.monthAriaLabelPrefix, day: m, onDayClick: e.handleDayClick, handleOnKeyDown: e.props.handleOnDayKeyDown, handleOnMonthKeyDown: e.props.handleOnKeyDown, onDayMouseEnter: e.handleDayMouseEnter, onMouseLeave: e.handleMonthMouseLeave, orderInDisplay: d, selectingDate: e.state.selectingDate, monthShowsDuplicateDaysEnd: f, monthShowsDuplicateDaysStart: g, dayNamesHeader: e.renderDayNamesHeader(m, d), monthHeader: e.props.monthHeaderPosition === "middle" ? e.renderHeader({ monthDate: m, i: d }) : void 0, monthFooter: e.props.monthHeaderPosition === "bottom" ? e.renderHeader({ monthDate: m, i: d }) : void 0 }))
            ));
          }
          return o;
        }
      }, e.renderYears = function() {
        if (!e.props.showTimeSelectOnly && e.props.showYearPicker)
          return C.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            e.renderHeader({ monthDate: e.state.date }),
            C.createElement(xg, W({}, n.defaultProps, e.props, { selectingDate: e.state.selectingDate, date: e.state.date, onDayClick: e.handleDayClick, clearSelectingDate: e.clearSelectingDate, onYearMouseEnter: e.handleYearMouseEnter, onYearMouseLeave: e.handleYearMouseLeave }))
          );
      }, e.renderTimeSection = function() {
        if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly))
          return C.createElement(Ig, W({}, n.defaultProps, e.props, { onChange: e.props.onTimeChange, format: e.props.timeFormat, intervals: e.props.timeIntervals, monthRef: e.state.monthContainer }));
      }, e.renderInputTimeSection = function() {
        var r, i;
        if (e.props.showTimeInput) {
          if (e.props.selectsRange) {
            var o = e.props, s = o.startDate, l = o.endDate, c = s ? new Date(s) : void 0, u = c && Ne(c) && !!s, d = u ? "".concat(La(c.getHours()), ":").concat(La(c.getMinutes())) : "", p = l ? new Date(l) : void 0, m = p && Ne(p) && !!l, h = m ? "".concat(La(p.getHours()), ":").concat(La(p.getMinutes())) : "";
            return C.createElement(
              C.Fragment,
              null,
              C.createElement(Bn, W({}, n.defaultProps, e.props, { date: c, timeString: d, onChange: function(b) {
                var k, D;
                (D = (k = e.props).onTimeChange) === null || D === void 0 || D.call(k, b, "start");
              }, timeInputLabel: ((r = e.props.timeInputLabel) !== null && r !== void 0 ? r : "Time") + " (Start)" })),
              C.createElement(Bn, W({}, n.defaultProps, e.props, { date: p, timeString: h, onChange: function(b) {
                var k, D;
                (D = (k = e.props).onTimeChange) === null || D === void 0 || D.call(k, b, "end");
              }, timeInputLabel: ((i = e.props.timeInputLabel) !== null && i !== void 0 ? i : "Time") + " (End)" }))
            );
          }
          var f = e.props.selected ? new Date(e.props.selected) : void 0, g = f && Ne(f) && !!e.props.selected, y = g ? "".concat(La(f.getHours()), ":").concat(La(f.getMinutes())) : "";
          return C.createElement(Bn, W({}, n.defaultProps, e.props, { date: f, timeString: y, onChange: function(b) {
            var k, D;
            (D = (k = e.props).onTimeChange) === null || D === void 0 || D.call(k, b);
          } }));
        }
      }, e.renderAriaLiveRegion = function() {
        var r;
        if (!Ne(e.state.date))
          return C.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" });
        var i = ea(e.state.date, (r = e.props.yearItemNumber) !== null && r !== void 0 ? r : n.defaultProps.yearItemNumber), o = i.startPeriod, s = i.endPeriod, l;
        return e.props.showYearPicker ? l = "".concat(o, " - ").concat(s) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? l = J(e.state.date) : l = "".concat(Mr(Te(e.state.date), e.props.locale), " ").concat(J(e.state.date)), C.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, e.state.isRenderAriaLiveMessage && l);
      }, e.renderChildren = function() {
        if (e.props.children)
          return C.createElement("div", { className: "react-datepicker__children-container" }, e.props.children);
      }, e.containerRef = pa(), e.state = {
        date: e.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, e;
    }
    return Object.defineProperty(n, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          outsideClickIgnoreClass: sl,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: wt,
          monthHeaderPosition: "top"
        };
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidMount = function() {
      var a = this;
      this.props.showTimeSelect && (this.assignMonthContainer = (function() {
        a.setState({ monthContainer: a.monthContainer });
      })());
    }, n.prototype.componentDidUpdate = function(a) {
      var e = this;
      if (this.props.preSelection && Ne(this.props.preSelection) && (!Q(this.props.preSelection, a.preSelection) || this.props.monthSelectedIn !== a.monthSelectedIn)) {
        var r = !Ce(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return r && e.handleCustomMonthChange(e.state.date);
        });
      } else this.props.openToDate && !Q(this.props.openToDate, a.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, n.prototype.render = function() {
      var a = this.props.container || Xf;
      return C.createElement(
        bn,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, ignoreClass: this.props.outsideClickIgnoreClass },
        C.createElement(
          "div",
          { style: { display: "contents" }, ref: this.containerRef },
          C.createElement(
            a,
            { className: _e("react-datepicker", this.props.className, {
              "react-datepicker--time-only": this.props.showTimeSelectOnly
            }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly, inline: this.props.inline },
            this.renderAriaLiveRegion(),
            this.props.monthHeaderPosition === "top" && this.renderPreviousButton(),
            this.props.monthHeaderPosition === "top" && this.renderNextButton(),
            this.renderMonths(),
            this.renderYears(),
            this.renderTodayButton(),
            this.renderTimeSection(),
            this.renderInputTimeSection(),
            this.renderChildren()
          )
        )
      );
    }, n;
  })(ye)
), Fg = function(t) {
  var n = t.icon, a = t.className, e = a === void 0 ? "" : a, r = t.onClick, i = "react-datepicker__calendar-icon";
  if (typeof n == "string")
    return C.createElement("i", { className: "".concat(i, " ").concat(n, " ").concat(e), "aria-hidden": "true", onClick: r });
  if (C.isValidElement(n)) {
    var o = n;
    return C.cloneElement(o, {
      className: "".concat(o.props.className || "", " ").concat(i, " ").concat(e),
      onClick: function(s) {
        typeof o.props.onClick == "function" && o.props.onClick(s), typeof r == "function" && r(s);
      }
    });
  }
  return C.createElement(
    "svg",
    { className: "".concat(i, " ").concat(e), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: r },
    C.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, ll = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.portalRoot = null, e.el = document.createElement("div"), e;
    }
    return n.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, n.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, n.prototype.render = function() {
      return Vl.createPortal(this.props.children, this.el);
    }, n;
  })(ye)
), Kg = "[tabindex], a, button, input, select, textarea", Hg = function(t) {
  return (t instanceof HTMLAnchorElement || !t.disabled) && t.tabIndex !== -1;
}, cl = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.getTabChildren = function() {
        var r;
        return Array.prototype.slice.call((r = e.tabLoopRef.current) === null || r === void 0 ? void 0 : r.querySelectorAll(Kg), 1, -1).filter(Hg);
      }, e.handleFocusStart = function() {
        var r = e.getTabChildren();
        r && r.length > 1 && r[r.length - 1].focus();
      }, e.handleFocusEnd = function() {
        var r = e.getTabChildren();
        r && r.length > 1 && r[0].focus();
      }, e.tabLoopRef = pa(), e;
    }
    return n.prototype.render = function() {
      var a;
      return ((a = this.props.enableTabLoop) !== null && a !== void 0 ? a : n.defaultProps.enableTabLoop) ? C.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        C.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        C.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, n.defaultProps = {
      enableTabLoop: !0
    }, n;
  })(ye)
);
function zg(t) {
  function n(a) {
    var e, r = typeof a.hidePopper == "boolean" ? a.hidePopper : !0, i = ue(null), o = qf(W({ open: !r, whileElementsMounted: Af, placement: a.popperPlacement, middleware: We([
      Mt({ padding: 15 }),
      Lf(10),
      // eslint-disable-next-line react-hooks/refs -- Floating UI requires refs to be passed during render
      Gf({ element: i })
    ], (e = a.popperModifiers) !== null && e !== void 0 ? e : [], !0) }, a.popperProps)), s = W(W({}, a), { hidePopper: r, popperProps: W(W({}, o), { arrowRef: i }) });
    return C.createElement(t, W({}, s));
  }
  return n.displayName = "withFloating(".concat(t.displayName || t.name || "Component", ")"), n;
}
var Vg = function(t) {
  var n = t.className, a = t.wrapperClassName, e = t.hidePopper, r = e === void 0 ? !0 : e, i = t.popperComponent, o = t.targetComponent, s = t.enableTabLoop, l = t.popperOnKeyDown, c = t.portalId, u = t.portalHost, d = t.popperProps, p = t.showArrow, m = t.popperTargetRef, h = t.monthHeaderPosition;
  de(function() {
    m != null && m.current && d.refs.setPositionReference(m.current);
  }, [m, d.refs]);
  var f = void 0;
  if (!r) {
    var g = _e("react-datepicker-popper", !p && "react-datepicker-popper-offset", h === "middle" && "react-datepicker-popper--header-middle", h === "bottom" && "react-datepicker-popper--header-bottom", n);
    f = C.createElement(
      cl,
      { enableTabLoop: s },
      C.createElement(
        "div",
        { ref: d.refs.setFloating, style: d.floatingStyles, className: g, "data-placement": d.placement, onKeyDown: l },
        i,
        p && C.createElement(jf, { ref: d.arrowRef, context: d.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
      )
    );
  }
  t.popperContainer && (f = Pl(t.popperContainer, {}, f)), c && !r && (f = C.createElement(ll, { portalId: c, portalHost: u }, f));
  var y = _e("react-datepicker-wrapper", a);
  return C.createElement(
    C.Fragment,
    null,
    C.createElement("div", { ref: d.refs.setReference, className: y }, o),
    f
  );
}, Ug = zg(Vg);
function Ri(t, n) {
  return t && n ? Te(t) !== Te(n) || J(t) !== J(n) : t !== n;
}
var On = "Date input not valid.", vn = (
  /** @class */
  (function(t) {
    be(n, t);
    function n(a) {
      var e = t.call(this, a) || this;
      return e.calendar = null, e.input = null, e.getPreSelection = function() {
        var r = e.props.timeZone, i = e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : $();
        return r ? bi(i, r) : i;
      }, e.modifyHolidays = function() {
        var r;
        return (r = e.props.holidays) === null || r === void 0 ? void 0 : r.reduce(function(i, o) {
          var s = ga(o.date, "yyyy-MM-dd", void 0, !1);
          return s ? We(We([], i, !0), [W(W({}, o), { date: s })], !1) : i;
        }, []);
      }, e.calcInitialState = function() {
        var r = e.props.timeZone, i = e.getPreSelection(), o = nl(e.props), s = rl(e.props), l = o && Ye(i, st(o)) ? o : s && na(i, ki(s)) ? s : i, c = e.props.selectsRange ? e.props.startDate : e.props.selected;
        return c && r && (c = bi(c, r)), {
          open: e.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: c ?? l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: Ti(e.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, e.getInputValue = function() {
        var r, i = e.props, o = i.locale, s = i.startDate, l = i.endDate, c = i.rangeSeparator, u = i.selected, d = i.selectedDates, p = i.selectsMultiple, m = i.selectsRange, h = i.formatMultipleDates, f = i.value, g = (r = e.props.dateFormat) !== null && r !== void 0 ? r : n.defaultProps.dateFormat, y = e.state.inputValue;
        if (typeof f == "string")
          return f;
        if (typeof y == "string")
          return y;
        if (m)
          return tg(s, l, {
            dateFormat: g,
            locale: o,
            rangeSeparator: c
          });
        if (p) {
          if (h) {
            var b = function(k) {
              return Pe(k, { dateFormat: g, locale: o });
            };
            return h(d ?? [], b);
          }
          return ng(d ?? [], {
            dateFormat: g,
            locale: o
          });
        }
        return Pe(u, {
          dateFormat: g,
          locale: o
        });
      }, e.resetHiddenStatus = function() {
        e.setState(W(W({}, e.state), { wasHidden: !1 }));
      }, e.setHiddenStatus = function() {
        e.setState(W(W({}, e.state), { wasHidden: !0 }));
      }, e.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && e.setHiddenStatus();
      }, e.clearPreventFocusTimeout = function() {
        e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
      }, e.setFocus = function() {
        var r, i;
        (i = (r = e.input) === null || r === void 0 ? void 0 : r.focus) === null || i === void 0 || i.call(r, { preventScroll: !0 });
      }, e.setBlur = function() {
        var r, i;
        (i = (r = e.input) === null || r === void 0 ? void 0 : r.blur) === null || i === void 0 || i.call(r), e.cancelFocusInput();
      }, e.deferBlur = function() {
        requestAnimationFrame(function() {
          e.setBlur();
        });
      }, e.setOpen = function(r, i) {
        i === void 0 && (i = !1), e.setState({
          open: r,
          preSelection: r && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection,
          lastPreSelectChange: Ln
        }, function() {
          r || e.setState(function(o) {
            return {
              focused: i ? o.focused : !1
            };
          }, function() {
            !i && e.deferBlur(), e.setState({ inputValue: null });
          });
        });
      }, e.inputOk = function() {
        return ta(e.state.preSelection);
      }, e.isCalendarOpen = function() {
        return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
      }, e.handleFocus = function(r) {
        var i, o, s = e.state.wasHidden, l = s ? e.state.open : !0;
        s && e.resetHiddenStatus(), e.state.preventFocus || ((o = (i = e.props).onFocus) === null || o === void 0 || o.call(i, r), l && !e.props.preventOpenOnFocus && !e.props.readOnly && e.setOpen(!0)), e.setState({ focused: !0 });
      }, e.sendFocusBackToInput = function() {
        e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({ preventFocus: !0 }, function() {
          e.preventFocusTimeout = setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        });
      }, e.cancelFocusInput = function() {
        clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = void 0;
      }, e.deferFocusInput = function() {
        e.cancelFocusInput(), e.inputFocusTimeout = setTimeout(function() {
          return e.setFocus();
        }, 1);
      }, e.handleDropdownFocus = function() {
        e.cancelFocusInput();
      }, e.resetInputValue = function() {
        e.setState(W(W({}, e.state), { inputValue: null }));
      }, e.handleBlur = function(r) {
        var i, o;
        (!e.state.open || e.props.withPortal || e.props.showTimeInput) && ((o = (i = e.props).onBlur) === null || o === void 0 || o.call(i, r)), e.resetInputValue(), e.state.open && e.props.open === !1 && e.setOpen(!1), e.setState({ focused: !1 });
      }, e.handleCalendarClickOutside = function(r) {
        var i, o;
        e.props.inline || e.setOpen(!1), (o = (i = e.props).onClickOutside) === null || o === void 0 || o.call(i, r), e.props.withPortal && r.preventDefault();
      }, e.handleChange = function() {
        for (var r, i, o, s, l, c, u = [], d = 0; d < arguments.length; d++)
          u[d] = arguments[d];
        var p = u[0];
        if (!(e.props.onChangeRaw && (e.props.onChangeRaw.apply(e, u), !p || typeof p.isDefaultPrevented != "function" || p.isDefaultPrevented()))) {
          e.setState({
            inputValue: (p == null ? void 0 : p.target) instanceof HTMLInputElement ? p.target.value : null,
            lastPreSelectChange: jg
          });
          var m = e.props, h = m.selectsRange, f = m.startDate, g = m.endDate, y = (r = e.props.dateFormat) !== null && r !== void 0 ? r : n.defaultProps.dateFormat, b = (i = e.props.strictParsing) !== null && i !== void 0 ? i : n.defaultProps.strictParsing, k = (p == null ? void 0 : p.target) instanceof HTMLInputElement ? p.target.value : "";
          if (h) {
            var D = e.props.rangeSeparator, v = D.trim(), S = k.split(y.includes(v) ? D : v, 2).map(function(K) {
              return K.trim();
            }), w = S[0], M = S[1], P = ga(w ?? "", y, e.props.locale, b), N = P ? ga(M ?? "", y, e.props.locale, b) : null, B = (f == null ? void 0 : f.getTime()) !== (P == null ? void 0 : P.getTime()), R = (g == null ? void 0 : g.getTime()) !== (N == null ? void 0 : N.getTime());
            if (!B && !R || P && Re(P, e.props) || N && Re(N, e.props))
              return;
            P && e.setState({ preSelection: P }), (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, [P, N], p);
          } else {
            var F = ga(k, y, e.props.locale, b, (l = e.props.selected) !== null && l !== void 0 ? l : void 0);
            if (F || !k)
              e.setSelected(F, p, !0);
            else if (!e.props.inline) {
              var x = ag(k, (c = e.state.preSelection) !== null && c !== void 0 ? c : void 0);
              x && (!e.props.minDate || !Ye(x, e.props.minDate)) && (!e.props.maxDate || !na(x, e.props.maxDate)) && e.setState({ preSelection: x });
            }
          }
        }
      }, e.handleSelect = function(r, i, o) {
        var s;
        if (!e.props.readOnly) {
          var l = e.props, c = l.selectsRange, u = l.startDate, d = l.endDate, p = l.locale, m = l.swapRange, h = (s = e.props.dateFormat) !== null && s !== void 0 ? s : n.defaultProps.dateFormat, f = !c || u && !d && (m || !En(r, u));
          if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && f && e.sendFocusBackToInput(), e.props.onChangeRaw) {
            var g = Pe(r, {
              dateFormat: h,
              locale: p
            });
            e.props.onChangeRaw(i, { date: r, formattedDate: g });
          }
          e.setSelected(r, i, !1, o), e.props.showDateSelect && e.setState({ isRenderAriaLiveMessage: !0 }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect ? e.setPreSelection(r) : f && e.setOpen(!1);
        }
      }, e.setSelected = function(r, i, o, s) {
        var l, c, u = e.props.timeZone, d = r;
        if (d && u && (d = qe(d, u)), e.props.showYearPicker) {
          if (d !== null && Ht(J(d), e.props))
            return;
        } else if (e.props.showMonthYearPicker) {
          if (d !== null && tl(d, e.props))
            return;
        } else if (d !== null && Re(d, e.props))
          return;
        var p = e.props, m = p.onChange, h = p.selectsRange, f = p.startDate, g = p.endDate, y = p.selectsMultiple, b = p.selectedDates, k = p.minTime, D = p.swapRange;
        if (!va(e.props.selected, d) || e.props.allowSameDay || h || y)
          if (d !== null && (e.props.selected && (!o || !e.props.showTimeSelect && !e.props.showTimeSelectOnly && !e.props.showTimeInput) && (d = Xe(d, {
            hour: ve(e.props.selected),
            minute: Se(e.props.selected),
            second: ua(e.props.selected)
          })), !o && (e.props.showTimeSelect || e.props.showTimeSelectOnly) && k && (d = Xe(d, {
            hour: k.getHours(),
            minute: k.getMinutes(),
            second: k.getSeconds()
          })), e.props.inline || e.setState({
            preSelection: d
          }), e.props.focusSelectedMonth || e.setState({ monthSelectedIn: s })), h) {
            var v = !f && !g, S = f && !g, w = !f && !!g, M = f && g;
            v ? m == null || m([d, null], i) : S ? d === null ? m == null || m([null, null], i) : En(d, f) ? D ? m == null || m([d, f], i) : m == null || m([d, null], i) : m == null || m([f, d], i) : w && (d && En(d, g) ? m == null || m([d, g], i) : m == null || m([d, null], i)), M && (m == null || m([d, null], i));
          } else if (y) {
            if (d !== null)
              if (!(b != null && b.length))
                m == null || m([d], i);
              else {
                var P = b.some(function(B) {
                  return Q(B, d);
                });
                if (P) {
                  var N = b.filter(function(B) {
                    return !Q(B, d);
                  });
                  m == null || m(N, i);
                } else
                  m == null || m(We(We([], b, !0), [d], !1), i);
              }
          } else
            m == null || m(d, i);
        o || ((c = (l = e.props).onSelect) === null || c === void 0 || c.call(l, d, i), e.setState({ inputValue: null }));
      }, e.setPreSelection = function(r) {
        if (!e.props.readOnly) {
          var i = ta(e.props.minDate), o = ta(e.props.maxDate), s = !0;
          if (r) {
            var l = st(r);
            if (i && o)
              s = ya(r, e.props.minDate, e.props.maxDate);
            else if (i) {
              var c = st(e.props.minDate);
              s = na(r, c) || va(l, c);
            } else if (o) {
              var u = ki(e.props.maxDate);
              s = Ye(r, u) || va(l, u);
            }
          }
          s && e.setState({
            preSelection: r
          });
        }
      }, e.toggleCalendar = function() {
        e.setOpen(!e.state.open);
      }, e.handleTimeChange = function(r, i) {
        var o, s;
        if (!e.props.selectsMultiple) {
          var l = e.props, c = l.selectsRange, u = l.startDate, d = l.endDate, p = l.onChange, m = l.timeZone;
          if (c)
            if (i === "start") {
              if (u) {
                var h = Xe(u, {
                  hour: ve(r),
                  minute: Se(r)
                });
                e.setState({
                  preSelection: h
                }), m && (h = qe(h, m)), p == null || p([
                  h,
                  d ? m ? qe(d, m) : d : null
                ], void 0);
              }
            } else if (i === "end") {
              if (d) {
                var f = Xe(d, {
                  hour: ve(r),
                  minute: Se(r)
                });
                e.setState({
                  preSelection: f
                }), m && (f = qe(f, m)), p == null || p([
                  u ? m ? qe(u, m) : u : null,
                  f
                ], void 0);
              }
            } else {
              var g = u && !d;
              if (g) {
                var h = Xe(u, {
                  hour: ve(r),
                  minute: Se(r)
                });
                e.setState({
                  preSelection: h
                }), m && (h = qe(h, m)), p == null || p([h, null], void 0);
              } else if (u && d) {
                var f = Xe(d, {
                  hour: ve(r),
                  minute: Se(r)
                });
                e.setState({
                  preSelection: f
                }), m && (f = qe(f, m)), p == null || p([
                  m ? qe(u, m) : u,
                  f
                ], void 0);
              } else {
                var y = Xe(e.getPreSelection(), {
                  hour: ve(r),
                  minute: Se(r)
                });
                e.setState({
                  preSelection: y
                });
              }
            }
          else {
            var b = e.props.selected ? e.props.selected : e.getPreSelection(), y = e.props.selected ? r : Xe(b, {
              hour: ve(r),
              minute: Se(r)
            });
            e.setState({
              preSelection: y
            }), y && m && (y = qe(y, m)), (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, y);
          }
          e.props.shouldCloseOnSelect && !e.props.showTimeInput && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), e.setState({ inputValue: null });
        }
      }, e.onInputClick = function() {
        var r, i;
        !e.props.disabled && !e.props.readOnly && e.setOpen(!0), (i = (r = e.props).onInputClick) === null || i === void 0 || i.call(r);
      }, e.handleTimeOnlyArrowKey = function(r) {
        var i, o, s, l, c = e.props.selected || e.state.preSelection || $(), u = (i = e.props.timeIntervals) !== null && i !== void 0 ? i : 30, d = (o = e.props.dateFormat) !== null && o !== void 0 ? o : n.defaultProps.dateFormat, p = Array.isArray(d) ? d[0] : d, m = st(c), h = ve(c) * 60 + Se(c), f = 1440 - u, g;
        if (r === E.ArrowUp) {
          var y = Math.max(0, h - u);
          g = ht(m, y);
        } else {
          var y = Math.min(f, h + u);
          g = ht(m, y);
        }
        var b = ie(g, p || n.defaultProps.dateFormat, e.props.locale);
        if (e.setState({
          preSelection: g,
          inputValue: b
        }), !(e.props.selectsRange || e.props.selectsMultiple)) {
          var k = e.props.selected ? e.props.selected : e.getPreSelection(), D = e.props.selected ? g : Xe(k, {
            hour: ve(g),
            minute: Se(g)
          });
          (l = (s = e.props).onChange) === null || l === void 0 || l.call(s, D), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), requestAnimationFrame(function() {
            e.scrollToTimeOption(g);
          });
        }
      }, e.handleTimeOnlyEnterKey = function(r) {
        var i, o, s, l, c = r.target, u = c.value, d = (i = e.props.dateFormat) !== null && i !== void 0 ? i : n.defaultProps.dateFormat, p = e.props.timeFormat || "p", m = e.state.preSelection || e.props.selected || $(), h = ga(u, d, e.props.locale, (o = e.props.strictParsing) !== null && o !== void 0 ? o : !1, m), f = m;
        if (h && Ne(h))
          f = h;
        else {
          var g = ((s = e.calendar) === null || s === void 0 ? void 0 : s.containerRef.current) instanceof Element && e.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
          if (g instanceof HTMLElement) {
            var y = (l = g.textContent) === null || l === void 0 ? void 0 : l.trim();
            if (y) {
              var b = ga(y, p, e.props.locale, !1, m);
              b && Ne(b) && (f = b);
            }
          }
        }
        e.handleTimeChange(f), e.setOpen(!1), e.sendFocusBackToInput();
      }, e.scrollToTimeOption = function(r) {
        var i, o;
        if (!((i = e.calendar) === null || i === void 0) && i.containerRef.current) {
          for (var s = e.calendar.containerRef.current, l = Array.from(s.querySelectorAll(".react-datepicker__time-list-item")), c = null, u = 1 / 0, d = e.props.timeFormat || "p", p = 0, m = l; p < m.length; p++) {
            var h = m[p], f = (o = h.textContent) === null || o === void 0 ? void 0 : o.trim();
            if (f) {
              var g = ga(f, d, e.props.locale, !1, r);
              if (g && Ne(g)) {
                if (il(g, r)) {
                  c = h;
                  break;
                }
                var y = Math.abs(g.getTime() - r.getTime());
                y < u && (u = y, c = h);
              }
            }
          }
          c && (l.forEach(function(b) {
            b.setAttribute("tabindex", "-1");
          }), c.setAttribute("tabindex", "0"), c.scrollIntoView({
            behavior: "smooth",
            block: "center"
          }));
        }
      }, e.onInputKeyDown = function(r) {
        var i, o, s, l, c, u;
        (o = (i = e.props).onKeyDown) === null || o === void 0 || o.call(i, r);
        var d = r.key;
        if (!e.state.open && !e.props.inline && !e.props.preventOpenOnFocus) {
          (d === E.ArrowDown || d === E.ArrowUp || d === E.Enter) && ((s = e.onInputClick) === null || s === void 0 || s.call(e));
          return;
        }
        if (e.state.open && e.props.showTimeSelectOnly) {
          if (d === E.ArrowDown || d === E.ArrowUp) {
            r.preventDefault(), e.handleTimeOnlyArrowKey(d);
            return;
          }
          if (d === E.Enter) {
            r.preventDefault(), e.handleTimeOnlyEnterKey(r);
            return;
          }
        }
        if (e.state.open) {
          if (d === E.ArrowDown || d === E.ArrowUp) {
            r.preventDefault();
            var p = e.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : e.props.showFullMonthYearPicker || e.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', m = ((l = e.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && e.calendar.containerRef.current.querySelector(p);
            m instanceof HTMLElement && m.focus({ preventScroll: !0 });
            return;
          }
          var h = $(e.state.preSelection);
          d === E.Enter ? (r.preventDefault(), r.target.blur(), e.inputOk() && e.state.lastPreSelectChange === Ln ? (e.handleSelect(h, r), !e.props.shouldCloseOnSelect && e.setPreSelection(h)) : e.setOpen(!1)) : d === E.Escape ? (r.preventDefault(), r.target.blur(), e.sendFocusBackToInput(), e.setOpen(!1)) : d === E.Tab && e.setOpen(!1), e.inputOk() || (u = (c = e.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: On });
        }
      }, e.onPortalKeyDown = function(r) {
        var i = r.key;
        i === E.Escape && (r.preventDefault(), e.setState({
          preventFocus: !0
        }, function() {
          e.setOpen(!1), setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        }));
      }, e.onDayKeyDown = function(r) {
        var i, o, s, l, c, u, d = e.props, p = d.minDate, m = d.maxDate, h = d.disabledKeyboardNavigation, f = d.showWeekPicker, g = d.shouldCloseOnSelect, y = d.locale, b = d.calendarStartDay, k = d.adjustDateOnChange, D = d.inline;
        if ((o = (i = e.props).onKeyDown) === null || o === void 0 || o.call(i, r), !h) {
          var v = r.key, S = r.shiftKey, w = $(e.state.preSelection), M = function(B, R) {
            var F = R;
            switch (B) {
              case E.ArrowRight:
                F = f ? Jt(R, 1) : Ge(R, 1);
                break;
              case E.ArrowLeft:
                F = f ? oi(R) : gh(R);
                break;
              case E.ArrowUp:
                F = oi(R);
                break;
              case E.ArrowDown:
                F = Jt(R, 1);
                break;
              case E.PageUp:
                F = S ? Ya(R, 1) : ka(R, 1);
                break;
              case E.PageDown:
                F = S ? aa(R, 1) : Fe(R, 1);
                break;
              case E.Home:
                F = da(R, y, b);
                break;
              case E.End:
                F = og(R);
                break;
            }
            return F;
          }, P = function(B, R) {
            for (var F = 40, x = B, K = !1, z = 0, T = M(B, R); !K; ) {
              if (z >= F) {
                T = R;
                break;
              }
              p && T < p && (x = E.ArrowRight, T = Re(p, e.props) ? M(x, T) : p), m && T > m && (x = E.ArrowLeft, T = Re(m, e.props) ? M(x, T) : m), Re(T, e.props) ? ((x === E.PageUp || x === E.Home) && (x = E.ArrowRight), (x === E.PageDown || x === E.End) && (x = E.ArrowLeft), T = M(x, T)) : K = !0, z++;
            }
            return T;
          };
          if (v === E.Enter) {
            r.preventDefault(), e.handleSelect(w, r), !g && e.setPreSelection(w);
            return;
          } else if (v === E.Escape) {
            r.preventDefault(), e.setOpen(!1), e.inputOk() || (l = (s = e.props).onInputError) === null || l === void 0 || l.call(s, { code: 1, msg: On });
            return;
          }
          var N = null;
          switch (v) {
            case E.ArrowLeft:
            case E.ArrowRight:
            case E.ArrowUp:
            case E.ArrowDown:
            case E.PageUp:
            case E.PageDown:
            case E.Home:
            case E.End:
              N = P(v, w);
              break;
          }
          if (!N) {
            (u = (c = e.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: On });
            return;
          }
          r.preventDefault(), e.setState({ lastPreSelectChange: Ln }), k && e.setSelected(N), e.setPreSelection(N), D && e.setState({ shouldFocusDayInline: !0 });
        }
      }, e.onPopperKeyDown = function(r) {
        var i = r.key;
        i === E.Escape && (r.preventDefault(), e.sendFocusBackToInput(), e.setOpen(!1));
      }, e.onClearClick = function(r) {
        r && r.preventDefault && r.preventDefault(), e.sendFocusBackToInput();
        var i = e.props, o = i.selectsRange, s = i.onChange;
        o ? s == null || s([null, null], r) : s == null || s(null, r), e.setState({ inputValue: null });
      }, e.clear = function() {
        e.onClearClick();
      }, e.onScroll = function(r) {
        typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? (r.target === document || r.target === document.documentElement || r.target === document.body) && e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(r) && e.setOpen(!1);
      }, e.handleMonthSelectedInChange = function(r) {
        e.setState({ monthSelectedIn: r });
      }, e.renderCalendar = function() {
        var r, i;
        return !e.props.inline && !e.isCalendarOpen() ? null : C.createElement(Gg, W({ showMonthYearDropdown: void 0, ref: function(o) {
          e.calendar = o;
        } }, e.props, e.state, { setOpen: e.setOpen, dateFormat: (r = e.props.dateFormatCalendar) !== null && r !== void 0 ? r : n.defaultProps.dateFormatCalendar, onSelect: e.handleSelect, onClickOutside: e.handleCalendarClickOutside, holidays: yg(e.modifyHolidays()), outsideClickIgnoreClass: e.props.outsideClickIgnoreClass, onDropdownFocus: e.handleDropdownFocus, onTimeChange: e.handleTimeChange, className: e.props.calendarClassName, container: e.props.calendarContainer, handleOnKeyDown: e.props.onKeyDown, handleOnDayKeyDown: e.onDayKeyDown, setPreSelection: e.setPreSelection, dropdownMode: (i = e.props.dropdownMode) !== null && i !== void 0 ? i : n.defaultProps.dropdownMode, onMonthSelectedInChange: e.handleMonthSelectedInChange }), e.props.children);
      }, e.renderAriaLiveRegion = function() {
        var r, i = e.props.locale, o = (r = e.props.dateFormat) !== null && r !== void 0 ? r : n.defaultProps.dateFormat, s = e.props.showTimeInput || e.props.showTimeSelect, l = s ? "PPPPp" : "PPPP", c;
        return e.props.selectsRange ? c = "Selected start date: ".concat(Pe(e.props.startDate, {
          dateFormat: l,
          locale: i
        }), ". ").concat(e.props.endDate ? "End date: " + Pe(e.props.endDate, {
          dateFormat: l,
          locale: i
        }) : "") : e.props.showTimeSelectOnly ? c = "Selected time: ".concat(Pe(e.props.selected, { dateFormat: o, locale: i })) : e.props.showYearPicker ? c = "Selected year: ".concat(Pe(e.props.selected, { dateFormat: "yyyy", locale: i })) : e.props.showMonthYearPicker ? c = "Selected month: ".concat(Pe(e.props.selected, { dateFormat: "MMMM yyyy", locale: i })) : e.props.showQuarterYearPicker ? c = "Selected quarter: ".concat(Pe(e.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: i
        })) : c = "Selected date: ".concat(Pe(e.props.selected, {
          dateFormat: l,
          locale: i
        })), C.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, c);
      }, e.renderDateInput = function() {
        var r, i, o, s, l, c, u, d = _e(e.props.className, (r = {}, r[e.props.outsideClickIgnoreClass || n.defaultProps.outsideClickIgnoreClass] = e.state.open, r)), p = e.props.customInput || C.createElement("input", { type: "text" }), m = e.props.customInputRef || "ref", h = {}, f = (o = e.props["aria-describedby"]) !== null && o !== void 0 ? o : e.props.ariaDescribedBy, g = (s = e.props["aria-invalid"]) !== null && s !== void 0 ? s : e.props.ariaInvalid, y = (l = e.props["aria-label"]) !== null && l !== void 0 ? l : e.props.ariaLabel, b = (c = e.props["aria-labelledby"]) !== null && c !== void 0 ? c : e.props.ariaLabelledBy, k = (u = e.props["aria-required"]) !== null && u !== void 0 ? u : e.props.ariaRequired;
        return f != null && (h["aria-describedby"] = f), g != null && (h["aria-invalid"] = g), y != null && (h["aria-label"] = y), b != null && (h["aria-labelledby"] = b), k != null && (h["aria-required"] = k), Qi(p, W((i = {}, i[m] = function(D) {
          e.input = D;
        }, i.value = e.getInputValue(), i.onBlur = e.handleBlur, i.onChange = e.handleChange, i.onClick = e.onInputClick, i.onFocus = e.handleFocus, i.onKeyDown = e.onInputKeyDown, i.id = e.props.id, i.name = e.props.name, i.form = e.props.form, i.autoFocus = e.props.autoFocus, i.placeholder = e.props.placeholderText, i.disabled = e.props.disabled, i.autoComplete = e.props.autoComplete, i.className = _e(p.props.className, d), i.title = e.props.title, i.readOnly = e.props.readOnly, i.required = e.props.required, i.tabIndex = e.props.tabIndex, i), h));
      }, e.renderClearButton = function() {
        var r = e.props, i = r.isClearable, o = r.disabled, s = r.selected, l = r.startDate, c = r.endDate, u = r.clearButtonTitle, d = r.clearButtonClassName, p = d === void 0 ? "" : d, m = r.ariaLabelClose, h = m === void 0 ? "Close" : m, f = r.selectedDates, g = r.readOnly;
        return i && !g && (s != null || l != null || c != null || f != null && f.length) ? C.createElement("button", { type: "button", className: _e("react-datepicker__close-icon", p, { "react-datepicker__close-icon--disabled": o }), disabled: o, "aria-label": h, onClick: e.onClearClick, title: u, tabIndex: -1 }) : null;
      }, e.state = e.calcInitialState(), e.preventFocusTimeout = void 0, e;
    }
    return Object.defineProperty(n, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          outsideClickIgnoreClass: sl,
          readOnly: !1,
          rangeSeparator: el,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: wt,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, n.prototype.componentDidUpdate = function(a, e) {
      var r, i, o, s;
      this.props.selectsRange && Ri(a.startDate, this.props.startDate) ? this.setPreSelection(this.props.startDate) : Ri(a.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && a.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), this.props.selectsRange && e.open === !1 && this.state.open === !0 && this.state.monthSelectedIn !== 0 && this.setState({ monthSelectedIn: 0 }), a.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: Ti(this.props.highlightDates)
      }), !e.focused && !va(a.selected, this.props.selected) && this.setState({ inputValue: null }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && ((i = (r = this.props).onCalendarOpen) === null || i === void 0 || i.call(r)), e.open === !0 && this.state.open === !1 && ((s = (o = this.props).onCalendarClose) === null || s === void 0 || s.call(o)));
    }, n.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, n.prototype.renderInputContainer = function() {
      var a = this.props, e = a.showIcon, r = a.icon, i = a.calendarIconClassname, o = a.calendarIconClassName, s = a.toggleCalendarOnIconClick, l = this.state.open;
      return i && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), C.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "") },
        e && C.createElement(Fg, W({ icon: r, className: _e(o, !o && i, l && "react-datepicker-ignore-onclickoutside") }, s ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, n.prototype.render = function() {
      var a = this.renderCalendar();
      if (this.props.inline)
        return a;
      if (this.props.withPortal) {
        var e = this.state.open ? C.createElement(
          cl,
          { enableTabLoop: this.props.enableTabLoop },
          C.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, a)
        ) : null;
        return this.state.open && this.props.portalId && (e = C.createElement(ll, W({ portalId: this.props.portalId }, this.props), e)), C.createElement(
          "div",
          null,
          this.renderInputContainer(),
          e
        );
      }
      return C.createElement(Ug, W({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: a, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow, monthHeaderPosition: this.props.monthHeaderPosition }));
    }, n;
  })(ye)
), jg = "input", Ln = "navigate";
const Yg = (t) => {
  const n = new Date(0, 0, 0, 0, 0), { hours: a, minutes: e, seconds: r } = Zg(t);
  return n.setHours(Number(a)), n.setMinutes(Number(e)), n.setSeconds(Number(r)), n;
}, Oi = (t) => {
  const n = t.getHours(), a = t.getMinutes(), e = t.getSeconds();
  return n * 3600 + a * 60 + e;
}, Wg = (t) => {
  const n = Math.floor(t / 3600), a = Math.floor(t % 3600 / 60);
  return {
    hours: n < 10 ? `0${n}` : String(n),
    minutes: a < 10 ? `0${a}` : String(a)
  };
}, Zg = (t) => {
  const { hours: n, minutes: a } = Wg(t), e = t % 60;
  return {
    hours: n,
    minutes: a,
    seconds: e < 10 ? `0${e}` : String(e)
  };
}, Sn = yt(function({
  error: n,
  label: a,
  labelClassName: e,
  labelRightElement: r,
  htmlFor: i,
  nativeLabelProps: o,
  value: s,
  onChange: l,
  onFocus: c,
  maxLength: u,
  placeholder: d,
  isPreFetching: p,
  required: m,
  description: h,
  className: f,
  addonBefore: g,
  addonAfter: y,
  inputClassName: b,
  success: k,
  addonAfterClassName: D,
  addonBeforeClassName: v,
  statusIcon: S,
  statusIconClassName: w,
  labelContentWrapperClassName: M,
  errorAndDescriptionClassName: P,
  descriptionClassName: N,
  errorClassName: B,
  ...R
}, F) {
  const x = A(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    p ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), K = A(lr, S && "pr-9");
  return /* @__PURE__ */ L(
    "label",
    {
      className: A("flex flex-col gap-1 text-sm font-medium", f),
      ...o,
      children: [
        /* @__PURE__ */ _(
          Na,
          {
            label: a,
            labelClassName: e,
            labelRightElement: r,
            required: m
          }
        ),
        /* @__PURE__ */ L(
          "div",
          {
            className: A(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              p && "animate-pulse",
              M
            ),
            children: [
              g && /* @__PURE__ */ _(
                "div",
                {
                  className: A(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    x,
                    v
                  ),
                  children: g
                }
              ),
              /* @__PURE__ */ _(
                "input",
                {
                  ref: F,
                  className: A(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    K,
                    n ? "border-danger" : k ? "border-green" : "border-text-secondary/30",
                    p ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    g && "rounded-l-none",
                    y && "rounded-r-none",
                    b
                  ),
                  type: R.type || "text",
                  value: s,
                  onChange: l,
                  onFocus: c,
                  maxLength: u,
                  placeholder: d,
                  spellCheck: !1,
                  disabled: R.disabled || p,
                  ...R
                }
              ),
              y && /* @__PURE__ */ _(
                "div",
                {
                  className: A(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    x,
                    D
                  ),
                  children: y
                }
              ),
              S && /* @__PURE__ */ _(
                "div",
                {
                  className: A(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    w
                  ),
                  children: S
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _(
          ha,
          {
            description: h,
            error: n,
            className: P,
            descriptionClassName: N,
            errorClassName: B
          }
        )
      ]
    }
  );
});
function _y({
  inputRef: t,
  label: n,
  labelClassName: a,
  required: e,
  value: r,
  onChange: i,
  onFocus: o,
  maxLength: s,
  error: l,
  placeholder: c,
  onClear: u,
  description: d,
  testAttributePostfix: p,
  isPreFetching: m,
  searchIconClassName: h,
  closeIconClassName: f,
  errorAndDescriptionClassName: g,
  descriptionClassName: y,
  errorClassName: b,
  showSearchIcon: k,
  ...D
}) {
  return /* @__PURE__ */ L("label", { className: `${D.className} relative flex flex-col gap-1 text-sm font-medium`, children: [
    /* @__PURE__ */ _(Na, { label: n, labelClassName: a, required: e }),
    (r === "" || k) && /* @__PURE__ */ _(
      El,
      {
        className: A(
          "z-1 absolute right-4 h-[21px] w-[21px] translate-y-1/2 scale-75",
          n && "top-[24px]",
          h
        )
      }
    ),
    r !== "" && /* @__PURE__ */ _(
      bt,
      {
        onClick: u,
        className: A(
          "z-1 fill-text-primary absolute right-2 h-[21px] w-[21px] translate-y-1/2 scale-75 cursor-pointer",
          n && "top-[24px]",
          f
        )
      }
    ),
    /* @__PURE__ */ _(
      "input",
      {
        ref: t,
        className: `text-text-primary main-transition-colors bg-background-secondary relative w-full rounded-lg border ${l ? "border-danger" : "border-text-secondary/30"} focus:border-brand-primary placeholder:text-text-tertiary/70 py-2.5 pl-4 pr-8 focus:outline-hidden ${m ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 animate-pulse text-transparent" : "disabled:bg-background-tertiary/40"} ${D.inputClassName || ""}`,
        onKeyDown: (v) => D.type === "number" && ["e", "E", "+", "-"].includes(v.key) && v.preventDefault(),
        type: D.type || "text",
        disabled: D.disabled || m,
        value: r,
        onChange: i,
        onFocus: o,
        maxLength: s,
        placeholder: c || G.t("public_pages_purchase.input.search"),
        spellCheck: !1,
        ...Hn(!!p, `${p}`)
      }
    ),
    /* @__PURE__ */ _(
      ha,
      {
        description: d,
        error: l,
        className: g,
        descriptionClassName: y,
        errorClassName: b
      }
    )
  ] });
}
const yy = ({
  onChange: t,
  value: n = "",
  addonBefore: a,
  withCopyButton: e,
  buttonClassName: r,
  linkIconClassName: i,
  scheme: o = "https://",
  ...s
}) => {
  const l = n.replace(o, "");
  return /* @__PURE__ */ _(
    Sn,
    {
      type: "url",
      addonBefore: a || o,
      value: l,
      onChange: ({ target: { value: u } }) => {
        if (!u || u === o) return t("");
        t(o + u.replace(o, ""));
      },
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: e && /* @__PURE__ */ _(
        "button",
        {
          type: "button",
          onClick: async (u) => {
            u.preventDefault(), await Zd(n, G.t("public_pages_purchase.copy_clipboard"));
          },
          className: A(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            r
          ),
          children: /* @__PURE__ */ _(
            Bl,
            {
              className: A(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                i
              )
            }
          )
        }
      ),
      ...s
    }
  );
}, by = ({
  value: t,
  onChange: n,
  type: a = "float",
  toFixed: e = 2,
  max: r,
  min: i,
  onBlur: o,
  ...s
}) => {
  const [l, c] = ee(t.toString());
  return de(() => {
    c(t.toString());
  }, [t]), /* @__PURE__ */ _(
    Sn,
    {
      value: l,
      onChange: (p) => {
        const m = p.target.value;
        if (a === "integer")
          /^[0-9]*$/.test(m) && c(m);
        else {
          const h = m.replace(",", "."), f = new RegExp(`^-?\\d*(\\.\\d{0,${e}})?$`);
          h.match(f) !== null && c(h);
        }
      },
      onBlur: (p) => {
        let m;
        a === "integer" ? m = parseInt(l, 10) || 0 : m = parseFloat(l) || 0, r !== void 0 && (m = Math.min(m, r)), i !== void 0 && (m = Math.max(m, i)), a === "integer" && (m = Math.max(0, m)), n(m), c(a === "integer" ? m.toString() : m.toFixed(e)), o == null || o(p, m);
      },
      min: a === "integer" ? "0" : void 0,
      type: "text",
      ...s
    }
  );
}, Jg = "react-international-phone-", ul = (...t) => t.filter((n) => !!n).join(" ").trim(), Qg = (...t) => ul(...t).split(" ").map((n) => `${Jg}${n}`).join(" "), Ae = ({ addPrefix: t, rawClassNames: n }) => ul(Qg(...t), ...n), ze = (t) => t.replace(/\D/g, ""), Li = 35, $g = ({
  value: t,
  mask: n,
  maskSymbol: a,
  allowMoreDigitsThanMaskAllows: e,
  offset: r = 0,
  trimNonMaskCharsLeftover: i = !1
}) => {
  if (t.length < r) return t;
  const o = t.slice(0, r), s = t.slice(r);
  let l = o, c = 0;
  for (const d of n.split("")) {
    if (c >= s.length) {
      if (!i && d !== a) {
        l += d;
        continue;
      }
      break;
    }
    d === a ? (l += s[c], c += 1) : l += d;
  }
  let u = ze(l);
  return e && u.length < t.length && (l += t.slice(u.length), u = ze(l)), u.length >= Li && (l = l.slice(0, -(u.length - Li) || void 0)), l;
}, qg = (t, n) => {
  const a = t.style.display;
  a !== "block" && (t.style.display = "block");
  const e = t.getBoundingClientRect(), r = n.getBoundingClientRect(), i = r.top - e.top, o = e.bottom - r.bottom;
  i >= 0 && o >= 0 || (Math.abs(i) < Math.abs(o) ? t.scrollTop += i : t.scrollTop -= o), t.style.display = a;
}, Le = (t) => {
  const [n, a, e, r, i, o, s] = t;
  return {
    name: n,
    regions: a,
    iso2: e,
    dialCode: r,
    format: i,
    priority: o,
    areaCodes: s
  };
}, Xg = (t) => `Field "${t}" is not supported`, Fa = ({
  value: t,
  field: n,
  countries: a,
  defaultCountry: e
}) => {
  if (["regions", "priority"].includes(n))
    throw new Error(Xg(n));
  const r = a.find((i) => {
    const o = Le(i);
    return t === o[n];
  }) || a.find((i) => {
    const o = Le(i);
    return e.toLocaleLowerCase() === o[n];
  });
  if (r)
    return Le(r);
}, Gi = ({
  phone: t,
  countries: n,
  currentCountryIso2: a,
  defaultCountry: e
}) => {
  var l;
  const r = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!t)
    return r;
  const i = ze(t);
  if (!i)
    return r;
  let o = r;
  const s = ({
    country: c,
    fullDialCodeMatch: u,
    areaCodeMatch: d
  }) => {
    var h, f;
    const p = c.dialCode === ((h = o.country) == null ? void 0 : h.dialCode), m = (c.priority ?? 0) < (((f = o.country) == null ? void 0 : f.priority) ?? 0);
    (!p || m) && (o = { country: c, fullDialCodeMatch: u, areaCodeMatch: d });
  };
  for (const c of n) {
    const u = Le(c), { dialCode: d, areaCodes: p } = u;
    if (i.startsWith(d)) {
      const m = o.country ? Number(d) >= Number(o.country.dialCode) : !0;
      if (p) {
        const h = i.substring(d.length);
        for (const f of p)
          if (h.startsWith(f))
            return {
              country: u,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (m || d === i || !o.fullDialCodeMatch) && s({
        country: u,
        fullDialCodeMatch: !0,
        areaCodeMatch: p ? !p : void 0
      });
    }
    o.fullDialCodeMatch || i.length < d.length && d.startsWith(i) && (!o.country || Number(d) <= Number(o.country.dialCode)) && s({ country: u, fullDialCodeMatch: !1 });
  }
  if (a) {
    const c = Fa({
      value: a,
      field: "iso2",
      countries: n,
      defaultCountry: e
    });
    !!o && !!c && // different countries with same dial code
    ((l = o.country) == null ? void 0 : l.dialCode) === c.dialCode && o.country !== c && // full dial code match (without area code)
    o.fullDialCodeMatch && !o.areaCodeMatch && (o = {
      country: c,
      areaCodeMatch: c != null && c.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return o;
}, e_ = ({
  phone: t,
  dialCode: n,
  prefix: a = "+",
  charAfterDialCode: e = " "
}) => {
  if (!t || !n)
    return t;
  let r = t;
  return r.startsWith(a) && (r = r.replace(a, "")), r.startsWith(n) ? (r = r.replace(n, ""), r.startsWith(e) && (r = r.replace(e, "")), r) : t;
}, Fi = ({
  phone: t,
  dialCode: n,
  prefix: a = "+",
  charAfterDialCode: e = " "
}) => `${a}${n}${e}${e_({
  phone: t,
  dialCode: n,
  charAfterDialCode: e,
  prefix: a
})}`, a_ = (t, n) => {
  const a = n.disableDialCodeAndPrefix ? !1 : n.forceDialCode, e = n.disableDialCodeAndPrefix ? !1 : n.insertDialCodeOnEmpty;
  let r = t;
  const i = (c) => n.trimNonDigitsEnd ? c.trim() : c;
  if (!r)
    return e && !r.length || a ? i(`${n.prefix}${n.dialCode}${n.charAfterDialCode}`) : i(r);
  if (r = ze(r), r === n.dialCode && !n.disableDialCodeAndPrefix)
    return i(`${n.prefix}${n.dialCode}${n.charAfterDialCode}`);
  if (n.dialCode.startsWith(r) && !n.disableDialCodeAndPrefix)
    return i(a ? `${n.prefix}${n.dialCode}${n.charAfterDialCode}` : `${n.prefix}${r}`);
  if (!r.startsWith(n.dialCode) && !n.disableDialCodeAndPrefix) {
    if (a)
      return i(`${n.prefix}${n.dialCode}${n.charAfterDialCode}`);
    if (r.length < n.dialCode.length)
      return i(`${n.prefix}${r}`);
  }
  const o = () => {
    let c = n.dialCode.length;
    n.disableDialCodeAndPrefix && (c = 0);
    const u = r.slice(0, c), d = r.slice(c);
    return {
      phoneLeftSide: u,
      phoneRightSide: d
    };
  };
  let { phoneLeftSide: s, phoneRightSide: l } = o();
  return s = `${n.prefix}${s}${n.charAfterDialCode}`, l = $g({
    value: l,
    mask: n.mask,
    maskSymbol: n.maskChar,
    allowMoreDigitsThanMaskAllows: n.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: n.trimNonDigitsEnd
  }), n.disableDialCodeAndPrefix && (s = ""), i(`${s}${l}`);
}, it = (t) => /\d/.test(t), t_ = ({
  phoneBeforeInput: t,
  phoneAfterInput: n,
  phoneAfterFormatted: a,
  cursorPositionAfterInput: e,
  leftOffset: r = 0,
  deletion: i
}) => {
  if (e < r)
    return r;
  if (!t)
    return a.length;
  const o = i === "backward";
  if (e === 0 && n.length > 0 && a.length > 0) {
    if (o) return 0;
    for (let d = 0; d < a.length; d += 1)
      if (it(a[d]))
        return d;
    return a.length;
  }
  if (n.length < t.length && n.length === 1)
    return a.length;
  let s = null;
  for (let d = e - 1; d >= 0; d -= 1)
    if (it(n[d])) {
      s = d;
      break;
    }
  if (s === null)
    return e !== 0 ? e : a.length;
  let l = 0;
  for (let d = 0; d < s; d += 1)
    it(n[d]) && (l += 1);
  o && (l -= 1);
  let c = 0, u = 0;
  for (let d = 0; d < a.length && (c += 1, it(a[d]) && (u += 1), u !== l + 1); d += 1)
    ;
  for (; !it(a[c]) && c < a.length; )
    c += 1;
  return o && (c += 1), c;
}, Cr = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
  ["Faroe Islands", ["europe"], "fo", "298"]
], qn = "fr", n_ = ".", r_ = {
  defaultCountry: qn,
  initialCountry: qn,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: Cr,
  dontShowDialCodePrefillOnFocus: !1
}, i_ = (t, n) => {
  const a = parseInt(t, 16);
  return Number(a + n).toString(16);
}, o_ = "abcdefghijklmnopqrstuvwxyz", s_ = "1f1e6", Ki = o_.split("").reduce((t, n, a) => ({
  ...t,
  // construct alphabet by incrementing A letter codepoint value
  [n]: i_(s_, a)
}), {}), l_ = (t) => [Ki[t[0]], Ki[t[1]]].join("-"), dl = ({
  iso2: t,
  size: n = "24px",
  protocol: a = "https",
  disableLazyLoading: e,
  className: r,
  ...i
}) => {
  if (!t)
    return /* @__PURE__ */ _("img", { width: n, height: n, ...i });
  const o = l_(t), s = `${a}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${o}.svg`;
  return /* @__PURE__ */ _(
    "img",
    {
      alt: t,
      className: Ae({
        addPrefix: ["flag-emoji"],
        rawClassNames: [r]
      }),
      src: s,
      width: n,
      height: n,
      draggable: !1,
      "data-country": t,
      loading: e ? void 0 : "lazy",
      ...i
    }
  );
}, pl = ({
  show: t,
  dialCodePrefix: n = "+",
  selectedCountry: a,
  countries: e = Cr,
  onSelect: r,
  onClose: i,
  searchInputPlaceholder: o,
  ...s
}) => {
  const l = ue(null), c = ue(null), u = ue(void 0), [d, p] = ee(""), m = Qa(() => {
    if (d) {
      const S = d.toLowerCase();
      return e.filter(([w]) => w.toLowerCase().includes(S));
    } else
      return e;
  }, [e, d]), h = Sa(
    (S) => m.findIndex((w) => Le(w).iso2 === S),
    [m]
  ), [f, g] = ee(h(a)), y = () => {
    u.current !== a && g(h(a));
  }, b = Sa(
    (S) => {
      g(h(S.iso2)), r == null || r(S);
    },
    [r, h]
  ), k = (S) => {
    const w = m.length - 1, M = (P) => S === "prev" ? P - 1 : S === "next" ? P + 1 : S === "last" ? w : 0;
    g((P) => {
      const N = M(P);
      return N < 0 ? 0 : N > w ? w : N;
    });
  }, D = (S) => {
    if (S.stopPropagation(), S.key === "Enter") {
      const w = Le(m[f]);
      b(w);
      return;
    }
    if (S.key === "Escape") {
      i == null || i();
      return;
    }
    if (S.key === "ArrowUp") {
      S.preventDefault(), k("prev");
      return;
    }
    if (S.key === "ArrowDown") {
      S.preventDefault(), k("next");
      return;
    }
    if (S.key === "PageUp") {
      S.preventDefault(), k("first");
      return;
    }
    if (S.key === "PageDown") {
      S.preventDefault(), k("last");
      return;
    }
    S.key === " " && S.preventDefault();
  }, v = Sa(() => {
    if (!c.current || f === void 0 || !m[f])
      return;
    const S = Le(m[f]).iso2;
    if (S === u.current) return;
    const w = c.current.querySelector(`[data-country="${S}"]`);
    w && (qg(c.current, w), u.current = S);
  }, [f, m]);
  return de(() => {
    v();
  }, [f, v]), de(() => {
    l.current && (t ? Promise.resolve().then(() => {
      var S;
      return (S = l.current) == null ? void 0 : S.focus();
    }) : y());
  }, [t]), de(() => {
    y();
  }, [a]), /* @__PURE__ */ L(
    "div",
    {
      className: Ae({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [s.className]
      }),
      style: { display: t ? "block" : "none", ...s.style },
      tabIndex: -1,
      "aria-activedescendant": `${m[f] && Le(m[f]).iso2}-option`,
      onBlur: i,
      children: [
        /* @__PURE__ */ _(
          "input",
          {
            ref: l,
            className: Ae({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [s.searchInputClassName]
            }),
            placeholder: o || "",
            style: s.searchInputStyle,
            type: "text",
            value: d,
            onChange: (S) => p(S.target.value),
            onKeyDown: D
          }
        ),
        d && /* @__PURE__ */ _(
          bt,
          {
            onClick: () => p(""),
            className: Ae({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [s.clearSearchInputClassName]
            }),
            style: s.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ _(
          "ul",
          {
            ref: c,
            role: "listbox",
            className: Ae({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [s.listClassName]
            }),
            style: s.listStyle,
            children: m.map((S, w) => {
              const M = Le(S), P = M.iso2 === a, N = w === f;
              return /* @__PURE__ */ L(
                "li",
                {
                  "data-country": M.iso2,
                  "data-focused": N,
                  role: "option",
                  "aria-selected": P,
                  "aria-label": `${M.name} ${n}${M.dialCode}`,
                  id: `${M.iso2}-option`,
                  className: Ae({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      P && "country-selector-dropdown__list-item--selected",
                      N && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [s.listItemClassName]
                  }),
                  onClick: () => b(M),
                  style: s.listItemStyle,
                  children: [
                    /* @__PURE__ */ _(
                      dl,
                      {
                        iso2: M.iso2,
                        className: Ae({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [s.listItemFlagClassName]
                        }),
                        style: s.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ _(
                      "span",
                      {
                        className: Ae({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [s.listItemCountryNameClassName]
                        }),
                        style: s.listItemCountryNameStyle,
                        children: M.name
                      }
                    ),
                    /* @__PURE__ */ L(
                      "span",
                      {
                        className: Ae({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [s.listItemDialCodeClassName]
                        }),
                        style: s.listItemDialCodeStyle,
                        children: [
                          n,
                          M.dialCode
                        ]
                      }
                    )
                  ]
                },
                M.iso2
              );
            })
          }
        )
      ]
    }
  );
}, c_ = ({
  selectedCountry: t,
  onSelect: n,
  disabled: a,
  hideDropdown: e,
  defaultCountry: r = qn,
  countries: i = Cr,
  renderButtonWrapper: o,
  ...s
}) => {
  const [l, c] = ee(!1), u = Qa(() => {
    if (t)
      return Fa({
        value: t,
        field: "iso2",
        countries: i,
        defaultCountry: r
      });
  }, [i, r, t]), d = ue(null), p = (h) => {
    h.key && ["ArrowUp", "ArrowDown"].includes(h.key) && (h.preventDefault(), c(!0));
  }, m = () => {
    const h = {
      title: u == null ? void 0 : u.name,
      onClick: () => c((g) => !g),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (g) => g.preventDefault(),
      onKeyDown: p,
      disabled: e || a,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": l
    }, f = /* @__PURE__ */ L(
      "div",
      {
        className: Ae({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [s.buttonContentWrapperClassName]
        }),
        style: s.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ _(
            dl,
            {
              iso2: t,
              className: Ae({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  a && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [s.flagClassName]
              }),
              style: {
                visibility: t ? "visible" : "hidden",
                ...s.flagStyle
              }
            }
          ),
          !e && /* @__PURE__ */ _(
            "div",
            {
              className: Ae({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  a && "country-selector-button__dropdown-arrow--disabled",
                  l && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [s.dropdownArrowClassName]
              }),
              style: s.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return o ? o({
      children: f,
      rootProps: h
    }) : /* @__PURE__ */ _(
      "button",
      {
        ...h,
        type: "button",
        className: Ae({
          addPrefix: [
            "country-selector-button",
            l && "country-selector-button--active",
            a && "country-selector-button--disabled",
            e && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [s.buttonClassName]
        }),
        "data-country": t,
        style: s.buttonStyle,
        children: f
      }
    );
  };
  return /* @__PURE__ */ L(
    "div",
    {
      className: Ae({
        addPrefix: ["country-selector"],
        rawClassNames: [s.className]
      }),
      style: s.style,
      ref: d,
      children: [
        m(),
        /* @__PURE__ */ _(
          pl,
          {
            show: l,
            countries: i,
            onSelect: (h) => {
              c(!1), n == null || n(h);
            },
            selectedCountry: t,
            onClose: () => {
              c(!1);
            },
            ...s.dropdownStyleProps
          }
        )
      ]
    }
  );
}, u_ = () => {
  const t = ue(void 0), n = ue(Date.now());
  return {
    check: () => {
      const e = Date.now(), r = t.current ? e - n.current : void 0;
      return t.current = n.current, n.current = e, r;
    }
  };
}, d_ = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function p_(t, n) {
  const { size: a, overrideLastItemDebounceMS: e, onChange: r } = {
    ...d_,
    ...n
  }, [i, o] = ee(t), [s, l] = ee([i]), [c, u] = ee(0), d = u_();
  return [i, (f, g) => {
    if (
      // compare entries if passed value is object
      typeof f == "object" && Object.entries(f).toString() === Object.entries(i).toString() || f === i
    )
      return;
    const y = e > 0, b = d.check(), k = y && b !== void 0 ? b > e : !0;
    if (
      // use value of config.overrideLastItem if passed
      (g == null ? void 0 : g.overrideLastItem) !== void 0 ? g.overrideLastItem : !k
    )
      l((v) => [...v.slice(0, c), f]);
    else {
      const v = s.length >= a;
      l((S) => [...S.slice(v ? 1 : 0, c + 1), f]), v || u((S) => S + 1);
    }
    o(f), r == null || r(f);
  }, () => {
    if (c <= 0)
      return { success: !1 };
    const f = s[c - 1];
    return o(f), u((g) => g - 1), r == null || r(f), { success: !0, value: f };
  }, () => {
    if (c + 1 >= s.length)
      return { success: !1 };
    const f = s[c + 1];
    return o(f), u((g) => g + 1), r == null || r(f), { success: !0, value: f };
  }];
}
const m_ = n_, De = r_, h_ = ({
  defaultCountry: t = De.defaultCountry,
  initialCountry: n = De.initialCountry,
  value: a = De.value,
  countries: e = De.countries,
  prefix: r = De.prefix,
  defaultMask: i = De.defaultMask,
  allowMoreDigitsThanMaskAllows: o = De.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: s = De.charAfterDialCode,
  historySaveDebounceMS: l = De.historySaveDebounceMS,
  disableCountryGuess: c = De.disableCountryGuess,
  disableDialCodePrefill: u = De.disableDialCodePrefill,
  forceDialCode: d = De.forceDialCode,
  disableDialCodeAndPrefix: p = De.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: m = De.dontShowDialCodePrefillOnFocus,
  onChange: h
}) => {
  const f = a || "", g = p ? !1 : !c, y = ue(null), b = ({
    value: T,
    country: I,
    trimNonDigitsEnd: V,
    insertDialCodeOnEmpty: U,
    forceDisableCountryGuess: ae
  }) => {
    const ge = !ae && g ? Gi({
      phone: T,
      countries: e,
      currentCountryIso2: I.iso2,
      defaultCountry: t
    }) : void 0, Me = (ge == null ? void 0 : ge.country) ?? I;
    return { phone: Me ? a_(T, {
      prefix: r,
      mask: Me.format || i,
      maskChar: m_,
      dialCode: Me.dialCode,
      allowMoreDigitsThanMaskAllows: o,
      trimNonDigitsEnd: V,
      charAfterDialCode: s,
      forceDialCode: d,
      insertDialCodeOnEmpty: U,
      disableDialCodeAndPrefix: p
    }) : T, countryGuessResult: ge, formatCountry: Me };
  }, k = (T) => {
    typeof document < "u" && document.activeElement === y.current && Promise.resolve().then(() => {
      var I;
      (I = y.current) == null || I.setSelectionRange(T, T);
    });
  }, D = Sa(
    ({ phone: T, country: I }) => h == null ? void 0 : h({
      phone: T,
      unformatedPhone: ze(T),
      country: I,
      prefix: r
    }),
    [h, r]
  ), [{ phone: v, country: S }, w, M, P] = p_(
    () => {
      const I = Gi({
        phone: f,
        countries: e,
        currentCountryIso2: n,
        defaultCountry: t
      }).country || Fa({
        value: n,
        field: "iso2",
        countries: e,
        defaultCountry: t
      });
      I || console.error(
        `[react-international-phone]: can not find a country with "${t}" iso2 code`
      );
      const V = I || // set "us" if user provided not valid country
      Le(e.find((ae) => Le(ae).iso2 === t)), U = b({
        value: f,
        country: V,
        insertDialCodeOnEmpty: m ? !u : !1
      }).phone;
      return k(U.length), {
        phone: U,
        country: V.iso2
      };
    },
    {
      overrideLastItemDebounceMS: l,
      onChange: D
    }
  ), N = Qa(() => Fa({
    value: S,
    field: "iso2",
    countries: e,
    defaultCountry: t
  }), [e, S, t]), B = Sa(() => {
    var T;
    m || (T = y == null ? void 0 : y.current) != null && T.value || D == null || D({
      phone: Fi({
        phone: v,
        dialCode: N.dialCode,
        charAfterDialCode: s,
        prefix: r
      }),
      country: S
    });
  }, [
    s,
    S,
    N,
    D,
    v,
    r,
    m
  ]), R = (T, {
    deletion: I,
    cursorPosition: V,
    insertDialCodeOnEmpty: U,
    inserted: ae
  } = {}) => {
    var qa;
    let me = T, ge = V;
    d && !p && N && // dial code has been changed
    !ze(T).startsWith(N.dialCode) && T && (ae && T.startsWith(r) && // cursor position was set to 0 before the input
    T.length - (V ?? 0) === 0 ? me = T : (me = v, ge = 0));
    const { phone: Me, countryGuessResult: Be } = b({
      value: me,
      country: N,
      trimNonDigitsEnd: I === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: U,
      forceDisableCountryGuess: d && !!I && ze(me).length < N.dialCode.length
    });
    let fa = N;
    g && (Be != null && Be.country) && Be.country.name !== S && Be.fullDialCodeMatch && (fa = Be.country);
    const Ea = t_({
      cursorPositionAfterInput: ge ?? 0,
      phoneBeforeInput: v,
      phoneAfterInput: T,
      phoneAfterFormatted: Me,
      leftOffset: d ? r.length + (((qa = N == null ? void 0 : N.dialCode) == null ? void 0 : qa.length) ?? 0) + s.length : 0,
      deletion: I
    });
    return w({
      phone: Me,
      country: fa.iso2
    }), k(Ea), Me;
  };
  de(() => {
    const T = y.current;
    if (!T) return;
    const I = (V) => {
      if (!V.key) return;
      const U = V.ctrlKey, ae = V.shiftKey, me = V.key.toLowerCase() === "z";
      !U || !me || (ae ? P() : M());
    };
    return T.addEventListener("keydown", I), () => {
      T.removeEventListener("keydown", I);
    };
  }, [y, M, P]);
  const F = (T) => {
    T.preventDefault();
    const I = T.nativeEvent.inputType, V = () => {
      if ((I == null ? void 0 : I.toLocaleLowerCase().includes("delete")) ?? !1)
        return I != null && I.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, U = I == null ? void 0 : I.startsWith("insertFrom"), ae = R(T.target.value, {
      deletion: V(),
      inserted: U,
      cursorPosition: T.target.selectionStart ?? 0
    });
    return p && N ? Fi({
      phone: ae,
      dialCode: N.dialCode,
      charAfterDialCode: s,
      prefix: r
    }) : ae;
  }, x = (T) => {
    const I = Fa({
      value: T,
      field: "iso2",
      countries: e,
      defaultCountry: t
    });
    if (!I) return;
    const V = p ? "" : `${r}${I.dialCode}${s}`;
    w({
      phone: V,
      country: I.iso2
    }), Promise.resolve().then(() => {
      var U;
      (U = y.current) == null || U.focus();
    });
  }, [K, z] = ee(!1);
  return de(() => {
    if (!K) {
      z(!0), f !== v && (D == null || D({ phone: v, country: S }));
      return;
    }
    ze(f) !== ze(v) && R(ze(f));
  }, [f]), de(() => {
    if (!v && n) {
      const T = Fa({
        value: n,
        field: "iso2",
        countries: e,
        defaultCountry: t
      });
      w({
        phone: v,
        country: (T == null ? void 0 : T.iso2) || t
      });
    }
  }, [n]), {
    phone: v,
    // Formatted phone string.
    country: S,
    // Current country iso code.
    setCountry: x,
    // Country setter.
    handlePhoneValueChange: F,
    // Change handler for input component
    onFocus: B,
    inputRef: y
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
}, vy = ({
  label: t,
  labelClassName: n,
  required: a,
  value: e,
  onChange: r,
  error: i,
  wrapperClassName: o,
  inputClassName: s,
  listClassName: l,
  searchInputClassName: c,
  clearSearchInputClassName: u,
  listItemClassName: d,
  listItemCountryNameClassName: p,
  countrySelectorDropdownClassName: m,
  countrySelectorClassName: h,
  buttonClassName: f,
  listboxButtonClassName: g,
  listboxOptionsClassName: y,
  initialCountry: b,
  ...k
}) => {
  const D = ue(null), v = ue(null), S = ue(null), { country: w, setCountry: M, phone: P, handlePhoneValueChange: N, onFocus: B, inputRef: R } = h_({
    value: e,
    onChange: ({ unformatedPhone: F }) => r(F),
    initialCountry: b == null ? void 0 : b.toLowerCase()
  });
  return /* @__PURE__ */ _("div", { className: o, children: /* @__PURE__ */ _(ar, { children: ({ open: F }) => {
    var x;
    return /* @__PURE__ */ L(Ee, { children: [
      /* @__PURE__ */ L("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ _(
          Na,
          {
            label: t,
            required: a,
            labelClassName: A("text-sm font-medium", n)
          }
        ),
        /* @__PURE__ */ L(
          "div",
          {
            ref: v,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ L(
                zt,
                {
                  ref: S,
                  as: "div",
                  role: "button",
                  disabled: k.disabled,
                  className: A(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    g,
                    k.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ _(
                      c_,
                      {
                        className: A("flex", h),
                        buttonStyle: { border: "none" },
                        buttonClassName: A(
                          k.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          f
                        ),
                        hideDropdown: !0,
                        disabled: k.disabled,
                        selectedCountry: w,
                        defaultCountry: b == null ? void 0 : b.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ _(
                      qi,
                      {
                        className: `transition-transform duration-300 ${F && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ _(
                Sn,
                {
                  ref: R,
                  type: "tel",
                  placeholder: G.t("public_pages_purchase.input.phone_number"),
                  inputClassName: A(
                    "pl-16",
                    F && "border-brand-primary",
                    s
                  ),
                  value: P,
                  onChange: N,
                  onFocus: B,
                  error: i,
                  ...k
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ _(
        tr,
        {
          className: A("focus-visible:outline-hidden", y),
          children: /* @__PURE__ */ _(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: D,
              style: {
                width: `${(x = R.current) == null ? void 0 : x.clientWidth}px`
              },
              children: /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
                pl,
                {
                  className: A(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    m
                  ),
                  listClassName: A(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    l
                  ),
                  searchInputClassName: A(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    c
                  ),
                  clearSearchInputClassName: A(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    u
                  ),
                  listItemClassName: A(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    d
                  ),
                  listItemCountryNameClassName: A(
                    "truncate",
                    p
                  ),
                  searchInputPlaceholder: G.t("public_pages_purchase.input.phone_search"),
                  show: F,
                  selectedCountry: w,
                  onSelect: (K) => {
                    var z;
                    M(K.iso2), (z = S.current) == null || z.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
}, f_ = (t) => {
  const n = {
    h: "-",
    hh: "--",
    H: "-",
    HH: "--",
    m: "-",
    mm: "--",
    s: "-",
    ss: "--",
    a: "AM/PM"
  };
  return t.split(/([^\w])/g).map((a) => n[a] || a).join("");
}, ml = (t, n) => {
  const a = {
    d: "dd",
    // Day of the month, 2 digits with leading zero
    m: "MM",
    // Month, 2 digits with leading zero
    Y: "yyyy"
    // Year, 4 digits
  }, e = {
    h: "hh",
    // Hour in 12-hour format, 2 digits with leading zero
    H: "HH",
    // Hour in 24-hour format, 2 digits with leading zero
    i: "mm",
    // Minutes, 2 digits with leading zero
    s: "ss",
    // Seconds, 2 digits with leading zero
    A: "a"
    // AM/PM marker
  }, r = (s, l) => s.split(/([ :/])/).map(
    (c) => c.split("").map((u) => l[u] || u).join("")
  ).join(""), i = r(t, e), o = r(n, a);
  return {
    timeFormat: i,
    dateFormat: o
  };
}, Sy = ({
  seconds: t,
  onChangeSeconds: n,
  containerClassName: a,
  userDateFormat: e,
  userTimeFormat: r,
  classNameCustomInput: i,
  wrapperClassName: o,
  showTimeSelect: s = !0,
  showTimeSelectOnly: l = !0,
  timeIntervals: c = 15,
  ...u
}) => {
  const { timeFormat: d } = e && r ? ml(r, e) : { timeFormat: "HH:mm" };
  return (
    // react-datepicker create a popup component as sibling which can cause "jumping" if parent has flex property
    /* @__PURE__ */ _("div", { className: A("w-min", a), children: /* @__PURE__ */ _(
      vn,
      {
        disabled: u.disabled || u.isPreFetching,
        selected: typeof t == "number" ? Yg(t) : null,
        onChange: (p) => {
          p && n(Oi(p));
        },
        showPopperArrow: !1,
        showTimeSelect: s,
        showTimeSelectOnly: l,
        timeIntervals: c,
        timeCaption: G.t("public_pages_purchase.date_picker.time"),
        timeFormat: d,
        dateFormat: d,
        popperModifiers: [Mt(), yn({ padding: 5, crossAxis: !0 })],
        placeholderText: f_(d),
        customInput: /* @__PURE__ */ _(Sn, { className: A("w-32", i), ...u }),
        timeClassName: (p) => t === Oi(p) ? "text-brand-primary" : "text-text-primary",
        wrapperClassName: A("time-only", o)
      }
    ) })
  );
};
var Xn = /* @__PURE__ */ ((t) => (t.DateSince = "dateSince", t.DateTill = "dateTill", t))(Xn || {}), dt = /* @__PURE__ */ ((t) => (t.Last30Days = "last_30_days", t.ThisMonth = "this_month", t.LastMonth = "last_month", t))(dt || {}), wa = /* @__PURE__ */ ((t) => (t.AllTime = "all_time", t.Last3Months = "last_3_months", t.EvaluationPeriod = "evaluation_period", t))(wa || {});
const kn = yt(
  ({
    onClick: t,
    error: n,
    label: a,
    labelClassName: e,
    required: r,
    wrapperButtonInputClassName: i,
    buttonInputClassName: o,
    description: s,
    children: l,
    value: c
  }, u) => /* @__PURE__ */ L("div", { className: A("flex flex-col gap-1", i), children: [
    /* @__PURE__ */ _(Na, { label: a, labelClassName: e, required: r }),
    /* @__PURE__ */ L("button", { onClick: t, ref: u, type: "button", className: o, children: [
      l(c),
      /* @__PURE__ */ _(
        Rl,
        {
          className: A(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            c ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ _(ha, { error: n, description: s })
  ] })
);
kn.displayName = "ButtonInput";
const Dr = ({
  date: t,
  prevMonthButtonDisabled: n,
  nextMonthButtonDisabled: a,
  increaseMonth: e,
  decreaseMonth: r,
  intlLocale: i
}) => /* @__PURE__ */ L("div", { className: "flex items-center justify-between px-2 py-2", children: [
  /* @__PURE__ */ _(
    "button",
    {
      onClick: r,
      disabled: n,
      type: "button",
      className: A(
        "group rounded-full outline-hidden  ",
        n && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ _(Ol, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  ),
  /* @__PURE__ */ _("span", { className: "text-text-primary text-base", children: new Intl.DateTimeFormat(i, {
    month: "long",
    year: "numeric"
  }).format(t) }),
  /* @__PURE__ */ _(
    "button",
    {
      onClick: e,
      disabled: a,
      type: "button",
      className: A(
        "group rounded-full outline-hidden ",
        a && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ _(Xi, { className: "fill-text-primary group-focus-visible:fill-brand-primary group-active:fill-brand-primary" })
    }
  )
] }), Pr = (t, n) => {
  de(() => {
    (async () => {
      try {
        if (t) {
          let e;
          switch (t) {
            case Z.ENGLISH:
            case "en":
              e = (await Promise.resolve().then(() => Nn)).enUS;
              break;
            case Z.FRENCH:
            case "fr":
              e = (await import("./fr-BR2ir8B9.mjs")).fr;
              break;
            case Z.SPANISH:
            case "es":
              e = (await import("./es-dGMgnVgS.mjs")).es;
              break;
            case Z.ITALIAN:
            case "it":
              e = (await import("./it-Co-sgXZS.mjs")).it;
              break;
            case Z.PORTUGUESE:
            case "pt":
              e = (await import("./pt-D7R8QORH.mjs")).pt;
              break;
            case Z.DEUTSCH:
            case "de":
              e = (await import("./de-B6_J_9Rl.mjs")).de;
              break;
            case Z.DUTCH:
            case "nl":
              e = (await import("./nl-CHHQpBAa.mjs")).nl;
              break;
            case Z.RUSSIAN:
            case "ru":
              e = (await import("./ru-DGzeP8YQ.mjs")).ru;
              break;
            case Z.JAPANESE:
            case "ja":
              e = (await import("./ja-CSPng3Um.mjs")).ja;
              break;
            case Z.ARABIC:
            case "ar":
              e = (await import("./ar-Bg5PABd9.mjs")).ar;
              break;
            case Z.TURKISH:
            case "tr":
              e = (await import("./tr-DZyJcupl.mjs")).tr;
              break;
            case Z.CHINESE:
            case "zh":
              e = (await import("./zh-CN-Cci4bs_8.mjs")).zhCN;
              break;
            case Z.SWEDISH:
            case "sv":
              e = (await import("./sv-BJoY32A-.mjs")).sv;
              break;
            case Z.ROMANIAN:
            case "ro":
              e = (await import("./ro-NMif-Epg.mjs")).ro;
              break;
            case Z.CZECH:
            case "cs":
              e = (await import("./cs-DhnD-hA2.mjs")).cs;
              break;
            case Z.HUNGARIAN:
            case "hu":
              e = (await import("./hu-C_D6LJCx.mjs")).hu;
              break;
            case Z.SLOVAK:
            case "sk":
              e = (await import("./sk-BEzGA4Eg.mjs")).sk;
              break;
            case Z.DANISH:
            case "da":
              e = (await import("./da-BkNYfbMh.mjs")).da;
              break;
            case Z.INDONESIAN:
            case "id":
              e = (await import("./id-DWZRpdX4.mjs")).id;
              break;
            case Z.POLISH:
            case "pl":
              e = (await import("./pl-CYGnUlc6.mjs")).pl;
              break;
            case Z.GREEK:
            case "el":
              e = (await import("./el-Chh2lFt8.mjs")).el;
              break;
            case Z.SERBIAN:
            case "sr":
              e = (await import("./sr-Bc7OTzgh.mjs")).sr;
              break;
            case Z.NORWEGIAN:
            case "no":
              e = (await import("./nb-4xyGp2qL.mjs")).nb;
              break;
            case Z.THAI:
            case "th":
              e = (await import("./th-lcgWY3ib.mjs")).th;
              break;
            case Z.SLOVENIAN:
            case "sl":
              e = (await import("./sl-DIe6Z5kj.mjs")).sl;
              break;
            case Z.UKRAINIAN:
            case "uk":
              e = (await import("./uk-Cqc-OhdT.mjs")).uk;
              break;
            case Z.ALBANIA:
            case "sq":
              e = (await import("./sq-5JOrivNJ.mjs")).sq;
              break;
            case Z.HINDI:
            case "hi":
              e = (await import("./hi-B1SFGuUC.mjs")).hi;
              break;
            default:
              e = (await Promise.resolve().then(() => Nn)).enUS;
              break;
          }
          n(e);
        } else {
          const e = (await Promise.resolve().then(() => Nn)).enUS;
          n(e);
        }
      } catch (e) {
        console.error("Error loading locale:", e), n(xa);
      }
    })();
  }, [t, n]);
}, ky = ({
  value: t,
  onChange: n,
  error: a,
  label: e,
  required: r,
  placeholder: i,
  description: o,
  customProps: s,
  wrapperButtonInputClassName: l,
  labelClassName: c,
  timezone: u,
  intlLocale: d,
  disableApplyButton: p,
  userTimeFormat: m,
  userDateFormat: h
}) => {
  const [f, g] = ee(
    t && ce(t, u) || null
  ), [y, b] = ee(
    t && ce(t, u) || null
  ), [k, D] = ee(xa), v = ue(null);
  de(() => {
    t && !f && !y && u && (g(ce(t, u)), b(ce(t, u)));
  }, [t, u, f, y]), Pr(d, D);
  const { timeFormat: S, dateFormat: w } = h && m ? ml(m, h) : { timeFormat: "HH:mm", dateFormat: "dd/MM/yyyy" };
  return /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
    vn,
    {
      ref: v,
      required: r,
      selected: f,
      showPopperArrow: !1,
      showTimeSelect: !0,
      dayClassName: (M) => f && y && M.toDateString() === y.toDateString() && f.toDateString() !== y.toDateString() ? "text-brand-primary/50" : "",
      timeClassName: (M) => f && y && M.getTime() === y.getTime() && f.getTime() !== y.getTime() ? "text-brand-primary/50" : ".",
      shouldCloseOnSelect: !1,
      onCalendarClose: () => {
        g(y);
      },
      timeFormat: S,
      dateFormat: w,
      timeIntervals: 15,
      timeCaption: G.t("public_pages_purchase.date_picker.time"),
      timeInputLabel: G.t("public_pages_purchase.date_picker.time"),
      onChange: (M) => {
        M && g(M);
      },
      locale: k,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperModifiers: [Mt(), yn({ padding: 5, crossAxis: !0 })],
      customInput: /* @__PURE__ */ _(
        kn,
        {
          error: a,
          label: e,
          required: r,
          wrapperButtonInputClassName: l,
          buttonInputClassName: `flex group justify-between min-w-[250px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${a ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          description: o,
          labelClassName: c,
          children: () => /* @__PURE__ */ _("span", { children: y ? new Intl.DateTimeFormat(d, {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "numeric",
            hour12: m === ot.hourMinuteAmPm || m === ot.hourMinuteSecondAmPm,
            minute: "numeric",
            second: m === ot.hourMinuteSecond || m === ot.hourMinuteSecondAmPm ? "numeric" : void 0
          }).format(y) : /* @__PURE__ */ _("span", { className: "text-text-tertiary/70", children: i }) })
        }
      ),
      renderCustomHeader: ({
        date: M,
        decreaseMonth: P,
        increaseMonth: N,
        prevMonthButtonDisabled: B,
        nextMonthButtonDisabled: R
      }) => /* @__PURE__ */ _(
        Dr,
        {
          date: M,
          decreaseMonth: P,
          increaseMonth: N,
          prevMonthButtonDisabled: B,
          nextMonthButtonDisabled: R,
          intlLocale: d
        }
      ),
      ...s,
      children: /* @__PURE__ */ L("div", { className: "flex w-full justify-center gap-5 sm:col-span-2", children: [
        /* @__PURE__ */ _(
          ps,
          {
            disabled: !f || (p == null ? void 0 : p(f)),
            onClick: () => {
              var M;
              f && ((M = v.current) == null || M.setOpen(!1), b(f), n(ba(f)));
            },
            width: "large",
            children: G.t("public_pages_purchase.date_picker.apply")
          }
        ),
        /* @__PURE__ */ _(
          ms,
          {
            onClick: () => {
              var M;
              (M = v.current) == null || M.setOpen(!1), b(null), n(null);
            },
            width: "large",
            children: G.t("public_pages_purchase.date_picker.clear")
          }
        )
      ] })
    }
  ) });
}, g_ = {
  [dt.Last30Days]: "public_pages_purchase.date_picker.last_30_days",
  [dt.ThisMonth]: "public_pages_purchase.date_picker.this_month",
  [dt.LastMonth]: "public_pages_purchase.date_picker.last_month"
}, __ = {
  [wa.AllTime]: "public_pages_purchase.date_picker.all_time",
  [wa.Last3Months]: "public_pages_purchase.date_picker.last_3_months",
  [wa.EvaluationPeriod]: "public_pages_purchase.date_picker.last_pool_period"
}, y_ = (t) => G.t(g_[t]), b_ = (t) => G.t(__[t]), v_ = (t, n, a) => (t && n && Ds(n, t) > a && (t = new Date(n.getTime() - a * 24 * 60 * 60 * 1e3)), [t, n]), S_ = (t) => Object.values(wa).includes(
  t
), k_ = ({
  activeFilter: t,
  setDateRange: n,
  timezone: a,
  customFilters: e
}) => {
  var i;
  if (S_(t)) {
    const o = (i = e.find((s) => s.slug === t)) == null ? void 0 : i.handler;
    o && n(o());
  } else
    switch (t) {
      case "last_30_days": {
        const o = ce("", a);
        o.setHours(23, 59, 59, 999);
        const s = new Date(o);
        s.setDate(s.getDate() - 30), s.setHours(0, 0, 0, 0), n([s, o]);
        break;
      }
      case "this_month": {
        const o = ce("", a), s = o.getFullYear(), l = o.getMonth(), c = new Date(s, l, 1), u = new Date(s, l + 1, 0);
        n([c, u]);
        break;
      }
      case "last_month": {
        const o = ce("", a), s = o.getFullYear(), l = o.getMonth(), c = new Date(s, l - 1, 1), u = new Date(s, l, 0);
        n([c, u]);
        break;
      }
    }
}, M_ = (t, n) => {
  const a = ce("", n);
  return a.setHours(23, 59, 59, 999), [ce(t, n), a];
}, w_ = (t) => {
  const n = ce("", t);
  n.setHours(23, 59, 59, 999);
  const a = ce("", t);
  return a.setMonth(a.getMonth() - 3), a.setHours(0, 0, 0, 0), [a, n];
}, Hi = (t, n) => ({
  slug: wa.AllTime,
  handler: () => M_(t, n)
}), My = (t) => ({
  slug: wa.Last3Months,
  handler: () => w_(t)
}), C_ = (t) => (t.setHours(0, 0, 0, 0), t), hl = (t) => (t.setHours(23, 59, 59, 999), t), wy = ({
  date: t,
  light: n,
  getDefaultDate: a,
  small: e,
  customFilters: r,
  filtersDisabled: i,
  onChange: o,
  placeholder: s,
  error: l,
  description: c,
  disabled: u,
  label: d,
  required: p,
  maxDate: m,
  minDate: h,
  wrapperButtonInputClassName: f,
  intlLocale: g,
  createdAt: y,
  timezone: b,
  dateFormat: k,
  customProps: D,
  labelClassName: v,
  maxInterval: S,
  showActionsSideBar: w = !0
}) => {
  const M = ue(null), [P, N] = ee(xa), B = Qa(
    () => (h && ba(h)) ?? y,
    [h, y]
  ), R = (re) => !g || !B || !re ? re : Ot(B) > Ot(re) ? B : re, [F, x] = t, K = R(t[0]), [z, T] = ee(), [I, V] = ee(), [U, ae] = ee([
    K && ce(K, b) || null,
    x && ce(x, b) || null
  ]), [me, ge] = U, [Me, Be] = ee(
    K && ce(K, b) || null
  ), [fa, Ea] = ee(
    x && ce(x, b) || null
  );
  de(() => {
    !b || !B || k_({
      activeFilter: I,
      timezone: b,
      setDateRange: ae,
      customFilters: r || [Hi(B, b)]
    });
  }, [z, I, r, B]), Pr(g, N), de(() => {
    if (K && x && b) {
      const re = ce(K, b), oe = ce(x, b);
      ae([re, oe]), Be(re), Ea(oe);
    }
  }, [t, K, x, b]);
  const qa = /* @__PURE__ */ L("div", { className: "flex w-full flex-col gap-3 px-2 sm:flex-row sm:gap-5", children: [
    /* @__PURE__ */ L("div", { className: "flex w-fit sm:w-full", children: [
      /* @__PURE__ */ L("span", { className: "text-text-secondary pr-1", children: [
        G.t("public_pages_purchase.date_picker.from"),
        ":"
      ] }),
      /* @__PURE__ */ _("span", { className: "text-text-primary", children: me ? Wr(me, { dateFormat: k }) : "-" })
    ] }),
    /* @__PURE__ */ L("div", { className: "flex w-fit sm:w-full sm:pl-2", children: [
      /* @__PURE__ */ L("span", { className: "text-text-secondary pr-1", children: [
        G.t("public_pages_purchase.date_picker.to"),
        ":"
      ] }),
      /* @__PURE__ */ _("span", { className: "text-text-primary", children: ge ? Wr(ge, { dateFormat: k }) : "-" })
    ] })
  ] }), Ar = /* @__PURE__ */ L(Ee, { children: [
    /* @__PURE__ */ _(
      ms,
      {
        disabled: u,
        onClick: () => {
          var re;
          if ((re = M.current) == null || re.setOpen(!1), a) {
            const [oe, $e] = a(), Mn = R(oe) ?? void 0, Dt = ce(Mn, b), Nr = ce($e, b);
            Ea(Nr), Be(Dt), o([
              ba(Dt),
              ba(Nr)
            ]);
          } else
            Ea(null), Be(null), o([null, null]);
          T(void 0);
        },
        className: "w-full",
        children: G.t("public_pages_purchase.date_picker.clear")
      }
    ),
    /* @__PURE__ */ _(
      ps,
      {
        disabled: !U[0] || !U[1] || u,
        className: "w-full",
        onClick: () => {
          var $e;
          const [re, oe] = U;
          re && oe ? (Be(re), Ea(oe), T(I), C_(re), hl(oe), o([ba(re), ba(oe)])) : o([null, null]), ($e = M.current) == null || $e.setOpen(!1);
        },
        children: G.t("public_pages_purchase.date_picker.apply")
      }
    )
  ] });
  return /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
    vn,
    {
      ref: M,
      shouldCloseOnSelect: !1,
      selectsRange: !0,
      monthsShown: 2,
      selected: me,
      startDate: me,
      className: "w-full",
      calendarClassName: "date-range-picker",
      onCalendarClose: () => {
        ae([Me, fa]), V(z);
      },
      calendarContainer: w ? (re) => /* @__PURE__ */ L(
        "div",
        {
          ...re,
          className: A(
            "flex flex-col justify-center gap-4 sm:flex-row sm:gap-5",
            re.className
          ),
          children: [
            /* @__PURE__ */ L("div", { className: "flex flex-col gap-4 md:mb-4", children: [
              /* @__PURE__ */ _("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: re.children }),
              qa
            ] }),
            /* @__PURE__ */ L("div", { className: "sm:border-text-secondary/30 flex w-full flex-col items-center justify-center gap-5 border-transparent sm:m-auto sm:border-t sm:p-2 md:w-fit md:border-l md:border-t-0 md:pl-5", children: [
              /* @__PURE__ */ L("ul", { className: "hidden w-1/2 gap-5 sm:flex sm:flex-col md:w-full", children: [
                Object.values(dt).map((oe) => /* @__PURE__ */ _("li", { children: /* @__PURE__ */ _(
                  Zr,
                  {
                    className: "w-full",
                    disabled: !b || i || u,
                    onClick: () => {
                      V(oe);
                    },
                    selected: oe === I,
                    children: y_(oe)
                  }
                ) }, oe)),
                (r || [Hi(B, b)]).map(
                  (oe) => /* @__PURE__ */ _("li", { children: /* @__PURE__ */ _(
                    Zr,
                    {
                      className: "w-full",
                      disabled: i || u,
                      onClick: () => {
                        V(oe.slug);
                      },
                      selected: oe.slug === I,
                      children: b_(oe.slug)
                    }
                  ) }, oe.slug)
                )
              ] }),
              /* @__PURE__ */ _("div", { className: "flex w-full justify-between gap-3 sm:w-1/2 md:w-full", children: Ar })
            ] })
          ]
        }
      ) : (re) => /* @__PURE__ */ L("div", { ...re, children: [
        /* @__PURE__ */ _("div", { className: "flex flex-col justify-center gap-5 sm:flex-row", children: re.children }),
        qa,
        /* @__PURE__ */ _("div", { className: "flex w-full justify-center gap-3", children: Ar })
      ] }),
      endDate: ge,
      minDate: Ot(B, b),
      maxDate: m,
      dateFormat: "MMMM d, yyyy",
      onChange: (re) => {
        if (re) {
          V(void 0);
          const [oe, $e] = re;
          ae(S ? v_(oe, $e, S) : [oe, $e]);
        }
      },
      locale: P,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperModifiers: [Mt(), yn({ padding: 5, crossAxis: !0 })],
      showPopperArrow: !1,
      customInput: /* @__PURE__ */ _(
        kn,
        {
          buttonInputClassName: `flex group justify-between ${e ? "" : "min-w-[150px] lg:min-w-[200px]"} w-full py-2.5 px-4 text-sm font-medium ${n ? "text-[rgb(var(--text-tertiary))]" : "text-text-primary"} border ${l ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          wrapperButtonInputClassName: f,
          labelClassName: v,
          error: l,
          label: d,
          required: p,
          description: c,
          children: () => /* @__PURE__ */ _("span", { className: "text-start whitespace-nowrap", children: Me && fa ? /* @__PURE__ */ L(Ee, { children: [
            /* @__PURE__ */ _("span", { className: "hidden lg:inline", children: `${new Intl.DateTimeFormat(g, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(Me)} - ${new Intl.DateTimeFormat(g, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(fa)}
              ` }),
            /* @__PURE__ */ _("span", { className: "inline lg:hidden", children: `${new Intl.DateTimeFormat(g, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(Me)} - ${new Intl.DateTimeFormat(g, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(fa)}
              ` })
          ] }) : /* @__PURE__ */ _("span", { className: "text-text-tertiary/70", children: s || G.t("public_pages_purchase.date_picker.title_dates") }) })
        }
      ),
      renderCustomHeader: ({
        monthDate: re,
        decreaseMonth: oe,
        increaseMonth: $e,
        prevMonthButtonDisabled: Mn,
        nextMonthButtonDisabled: Dt
      }) => /* @__PURE__ */ _(
        Dr,
        {
          date: re,
          decreaseMonth: oe,
          increaseMonth: $e,
          prevMonthButtonDisabled: Mn,
          nextMonthButtonDisabled: Dt,
          intlLocale: g
        }
      ),
      ...D
    }
  ) });
}, Cy = ({
  mode: t = Xn.DateSince,
  value: n,
  onChange: a,
  description: e,
  error: r,
  label: i,
  required: o,
  placeholder: s,
  maxDate: l,
  minDate: c,
  wrapperButtonInputClassName: u,
  disabled: d,
  timezone: p,
  intlLocale: m,
  createdAt: h,
  labelClassName: f
}) => {
  const [g, y] = ee(
    n && ce(n, p) || null
  ), [b, k] = ee(), [D, v] = ee(xa), S = h && p ? Ot(h, p) : null;
  return Pr(m, v), de(() => {
    if (!p) return;
    const w = n ? ce(n, p) : null;
    (!g || (w == null ? void 0 : w.toISOString()) !== g.toISOString()) && y(w);
  }, [n, p, g]), /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(
    vn,
    {
      selected: g,
      dateFormat: "MMMM d, yyyy",
      onChange: (w) => {
        w && ((g ? w.toDateString() === g.toDateString() : !1) ? (y(null), a(null)) : (y(w), t === Xn.DateTill && hl(w), a(ba(w))));
      },
      onChangeRaw: (w) => {
        const M = w == null ? void 0 : w.target;
        b === (M == null ? void 0 : M.ariaLabel) ? (y(null), a(null)) : k(M == null ? void 0 : M.ariaLabel);
      },
      locale: D,
      minDate: c || S || void 0,
      maxDate: l || void 0,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperModifiers: [Mt(), yn({ padding: 5, crossAxis: !0 })],
      showPopperArrow: !1,
      customInput: /* @__PURE__ */ _(
        kn,
        {
          description: e,
          buttonInputClassName: `flex group justify-between min-w-[200px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${d ? "bg-background-tertiary/40" : "bg-background-secondary focus:border-brand-primary"} ${r ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          error: r,
          label: i,
          required: o,
          wrapperButtonInputClassName: u,
          labelClassName: f,
          children: (w) => /* @__PURE__ */ _("span", { className: "text-start", children: w || /* @__PURE__ */ _("span", { className: "text-text-tertiary/70", children: s }) })
        }
      ),
      renderCustomHeader: ({
        date: w,
        decreaseMonth: M,
        increaseMonth: P,
        prevMonthButtonDisabled: N,
        nextMonthButtonDisabled: B
      }) => /* @__PURE__ */ _(
        Dr,
        {
          date: w,
          decreaseMonth: M,
          increaseMonth: P,
          prevMonthButtonDisabled: N,
          nextMonthButtonDisabled: B,
          intlLocale: m
        }
      ),
      disabled: d
    }
  ) });
}, zi = ({
  children: t,
  isLast: n,
  className: a,
  isLink: e,
  onClick: r
}) => {
  const i = (o) => {
    r && (o.preventDefault(), r());
  };
  return /* @__PURE__ */ _(
    "h2",
    {
      className: A(
        "text-text-tertiary text-[18px] font-semibold leading-8 transition-colors md:truncate md:text-[20px]  lg:text-[22px]",
        a,
        (e || r) && "hover:text-text-primary cursor-pointer",
        n && "text-text-primary"
      ),
      onClick: i,
      children: t
    }
  );
}, Dy = ({
  data: t,
  isFetching: n,
  classnameBreadcrumbsItem: a,
  CustomBreadcrumbLinkItem: e
}) => {
  const r = ue(null), i = ue(null);
  return nr(() => {
    r.current && i.current && r.current.scrollTo(i.current.offsetLeft, 0);
  }, [n]), /* @__PURE__ */ _(
    "ul",
    {
      ref: r,
      className: `
        md:overflow:hidden hide-scrollbar
        flex min-h-[42px] w-full flex-nowrap items-center gap-3 gap-y-0
        overflow-scroll whitespace-nowrap
        md:flex-wrap md:truncate 
        lg:flex-nowrap
      `,
      children: t.map((o, s) => {
        const l = s === t.length - 1;
        return /* @__PURE__ */ L(
          "li",
          {
            className: "flex flex-nowrap items-center gap-3 md:truncate",
            ref: l ? i : void 0,
            children: [
              s !== 0 && /* @__PURE__ */ _(Xi, { height: "14", width: "10", fill: "rgb(var(--text-tertiary))" }),
              !o.isStatic && n ? /* @__PURE__ */ _(Vt, { small: !0, type: "dark" }) : o.href ? /* @__PURE__ */ _(
                zi,
                {
                  isLast: l,
                  className: A(a),
                  isLink: !0,
                  onClick: o.onClick,
                  children: e ? /* @__PURE__ */ _(e, { href: o.href, children: o.caption }) : /* @__PURE__ */ _("a", { href: o.href, rel: "noreferrer", className: "outline-hidden", children: o.caption })
                }
              ) : /* @__PURE__ */ _(
                zi,
                {
                  onClick: o.onClick,
                  className: A(a),
                  isLast: l,
                  children: o.caption
                }
              )
            ]
          },
          s
        );
      })
    }
  );
};
export {
  op as $,
  oy as A,
  Eu as B,
  G_ as C,
  ms as D,
  py as E,
  Na as F,
  my as G,
  bs as H,
  Ss as I,
  dr as J,
  ur as K,
  Vt as L,
  O_ as M,
  ny as N,
  vs as O,
  F_ as P,
  Jr as Q,
  uy as R,
  ry as S,
  ly as T,
  _s as U,
  or as V,
  sr as W,
  gs as X,
  cr as Y,
  un as Z,
  ys as _,
  at as a,
  ip as a0,
  hy as a1,
  fy as a2,
  rr as a3,
  gy as a4,
  Zg as a5,
  Yg as a6,
  Oi as a7,
  Wg as a8,
  Sy as a9,
  so as aA,
  Y_ as aB,
  Ca as aC,
  V_ as aD,
  Bu as aE,
  U_ as aF,
  W_ as aG,
  ir as aH,
  Z_ as aI,
  J_ as aJ,
  we as aK,
  jd as aL,
  Q_ as aM,
  Yd as aN,
  Hn as aO,
  Ot as aP,
  Pn as aQ,
  ce as aR,
  ba as aS,
  Wr as aT,
  $_ as aU,
  Zd as aV,
  q_ as aW,
  X_ as aX,
  ey as aY,
  ay as aZ,
  fs as a_,
  Xn as aa,
  dt as ab,
  wa as ac,
  ky as ad,
  wy as ae,
  Cy as af,
  My as ag,
  C_ as ah,
  hl as ai,
  zi as aj,
  Dy as ak,
  Sn as al,
  _y as am,
  yy as an,
  by as ao,
  vy as ap,
  no as aq,
  ro as ar,
  Iu as as,
  se as at,
  z_ as au,
  L_ as av,
  zn as aw,
  ot as ax,
  Z as ay,
  j_ as az,
  An as b,
  tt as c,
  Op as d,
  Ul as e,
  ha as f,
  K_ as g,
  H_ as h,
  ty as i,
  Va as j,
  iy as k,
  Zr as l,
  ps as m,
  oa as n,
  Ta as o,
  $d as p,
  ep as q,
  Xd as r,
  ia as s,
  H as t,
  Jd as u,
  Qd as v,
  sy as w,
  tp as x,
  cy as y,
  dy as z
};
